function rl(o) {
  return o.standingPlacesFromS2 ?? null;
}
function V_(o) {
  const r = rl(o), { seats: n, companionSeats: a } = o;
  return n == null || r === null || a === null || a === void 0 ? null : n + r + a + 1;
}
function zT(o) {
  const r = rl(o), n = V_(o);
  return {
    ...r !== null ? { standingPlaces: r } : {},
    ...n !== null ? { totalCapacity: n } : {}
  };
}
const j_ = [
  "licensePlate",
  "inspectionExpiryDate",
  // BSD-4761: a vehicle never registered was not registered under the Regio Decreto either. Waived and
  // cleared like the other two, but not refused at publish, which checks only those.
  "registeredWithRegioDecreto"
];
function Bi({ firstRegistration: o }) {
  return o == null ? !0 : typeof o == "string" && o.trim() === "";
}
function J_(o, r) {
  return j_.some((n) => n === o) && Bi(r);
}
const Y_ = [
  "registrationDocument",
  "registrationDocumentPartTwo",
  "inspectionSticker"
];
function X_(o, r) {
  return Y_.some((n) => n === o) && Bi(r);
}
const Q_ = [
  // Visibility-only: visible Back Office where shown, hidden elsewhere.
  "useType",
  "registeredWithRegioDecreto",
  "engineBrand",
  "engineModel",
  "width",
  "height",
  // Responsibility-varying: always visible; Back Office/Inspector and required both vary.
  "length",
  "axles",
  "wheels",
  "wheelsSizeAxle1",
  "wheelsSizeAxle2",
  "wheelsSizeAxle3",
  "inspectionExpiryDate",
  // Inspector or hidden.
  "hasDepotService"
], OT = [
  "cocDocument",
  "registrationDocument",
  "registrationDocumentPartTwo",
  "maintenanceCard",
  "technicalSheet",
  "inspectionAndMileageCheck",
  "inspectionSticker"
], oo = { visibility: "hidden" }, C = { visibility: "visible", responsibility: "BackOffice", required: !0 }, Vo = { visibility: "visible", responsibility: "BackOffice", required: !1 }, uo = { visibility: "visible", responsibility: "Inspector", required: !0 }, Wo = { visibility: "visible", responsibility: "Inspector", required: !1 }, Ri = {
  useType: { default: oo, overrides: { IT: C } },
  // Question 1420 of the field sheet (PT-962): a Spanish special registration that no other country accepts.
  registeredWithRegioDecreto: { default: oo, overrides: { ES: C } },
  engineBrand: {
    default: oo,
    overrides: {
      IT: C,
      ES: C,
      PT: C,
      BE: C,
      AT: C,
      NL: C
    }
  },
  engineModel: { default: oo, overrides: { IT: C, ES: C, AT: C } },
  width: {
    default: oo,
    overrides: { IT: C, ES: C, DE: C, AT: C, LU: C }
  },
  height: { default: oo, overrides: { ES: C, DE: C, AT: C, LU: C } },
  length: {
    default: uo,
    overrides: {
      IT: C,
      ES: C,
      BE: C,
      DE: C,
      AT: C,
      CZ: C,
      NL: C,
      LU: C,
      PT: Wo
    }
  },
  axles: {
    default: uo,
    overrides: {
      IT: C,
      ES: C,
      DE: C,
      AT: C,
      LU: C,
      PT: Wo
    }
  },
  wheels: {
    default: uo,
    overrides: {
      IT: C,
      ES: C,
      DE: C,
      AT: C,
      LU: C,
      PT: Wo
    }
  },
  wheelsSizeAxle1: {
    default: Wo,
    overrides: { IT: C, ES: C, DE: C, AT: C, LU: C }
  },
  wheelsSizeAxle2: {
    default: Wo,
    overrides: { IT: C, ES: C, DE: C, AT: C, LU: Vo }
  },
  wheelsSizeAxle3: {
    default: Wo,
    overrides: { IT: C, ES: C, DE: C, AT: C, LU: Vo }
  },
  inspectionExpiryDate: { default: C, overrides: { PT: uo, DE: uo } },
  // Deliberately NOT aligned to PT-703 (BSD-4329): the sheet's "Depot Service" (code 60) is an attribute the
  // inspector observes, whereas this column is a commercial flag, set when the seller accepts the depot terms
  // (BusAsset.depotTermsAcceptedAt). Same name, different thing — do not sync this row from the sheet.
  hasDepotService: { default: oo, overrides: { IT: Wo } }
}, Pi = {
  cocDocument: { default: Vo, overrides: { BE: C, NL: C } },
  registrationDocument: { default: C, overrides: { DE: uo, AT: uo, CZ: uo } },
  registrationDocumentPartTwo: { default: oo, overrides: { DE: C, AT: C, CZ: C } },
  maintenanceCard: { default: Vo },
  technicalSheet: { default: oo, overrides: { ES: C } },
  inspectionAndMileageCheck: { default: oo, overrides: { IT: Vo, ES: Vo, PL: Vo } },
  inspectionSticker: { default: oo, overrides: { DE: uo, AT: uo } }
};
function gt(o, r) {
  const { default: n, overrides: a } = o;
  if (r != null && a !== void 0) {
    const u = a[r];
    if (u !== void 0) return u;
  }
  return n;
}
function GT(o, r) {
  return gt(Ri[o], r).visibility === "hidden";
}
function eA(o, r, n) {
  if (n !== void 0 && J_(o, n)) return !1;
  const a = gt(Ri[o], r);
  return a.visibility === "visible" && a.required;
}
function qT(o, r) {
  const n = gt(Ri[o], r);
  return n.visibility === "visible" ? n.responsibility : void 0;
}
function UT(o, r) {
  return Q_.filter((n) => eA(n, o, r));
}
function ZT(o, r) {
  return gt(Pi[o], r).visibility === "hidden";
}
function $T(o, r, n) {
  if (n !== void 0 && X_(o, n)) return !1;
  const a = gt(Pi[o], r);
  return a.visibility === "visible" && a.required;
}
function KT(o, r) {
  const n = gt(Pi[o], r);
  return n.visibility === "visible" ? n.responsibility : void 0;
}
const HT = ["Autobus", "Minibus", "Other"], WT = ["ClassOne", "ClassTwo", "ClassThree", "ClassA", "ClassB", "SchoolBus"], oA = [
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !1, cubicMetres: 13 },
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !1, cubicMetres: 12 },
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !0, cubicMetres: 11.5 },
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !0, cubicMetres: 11 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !1, cubicMetres: 9 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !1, cubicMetres: 8 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !0, cubicMetres: 7.5 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !0, cubicMetres: 7 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !1, cubicMetres: 10 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !1, cubicMetres: 9 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !0, cubicMetres: 8.5 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !0, cubicMetres: 8 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !1, cubicMetres: 7 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !1, cubicMetres: 6 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !0, cubicMetres: 5.5 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !0, cubicMetres: 5 }
], tA = 2;
function VT(o) {
  if (o.class === "ClassOne") return null;
  if (o.type === "Minibus") return tA;
  if (o.type !== "Autobus" || o.class !== "ClassTwo" && o.class !== "ClassThree") return null;
  const { axles: r, passThroughLuggageCompartment: n, toilet: a, driverBerth: u } = o;
  return r == null || n === null || n === void 0 || a === null || a === void 0 || u === null || u === void 0 ? null : oA.find(
    (d) => d.axles === r && d.passThroughLuggageCompartment === n && d.toilet === a && d.driverBerth === u
  )?.cubicMetres ?? null;
}
function N(o, r, n) {
  function a(b, T) {
    if (b._zod || Object.defineProperty(b, "_zod", {
      value: {
        def: T,
        constr: d,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), b._zod.traits.has(o))
      return;
    b._zod.traits.add(o), r(b, T);
    const S = d.prototype, w = Object.keys(S);
    for (let O = 0; O < w.length; O++) {
      const k = w[O];
      k in b || (b[k] = S[k].bind(b));
    }
  }
  const u = n?.Parent ?? Object;
  class f extends u {
  }
  Object.defineProperty(f, "name", { value: o });
  function d(b) {
    var T;
    const S = n?.Parent ? new f() : this;
    a(S, b), (T = S._zod).deferred ?? (T.deferred = []);
    for (const w of S._zod.deferred)
      w();
    return S;
  }
  return Object.defineProperty(d, "init", { value: a }), Object.defineProperty(d, Symbol.hasInstance, {
    value: (b) => n?.Parent && b instanceof n.Parent ? !0 : b?._zod?.traits?.has(o)
  }), Object.defineProperty(d, "name", { value: o }), d;
}
class bt extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class nl extends Error {
  constructor(r) {
    super(`Encountered unidirectional transform during encode: ${r}`), this.name = "ZodEncodeError";
  }
}
const il = {};
function jo(o) {
  return il;
}
function al(o) {
  const r = Object.values(o).filter((a) => typeof a == "number");
  return Object.entries(o).filter(([a, u]) => r.indexOf(+a) === -1).map(([a, u]) => u);
}
function Ei(o, r) {
  return typeof r == "bigint" ? r.toString() : r;
}
function zi(o) {
  return {
    get value() {
      {
        const r = o();
        return Object.defineProperty(this, "value", { value: r }), r;
      }
    }
  };
}
function Oi(o) {
  return o == null;
}
function Gi(o) {
  const r = o.startsWith("^") ? 1 : 0, n = o.endsWith("$") ? o.length - 1 : o.length;
  return o.slice(r, n);
}
function rA(o, r) {
  const n = (o.toString().split(".")[1] || "").length, a = r.toString();
  let u = (a.split(".")[1] || "").length;
  if (u === 0 && /\d?e-\d?/.test(a)) {
    const T = a.match(/\d?e-(\d?)/);
    T?.[1] && (u = Number.parseInt(T[1]));
  }
  const f = n > u ? n : u, d = Number.parseInt(o.toFixed(f).replace(".", "")), b = Number.parseInt(r.toFixed(f).replace(".", ""));
  return d % b / 10 ** f;
}
const Eu = /* @__PURE__ */ Symbol("evaluating");
function J(o, r, n) {
  let a;
  Object.defineProperty(o, r, {
    get() {
      if (a !== Eu)
        return a === void 0 && (a = Eu, a = n()), a;
    },
    set(u) {
      Object.defineProperty(o, r, {
        value: u
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Yo(o, r, n) {
  Object.defineProperty(o, r, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Lo(...o) {
  const r = {};
  for (const n of o) {
    const a = Object.getOwnPropertyDescriptors(n);
    Object.assign(r, a);
  }
  return Object.defineProperties({}, r);
}
function Cu(o) {
  return JSON.stringify(o);
}
function nA(o) {
  return o.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const sl = "captureStackTrace" in Error ? Error.captureStackTrace : (...o) => {
};
function Vr(o) {
  return typeof o == "object" && o !== null && !Array.isArray(o);
}
const iA = zi(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const o = Function;
    return new o(""), !0;
  } catch {
    return !1;
  }
});
function jt(o) {
  if (Vr(o) === !1)
    return !1;
  const r = o.constructor;
  if (r === void 0 || typeof r != "function")
    return !0;
  const n = r.prototype;
  return !(Vr(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function ul(o) {
  return jt(o) ? { ...o } : Array.isArray(o) ? [...o] : o;
}
const aA = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function _t(o) {
  return o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Bo(o, r, n) {
  const a = new o._zod.constr(r ?? o._zod.def);
  return (!r || n?.parent) && (a._zod.parent = o), a;
}
function D(o) {
  const r = o;
  if (!r)
    return {};
  if (typeof r == "string")
    return { error: () => r };
  if (r?.message !== void 0) {
    if (r?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    r.error = r.message;
  }
  return delete r.message, typeof r.error == "string" ? { ...r, error: () => r.error } : r;
}
function sA(o) {
  return Object.keys(o).filter((r) => o[r]._zod.optin === "optional" && o[r]._zod.optout === "optional");
}
const uA = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function lA(o, r) {
  const n = o._zod.def, a = n.checks;
  if (a && a.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const f = Lo(o._zod.def, {
    get shape() {
      const d = {};
      for (const b in r) {
        if (!(b in n.shape))
          throw new Error(`Unrecognized key: "${b}"`);
        r[b] && (d[b] = n.shape[b]);
      }
      return Yo(this, "shape", d), d;
    },
    checks: []
  });
  return Bo(o, f);
}
function cA(o, r) {
  const n = o._zod.def, a = n.checks;
  if (a && a.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const f = Lo(o._zod.def, {
    get shape() {
      const d = { ...o._zod.def.shape };
      for (const b in r) {
        if (!(b in n.shape))
          throw new Error(`Unrecognized key: "${b}"`);
        r[b] && delete d[b];
      }
      return Yo(this, "shape", d), d;
    },
    checks: []
  });
  return Bo(o, f);
}
function dA(o, r) {
  if (!jt(r))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = o._zod.def.checks;
  if (n && n.length > 0) {
    const f = o._zod.def.shape;
    for (const d in r)
      if (Object.getOwnPropertyDescriptor(f, d) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const u = Lo(o._zod.def, {
    get shape() {
      const f = { ...o._zod.def.shape, ...r };
      return Yo(this, "shape", f), f;
    }
  });
  return Bo(o, u);
}
function pA(o, r) {
  if (!jt(r))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = Lo(o._zod.def, {
    get shape() {
      const a = { ...o._zod.def.shape, ...r };
      return Yo(this, "shape", a), a;
    }
  });
  return Bo(o, n);
}
function fA(o, r) {
  const n = Lo(o._zod.def, {
    get shape() {
      const a = { ...o._zod.def.shape, ...r._zod.def.shape };
      return Yo(this, "shape", a), a;
    },
    get catchall() {
      return r._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Bo(o, n);
}
function mA(o, r, n) {
  const u = r._zod.def.checks;
  if (u && u.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const d = Lo(r._zod.def, {
    get shape() {
      const b = r._zod.def.shape, T = { ...b };
      if (n)
        for (const S in n) {
          if (!(S in b))
            throw new Error(`Unrecognized key: "${S}"`);
          n[S] && (T[S] = o ? new o({
            type: "optional",
            innerType: b[S]
          }) : b[S]);
        }
      else
        for (const S in b)
          T[S] = o ? new o({
            type: "optional",
            innerType: b[S]
          }) : b[S];
      return Yo(this, "shape", T), T;
    },
    checks: []
  });
  return Bo(r, d);
}
function hA(o, r, n) {
  const a = Lo(r._zod.def, {
    get shape() {
      const u = r._zod.def.shape, f = { ...u };
      if (n)
        for (const d in n) {
          if (!(d in f))
            throw new Error(`Unrecognized key: "${d}"`);
          n[d] && (f[d] = new o({
            type: "nonoptional",
            innerType: u[d]
          }));
        }
      else
        for (const d in u)
          f[d] = new o({
            type: "nonoptional",
            innerType: u[d]
          });
      return Yo(this, "shape", f), f;
    }
  });
  return Bo(r, a);
}
function mt(o, r = 0) {
  if (o.aborted === !0)
    return !0;
  for (let n = r; n < o.issues.length; n++)
    if (o.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function ll(o, r) {
  return r.map((n) => {
    var a;
    return (a = n).path ?? (a.path = []), n.path.unshift(o), n;
  });
}
function $r(o) {
  return typeof o == "string" ? o : o?.message;
}
function Jo(o, r, n) {
  const a = { ...o, path: o.path ?? [] };
  if (!o.message) {
    const u = $r(o.inst?._zod.def?.error?.(o)) ?? $r(r?.error?.(o)) ?? $r(n.customError?.(o)) ?? $r(n.localeError?.(o)) ?? "Invalid input";
    a.message = u;
  }
  return delete a.inst, delete a.continue, r?.reportInput || delete a.input, a;
}
function qi(o) {
  return Array.isArray(o) ? "array" : typeof o == "string" ? "string" : "unknown";
}
function Jt(...o) {
  const [r, n, a] = o;
  return typeof r == "string" ? {
    message: r,
    code: "custom",
    input: n,
    inst: a
  } : { ...r };
}
const cl = (o, r) => {
  o.name = "$ZodError", Object.defineProperty(o, "_zod", {
    value: o._zod,
    enumerable: !1
  }), Object.defineProperty(o, "issues", {
    value: r,
    enumerable: !1
  }), o.message = JSON.stringify(r, Ei, 2), Object.defineProperty(o, "toString", {
    value: () => o.message,
    enumerable: !1
  });
}, dl = N("$ZodError", cl), pl = N("$ZodError", cl, { Parent: Error });
function bA(o, r = (n) => n.message) {
  const n = {}, a = [];
  for (const u of o.issues)
    u.path.length > 0 ? (n[u.path[0]] = n[u.path[0]] || [], n[u.path[0]].push(r(u))) : a.push(r(u));
  return { formErrors: a, fieldErrors: n };
}
function _A(o, r = (n) => n.message) {
  const n = { _errors: [] }, a = (u) => {
    for (const f of u.issues)
      if (f.code === "invalid_union" && f.errors.length)
        f.errors.map((d) => a({ issues: d }));
      else if (f.code === "invalid_key")
        a({ issues: f.issues });
      else if (f.code === "invalid_element")
        a({ issues: f.issues });
      else if (f.path.length === 0)
        n._errors.push(r(f));
      else {
        let d = n, b = 0;
        for (; b < f.path.length; ) {
          const T = f.path[b];
          b === f.path.length - 1 ? (d[T] = d[T] || { _errors: [] }, d[T]._errors.push(r(f))) : d[T] = d[T] || { _errors: [] }, d = d[T], b++;
        }
      }
  };
  return a(o), n;
}
const Ui = (o) => (r, n, a, u) => {
  const f = a ? Object.assign(a, { async: !1 }) : { async: !1 }, d = r._zod.run({ value: n, issues: [] }, f);
  if (d instanceof Promise)
    throw new bt();
  if (d.issues.length) {
    const b = new (u?.Err ?? o)(d.issues.map((T) => Jo(T, f, jo())));
    throw sl(b, u?.callee), b;
  }
  return d.value;
}, Zi = (o) => async (r, n, a, u) => {
  const f = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let d = r._zod.run({ value: n, issues: [] }, f);
  if (d instanceof Promise && (d = await d), d.issues.length) {
    const b = new (u?.Err ?? o)(d.issues.map((T) => Jo(T, f, jo())));
    throw sl(b, u?.callee), b;
  }
  return d.value;
}, Qr = (o) => (r, n, a) => {
  const u = a ? { ...a, async: !1 } : { async: !1 }, f = r._zod.run({ value: n, issues: [] }, u);
  if (f instanceof Promise)
    throw new bt();
  return f.issues.length ? {
    success: !1,
    error: new (o ?? dl)(f.issues.map((d) => Jo(d, u, jo())))
  } : { success: !0, data: f.value };
}, AA = /* @__PURE__ */ Qr(pl), en = (o) => async (r, n, a) => {
  const u = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let f = r._zod.run({ value: n, issues: [] }, u);
  return f instanceof Promise && (f = await f), f.issues.length ? {
    success: !1,
    error: new o(f.issues.map((d) => Jo(d, u, jo())))
  } : { success: !0, data: f.value };
}, gA = /* @__PURE__ */ en(pl), yA = (o) => (r, n, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Ui(o)(r, n, u);
}, TA = (o) => (r, n, a) => Ui(o)(r, n, a), MA = (o) => async (r, n, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Zi(o)(r, n, u);
}, NA = (o) => async (r, n, a) => Zi(o)(r, n, a), FA = (o) => (r, n, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Qr(o)(r, n, u);
}, IA = (o) => (r, n, a) => Qr(o)(r, n, a), SA = (o) => async (r, n, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return en(o)(r, n, u);
}, xA = (o) => async (r, n, a) => en(o)(r, n, a), vA = /^[cC][^\s-]{8,}$/, wA = /^[0-9a-z]+$/, EA = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, CA = /^[0-9a-vA-V]{20}$/, kA = /^[A-Za-z0-9]{27}$/, DA = /^[a-zA-Z0-9_-]{21}$/, LA = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, BA = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, ku = (o) => o ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${o}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, RA = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, PA = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function zA() {
  return new RegExp(PA, "u");
}
const OA = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, GA = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, qA = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, UA = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ZA = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, fl = /^[A-Za-z0-9_-]*$/, $A = /^\+[1-9]\d{6,14}$/, ml = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", KA = /* @__PURE__ */ new RegExp(`^${ml}$`);
function hl(o) {
  const r = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof o.precision == "number" ? o.precision === -1 ? `${r}` : o.precision === 0 ? `${r}:[0-5]\\d` : `${r}:[0-5]\\d\\.\\d{${o.precision}}` : `${r}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function HA(o) {
  return new RegExp(`^${hl(o)}$`);
}
function WA(o) {
  const r = hl({ precision: o.precision }), n = ["Z"];
  o.local && n.push(""), o.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const a = `${r}(?:${n.join("|")})`;
  return new RegExp(`^${ml}T(?:${a})$`);
}
const VA = (o) => {
  const r = o ? `[\\s\\S]{${o?.minimum ?? 0},${o?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${r}$`);
}, jA = /^-?\d+$/, JA = /^-?\d+(?:\.\d+)?$/, YA = /^[^A-Z]*$/, XA = /^[^a-z]*$/, Ee = /* @__PURE__ */ N("$ZodCheck", (o, r) => {
  var n;
  o._zod ?? (o._zod = {}), o._zod.def = r, (n = o._zod).onattach ?? (n.onattach = []);
}), bl = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, _l = /* @__PURE__ */ N("$ZodCheckLessThan", (o, r) => {
  Ee.init(o, r);
  const n = bl[typeof r.value];
  o._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (r.inclusive ? u.maximum : u.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    r.value < f && (r.inclusive ? u.maximum = r.value : u.exclusiveMaximum = r.value);
  }), o._zod.check = (a) => {
    (r.inclusive ? a.value <= r.value : a.value < r.value) || a.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof r.value == "object" ? r.value.getTime() : r.value,
      input: a.value,
      inclusive: r.inclusive,
      inst: o,
      continue: !r.abort
    });
  };
}), Al = /* @__PURE__ */ N("$ZodCheckGreaterThan", (o, r) => {
  Ee.init(o, r);
  const n = bl[typeof r.value];
  o._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (r.inclusive ? u.minimum : u.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    r.value > f && (r.inclusive ? u.minimum = r.value : u.exclusiveMinimum = r.value);
  }), o._zod.check = (a) => {
    (r.inclusive ? a.value >= r.value : a.value > r.value) || a.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof r.value == "object" ? r.value.getTime() : r.value,
      input: a.value,
      inclusive: r.inclusive,
      inst: o,
      continue: !r.abort
    });
  };
}), QA = /* @__PURE__ */ N("$ZodCheckMultipleOf", (o, r) => {
  Ee.init(o, r), o._zod.onattach.push((n) => {
    var a;
    (a = n._zod.bag).multipleOf ?? (a.multipleOf = r.value);
  }), o._zod.check = (n) => {
    if (typeof n.value != typeof r.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % r.value === BigInt(0) : rA(n.value, r.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: r.value,
      input: n.value,
      inst: o,
      continue: !r.abort
    });
  };
}), e0 = /* @__PURE__ */ N("$ZodCheckNumberFormat", (o, r) => {
  Ee.init(o, r), r.format = r.format || "float64";
  const n = r.format?.includes("int"), a = n ? "int" : "number", [u, f] = uA[r.format];
  o._zod.onattach.push((d) => {
    const b = d._zod.bag;
    b.format = r.format, b.minimum = u, b.maximum = f, n && (b.pattern = jA);
  }), o._zod.check = (d) => {
    const b = d.value;
    if (n) {
      if (!Number.isInteger(b)) {
        d.issues.push({
          expected: a,
          format: r.format,
          code: "invalid_type",
          continue: !1,
          input: b,
          inst: o
        });
        return;
      }
      if (!Number.isSafeInteger(b)) {
        b > 0 ? d.issues.push({
          input: b,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: o,
          origin: a,
          inclusive: !0,
          continue: !r.abort
        }) : d.issues.push({
          input: b,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: o,
          origin: a,
          inclusive: !0,
          continue: !r.abort
        });
        return;
      }
    }
    b < u && d.issues.push({
      origin: "number",
      input: b,
      code: "too_small",
      minimum: u,
      inclusive: !0,
      inst: o,
      continue: !r.abort
    }), b > f && d.issues.push({
      origin: "number",
      input: b,
      code: "too_big",
      maximum: f,
      inclusive: !0,
      inst: o,
      continue: !r.abort
    });
  };
}), o0 = /* @__PURE__ */ N("$ZodCheckMaxLength", (o, r) => {
  var n;
  Ee.init(o, r), (n = o._zod.def).when ?? (n.when = (a) => {
    const u = a.value;
    return !Oi(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    r.maximum < u && (a._zod.bag.maximum = r.maximum);
  }), o._zod.check = (a) => {
    const u = a.value;
    if (u.length <= r.maximum)
      return;
    const d = qi(u);
    a.issues.push({
      origin: d,
      code: "too_big",
      maximum: r.maximum,
      inclusive: !0,
      input: u,
      inst: o,
      continue: !r.abort
    });
  };
}), t0 = /* @__PURE__ */ N("$ZodCheckMinLength", (o, r) => {
  var n;
  Ee.init(o, r), (n = o._zod.def).when ?? (n.when = (a) => {
    const u = a.value;
    return !Oi(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    r.minimum > u && (a._zod.bag.minimum = r.minimum);
  }), o._zod.check = (a) => {
    const u = a.value;
    if (u.length >= r.minimum)
      return;
    const d = qi(u);
    a.issues.push({
      origin: d,
      code: "too_small",
      minimum: r.minimum,
      inclusive: !0,
      input: u,
      inst: o,
      continue: !r.abort
    });
  };
}), r0 = /* @__PURE__ */ N("$ZodCheckLengthEquals", (o, r) => {
  var n;
  Ee.init(o, r), (n = o._zod.def).when ?? (n.when = (a) => {
    const u = a.value;
    return !Oi(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.minimum = r.length, u.maximum = r.length, u.length = r.length;
  }), o._zod.check = (a) => {
    const u = a.value, f = u.length;
    if (f === r.length)
      return;
    const d = qi(u), b = f > r.length;
    a.issues.push({
      origin: d,
      ...b ? { code: "too_big", maximum: r.length } : { code: "too_small", minimum: r.length },
      inclusive: !0,
      exact: !0,
      input: a.value,
      inst: o,
      continue: !r.abort
    });
  };
}), on = /* @__PURE__ */ N("$ZodCheckStringFormat", (o, r) => {
  var n, a;
  Ee.init(o, r), o._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.format = r.format, r.pattern && (f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(r.pattern));
  }), r.pattern ? (n = o._zod).check ?? (n.check = (u) => {
    r.pattern.lastIndex = 0, !r.pattern.test(u.value) && u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: r.format,
      input: u.value,
      ...r.pattern ? { pattern: r.pattern.toString() } : {},
      inst: o,
      continue: !r.abort
    });
  }) : (a = o._zod).check ?? (a.check = () => {
  });
}), n0 = /* @__PURE__ */ N("$ZodCheckRegex", (o, r) => {
  on.init(o, r), o._zod.check = (n) => {
    r.pattern.lastIndex = 0, !r.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: r.pattern.toString(),
      inst: o,
      continue: !r.abort
    });
  };
}), i0 = /* @__PURE__ */ N("$ZodCheckLowerCase", (o, r) => {
  r.pattern ?? (r.pattern = YA), on.init(o, r);
}), a0 = /* @__PURE__ */ N("$ZodCheckUpperCase", (o, r) => {
  r.pattern ?? (r.pattern = XA), on.init(o, r);
}), s0 = /* @__PURE__ */ N("$ZodCheckIncludes", (o, r) => {
  Ee.init(o, r);
  const n = _t(r.includes), a = new RegExp(typeof r.position == "number" ? `^.{${r.position}}${n}` : n);
  r.pattern = a, o._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(a);
  }), o._zod.check = (u) => {
    u.value.includes(r.includes, r.position) || u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: r.includes,
      input: u.value,
      inst: o,
      continue: !r.abort
    });
  };
}), u0 = /* @__PURE__ */ N("$ZodCheckStartsWith", (o, r) => {
  Ee.init(o, r);
  const n = new RegExp(`^${_t(r.prefix)}.*`);
  r.pattern ?? (r.pattern = n), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(n);
  }), o._zod.check = (a) => {
    a.value.startsWith(r.prefix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: r.prefix,
      input: a.value,
      inst: o,
      continue: !r.abort
    });
  };
}), l0 = /* @__PURE__ */ N("$ZodCheckEndsWith", (o, r) => {
  Ee.init(o, r);
  const n = new RegExp(`.*${_t(r.suffix)}$`);
  r.pattern ?? (r.pattern = n), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(n);
  }), o._zod.check = (a) => {
    a.value.endsWith(r.suffix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: r.suffix,
      input: a.value,
      inst: o,
      continue: !r.abort
    });
  };
}), c0 = /* @__PURE__ */ N("$ZodCheckOverwrite", (o, r) => {
  Ee.init(o, r), o._zod.check = (n) => {
    n.value = r.tx(n.value);
  };
});
class d0 {
  constructor(r = []) {
    this.content = [], this.indent = 0, this && (this.args = r);
  }
  indented(r) {
    this.indent += 1, r(this), this.indent -= 1;
  }
  write(r) {
    if (typeof r == "function") {
      r(this, { execution: "sync" }), r(this, { execution: "async" });
      return;
    }
    const a = r.split(`
`).filter((d) => d), u = Math.min(...a.map((d) => d.length - d.trimStart().length)), f = a.map((d) => d.slice(u)).map((d) => " ".repeat(this.indent * 2) + d);
    for (const d of f)
      this.content.push(d);
  }
  compile() {
    const r = Function, n = this?.args, u = [...(this?.content ?? [""]).map((f) => `  ${f}`)];
    return new r(...n, u.join(`
`));
  }
}
const p0 = {
  major: 4,
  minor: 3,
  patch: 6
}, ce = /* @__PURE__ */ N("$ZodType", (o, r) => {
  var n;
  o ?? (o = {}), o._zod.def = r, o._zod.bag = o._zod.bag || {}, o._zod.version = p0;
  const a = [...o._zod.def.checks ?? []];
  o._zod.traits.has("$ZodCheck") && a.unshift(o);
  for (const u of a)
    for (const f of u._zod.onattach)
      f(o);
  if (a.length === 0)
    (n = o._zod).deferred ?? (n.deferred = []), o._zod.deferred?.push(() => {
      o._zod.run = o._zod.parse;
    });
  else {
    const u = (d, b, T) => {
      let S = mt(d), w;
      for (const O of b) {
        if (O._zod.def.when) {
          if (!O._zod.def.when(d))
            continue;
        } else if (S)
          continue;
        const k = d.issues.length, P = O._zod.check(d);
        if (P instanceof Promise && T?.async === !1)
          throw new bt();
        if (w || P instanceof Promise)
          w = (w ?? Promise.resolve()).then(async () => {
            await P, d.issues.length !== k && (S || (S = mt(d, k)));
          });
        else {
          if (d.issues.length === k)
            continue;
          S || (S = mt(d, k));
        }
      }
      return w ? w.then(() => d) : d;
    }, f = (d, b, T) => {
      if (mt(d))
        return d.aborted = !0, d;
      const S = u(b, a, T);
      if (S instanceof Promise) {
        if (T.async === !1)
          throw new bt();
        return S.then((w) => o._zod.parse(w, T));
      }
      return o._zod.parse(S, T);
    };
    o._zod.run = (d, b) => {
      if (b.skipChecks)
        return o._zod.parse(d, b);
      if (b.direction === "backward") {
        const S = o._zod.parse({ value: d.value, issues: [] }, { ...b, skipChecks: !0 });
        return S instanceof Promise ? S.then((w) => f(w, d, b)) : f(S, d, b);
      }
      const T = o._zod.parse(d, b);
      if (T instanceof Promise) {
        if (b.async === !1)
          throw new bt();
        return T.then((S) => u(S, a, b));
      }
      return u(T, a, b);
    };
  }
  J(o, "~standard", () => ({
    validate: (u) => {
      try {
        const f = AA(o, u);
        return f.success ? { value: f.data } : { issues: f.error?.issues };
      } catch {
        return gA(o, u).then((d) => d.success ? { value: d.data } : { issues: d.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), $i = /* @__PURE__ */ N("$ZodString", (o, r) => {
  ce.init(o, r), o._zod.pattern = [...o?._zod.bag?.patterns ?? []].pop() ?? VA(o._zod.bag), o._zod.parse = (n, a) => {
    if (r.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: o
    }), n;
  };
}), re = /* @__PURE__ */ N("$ZodStringFormat", (o, r) => {
  on.init(o, r), $i.init(o, r);
}), f0 = /* @__PURE__ */ N("$ZodGUID", (o, r) => {
  r.pattern ?? (r.pattern = BA), re.init(o, r);
}), m0 = /* @__PURE__ */ N("$ZodUUID", (o, r) => {
  if (r.version) {
    const a = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[r.version];
    if (a === void 0)
      throw new Error(`Invalid UUID version: "${r.version}"`);
    r.pattern ?? (r.pattern = ku(a));
  } else
    r.pattern ?? (r.pattern = ku());
  re.init(o, r);
}), h0 = /* @__PURE__ */ N("$ZodEmail", (o, r) => {
  r.pattern ?? (r.pattern = RA), re.init(o, r);
}), b0 = /* @__PURE__ */ N("$ZodURL", (o, r) => {
  re.init(o, r), o._zod.check = (n) => {
    try {
      const a = n.value.trim(), u = new URL(a);
      r.hostname && (r.hostname.lastIndex = 0, r.hostname.test(u.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: r.hostname.source,
        input: n.value,
        inst: o,
        continue: !r.abort
      })), r.protocol && (r.protocol.lastIndex = 0, r.protocol.test(u.protocol.endsWith(":") ? u.protocol.slice(0, -1) : u.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: r.protocol.source,
        input: n.value,
        inst: o,
        continue: !r.abort
      })), r.normalize ? n.value = u.href : n.value = a;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: o,
        continue: !r.abort
      });
    }
  };
}), _0 = /* @__PURE__ */ N("$ZodEmoji", (o, r) => {
  r.pattern ?? (r.pattern = zA()), re.init(o, r);
}), A0 = /* @__PURE__ */ N("$ZodNanoID", (o, r) => {
  r.pattern ?? (r.pattern = DA), re.init(o, r);
}), g0 = /* @__PURE__ */ N("$ZodCUID", (o, r) => {
  r.pattern ?? (r.pattern = vA), re.init(o, r);
}), y0 = /* @__PURE__ */ N("$ZodCUID2", (o, r) => {
  r.pattern ?? (r.pattern = wA), re.init(o, r);
}), T0 = /* @__PURE__ */ N("$ZodULID", (o, r) => {
  r.pattern ?? (r.pattern = EA), re.init(o, r);
}), M0 = /* @__PURE__ */ N("$ZodXID", (o, r) => {
  r.pattern ?? (r.pattern = CA), re.init(o, r);
}), N0 = /* @__PURE__ */ N("$ZodKSUID", (o, r) => {
  r.pattern ?? (r.pattern = kA), re.init(o, r);
}), F0 = /* @__PURE__ */ N("$ZodISODateTime", (o, r) => {
  r.pattern ?? (r.pattern = WA(r)), re.init(o, r);
}), I0 = /* @__PURE__ */ N("$ZodISODate", (o, r) => {
  r.pattern ?? (r.pattern = KA), re.init(o, r);
}), S0 = /* @__PURE__ */ N("$ZodISOTime", (o, r) => {
  r.pattern ?? (r.pattern = HA(r)), re.init(o, r);
}), x0 = /* @__PURE__ */ N("$ZodISODuration", (o, r) => {
  r.pattern ?? (r.pattern = LA), re.init(o, r);
}), v0 = /* @__PURE__ */ N("$ZodIPv4", (o, r) => {
  r.pattern ?? (r.pattern = OA), re.init(o, r), o._zod.bag.format = "ipv4";
}), w0 = /* @__PURE__ */ N("$ZodIPv6", (o, r) => {
  r.pattern ?? (r.pattern = GA), re.init(o, r), o._zod.bag.format = "ipv6", o._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: o,
        continue: !r.abort
      });
    }
  };
}), E0 = /* @__PURE__ */ N("$ZodCIDRv4", (o, r) => {
  r.pattern ?? (r.pattern = qA), re.init(o, r);
}), C0 = /* @__PURE__ */ N("$ZodCIDRv6", (o, r) => {
  r.pattern ?? (r.pattern = UA), re.init(o, r), o._zod.check = (n) => {
    const a = n.value.split("/");
    try {
      if (a.length !== 2)
        throw new Error();
      const [u, f] = a;
      if (!f)
        throw new Error();
      const d = Number(f);
      if (`${d}` !== f)
        throw new Error();
      if (d < 0 || d > 128)
        throw new Error();
      new URL(`http://[${u}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: o,
        continue: !r.abort
      });
    }
  };
});
function gl(o) {
  if (o === "")
    return !0;
  if (o.length % 4 !== 0)
    return !1;
  try {
    return atob(o), !0;
  } catch {
    return !1;
  }
}
const k0 = /* @__PURE__ */ N("$ZodBase64", (o, r) => {
  r.pattern ?? (r.pattern = ZA), re.init(o, r), o._zod.bag.contentEncoding = "base64", o._zod.check = (n) => {
    gl(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: o,
      continue: !r.abort
    });
  };
});
function D0(o) {
  if (!fl.test(o))
    return !1;
  const r = o.replace(/[-_]/g, (a) => a === "-" ? "+" : "/"), n = r.padEnd(Math.ceil(r.length / 4) * 4, "=");
  return gl(n);
}
const L0 = /* @__PURE__ */ N("$ZodBase64URL", (o, r) => {
  r.pattern ?? (r.pattern = fl), re.init(o, r), o._zod.bag.contentEncoding = "base64url", o._zod.check = (n) => {
    D0(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: o,
      continue: !r.abort
    });
  };
}), B0 = /* @__PURE__ */ N("$ZodE164", (o, r) => {
  r.pattern ?? (r.pattern = $A), re.init(o, r);
});
function R0(o, r = null) {
  try {
    const n = o.split(".");
    if (n.length !== 3)
      return !1;
    const [a] = n;
    if (!a)
      return !1;
    const u = JSON.parse(atob(a));
    return !("typ" in u && u?.typ !== "JWT" || !u.alg || r && (!("alg" in u) || u.alg !== r));
  } catch {
    return !1;
  }
}
const P0 = /* @__PURE__ */ N("$ZodJWT", (o, r) => {
  re.init(o, r), o._zod.check = (n) => {
    R0(n.value, r.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: o,
      continue: !r.abort
    });
  };
}), yl = /* @__PURE__ */ N("$ZodNumber", (o, r) => {
  ce.init(o, r), o._zod.pattern = o._zod.bag.pattern ?? JA, o._zod.parse = (n, a) => {
    if (r.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const u = n.value;
    if (typeof u == "number" && !Number.isNaN(u) && Number.isFinite(u))
      return n;
    const f = typeof u == "number" ? Number.isNaN(u) ? "NaN" : Number.isFinite(u) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: u,
      inst: o,
      ...f ? { received: f } : {}
    }), n;
  };
}), z0 = /* @__PURE__ */ N("$ZodNumberFormat", (o, r) => {
  e0.init(o, r), yl.init(o, r);
}), O0 = /* @__PURE__ */ N("$ZodUnknown", (o, r) => {
  ce.init(o, r), o._zod.parse = (n) => n;
}), G0 = /* @__PURE__ */ N("$ZodNever", (o, r) => {
  ce.init(o, r), o._zod.parse = (n, a) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: o
  }), n);
});
function Du(o, r, n) {
  o.issues.length && r.issues.push(...ll(n, o.issues)), r.value[n] = o.value;
}
const q0 = /* @__PURE__ */ N("$ZodArray", (o, r) => {
  ce.init(o, r), o._zod.parse = (n, a) => {
    const u = n.value;
    if (!Array.isArray(u))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: u,
        inst: o
      }), n;
    n.value = Array(u.length);
    const f = [];
    for (let d = 0; d < u.length; d++) {
      const b = u[d], T = r.element._zod.run({
        value: b,
        issues: []
      }, a);
      T instanceof Promise ? f.push(T.then((S) => Du(S, n, d))) : Du(T, n, d);
    }
    return f.length ? Promise.all(f).then(() => n) : n;
  };
});
function jr(o, r, n, a, u) {
  if (o.issues.length) {
    if (u && !(n in a))
      return;
    r.issues.push(...ll(n, o.issues));
  }
  o.value === void 0 ? n in a && (r.value[n] = void 0) : r.value[n] = o.value;
}
function Tl(o) {
  const r = Object.keys(o.shape);
  for (const a of r)
    if (!o.shape?.[a]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${a}": expected a Zod schema`);
  const n = sA(o.shape);
  return {
    ...o,
    keys: r,
    keySet: new Set(r),
    numKeys: r.length,
    optionalKeys: new Set(n)
  };
}
function Ml(o, r, n, a, u, f) {
  const d = [], b = u.keySet, T = u.catchall._zod, S = T.def.type, w = T.optout === "optional";
  for (const O in r) {
    if (b.has(O))
      continue;
    if (S === "never") {
      d.push(O);
      continue;
    }
    const k = T.run({ value: r[O], issues: [] }, a);
    k instanceof Promise ? o.push(k.then((P) => jr(P, n, O, r, w))) : jr(k, n, O, r, w);
  }
  return d.length && n.issues.push({
    code: "unrecognized_keys",
    keys: d,
    input: r,
    inst: f
  }), o.length ? Promise.all(o).then(() => n) : n;
}
const U0 = /* @__PURE__ */ N("$ZodObject", (o, r) => {
  if (ce.init(o, r), !Object.getOwnPropertyDescriptor(r, "shape")?.get) {
    const b = r.shape;
    Object.defineProperty(r, "shape", {
      get: () => {
        const T = { ...b };
        return Object.defineProperty(r, "shape", {
          value: T
        }), T;
      }
    });
  }
  const a = zi(() => Tl(r));
  J(o._zod, "propValues", () => {
    const b = r.shape, T = {};
    for (const S in b) {
      const w = b[S]._zod;
      if (w.values) {
        T[S] ?? (T[S] = /* @__PURE__ */ new Set());
        for (const O of w.values)
          T[S].add(O);
      }
    }
    return T;
  });
  const u = Vr, f = r.catchall;
  let d;
  o._zod.parse = (b, T) => {
    d ?? (d = a.value);
    const S = b.value;
    if (!u(S))
      return b.issues.push({
        expected: "object",
        code: "invalid_type",
        input: S,
        inst: o
      }), b;
    b.value = {};
    const w = [], O = d.shape;
    for (const k of d.keys) {
      const P = O[k], ae = P._zod.optout === "optional", ee = P._zod.run({ value: S[k], issues: [] }, T);
      ee instanceof Promise ? w.push(ee.then((po) => jr(po, b, k, S, ae))) : jr(ee, b, k, S, ae);
    }
    return f ? Ml(w, S, b, T, a.value, o) : w.length ? Promise.all(w).then(() => b) : b;
  };
}), Z0 = /* @__PURE__ */ N("$ZodObjectJIT", (o, r) => {
  U0.init(o, r);
  const n = o._zod.parse, a = zi(() => Tl(r)), u = (k) => {
    const P = new d0(["shape", "payload", "ctx"]), ae = a.value, ee = (ke) => {
      const oe = Cu(ke);
      return `shape[${oe}]._zod.run({ value: input[${oe}], issues: [] }, ctx)`;
    };
    P.write("const input = payload.value;");
    const po = /* @__PURE__ */ Object.create(null);
    let Ce = 0;
    for (const ke of ae.keys)
      po[ke] = `key_${Ce++}`;
    P.write("const newResult = {};");
    for (const ke of ae.keys) {
      const oe = po[ke], he = Cu(ke), Ro = k[ke]?._zod?.optout === "optional";
      P.write(`const ${oe} = ${ee(ke)};`), Ro ? P.write(`
        if (${oe}.issues.length) {
          if (${he} in input) {
            payload.issues = payload.issues.concat(${oe}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${he}, ...iss.path] : [${he}]
            })));
          }
        }
        
        if (${oe}.value === undefined) {
          if (${he} in input) {
            newResult[${he}] = undefined;
          }
        } else {
          newResult[${he}] = ${oe}.value;
        }
        
      `) : P.write(`
        if (${oe}.issues.length) {
          payload.issues = payload.issues.concat(${oe}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${he}, ...iss.path] : [${he}]
          })));
        }
        
        if (${oe}.value === undefined) {
          if (${he} in input) {
            newResult[${he}] = undefined;
          }
        } else {
          newResult[${he}] = ${oe}.value;
        }
        
      `);
    }
    P.write("payload.value = newResult;"), P.write("return payload;");
    const No = P.compile();
    return (ke, oe) => No(k, ke, oe);
  };
  let f;
  const d = Vr, b = !il.jitless, S = b && iA.value, w = r.catchall;
  let O;
  o._zod.parse = (k, P) => {
    O ?? (O = a.value);
    const ae = k.value;
    return d(ae) ? b && S && P?.async === !1 && P.jitless !== !0 ? (f || (f = u(r.shape)), k = f(k, P), w ? Ml([], ae, k, P, O, o) : k) : n(k, P) : (k.issues.push({
      expected: "object",
      code: "invalid_type",
      input: ae,
      inst: o
    }), k);
  };
});
function Lu(o, r, n, a) {
  for (const f of o)
    if (f.issues.length === 0)
      return r.value = f.value, r;
  const u = o.filter((f) => !mt(f));
  return u.length === 1 ? (r.value = u[0].value, u[0]) : (r.issues.push({
    code: "invalid_union",
    input: r.value,
    inst: n,
    errors: o.map((f) => f.issues.map((d) => Jo(d, a, jo())))
  }), r);
}
const $0 = /* @__PURE__ */ N("$ZodUnion", (o, r) => {
  ce.init(o, r), J(o._zod, "optin", () => r.options.some((u) => u._zod.optin === "optional") ? "optional" : void 0), J(o._zod, "optout", () => r.options.some((u) => u._zod.optout === "optional") ? "optional" : void 0), J(o._zod, "values", () => {
    if (r.options.every((u) => u._zod.values))
      return new Set(r.options.flatMap((u) => Array.from(u._zod.values)));
  }), J(o._zod, "pattern", () => {
    if (r.options.every((u) => u._zod.pattern)) {
      const u = r.options.map((f) => f._zod.pattern);
      return new RegExp(`^(${u.map((f) => Gi(f.source)).join("|")})$`);
    }
  });
  const n = r.options.length === 1, a = r.options[0]._zod.run;
  o._zod.parse = (u, f) => {
    if (n)
      return a(u, f);
    let d = !1;
    const b = [];
    for (const T of r.options) {
      const S = T._zod.run({
        value: u.value,
        issues: []
      }, f);
      if (S instanceof Promise)
        b.push(S), d = !0;
      else {
        if (S.issues.length === 0)
          return S;
        b.push(S);
      }
    }
    return d ? Promise.all(b).then((T) => Lu(T, u, o, f)) : Lu(b, u, o, f);
  };
}), K0 = /* @__PURE__ */ N("$ZodIntersection", (o, r) => {
  ce.init(o, r), o._zod.parse = (n, a) => {
    const u = n.value, f = r.left._zod.run({ value: u, issues: [] }, a), d = r.right._zod.run({ value: u, issues: [] }, a);
    return f instanceof Promise || d instanceof Promise ? Promise.all([f, d]).then(([T, S]) => Bu(n, T, S)) : Bu(n, f, d);
  };
});
function Ci(o, r) {
  if (o === r)
    return { valid: !0, data: o };
  if (o instanceof Date && r instanceof Date && +o == +r)
    return { valid: !0, data: o };
  if (jt(o) && jt(r)) {
    const n = Object.keys(r), a = Object.keys(o).filter((f) => n.indexOf(f) !== -1), u = { ...o, ...r };
    for (const f of a) {
      const d = Ci(o[f], r[f]);
      if (!d.valid)
        return {
          valid: !1,
          mergeErrorPath: [f, ...d.mergeErrorPath]
        };
      u[f] = d.data;
    }
    return { valid: !0, data: u };
  }
  if (Array.isArray(o) && Array.isArray(r)) {
    if (o.length !== r.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let a = 0; a < o.length; a++) {
      const u = o[a], f = r[a], d = Ci(u, f);
      if (!d.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...d.mergeErrorPath]
        };
      n.push(d.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Bu(o, r, n) {
  const a = /* @__PURE__ */ new Map();
  let u;
  for (const b of r.issues)
    if (b.code === "unrecognized_keys") {
      u ?? (u = b);
      for (const T of b.keys)
        a.has(T) || a.set(T, {}), a.get(T).l = !0;
    } else
      o.issues.push(b);
  for (const b of n.issues)
    if (b.code === "unrecognized_keys")
      for (const T of b.keys)
        a.has(T) || a.set(T, {}), a.get(T).r = !0;
    else
      o.issues.push(b);
  const f = [...a].filter(([, b]) => b.l && b.r).map(([b]) => b);
  if (f.length && u && o.issues.push({ ...u, keys: f }), mt(o))
    return o;
  const d = Ci(r.value, n.value);
  if (!d.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(d.mergeErrorPath)}`);
  return o.value = d.data, o;
}
const H0 = /* @__PURE__ */ N("$ZodEnum", (o, r) => {
  ce.init(o, r);
  const n = al(r.entries), a = new Set(n);
  o._zod.values = a, o._zod.pattern = new RegExp(`^(${n.filter((u) => aA.has(typeof u)).map((u) => typeof u == "string" ? _t(u) : u.toString()).join("|")})$`), o._zod.parse = (u, f) => {
    const d = u.value;
    return a.has(d) || u.issues.push({
      code: "invalid_value",
      values: n,
      input: d,
      inst: o
    }), u;
  };
}), W0 = /* @__PURE__ */ N("$ZodLiteral", (o, r) => {
  if (ce.init(o, r), r.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const n = new Set(r.values);
  o._zod.values = n, o._zod.pattern = new RegExp(`^(${r.values.map((a) => typeof a == "string" ? _t(a) : a ? _t(a.toString()) : String(a)).join("|")})$`), o._zod.parse = (a, u) => {
    const f = a.value;
    return n.has(f) || a.issues.push({
      code: "invalid_value",
      values: r.values,
      input: f,
      inst: o
    }), a;
  };
}), V0 = /* @__PURE__ */ N("$ZodTransform", (o, r) => {
  ce.init(o, r), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      throw new nl(o.constructor.name);
    const u = r.transform(n.value, n);
    if (a.async)
      return (u instanceof Promise ? u : Promise.resolve(u)).then((d) => (n.value = d, n));
    if (u instanceof Promise)
      throw new bt();
    return n.value = u, n;
  };
});
function Ru(o, r) {
  return o.issues.length && r === void 0 ? { issues: [], value: void 0 } : o;
}
const Nl = /* @__PURE__ */ N("$ZodOptional", (o, r) => {
  ce.init(o, r), o._zod.optin = "optional", o._zod.optout = "optional", J(o._zod, "values", () => r.innerType._zod.values ? /* @__PURE__ */ new Set([...r.innerType._zod.values, void 0]) : void 0), J(o._zod, "pattern", () => {
    const n = r.innerType._zod.pattern;
    return n ? new RegExp(`^(${Gi(n.source)})?$`) : void 0;
  }), o._zod.parse = (n, a) => {
    if (r.innerType._zod.optin === "optional") {
      const u = r.innerType._zod.run(n, a);
      return u instanceof Promise ? u.then((f) => Ru(f, n.value)) : Ru(u, n.value);
    }
    return n.value === void 0 ? n : r.innerType._zod.run(n, a);
  };
}), j0 = /* @__PURE__ */ N("$ZodExactOptional", (o, r) => {
  Nl.init(o, r), J(o._zod, "values", () => r.innerType._zod.values), J(o._zod, "pattern", () => r.innerType._zod.pattern), o._zod.parse = (n, a) => r.innerType._zod.run(n, a);
}), J0 = /* @__PURE__ */ N("$ZodNullable", (o, r) => {
  ce.init(o, r), J(o._zod, "optin", () => r.innerType._zod.optin), J(o._zod, "optout", () => r.innerType._zod.optout), J(o._zod, "pattern", () => {
    const n = r.innerType._zod.pattern;
    return n ? new RegExp(`^(${Gi(n.source)}|null)$`) : void 0;
  }), J(o._zod, "values", () => r.innerType._zod.values ? /* @__PURE__ */ new Set([...r.innerType._zod.values, null]) : void 0), o._zod.parse = (n, a) => n.value === null ? n : r.innerType._zod.run(n, a);
}), Y0 = /* @__PURE__ */ N("$ZodDefault", (o, r) => {
  ce.init(o, r), o._zod.optin = "optional", J(o._zod, "values", () => r.innerType._zod.values), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      return r.innerType._zod.run(n, a);
    if (n.value === void 0)
      return n.value = r.defaultValue, n;
    const u = r.innerType._zod.run(n, a);
    return u instanceof Promise ? u.then((f) => Pu(f, r)) : Pu(u, r);
  };
});
function Pu(o, r) {
  return o.value === void 0 && (o.value = r.defaultValue), o;
}
const X0 = /* @__PURE__ */ N("$ZodPrefault", (o, r) => {
  ce.init(o, r), o._zod.optin = "optional", J(o._zod, "values", () => r.innerType._zod.values), o._zod.parse = (n, a) => (a.direction === "backward" || n.value === void 0 && (n.value = r.defaultValue), r.innerType._zod.run(n, a));
}), Q0 = /* @__PURE__ */ N("$ZodNonOptional", (o, r) => {
  ce.init(o, r), J(o._zod, "values", () => {
    const n = r.innerType._zod.values;
    return n ? new Set([...n].filter((a) => a !== void 0)) : void 0;
  }), o._zod.parse = (n, a) => {
    const u = r.innerType._zod.run(n, a);
    return u instanceof Promise ? u.then((f) => zu(f, o)) : zu(u, o);
  };
});
function zu(o, r) {
  return !o.issues.length && o.value === void 0 && o.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: o.value,
    inst: r
  }), o;
}
const eg = /* @__PURE__ */ N("$ZodCatch", (o, r) => {
  ce.init(o, r), J(o._zod, "optin", () => r.innerType._zod.optin), J(o._zod, "optout", () => r.innerType._zod.optout), J(o._zod, "values", () => r.innerType._zod.values), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      return r.innerType._zod.run(n, a);
    const u = r.innerType._zod.run(n, a);
    return u instanceof Promise ? u.then((f) => (n.value = f.value, f.issues.length && (n.value = r.catchValue({
      ...n,
      error: {
        issues: f.issues.map((d) => Jo(d, a, jo()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = u.value, u.issues.length && (n.value = r.catchValue({
      ...n,
      error: {
        issues: u.issues.map((f) => Jo(f, a, jo()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), og = /* @__PURE__ */ N("$ZodPipe", (o, r) => {
  ce.init(o, r), J(o._zod, "values", () => r.in._zod.values), J(o._zod, "optin", () => r.in._zod.optin), J(o._zod, "optout", () => r.out._zod.optout), J(o._zod, "propValues", () => r.in._zod.propValues), o._zod.parse = (n, a) => {
    if (a.direction === "backward") {
      const f = r.out._zod.run(n, a);
      return f instanceof Promise ? f.then((d) => Kr(d, r.in, a)) : Kr(f, r.in, a);
    }
    const u = r.in._zod.run(n, a);
    return u instanceof Promise ? u.then((f) => Kr(f, r.out, a)) : Kr(u, r.out, a);
  };
});
function Kr(o, r, n) {
  return o.issues.length ? (o.aborted = !0, o) : r._zod.run({ value: o.value, issues: o.issues }, n);
}
const tg = /* @__PURE__ */ N("$ZodReadonly", (o, r) => {
  ce.init(o, r), J(o._zod, "propValues", () => r.innerType._zod.propValues), J(o._zod, "values", () => r.innerType._zod.values), J(o._zod, "optin", () => r.innerType?._zod?.optin), J(o._zod, "optout", () => r.innerType?._zod?.optout), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      return r.innerType._zod.run(n, a);
    const u = r.innerType._zod.run(n, a);
    return u instanceof Promise ? u.then(Ou) : Ou(u);
  };
});
function Ou(o) {
  return o.value = Object.freeze(o.value), o;
}
const rg = /* @__PURE__ */ N("$ZodCustom", (o, r) => {
  Ee.init(o, r), ce.init(o, r), o._zod.parse = (n, a) => n, o._zod.check = (n) => {
    const a = n.value, u = r.fn(a);
    if (u instanceof Promise)
      return u.then((f) => Gu(f, n, a, o));
    Gu(u, n, a, o);
  };
});
function Gu(o, r, n, a) {
  if (!o) {
    const u = {
      code: "custom",
      input: n,
      inst: a,
      // incorporates params.error into issue reporting
      path: [...a._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !a._zod.def.abort
      // params: inst._zod.def.params,
    };
    a._zod.def.params && (u.params = a._zod.def.params), r.issues.push(Jt(u));
  }
}
var qu;
class ng {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(r, ...n) {
    const a = n[0];
    return this._map.set(r, a), a && typeof a == "object" && "id" in a && this._idmap.set(a.id, r), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(r) {
    const n = this._map.get(r);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(r), this;
  }
  get(r) {
    const n = r._zod.parent;
    if (n) {
      const a = { ...this.get(n) ?? {} };
      delete a.id;
      const u = { ...a, ...this._map.get(r) };
      return Object.keys(u).length ? u : void 0;
    }
    return this._map.get(r);
  }
  has(r) {
    return this._map.has(r);
  }
}
function ig() {
  return new ng();
}
(qu = globalThis).__zod_globalRegistry ?? (qu.__zod_globalRegistry = ig());
const Kt = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function ag(o, r) {
  return new o({
    type: "string",
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function sg(o, r) {
  return new o({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Uu(o, r) {
  return new o({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Fl(o, r) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function ug(o, r) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function lg(o, r) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function cg(o, r) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function dg(o, r) {
  return new o({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function pg(o, r) {
  return new o({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function fg(o, r) {
  return new o({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function mg(o, r) {
  return new o({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function hg(o, r) {
  return new o({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function bg(o, r) {
  return new o({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function _g(o, r) {
  return new o({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Ag(o, r) {
  return new o({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function gg(o, r) {
  return new o({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function yg(o, r) {
  return new o({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Tg(o, r) {
  return new o({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Mg(o, r) {
  return new o({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Ng(o, r) {
  return new o({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Fg(o, r) {
  return new o({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Ig(o, r) {
  return new o({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Sg(o, r) {
  return new o({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function xg(o, r) {
  return new o({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function vg(o, r) {
  return new o({
    type: "string",
    format: "date",
    check: "string_format",
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function wg(o, r) {
  return new o({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Eg(o, r) {
  return new o({
    type: "string",
    format: "duration",
    check: "string_format",
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Cg(o, r) {
  return new o({
    type: "number",
    checks: [],
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function kg(o, r) {
  return new o({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Dg(o) {
  return new o({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function Lg(o, r) {
  return new o({
    type: "never",
    ...D(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Zu(o, r) {
  return new _l({
    check: "less_than",
    ...D(r),
    value: o,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function vi(o, r) {
  return new _l({
    check: "less_than",
    ...D(r),
    value: o,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function $u(o, r) {
  return new Al({
    check: "greater_than",
    ...D(r),
    value: o,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function wi(o, r) {
  return new Al({
    check: "greater_than",
    ...D(r),
    value: o,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Ku(o, r) {
  return new QA({
    check: "multiple_of",
    ...D(r),
    value: o
  });
}
// @__NO_SIDE_EFFECTS__
function Il(o, r) {
  return new o0({
    check: "max_length",
    ...D(r),
    maximum: o
  });
}
// @__NO_SIDE_EFFECTS__
function Jr(o, r) {
  return new t0({
    check: "min_length",
    ...D(r),
    minimum: o
  });
}
// @__NO_SIDE_EFFECTS__
function Sl(o, r) {
  return new r0({
    check: "length_equals",
    ...D(r),
    length: o
  });
}
// @__NO_SIDE_EFFECTS__
function Bg(o, r) {
  return new n0({
    check: "string_format",
    format: "regex",
    ...D(r),
    pattern: o
  });
}
// @__NO_SIDE_EFFECTS__
function Rg(o) {
  return new i0({
    check: "string_format",
    format: "lowercase",
    ...D(o)
  });
}
// @__NO_SIDE_EFFECTS__
function Pg(o) {
  return new a0({
    check: "string_format",
    format: "uppercase",
    ...D(o)
  });
}
// @__NO_SIDE_EFFECTS__
function zg(o, r) {
  return new s0({
    check: "string_format",
    format: "includes",
    ...D(r),
    includes: o
  });
}
// @__NO_SIDE_EFFECTS__
function Og(o, r) {
  return new u0({
    check: "string_format",
    format: "starts_with",
    ...D(r),
    prefix: o
  });
}
// @__NO_SIDE_EFFECTS__
function Gg(o, r) {
  return new l0({
    check: "string_format",
    format: "ends_with",
    ...D(r),
    suffix: o
  });
}
// @__NO_SIDE_EFFECTS__
function yt(o) {
  return new c0({
    check: "overwrite",
    tx: o
  });
}
// @__NO_SIDE_EFFECTS__
function qg(o) {
  return /* @__PURE__ */ yt((r) => r.normalize(o));
}
// @__NO_SIDE_EFFECTS__
function Ug() {
  return /* @__PURE__ */ yt((o) => o.trim());
}
// @__NO_SIDE_EFFECTS__
function Zg() {
  return /* @__PURE__ */ yt((o) => o.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function $g() {
  return /* @__PURE__ */ yt((o) => o.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Kg() {
  return /* @__PURE__ */ yt((o) => nA(o));
}
// @__NO_SIDE_EFFECTS__
function Hg(o, r, n) {
  return new o({
    type: "array",
    element: r,
    // get element() {
    //   return element;
    // },
    ...D(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Wg(o, r, n) {
  return new o({
    type: "custom",
    check: "custom",
    fn: r,
    ...D(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Vg(o) {
  const r = /* @__PURE__ */ jg((n) => (n.addIssue = (a) => {
    if (typeof a == "string")
      n.issues.push(Jt(a, n.value, r._zod.def));
    else {
      const u = a;
      u.fatal && (u.continue = !1), u.code ?? (u.code = "custom"), u.input ?? (u.input = n.value), u.inst ?? (u.inst = r), u.continue ?? (u.continue = !r._zod.def.abort), n.issues.push(Jt(u));
    }
  }, o(n.value, n)));
  return r;
}
// @__NO_SIDE_EFFECTS__
function jg(o, r) {
  const n = new Ee({
    check: "custom",
    ...D(r)
  });
  return n._zod.check = o, n;
}
function xl(o) {
  let r = o?.target ?? "draft-2020-12";
  return r === "draft-4" && (r = "draft-04"), r === "draft-7" && (r = "draft-07"), {
    processors: o.processors ?? {},
    metadataRegistry: o?.metadata ?? Kt,
    target: r,
    unrepresentable: o?.unrepresentable ?? "throw",
    override: o?.override ?? (() => {
    }),
    io: o?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: o?.cycles ?? "ref",
    reused: o?.reused ?? "inline",
    external: o?.external ?? void 0
  };
}
function ge(o, r, n = { path: [], schemaPath: [] }) {
  var a;
  const u = o._zod.def, f = r.seen.get(o);
  if (f)
    return f.count++, n.schemaPath.includes(o) && (f.cycle = n.path), f.schema;
  const d = { schema: {}, count: 1, cycle: void 0, path: n.path };
  r.seen.set(o, d);
  const b = o._zod.toJSONSchema?.();
  if (b)
    d.schema = b;
  else {
    const w = {
      ...n,
      schemaPath: [...n.schemaPath, o],
      path: n.path
    };
    if (o._zod.processJSONSchema)
      o._zod.processJSONSchema(r, d.schema, w);
    else {
      const k = d.schema, P = r.processors[u.type];
      if (!P)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${u.type}`);
      P(o, r, k, w);
    }
    const O = o._zod.parent;
    O && (d.ref || (d.ref = O), ge(O, r, w), r.seen.get(O).isParent = !0);
  }
  const T = r.metadataRegistry.get(o);
  return T && Object.assign(d.schema, T), r.io === "input" && Ie(o) && (delete d.schema.examples, delete d.schema.default), r.io === "input" && d.schema._prefault && ((a = d.schema).default ?? (a.default = d.schema._prefault)), delete d.schema._prefault, r.seen.get(o).schema;
}
function vl(o, r) {
  const n = o.seen.get(r);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = /* @__PURE__ */ new Map();
  for (const d of o.seen.entries()) {
    const b = o.metadataRegistry.get(d[0])?.id;
    if (b) {
      const T = a.get(b);
      if (T && T !== d[0])
        throw new Error(`Duplicate schema id "${b}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      a.set(b, d[0]);
    }
  }
  const u = (d) => {
    const b = o.target === "draft-2020-12" ? "$defs" : "definitions";
    if (o.external) {
      const O = o.external.registry.get(d[0])?.id, k = o.external.uri ?? ((ae) => ae);
      if (O)
        return { ref: k(O) };
      const P = d[1].defId ?? d[1].schema.id ?? `schema${o.counter++}`;
      return d[1].defId = P, { defId: P, ref: `${k("__shared")}#/${b}/${P}` };
    }
    if (d[1] === n)
      return { ref: "#" };
    const S = `#/${b}/`, w = d[1].schema.id ?? `__schema${o.counter++}`;
    return { defId: w, ref: S + w };
  }, f = (d) => {
    if (d[1].schema.$ref)
      return;
    const b = d[1], { ref: T, defId: S } = u(d);
    b.def = { ...b.schema }, S && (b.defId = S);
    const w = b.schema;
    for (const O in w)
      delete w[O];
    w.$ref = T;
  };
  if (o.cycles === "throw")
    for (const d of o.seen.entries()) {
      const b = d[1];
      if (b.cycle)
        throw new Error(`Cycle detected: #/${b.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const d of o.seen.entries()) {
    const b = d[1];
    if (r === d[0]) {
      f(d);
      continue;
    }
    if (o.external) {
      const S = o.external.registry.get(d[0])?.id;
      if (r !== d[0] && S) {
        f(d);
        continue;
      }
    }
    if (o.metadataRegistry.get(d[0])?.id) {
      f(d);
      continue;
    }
    if (b.cycle) {
      f(d);
      continue;
    }
    if (b.count > 1 && o.reused === "ref") {
      f(d);
      continue;
    }
  }
}
function wl(o, r) {
  const n = o.seen.get(r);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (d) => {
    const b = o.seen.get(d);
    if (b.ref === null)
      return;
    const T = b.def ?? b.schema, S = { ...T }, w = b.ref;
    if (b.ref = null, w) {
      a(w);
      const k = o.seen.get(w), P = k.schema;
      if (P.$ref && (o.target === "draft-07" || o.target === "draft-04" || o.target === "openapi-3.0") ? (T.allOf = T.allOf ?? [], T.allOf.push(P)) : Object.assign(T, P), Object.assign(T, S), d._zod.parent === w)
        for (const ee in T)
          ee === "$ref" || ee === "allOf" || ee in S || delete T[ee];
      if (P.$ref && k.def)
        for (const ee in T)
          ee === "$ref" || ee === "allOf" || ee in k.def && JSON.stringify(T[ee]) === JSON.stringify(k.def[ee]) && delete T[ee];
    }
    const O = d._zod.parent;
    if (O && O !== w) {
      a(O);
      const k = o.seen.get(O);
      if (k?.schema.$ref && (T.$ref = k.schema.$ref, k.def))
        for (const P in T)
          P === "$ref" || P === "allOf" || P in k.def && JSON.stringify(T[P]) === JSON.stringify(k.def[P]) && delete T[P];
    }
    o.override({
      zodSchema: d,
      jsonSchema: T,
      path: b.path ?? []
    });
  };
  for (const d of [...o.seen.entries()].reverse())
    a(d[0]);
  const u = {};
  if (o.target === "draft-2020-12" ? u.$schema = "https://json-schema.org/draft/2020-12/schema" : o.target === "draft-07" ? u.$schema = "http://json-schema.org/draft-07/schema#" : o.target === "draft-04" ? u.$schema = "http://json-schema.org/draft-04/schema#" : o.target, o.external?.uri) {
    const d = o.external.registry.get(r)?.id;
    if (!d)
      throw new Error("Schema is missing an `id` property");
    u.$id = o.external.uri(d);
  }
  Object.assign(u, n.def ?? n.schema);
  const f = o.external?.defs ?? {};
  for (const d of o.seen.entries()) {
    const b = d[1];
    b.def && b.defId && (f[b.defId] = b.def);
  }
  o.external || Object.keys(f).length > 0 && (o.target === "draft-2020-12" ? u.$defs = f : u.definitions = f);
  try {
    const d = JSON.parse(JSON.stringify(u));
    return Object.defineProperty(d, "~standard", {
      value: {
        ...r["~standard"],
        jsonSchema: {
          input: Yr(r, "input", o.processors),
          output: Yr(r, "output", o.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), d;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Ie(o, r) {
  const n = r ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(o))
    return !1;
  n.seen.add(o);
  const a = o._zod.def;
  if (a.type === "transform")
    return !0;
  if (a.type === "array")
    return Ie(a.element, n);
  if (a.type === "set")
    return Ie(a.valueType, n);
  if (a.type === "lazy")
    return Ie(a.getter(), n);
  if (a.type === "promise" || a.type === "optional" || a.type === "nonoptional" || a.type === "nullable" || a.type === "readonly" || a.type === "default" || a.type === "prefault")
    return Ie(a.innerType, n);
  if (a.type === "intersection")
    return Ie(a.left, n) || Ie(a.right, n);
  if (a.type === "record" || a.type === "map")
    return Ie(a.keyType, n) || Ie(a.valueType, n);
  if (a.type === "pipe")
    return Ie(a.in, n) || Ie(a.out, n);
  if (a.type === "object") {
    for (const u in a.shape)
      if (Ie(a.shape[u], n))
        return !0;
    return !1;
  }
  if (a.type === "union") {
    for (const u of a.options)
      if (Ie(u, n))
        return !0;
    return !1;
  }
  if (a.type === "tuple") {
    for (const u of a.items)
      if (Ie(u, n))
        return !0;
    return !!(a.rest && Ie(a.rest, n));
  }
  return !1;
}
const Jg = (o, r = {}) => (n) => {
  const a = xl({ ...n, processors: r });
  return ge(o, a), vl(a, o), wl(a, o);
}, Yr = (o, r, n = {}) => (a) => {
  const { libraryOptions: u, target: f } = a ?? {}, d = xl({ ...u ?? {}, target: f, io: r, processors: n });
  return ge(o, d), vl(d, o), wl(d, o);
}, Yg = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Xg = (o, r, n, a) => {
  const u = n;
  u.type = "string";
  const { minimum: f, maximum: d, format: b, patterns: T, contentEncoding: S } = o._zod.bag;
  if (typeof f == "number" && (u.minLength = f), typeof d == "number" && (u.maxLength = d), b && (u.format = Yg[b] ?? b, u.format === "" && delete u.format, b === "time" && delete u.format), S && (u.contentEncoding = S), T && T.size > 0) {
    const w = [...T];
    w.length === 1 ? u.pattern = w[0].source : w.length > 1 && (u.allOf = [
      ...w.map((O) => ({
        ...r.target === "draft-07" || r.target === "draft-04" || r.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: O.source
      }))
    ]);
  }
}, Qg = (o, r, n, a) => {
  const u = n, { minimum: f, maximum: d, format: b, multipleOf: T, exclusiveMaximum: S, exclusiveMinimum: w } = o._zod.bag;
  typeof b == "string" && b.includes("int") ? u.type = "integer" : u.type = "number", typeof w == "number" && (r.target === "draft-04" || r.target === "openapi-3.0" ? (u.minimum = w, u.exclusiveMinimum = !0) : u.exclusiveMinimum = w), typeof f == "number" && (u.minimum = f, typeof w == "number" && r.target !== "draft-04" && (w >= f ? delete u.minimum : delete u.exclusiveMinimum)), typeof S == "number" && (r.target === "draft-04" || r.target === "openapi-3.0" ? (u.maximum = S, u.exclusiveMaximum = !0) : u.exclusiveMaximum = S), typeof d == "number" && (u.maximum = d, typeof S == "number" && r.target !== "draft-04" && (S <= d ? delete u.maximum : delete u.exclusiveMaximum)), typeof T == "number" && (u.multipleOf = T);
}, e1 = (o, r, n, a) => {
  n.not = {};
}, o1 = (o, r, n, a) => {
}, t1 = (o, r, n, a) => {
  const u = o._zod.def, f = al(u.entries);
  f.every((d) => typeof d == "number") && (n.type = "number"), f.every((d) => typeof d == "string") && (n.type = "string"), n.enum = f;
}, r1 = (o, r, n, a) => {
  const u = o._zod.def, f = [];
  for (const d of u.values)
    if (d === void 0) {
      if (r.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof d == "bigint") {
      if (r.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      f.push(Number(d));
    } else
      f.push(d);
  if (f.length !== 0) if (f.length === 1) {
    const d = f[0];
    n.type = d === null ? "null" : typeof d, r.target === "draft-04" || r.target === "openapi-3.0" ? n.enum = [d] : n.const = d;
  } else
    f.every((d) => typeof d == "number") && (n.type = "number"), f.every((d) => typeof d == "string") && (n.type = "string"), f.every((d) => typeof d == "boolean") && (n.type = "boolean"), f.every((d) => d === null) && (n.type = "null"), n.enum = f;
}, n1 = (o, r, n, a) => {
  if (r.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, i1 = (o, r, n, a) => {
  if (r.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, a1 = (o, r, n, a) => {
  const u = n, f = o._zod.def, { minimum: d, maximum: b } = o._zod.bag;
  typeof d == "number" && (u.minItems = d), typeof b == "number" && (u.maxItems = b), u.type = "array", u.items = ge(f.element, r, { ...a, path: [...a.path, "items"] });
}, s1 = (o, r, n, a) => {
  const u = n, f = o._zod.def;
  u.type = "object", u.properties = {};
  const d = f.shape;
  for (const S in d)
    u.properties[S] = ge(d[S], r, {
      ...a,
      path: [...a.path, "properties", S]
    });
  const b = new Set(Object.keys(d)), T = new Set([...b].filter((S) => {
    const w = f.shape[S]._zod;
    return r.io === "input" ? w.optin === void 0 : w.optout === void 0;
  }));
  T.size > 0 && (u.required = Array.from(T)), f.catchall?._zod.def.type === "never" ? u.additionalProperties = !1 : f.catchall ? f.catchall && (u.additionalProperties = ge(f.catchall, r, {
    ...a,
    path: [...a.path, "additionalProperties"]
  })) : r.io === "output" && (u.additionalProperties = !1);
}, u1 = (o, r, n, a) => {
  const u = o._zod.def, f = u.inclusive === !1, d = u.options.map((b, T) => ge(b, r, {
    ...a,
    path: [...a.path, f ? "oneOf" : "anyOf", T]
  }));
  f ? n.oneOf = d : n.anyOf = d;
}, l1 = (o, r, n, a) => {
  const u = o._zod.def, f = ge(u.left, r, {
    ...a,
    path: [...a.path, "allOf", 0]
  }), d = ge(u.right, r, {
    ...a,
    path: [...a.path, "allOf", 1]
  }), b = (S) => "allOf" in S && Object.keys(S).length === 1, T = [
    ...b(f) ? f.allOf : [f],
    ...b(d) ? d.allOf : [d]
  ];
  n.allOf = T;
}, c1 = (o, r, n, a) => {
  const u = o._zod.def, f = ge(u.innerType, r, a), d = r.seen.get(o);
  r.target === "openapi-3.0" ? (d.ref = u.innerType, n.nullable = !0) : n.anyOf = [f, { type: "null" }];
}, d1 = (o, r, n, a) => {
  const u = o._zod.def;
  ge(u.innerType, r, a);
  const f = r.seen.get(o);
  f.ref = u.innerType;
}, p1 = (o, r, n, a) => {
  const u = o._zod.def;
  ge(u.innerType, r, a);
  const f = r.seen.get(o);
  f.ref = u.innerType, n.default = JSON.parse(JSON.stringify(u.defaultValue));
}, f1 = (o, r, n, a) => {
  const u = o._zod.def;
  ge(u.innerType, r, a);
  const f = r.seen.get(o);
  f.ref = u.innerType, r.io === "input" && (n._prefault = JSON.parse(JSON.stringify(u.defaultValue)));
}, m1 = (o, r, n, a) => {
  const u = o._zod.def;
  ge(u.innerType, r, a);
  const f = r.seen.get(o);
  f.ref = u.innerType;
  let d;
  try {
    d = u.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = d;
}, h1 = (o, r, n, a) => {
  const u = o._zod.def, f = r.io === "input" ? u.in._zod.def.type === "transform" ? u.out : u.in : u.out;
  ge(f, r, a);
  const d = r.seen.get(o);
  d.ref = f;
}, b1 = (o, r, n, a) => {
  const u = o._zod.def;
  ge(u.innerType, r, a);
  const f = r.seen.get(o);
  f.ref = u.innerType, n.readOnly = !0;
}, El = (o, r, n, a) => {
  const u = o._zod.def;
  ge(u.innerType, r, a);
  const f = r.seen.get(o);
  f.ref = u.innerType;
}, _1 = /* @__PURE__ */ N("ZodISODateTime", (o, r) => {
  F0.init(o, r), ie.init(o, r);
});
function A1(o) {
  return /* @__PURE__ */ xg(_1, o);
}
const g1 = /* @__PURE__ */ N("ZodISODate", (o, r) => {
  I0.init(o, r), ie.init(o, r);
});
function y1(o) {
  return /* @__PURE__ */ vg(g1, o);
}
const T1 = /* @__PURE__ */ N("ZodISOTime", (o, r) => {
  S0.init(o, r), ie.init(o, r);
});
function M1(o) {
  return /* @__PURE__ */ wg(T1, o);
}
const N1 = /* @__PURE__ */ N("ZodISODuration", (o, r) => {
  x0.init(o, r), ie.init(o, r);
});
function F1(o) {
  return /* @__PURE__ */ Eg(N1, o);
}
const I1 = (o, r) => {
  dl.init(o, r), o.name = "ZodError", Object.defineProperties(o, {
    format: {
      value: (n) => _A(o, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => bA(o, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        o.issues.push(n), o.message = JSON.stringify(o.issues, Ei, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        o.issues.push(...n), o.message = JSON.stringify(o.issues, Ei, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return o.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, We = N("ZodError", I1, {
  Parent: Error
}), S1 = /* @__PURE__ */ Ui(We), x1 = /* @__PURE__ */ Zi(We), v1 = /* @__PURE__ */ Qr(We), w1 = /* @__PURE__ */ en(We), E1 = /* @__PURE__ */ yA(We), C1 = /* @__PURE__ */ TA(We), k1 = /* @__PURE__ */ MA(We), D1 = /* @__PURE__ */ NA(We), L1 = /* @__PURE__ */ FA(We), B1 = /* @__PURE__ */ IA(We), R1 = /* @__PURE__ */ SA(We), P1 = /* @__PURE__ */ xA(We), de = /* @__PURE__ */ N("ZodType", (o, r) => (ce.init(o, r), Object.assign(o["~standard"], {
  jsonSchema: {
    input: Yr(o, "input"),
    output: Yr(o, "output")
  }
}), o.toJSONSchema = Jg(o, {}), o.def = r, o.type = r.type, Object.defineProperty(o, "_def", { value: r }), o.check = (...n) => o.clone(Lo(r, {
  checks: [
    ...r.checks ?? [],
    ...n.map((a) => typeof a == "function" ? { _zod: { check: a, def: { check: "custom" }, onattach: [] } } : a)
  ]
}), {
  parent: !0
}), o.with = o.check, o.clone = (n, a) => Bo(o, n, a), o.brand = () => o, o.register = ((n, a) => (n.add(o, a), o)), o.parse = (n, a) => S1(o, n, a, { callee: o.parse }), o.safeParse = (n, a) => v1(o, n, a), o.parseAsync = async (n, a) => x1(o, n, a, { callee: o.parseAsync }), o.safeParseAsync = async (n, a) => w1(o, n, a), o.spa = o.safeParseAsync, o.encode = (n, a) => E1(o, n, a), o.decode = (n, a) => C1(o, n, a), o.encodeAsync = async (n, a) => k1(o, n, a), o.decodeAsync = async (n, a) => D1(o, n, a), o.safeEncode = (n, a) => L1(o, n, a), o.safeDecode = (n, a) => B1(o, n, a), o.safeEncodeAsync = async (n, a) => R1(o, n, a), o.safeDecodeAsync = async (n, a) => P1(o, n, a), o.refine = (n, a) => o.check(Ey(n, a)), o.superRefine = (n) => o.check(Cy(n)), o.overwrite = (n) => o.check(/* @__PURE__ */ yt(n)), o.optional = () => ju(o), o.exactOptional = () => _y(o), o.nullable = () => Ju(o), o.nullish = () => ju(Ju(o)), o.nonoptional = (n) => Ny(o, n), o.array = () => sy(o), o.or = (n) => Dl([o, n]), o.and = (n) => dy(o, n), o.transform = (n) => Yu(o, hy(n)), o.default = (n) => yy(o, n), o.prefault = (n) => My(o, n), o.catch = (n) => Iy(o, n), o.pipe = (n) => Yu(o, n), o.readonly = () => vy(o), o.describe = (n) => {
  const a = o.clone();
  return Kt.add(a, { description: n }), a;
}, Object.defineProperty(o, "description", {
  get() {
    return Kt.get(o)?.description;
  },
  configurable: !0
}), o.meta = (...n) => {
  if (n.length === 0)
    return Kt.get(o);
  const a = o.clone();
  return Kt.add(a, n[0]), a;
}, o.isOptional = () => o.safeParse(void 0).success, o.isNullable = () => o.safeParse(null).success, o.apply = (n) => n(o), o)), Cl = /* @__PURE__ */ N("_ZodString", (o, r) => {
  $i.init(o, r), de.init(o, r), o._zod.processJSONSchema = (a, u, f) => Xg(o, a, u);
  const n = o._zod.bag;
  o.format = n.format ?? null, o.minLength = n.minimum ?? null, o.maxLength = n.maximum ?? null, o.regex = (...a) => o.check(/* @__PURE__ */ Bg(...a)), o.includes = (...a) => o.check(/* @__PURE__ */ zg(...a)), o.startsWith = (...a) => o.check(/* @__PURE__ */ Og(...a)), o.endsWith = (...a) => o.check(/* @__PURE__ */ Gg(...a)), o.min = (...a) => o.check(/* @__PURE__ */ Jr(...a)), o.max = (...a) => o.check(/* @__PURE__ */ Il(...a)), o.length = (...a) => o.check(/* @__PURE__ */ Sl(...a)), o.nonempty = (...a) => o.check(/* @__PURE__ */ Jr(1, ...a)), o.lowercase = (a) => o.check(/* @__PURE__ */ Rg(a)), o.uppercase = (a) => o.check(/* @__PURE__ */ Pg(a)), o.trim = () => o.check(/* @__PURE__ */ Ug()), o.normalize = (...a) => o.check(/* @__PURE__ */ qg(...a)), o.toLowerCase = () => o.check(/* @__PURE__ */ Zg()), o.toUpperCase = () => o.check(/* @__PURE__ */ $g()), o.slugify = () => o.check(/* @__PURE__ */ Kg());
}), z1 = /* @__PURE__ */ N("ZodString", (o, r) => {
  $i.init(o, r), Cl.init(o, r), o.email = (n) => o.check(/* @__PURE__ */ sg(O1, n)), o.url = (n) => o.check(/* @__PURE__ */ dg(G1, n)), o.jwt = (n) => o.check(/* @__PURE__ */ Sg(oy, n)), o.emoji = (n) => o.check(/* @__PURE__ */ pg(q1, n)), o.guid = (n) => o.check(/* @__PURE__ */ Uu(Hu, n)), o.uuid = (n) => o.check(/* @__PURE__ */ Fl(Ht, n)), o.uuidv4 = (n) => o.check(/* @__PURE__ */ ug(Ht, n)), o.uuidv6 = (n) => o.check(/* @__PURE__ */ lg(Ht, n)), o.uuidv7 = (n) => o.check(/* @__PURE__ */ cg(Ht, n)), o.nanoid = (n) => o.check(/* @__PURE__ */ fg(U1, n)), o.guid = (n) => o.check(/* @__PURE__ */ Uu(Hu, n)), o.cuid = (n) => o.check(/* @__PURE__ */ mg(Z1, n)), o.cuid2 = (n) => o.check(/* @__PURE__ */ hg($1, n)), o.ulid = (n) => o.check(/* @__PURE__ */ bg(K1, n)), o.base64 = (n) => o.check(/* @__PURE__ */ Ng(X1, n)), o.base64url = (n) => o.check(/* @__PURE__ */ Fg(Q1, n)), o.xid = (n) => o.check(/* @__PURE__ */ _g(H1, n)), o.ksuid = (n) => o.check(/* @__PURE__ */ Ag(W1, n)), o.ipv4 = (n) => o.check(/* @__PURE__ */ gg(V1, n)), o.ipv6 = (n) => o.check(/* @__PURE__ */ yg(j1, n)), o.cidrv4 = (n) => o.check(/* @__PURE__ */ Tg(J1, n)), o.cidrv6 = (n) => o.check(/* @__PURE__ */ Mg(Y1, n)), o.e164 = (n) => o.check(/* @__PURE__ */ Ig(ey, n)), o.datetime = (n) => o.check(A1(n)), o.date = (n) => o.check(y1(n)), o.time = (n) => o.check(M1(n)), o.duration = (n) => o.check(F1(n));
});
function Ae(o) {
  return /* @__PURE__ */ ag(z1, o);
}
const ie = /* @__PURE__ */ N("ZodStringFormat", (o, r) => {
  re.init(o, r), Cl.init(o, r);
}), O1 = /* @__PURE__ */ N("ZodEmail", (o, r) => {
  h0.init(o, r), ie.init(o, r);
}), Hu = /* @__PURE__ */ N("ZodGUID", (o, r) => {
  f0.init(o, r), ie.init(o, r);
}), Ht = /* @__PURE__ */ N("ZodUUID", (o, r) => {
  m0.init(o, r), ie.init(o, r);
});
function Xr(o) {
  return /* @__PURE__ */ Fl(Ht, o);
}
const G1 = /* @__PURE__ */ N("ZodURL", (o, r) => {
  b0.init(o, r), ie.init(o, r);
}), q1 = /* @__PURE__ */ N("ZodEmoji", (o, r) => {
  _0.init(o, r), ie.init(o, r);
}), U1 = /* @__PURE__ */ N("ZodNanoID", (o, r) => {
  A0.init(o, r), ie.init(o, r);
}), Z1 = /* @__PURE__ */ N("ZodCUID", (o, r) => {
  g0.init(o, r), ie.init(o, r);
}), $1 = /* @__PURE__ */ N("ZodCUID2", (o, r) => {
  y0.init(o, r), ie.init(o, r);
}), K1 = /* @__PURE__ */ N("ZodULID", (o, r) => {
  T0.init(o, r), ie.init(o, r);
}), H1 = /* @__PURE__ */ N("ZodXID", (o, r) => {
  M0.init(o, r), ie.init(o, r);
}), W1 = /* @__PURE__ */ N("ZodKSUID", (o, r) => {
  N0.init(o, r), ie.init(o, r);
}), V1 = /* @__PURE__ */ N("ZodIPv4", (o, r) => {
  v0.init(o, r), ie.init(o, r);
}), j1 = /* @__PURE__ */ N("ZodIPv6", (o, r) => {
  w0.init(o, r), ie.init(o, r);
}), J1 = /* @__PURE__ */ N("ZodCIDRv4", (o, r) => {
  E0.init(o, r), ie.init(o, r);
}), Y1 = /* @__PURE__ */ N("ZodCIDRv6", (o, r) => {
  C0.init(o, r), ie.init(o, r);
}), X1 = /* @__PURE__ */ N("ZodBase64", (o, r) => {
  k0.init(o, r), ie.init(o, r);
}), Q1 = /* @__PURE__ */ N("ZodBase64URL", (o, r) => {
  L0.init(o, r), ie.init(o, r);
}), ey = /* @__PURE__ */ N("ZodE164", (o, r) => {
  B0.init(o, r), ie.init(o, r);
}), oy = /* @__PURE__ */ N("ZodJWT", (o, r) => {
  P0.init(o, r), ie.init(o, r);
}), kl = /* @__PURE__ */ N("ZodNumber", (o, r) => {
  yl.init(o, r), de.init(o, r), o._zod.processJSONSchema = (a, u, f) => Qg(o, a, u), o.gt = (a, u) => o.check(/* @__PURE__ */ $u(a, u)), o.gte = (a, u) => o.check(/* @__PURE__ */ wi(a, u)), o.min = (a, u) => o.check(/* @__PURE__ */ wi(a, u)), o.lt = (a, u) => o.check(/* @__PURE__ */ Zu(a, u)), o.lte = (a, u) => o.check(/* @__PURE__ */ vi(a, u)), o.max = (a, u) => o.check(/* @__PURE__ */ vi(a, u)), o.int = (a) => o.check(Wu(a)), o.safe = (a) => o.check(Wu(a)), o.positive = (a) => o.check(/* @__PURE__ */ $u(0, a)), o.nonnegative = (a) => o.check(/* @__PURE__ */ wi(0, a)), o.negative = (a) => o.check(/* @__PURE__ */ Zu(0, a)), o.nonpositive = (a) => o.check(/* @__PURE__ */ vi(0, a)), o.multipleOf = (a, u) => o.check(/* @__PURE__ */ Ku(a, u)), o.step = (a, u) => o.check(/* @__PURE__ */ Ku(a, u)), o.finite = () => o;
  const n = o._zod.bag;
  o.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, o.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, o.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), o.isFinite = !0, o.format = n.format ?? null;
});
function to(o) {
  return /* @__PURE__ */ Cg(kl, o);
}
const ty = /* @__PURE__ */ N("ZodNumberFormat", (o, r) => {
  z0.init(o, r), kl.init(o, r);
});
function Wu(o) {
  return /* @__PURE__ */ kg(ty, o);
}
const ry = /* @__PURE__ */ N("ZodUnknown", (o, r) => {
  O0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => o1();
});
function Vu() {
  return /* @__PURE__ */ Dg(ry);
}
const ny = /* @__PURE__ */ N("ZodNever", (o, r) => {
  G0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => e1(o, n, a);
});
function iy(o) {
  return /* @__PURE__ */ Lg(ny, o);
}
const ay = /* @__PURE__ */ N("ZodArray", (o, r) => {
  q0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => a1(o, n, a, u), o.element = r.element, o.min = (n, a) => o.check(/* @__PURE__ */ Jr(n, a)), o.nonempty = (n) => o.check(/* @__PURE__ */ Jr(1, n)), o.max = (n, a) => o.check(/* @__PURE__ */ Il(n, a)), o.length = (n, a) => o.check(/* @__PURE__ */ Sl(n, a)), o.unwrap = () => o.element;
});
function sy(o, r) {
  return /* @__PURE__ */ Hg(ay, o, r);
}
const uy = /* @__PURE__ */ N("ZodObject", (o, r) => {
  Z0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => s1(o, n, a, u), J(o, "shape", () => r.shape), o.keyof = () => tn(Object.keys(o._zod.def.shape)), o.catchall = (n) => o.clone({ ...o._zod.def, catchall: n }), o.passthrough = () => o.clone({ ...o._zod.def, catchall: Vu() }), o.loose = () => o.clone({ ...o._zod.def, catchall: Vu() }), o.strict = () => o.clone({ ...o._zod.def, catchall: iy() }), o.strip = () => o.clone({ ...o._zod.def, catchall: void 0 }), o.extend = (n) => dA(o, n), o.safeExtend = (n) => pA(o, n), o.merge = (n) => fA(o, n), o.pick = (n) => lA(o, n), o.omit = (n) => cA(o, n), o.partial = (...n) => mA(Ll, o, n[0]), o.required = (...n) => hA(Bl, o, n[0]);
});
function Tt(o, r) {
  const n = {
    type: "object",
    shape: o ?? {},
    ...D(r)
  };
  return new uy(n);
}
const ly = /* @__PURE__ */ N("ZodUnion", (o, r) => {
  $0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => u1(o, n, a, u), o.options = r.options;
});
function Dl(o, r) {
  return new ly({
    type: "union",
    options: o,
    ...D(r)
  });
}
const cy = /* @__PURE__ */ N("ZodIntersection", (o, r) => {
  K0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => l1(o, n, a, u);
});
function dy(o, r) {
  return new cy({
    type: "intersection",
    left: o,
    right: r
  });
}
const ki = /* @__PURE__ */ N("ZodEnum", (o, r) => {
  H0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (a, u, f) => t1(o, a, u), o.enum = r.entries, o.options = Object.values(r.entries);
  const n = new Set(Object.keys(r.entries));
  o.extract = (a, u) => {
    const f = {};
    for (const d of a)
      if (n.has(d))
        f[d] = r.entries[d];
      else
        throw new Error(`Key ${d} not found in enum`);
    return new ki({
      ...r,
      checks: [],
      ...D(u),
      entries: f
    });
  }, o.exclude = (a, u) => {
    const f = { ...r.entries };
    for (const d of a)
      if (n.has(d))
        delete f[d];
      else
        throw new Error(`Key ${d} not found in enum`);
    return new ki({
      ...r,
      checks: [],
      ...D(u),
      entries: f
    });
  };
});
function tn(o, r) {
  const n = Array.isArray(o) ? Object.fromEntries(o.map((a) => [a, a])) : o;
  return new ki({
    type: "enum",
    entries: n,
    ...D(r)
  });
}
const py = /* @__PURE__ */ N("ZodLiteral", (o, r) => {
  W0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => r1(o, n, a), o.values = new Set(r.values), Object.defineProperty(o, "value", {
    get() {
      if (r.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return r.values[0];
    }
  });
});
function fy(o, r) {
  return new py({
    type: "literal",
    values: Array.isArray(o) ? o : [o],
    ...D(r)
  });
}
const my = /* @__PURE__ */ N("ZodTransform", (o, r) => {
  V0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => i1(o, n), o._zod.parse = (n, a) => {
    if (a.direction === "backward")
      throw new nl(o.constructor.name);
    n.addIssue = (f) => {
      if (typeof f == "string")
        n.issues.push(Jt(f, n.value, r));
      else {
        const d = f;
        d.fatal && (d.continue = !1), d.code ?? (d.code = "custom"), d.input ?? (d.input = n.value), d.inst ?? (d.inst = o), n.issues.push(Jt(d));
      }
    };
    const u = r.transform(n.value, n);
    return u instanceof Promise ? u.then((f) => (n.value = f, n)) : (n.value = u, n);
  };
});
function hy(o) {
  return new my({
    type: "transform",
    transform: o
  });
}
const Ll = /* @__PURE__ */ N("ZodOptional", (o, r) => {
  Nl.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => El(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function ju(o) {
  return new Ll({
    type: "optional",
    innerType: o
  });
}
const by = /* @__PURE__ */ N("ZodExactOptional", (o, r) => {
  j0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => El(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function _y(o) {
  return new by({
    type: "optional",
    innerType: o
  });
}
const Ay = /* @__PURE__ */ N("ZodNullable", (o, r) => {
  J0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => c1(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function Ju(o) {
  return new Ay({
    type: "nullable",
    innerType: o
  });
}
const gy = /* @__PURE__ */ N("ZodDefault", (o, r) => {
  Y0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => p1(o, n, a, u), o.unwrap = () => o._zod.def.innerType, o.removeDefault = o.unwrap;
});
function yy(o, r) {
  return new gy({
    type: "default",
    innerType: o,
    get defaultValue() {
      return typeof r == "function" ? r() : ul(r);
    }
  });
}
const Ty = /* @__PURE__ */ N("ZodPrefault", (o, r) => {
  X0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => f1(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function My(o, r) {
  return new Ty({
    type: "prefault",
    innerType: o,
    get defaultValue() {
      return typeof r == "function" ? r() : ul(r);
    }
  });
}
const Bl = /* @__PURE__ */ N("ZodNonOptional", (o, r) => {
  Q0.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => d1(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function Ny(o, r) {
  return new Bl({
    type: "nonoptional",
    innerType: o,
    ...D(r)
  });
}
const Fy = /* @__PURE__ */ N("ZodCatch", (o, r) => {
  eg.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => m1(o, n, a, u), o.unwrap = () => o._zod.def.innerType, o.removeCatch = o.unwrap;
});
function Iy(o, r) {
  return new Fy({
    type: "catch",
    innerType: o,
    catchValue: typeof r == "function" ? r : () => r
  });
}
const Sy = /* @__PURE__ */ N("ZodPipe", (o, r) => {
  og.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => h1(o, n, a, u), o.in = r.in, o.out = r.out;
});
function Yu(o, r) {
  return new Sy({
    type: "pipe",
    in: o,
    out: r
    // ...util.normalizeParams(params),
  });
}
const xy = /* @__PURE__ */ N("ZodReadonly", (o, r) => {
  tg.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => b1(o, n, a, u), o.unwrap = () => o._zod.def.innerType;
});
function vy(o) {
  return new xy({
    type: "readonly",
    innerType: o
  });
}
const wy = /* @__PURE__ */ N("ZodCustom", (o, r) => {
  rg.init(o, r), de.init(o, r), o._zod.processJSONSchema = (n, a, u) => n1(o, n);
});
function Ey(o, r = {}) {
  return /* @__PURE__ */ Wg(wy, o, r);
}
function Cy(o) {
  return /* @__PURE__ */ Vg(o);
}
const Rl = Tt({
  userId: Xr(),
  companyId: Xr()
}), ky = Rl.extend({
  auctionId: Xr()
}), Dy = Rl.extend({
  directSaleId: Xr()
}), jT = Dl([ky, Dy]), JT = 50, YT = 1, XT = "bnk_", Ly = {
  // Exteriors
  photo_front: {
    name: "photo_front",
    position: 10,
    position_admin: 30,
    positionByType: {
      MinibusCityIntercity: 20,
      MinibusTouristic: 20,
      AutobusNormalFloor2Axle: 20,
      AutobusNormalFloor3Axle: 20,
      AutobusLowFloorLowEntry8_12Mt: 20,
      Autobus18Mt: 20,
      DoubleDecker: 20
    },
    positionAdminByType: {
      MinibusCityIntercity: 40,
      MinibusTouristic: 40,
      AutobusNormalFloor2Axle: 40,
      AutobusNormalFloor3Axle: 40,
      AutobusLowFloorLowEntry8_12Mt: 40,
      Autobus18Mt: 40,
      DoubleDecker: 40
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Front",
    group: "exteriors",
    description: "A photo capturing the front view of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_front_side_left: {
    name: "photo_3_4_front_side_left",
    position: 20,
    position_admin: 40,
    positionByType: {
      MinibusCityIntercity: 50,
      MinibusTouristic: 50,
      AutobusNormalFloor2Axle: 50,
      AutobusNormalFloor3Axle: 50,
      AutobusLowFloorLowEntry8_12Mt: 50,
      Autobus18Mt: 50,
      DoubleDecker: 60
    },
    positionAdminByType: {
      MinibusCityIntercity: 70,
      MinibusTouristic: 70,
      AutobusNormalFloor2Axle: 70,
      AutobusNormalFloor3Axle: 70,
      AutobusLowFloorLowEntry8_12Mt: 70,
      Autobus18Mt: 70,
      DoubleDecker: 80
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "3/4 Front Left Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the left.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_side_left: {
    name: "photo_side_left",
    position: 30,
    position_admin: 70,
    positionByType: {
      MinibusCityIntercity: 60,
      MinibusTouristic: 60,
      AutobusNormalFloor2Axle: 60,
      AutobusNormalFloor3Axle: 60,
      AutobusLowFloorLowEntry8_12Mt: 60,
      Autobus18Mt: 60,
      DoubleDecker: 70
    },
    positionAdminByType: {
      MinibusCityIntercity: 80,
      MinibusTouristic: 80,
      AutobusNormalFloor2Axle: 80,
      AutobusNormalFloor3Axle: 80,
      AutobusLowFloorLowEntry8_12Mt: 80,
      Autobus18Mt: 80,
      DoubleDecker: 90
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Left Side",
    group: "exteriors",
    description: "A photo showing the left side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_left_rear: {
    name: "photo_3_4_side_left_rear",
    position: 40,
    position_admin: 120,
    positionByType: {
      MinibusCityIntercity: 70,
      MinibusTouristic: 70,
      AutobusNormalFloor2Axle: 70,
      AutobusNormalFloor3Axle: 70,
      AutobusLowFloorLowEntry8_12Mt: 70,
      Autobus18Mt: 70,
      DoubleDecker: 80
    },
    positionAdminByType: {
      MinibusCityIntercity: 90,
      MinibusTouristic: 90,
      AutobusNormalFloor2Axle: 90,
      AutobusNormalFloor3Axle: 90,
      AutobusLowFloorLowEntry8_12Mt: 90,
      Autobus18Mt: 90,
      DoubleDecker: 100
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "3/4 Rear Left Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the left rear side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_closed: {
    name: "photo_rear_hatch_closed",
    position: 50,
    position_admin: 130,
    positionByType: {
      MinibusCityIntercity: 80,
      MinibusTouristic: 80,
      AutobusNormalFloor2Axle: 80,
      AutobusNormalFloor3Axle: 80,
      AutobusLowFloorLowEntry8_12Mt: 80,
      Autobus18Mt: 80,
      DoubleDecker: 90
    },
    positionAdminByType: {
      MinibusCityIntercity: 100,
      MinibusTouristic: 100,
      AutobusNormalFloor2Axle: 100,
      AutobusNormalFloor3Axle: 100,
      AutobusLowFloorLowEntry8_12Mt: 100,
      Autobus18Mt: 100,
      DoubleDecker: 110
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Rear",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_closed: {
    name: "photo_3_4_side_right_rear_doors_closed",
    position: 60,
    position_admin: 190,
    positionByType: {
      MinibusCityIntercity: 90,
      MinibusTouristic: 90,
      AutobusNormalFloor2Axle: 90,
      AutobusNormalFloor3Axle: 90,
      AutobusLowFloorLowEntry8_12Mt: 90,
      Autobus18Mt: 90,
      DoubleDecker: 100
    },
    positionAdminByType: {
      MinibusCityIntercity: 110,
      MinibusTouristic: 110,
      AutobusNormalFloor2Axle: 110,
      AutobusNormalFloor3Axle: 110,
      AutobusLowFloorLowEntry8_12Mt: 110,
      Autobus18Mt: 110,
      DoubleDecker: 120
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "3/4 Rear Right Side",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_closed: {
    name: "photo_side_right_doors_closed",
    position: 70,
    position_admin: 200,
    positionByType: {
      MinibusCityIntercity: 100,
      MinibusTouristic: 120,
      AutobusNormalFloor2Axle: 100,
      AutobusNormalFloor3Axle: 100,
      AutobusLowFloorLowEntry8_12Mt: 100,
      Autobus18Mt: 100,
      DoubleDecker: 110
    },
    positionAdminByType: {
      MinibusCityIntercity: 120,
      MinibusTouristic: 140,
      AutobusNormalFloor2Axle: 120,
      AutobusNormalFloor3Axle: 120,
      AutobusLowFloorLowEntry8_12Mt: 120,
      Autobus18Mt: 120,
      DoubleDecker: 130
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Right Side",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_external_if_present_only_18mt: {
    name: "turntable_photo_external_if_present_only_18mt",
    position: 80,
    position_admin: 210,
    positionByType: { Autobus18Mt: 110 },
    positionAdminByType: { Autobus18Mt: 130 },
    label: "Turntable External",
    group: "exteriors",
    description: "An external photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_front_side_right_doors_closed: {
    name: "photo_3_4_front_side_right_doors_closed",
    position: 90,
    position_admin: 10,
    positionByType: {
      MinibusCityIntercity: 10,
      MinibusTouristic: 10,
      AutobusNormalFloor2Axle: 10,
      AutobusNormalFloor3Axle: 10,
      AutobusLowFloorLowEntry8_12Mt: 10,
      Autobus18Mt: 10,
      DoubleDecker: 10
    },
    positionAdminByType: {
      MinibusCityIntercity: 30,
      MinibusTouristic: 30,
      AutobusNormalFloor2Axle: 30,
      AutobusNormalFloor3Axle: 30,
      AutobusLowFloorLowEntry8_12Mt: 30,
      Autobus18Mt: 30,
      DoubleDecker: 30
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "3/4 Front Right Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the right, with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_side_right_front_doors_open: {
    name: "photo_3_4_side_right_front_doors_open",
    position: 100,
    position_admin: 230,
    positionByType: {
      MinibusCityIntercity: 130,
      MinibusTouristic: 130,
      AutobusNormalFloor2Axle: 110,
      AutobusNormalFloor3Axle: 110,
      AutobusLowFloorLowEntry8_12Mt: 110,
      Autobus18Mt: 120,
      DoubleDecker: 120
    },
    positionAdminByType: {
      MinibusCityIntercity: 150,
      MinibusTouristic: 150,
      AutobusNormalFloor2Axle: 130,
      AutobusNormalFloor3Axle: 130,
      AutobusLowFloorLowEntry8_12Mt: 130,
      Autobus18Mt: 140,
      DoubleDecker: 140
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt"],
    label: "3/4 Front Right Side Doors Open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right front side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_1: {
    name: "front_photo_per_door_doors_open_door_1",
    position: 110,
    position_admin: 300,
    positionByType: {
      MinibusCityIntercity: 160,
      MinibusTouristic: 160,
      AutobusNormalFloor2Axle: 120,
      AutobusNormalFloor3Axle: 120,
      AutobusLowFloorLowEntry8_12Mt: 120,
      Autobus18Mt: 130,
      DoubleDecker: 130
    },
    positionAdminByType: {
      MinibusCityIntercity: 180,
      MinibusTouristic: 180,
      AutobusNormalFloor2Axle: 140,
      AutobusNormalFloor3Axle: 140,
      AutobusLowFloorLowEntry8_12Mt: 140,
      Autobus18Mt: 150,
      DoubleDecker: 150
    },
    requiredFor: ["AutobusNormalFloor3Axle"],
    label: "Front Door Open",
    group: "exteriors",
    description: "A photo of the front door 1 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_open: {
    name: "photo_side_right_doors_open",
    position: 120,
    position_admin: 240,
    positionByType: {
      MinibusCityIntercity: 140,
      MinibusTouristic: 140,
      AutobusNormalFloor2Axle: 130,
      AutobusNormalFloor3Axle: 130,
      AutobusLowFloorLowEntry8_12Mt: 130,
      Autobus18Mt: 140,
      DoubleDecker: 140
    },
    positionAdminByType: {
      MinibusCityIntercity: 160,
      MinibusTouristic: 160,
      AutobusNormalFloor2Axle: 150,
      AutobusNormalFloor3Axle: 150,
      AutobusLowFloorLowEntry8_12Mt: 150,
      Autobus18Mt: 160,
      DoubleDecker: 160
    },
    requiredFor: ["AutobusNormalFloor3Axle"],
    label: "Right Side Doors Open",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_2: {
    name: "front_photo_per_door_doors_open_door_2",
    position: 130,
    position_admin: 270,
    positionByType: {
      MinibusCityIntercity: 220,
      MinibusTouristic: 220,
      AutobusNormalFloor2Axle: 140,
      AutobusNormalFloor3Axle: 140,
      AutobusLowFloorLowEntry8_12Mt: 140,
      Autobus18Mt: 150,
      DoubleDecker: 150
    },
    positionAdminByType: {
      MinibusCityIntercity: 240,
      MinibusTouristic: 240,
      AutobusNormalFloor2Axle: 160,
      AutobusNormalFloor3Axle: 160,
      AutobusLowFloorLowEntry8_12Mt: 160,
      Autobus18Mt: 170,
      DoubleDecker: 170
    },
    label: "Second Door Open",
    group: "exteriors",
    description: "A photo of the front door 2 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_3: {
    name: "front_photo_per_door_doors_open_door_3",
    position: 140,
    position_admin: 260,
    positionByType: { AutobusLowFloorLowEntry8_12Mt: 150, Autobus18Mt: 160 },
    positionAdminByType: { AutobusLowFloorLowEntry8_12Mt: 170, Autobus18Mt: 180 },
    label: "Third Door Open",
    group: "exteriors",
    description: "A photo of the front door 3 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_open: {
    name: "photo_3_4_side_right_rear_doors_open",
    position: 150,
    position_admin: 250,
    positionByType: {
      MinibusCityIntercity: 150,
      MinibusTouristic: 150,
      AutobusNormalFloor2Axle: 150,
      AutobusNormalFloor3Axle: 150,
      AutobusLowFloorLowEntry8_12Mt: 160,
      Autobus18Mt: 180,
      DoubleDecker: 160
    },
    positionAdminByType: {
      MinibusCityIntercity: 170,
      MinibusTouristic: 170,
      AutobusNormalFloor2Axle: 170,
      AutobusNormalFloor3Axle: 170,
      AutobusLowFloorLowEntry8_12Mt: 180,
      Autobus18Mt: 200,
      DoubleDecker: 180
    },
    label: "3/4 Rear Right Side Doors Open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage: {
    name: "photo_luggage",
    position: 160,
    position_admin: 80,
    positionByType: { MinibusTouristic: 230, AutobusNormalFloor2Axle: 240, AutobusNormalFloor3Axle: 240, DoubleDecker: 250 },
    positionAdminByType: { MinibusTouristic: 250, AutobusNormalFloor2Axle: 260, AutobusNormalFloor3Axle: 260, DoubleDecker: 270 },
    label: "Luggage Rack Left Side",
    group: "exteriors",
    description: "A photo showing the luggage rack in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_internal_frame_for_potential_rust: {
    name: "photo_internal_frame_for_potential_rust",
    position: 170,
    position_admin: 90,
    positionByType: { MinibusTouristic: 240, AutobusNormalFloor2Axle: 250, AutobusNormalFloor3Axle: 250, DoubleDecker: 260 },
    positionAdminByType: { MinibusTouristic: 260, AutobusNormalFloor2Axle: 270, AutobusNormalFloor3Axle: 270, DoubleDecker: 280 },
    requiredFor: ["MinibusTouristic", "DoubleDecker"],
    label: "Luggage",
    group: "exteriors",
    description: "A photo showing the luggage compartment of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_under_carpet_if_carpet_present: {
    name: "photo_under_carpet_if_carpet_present",
    position: 180,
    position_admin: 95,
    positionByType: { AutobusNormalFloor2Axle: 260, AutobusNormalFloor3Axle: 260, DoubleDecker: 270 },
    positionAdminByType: { AutobusNormalFloor2Axle: 280, AutobusNormalFloor3Axle: 280, DoubleDecker: 290 },
    label: "Luggage Under Carpet Photo",
    group: "exteriors",
    description: "A photo showing the area under the carpet if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_open: {
    name: "photo_rear_hatch_open",
    position: 190,
    position_admin: 140,
    positionByType: {
      AutobusNormalFloor2Axle: 160,
      AutobusNormalFloor3Axle: 160,
      AutobusLowFloorLowEntry8_12Mt: 170,
      Autobus18Mt: 190,
      DoubleDecker: 170
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 180,
      AutobusNormalFloor3Axle: 180,
      AutobusLowFloorLowEntry8_12Mt: 190,
      Autobus18Mt: 210,
      DoubleDecker: 190
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Rear Hatch Open",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch open.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !0
  },
  photo_compressor_air_conditioning: {
    name: "photo_compressor_air_conditioning",
    position: 200,
    position_admin: 150,
    positionByType: {
      AutobusNormalFloor2Axle: 190,
      AutobusNormalFloor3Axle: 190,
      AutobusLowFloorLowEntry8_12Mt: 200,
      Autobus18Mt: 220,
      DoubleDecker: 200
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 210,
      AutobusNormalFloor3Axle: 210,
      AutobusLowFloorLowEntry8_12Mt: 220,
      Autobus18Mt: 240,
      DoubleDecker: 220
    },
    label: "Air Conditioning Compressor",
    group: "exteriors",
    description: "A photo showing the air conditioning compressor.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_preheater_webasto_if_present: {
    name: "photo_preheater_webasto_if_present",
    position: 210,
    position_admin: 170,
    positionByType: {
      AutobusNormalFloor2Axle: 200,
      AutobusNormalFloor3Axle: 200,
      AutobusLowFloorLowEntry8_12Mt: 210,
      Autobus18Mt: 230,
      DoubleDecker: 210
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 220,
      AutobusNormalFloor3Axle: 220,
      AutobusLowFloorLowEntry8_12Mt: 230,
      Autobus18Mt: 250,
      DoubleDecker: 230
    },
    label: "Preheater",
    group: "exteriors",
    description: "A photo of the preheater (webasto) system if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_extinguishing_system: {
    name: "photo_fire_extinguishing_system",
    position: 220,
    position_admin: 160,
    label: "Fire Suppression System",
    group: "exteriors",
    description: "A photo showing the fire extinguishing system of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_external_compartments_various_internal_photo: {
    name: "photo_external_compartments_various_internal_photo",
    position: 230,
    position_admin: 60,
    label: "external compartments photo",
    group: "exteriors",
    description: "A photo showing various external compartments.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_open_platform: {
    name: "photo_platform_open_platform",
    position: 240,
    position_admin: 215,
    positionByType: {
      MinibusCityIntercity: 180,
      MinibusTouristic: 180,
      AutobusNormalFloor2Axle: 220,
      AutobusNormalFloor3Axle: 220,
      AutobusLowFloorLowEntry8_12Mt: 230,
      Autobus18Mt: 250,
      DoubleDecker: 230
    },
    positionAdminByType: {
      MinibusCityIntercity: 200,
      MinibusTouristic: 200,
      AutobusNormalFloor2Axle: 240,
      AutobusNormalFloor3Axle: 240,
      AutobusLowFloorLowEntry8_12Mt: 250,
      Autobus18Mt: 270,
      DoubleDecker: 250
    },
    label: "Platform Open",
    group: "exteriors",
    description: "A photo of the platform in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_code: {
    name: "photo_platform_code",
    position: 250,
    position_admin: 216,
    positionByType: {
      MinibusCityIntercity: 190,
      MinibusTouristic: 190,
      AutobusNormalFloor2Axle: 230,
      AutobusNormalFloor3Axle: 230,
      AutobusLowFloorLowEntry8_12Mt: 240,
      Autobus18Mt: 260,
      DoubleDecker: 240
    },
    positionAdminByType: {
      MinibusCityIntercity: 210,
      MinibusTouristic: 210,
      AutobusNormalFloor2Axle: 250,
      AutobusNormalFloor3Axle: 250,
      AutobusLowFloorLowEntry8_12Mt: 260,
      Autobus18Mt: 280,
      DoubleDecker: 260
    },
    label: "Platform Code",
    group: "exteriors",
    description: "A photo showing the platform's code.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  engine_plate_photo_if_present: {
    name: "engine_plate_photo_if_present",
    position: 260,
    position_admin: 165,
    label: "engine plate photo",
    group: "exteriors",
    description: "A photo showing the engine plate if present.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_plate_vehicle: {
    name: "photo_plate_vehicle",
    position: 270,
    position_admin: 310,
    positionAdminByType: {
      MinibusCityIntercity: 20,
      MinibusTouristic: 20,
      AutobusNormalFloor2Axle: 20,
      AutobusNormalFloor3Axle: 20,
      AutobusLowFloorLowEntry8_12Mt: 20,
      Autobus18Mt: 20,
      DoubleDecker: 20
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Vehicle Plate",
    group: "technical-data",
    description: "A photo showing the vehicle's plate.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  // Interiors
  photo_plate_seats: {
    name: "photo_plate_seats",
    position: 280,
    position_admin: 320,
    positionByType: {
      MinibusCityIntercity: 230,
      MinibusTouristic: 290,
      AutobusNormalFloor2Axle: 290,
      AutobusNormalFloor3Axle: 280,
      AutobusLowFloorLowEntry8_12Mt: 250,
      Autobus18Mt: 270,
      DoubleDecker: 300
    },
    positionAdminByType: {
      MinibusCityIntercity: 250,
      MinibusTouristic: 310,
      AutobusNormalFloor2Axle: 310,
      AutobusNormalFloor3Axle: 300,
      AutobusLowFloorLowEntry8_12Mt: 270,
      Autobus18Mt: 290,
      DoubleDecker: 320
    },
    label: "Seats Plate",
    group: "interiors",
    description: "A photo showing the seat plate inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_driver_microphone: {
    name: "photo_accessories_driver_microphone",
    position: 290,
    position_admin: 330,
    positionByType: { MinibusTouristic: 300, AutobusNormalFloor2Axle: 300, AutobusNormalFloor3Axle: 290, DoubleDecker: 310 },
    positionAdminByType: { MinibusTouristic: 320, AutobusNormalFloor2Axle: 320, AutobusNormalFloor3Axle: 310, DoubleDecker: 330 },
    label: "Driver Microphone",
    group: "interiors",
    description: "A photo showing the driver's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_drive_seat: {
    name: "photo_drive_seat",
    position: 300,
    position_admin: 340,
    positionByType: {
      MinibusCityIntercity: 240,
      MinibusTouristic: 310,
      AutobusNormalFloor2Axle: 310,
      AutobusNormalFloor3Axle: 300,
      AutobusLowFloorLowEntry8_12Mt: 260,
      Autobus18Mt: 280,
      DoubleDecker: 320
    },
    positionAdminByType: {
      MinibusCityIntercity: 260,
      MinibusTouristic: 330,
      AutobusNormalFloor2Axle: 330,
      AutobusNormalFloor3Axle: 320,
      AutobusLowFloorLowEntry8_12Mt: 280,
      Autobus18Mt: 300,
      DoubleDecker: 340
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "DoubleDecker"],
    label: "Driver's Seat",
    group: "interiors",
    description: "A photo of the driver's seat.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !0
  },
  photo_steering_wheel: {
    name: "photo_steering_wheel",
    position: 310,
    position_admin: 350,
    positionByType: {
      MinibusCityIntercity: 250,
      MinibusTouristic: 320,
      AutobusNormalFloor2Axle: 320,
      AutobusNormalFloor3Axle: 310,
      AutobusLowFloorLowEntry8_12Mt: 270,
      Autobus18Mt: 290,
      DoubleDecker: 330
    },
    positionAdminByType: {
      MinibusCityIntercity: 270,
      MinibusTouristic: 340,
      AutobusNormalFloor2Axle: 340,
      AutobusNormalFloor3Axle: 330,
      AutobusLowFloorLowEntry8_12Mt: 290,
      Autobus18Mt: 310,
      DoubleDecker: 350
    },
    label: "Steering Wheel",
    group: "interiors",
    description: "A photo of the steering wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_dashboard_on_for_number_km_and_lights_on: {
    name: "photo_dashboard_on_for_number_km_and_lights_on",
    position: 320,
    position_admin: 360,
    positionByType: {
      MinibusCityIntercity: 260,
      MinibusTouristic: 330,
      AutobusNormalFloor2Axle: 330,
      AutobusNormalFloor3Axle: 320,
      AutobusLowFloorLowEntry8_12Mt: 280,
      Autobus18Mt: 300,
      DoubleDecker: 340
    },
    positionAdminByType: {
      MinibusCityIntercity: 280,
      MinibusTouristic: 350,
      AutobusNormalFloor2Axle: 350,
      AutobusNormalFloor3Axle: 340,
      AutobusLowFloorLowEntry8_12Mt: 300,
      Autobus18Mt: 320,
      DoubleDecker: 360
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Dashboard Engine On",
    group: "interiors",
    description: "A photo showing the dashboard with the vehicle's odometer reading and warning lights illuminated.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_buttons_e_panels_on: {
    name: "photo_buttons_e_panels_on",
    position: 330,
    position_admin: 370,
    positionByType: {
      MinibusCityIntercity: 270,
      MinibusTouristic: 340,
      AutobusNormalFloor2Axle: 340,
      AutobusNormalFloor3Axle: 330,
      AutobusLowFloorLowEntry8_12Mt: 290,
      Autobus18Mt: 310,
      DoubleDecker: 350
    },
    positionAdminByType: {
      MinibusCityIntercity: 290,
      MinibusTouristic: 360,
      AutobusNormalFloor2Axle: 360,
      AutobusNormalFloor3Axle: 350,
      AutobusLowFloorLowEntry8_12Mt: 310,
      Autobus18Mt: 330,
      DoubleDecker: 370
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Complete Driver's Dashboard",
    group: "interiors",
    description: "A photo showing the vehicle's buttons and panels in an 'on' state.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_tachograph: {
    name: "photo_tachograph",
    position: 340,
    position_admin: 380,
    positionByType: {
      MinibusCityIntercity: 280,
      MinibusTouristic: 350,
      AutobusNormalFloor2Axle: 350,
      AutobusNormalFloor3Axle: 340,
      AutobusLowFloorLowEntry8_12Mt: 300,
      Autobus18Mt: 320,
      DoubleDecker: 360
    },
    positionAdminByType: {
      MinibusCityIntercity: 300,
      MinibusTouristic: 370,
      AutobusNormalFloor2Axle: 370,
      AutobusNormalFloor3Axle: 360,
      AutobusLowFloorLowEntry8_12Mt: 320,
      Autobus18Mt: 340,
      DoubleDecker: 380
    },
    requiredFor: ["AutobusNormalFloor2Axle", "DoubleDecker"],
    label: "Tachograph",
    group: "interiors",
    description: "A photo of the Tachograph.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_radio: {
    name: "photo_accessories_radio",
    position: 350,
    position_admin: 390,
    positionByType: { AutobusNormalFloor2Axle: 360, AutobusNormalFloor3Axle: 350, DoubleDecker: 370 },
    positionAdminByType: { AutobusNormalFloor2Axle: 380, AutobusNormalFloor3Axle: 370, DoubleDecker: 390 },
    label: "Radio",
    group: "interiors",
    description: "A photo showing the radio accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_1: {
    name: "photo_any_devices_onboard_1",
    position: 360,
    position_admin: 400,
    positionByType: {
      MinibusCityIntercity: 290,
      MinibusTouristic: 360,
      AutobusNormalFloor2Axle: 370,
      AutobusNormalFloor3Axle: 360,
      AutobusLowFloorLowEntry8_12Mt: 310,
      Autobus18Mt: 330,
      DoubleDecker: 380
    },
    positionAdminByType: {
      MinibusCityIntercity: 310,
      MinibusTouristic: 380,
      AutobusNormalFloor2Axle: 390,
      AutobusNormalFloor3Axle: 380,
      AutobusLowFloorLowEntry8_12Mt: 330,
      Autobus18Mt: 350,
      DoubleDecker: 400
    },
    requiredFor: ["AutobusNormalFloor3Axle", "DoubleDecker"],
    label: "Onboard Device 1",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_2: {
    name: "photo_any_devices_onboard_2",
    position: 370,
    position_admin: 410,
    positionByType: {
      MinibusCityIntercity: 300,
      MinibusTouristic: 370,
      AutobusNormalFloor2Axle: 380,
      AutobusNormalFloor3Axle: 370,
      AutobusLowFloorLowEntry8_12Mt: 320,
      Autobus18Mt: 340,
      DoubleDecker: 390
    },
    positionAdminByType: {
      MinibusCityIntercity: 320,
      MinibusTouristic: 390,
      AutobusNormalFloor2Axle: 400,
      AutobusNormalFloor3Axle: 390,
      AutobusLowFloorLowEntry8_12Mt: 340,
      Autobus18Mt: 360,
      DoubleDecker: 410
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "DoubleDecker"],
    label: "Onboard Device 2",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  control_unit_command_signs_indicators: {
    name: "control_unit_command_signs_indicators",
    position: 380,
    position_admin: 430,
    positionByType: {
      MinibusCityIntercity: 310,
      MinibusTouristic: 380,
      AutobusNormalFloor2Axle: 400,
      AutobusNormalFloor3Axle: 390,
      AutobusLowFloorLowEntry8_12Mt: 340,
      Autobus18Mt: 360,
      DoubleDecker: 410
    },
    positionAdminByType: {
      MinibusCityIntercity: 330,
      MinibusTouristic: 400,
      AutobusNormalFloor2Axle: 420,
      AutobusNormalFloor3Axle: 410,
      AutobusLowFloorLowEntry8_12Mt: 360,
      Autobus18Mt: 380,
      DoubleDecker: 430
    },
    requiredFor: ["MinibusCityIntercity", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt"],
    label: "Command Unit Indicators",
    group: "interiors",
    description: "A photo of the control unit for signs and indicators.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_seat_hostess: {
    name: "photo_seat_hostess",
    position: 390,
    position_admin: 440,
    positionByType: { MinibusTouristic: 410, AutobusNormalFloor2Axle: 410, AutobusNormalFloor3Axle: 400, DoubleDecker: 420 },
    positionAdminByType: { MinibusTouristic: 430, AutobusNormalFloor2Axle: 430, AutobusNormalFloor3Axle: 420, DoubleDecker: 440 },
    label: "Hostess Seat",
    group: "interiors",
    description: "A photo of the hostess seat in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_hostes_microphone: {
    name: "photo_accessories_hostes_microphone",
    position: 400,
    position_admin: 450,
    positionByType: { MinibusTouristic: 420, AutobusNormalFloor2Axle: 420, AutobusNormalFloor3Axle: 410, DoubleDecker: 430 },
    positionAdminByType: { MinibusTouristic: 440, AutobusNormalFloor2Axle: 440, AutobusNormalFloor3Axle: 430, DoubleDecker: 450 },
    label: "Hostess Microphone",
    group: "interiors",
    description: "A photo showing the hostes's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_handrails: {
    name: "photo_handrails",
    position: 410,
    position_admin: 460,
    label: "handrails photo",
    group: "interiors",
    description: "A photo showing the handrails inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_door_mechanism_internal_photo: {
    name: "photo_door_mechanism_internal_photo",
    position: 420,
    position_admin: 470,
    positionByType: {
      MinibusCityIntercity: 320,
      MinibusTouristic: 430,
      AutobusNormalFloor2Axle: 450,
      AutobusNormalFloor3Axle: 440,
      AutobusLowFloorLowEntry8_12Mt: 350,
      Autobus18Mt: 370,
      DoubleDecker: 460
    },
    positionAdminByType: {
      MinibusCityIntercity: 340,
      MinibusTouristic: 450,
      AutobusNormalFloor2Axle: 470,
      AutobusNormalFloor3Axle: 460,
      AutobusLowFloorLowEntry8_12Mt: 370,
      Autobus18Mt: 390,
      DoubleDecker: 480
    },
    requiredFor: ["AutobusNormalFloor2Axle"],
    label: "Door Mechanism",
    group: "interiors",
    description: "A photo of the internal door mechanism.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista: {
    name: "photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista",
    position: 430,
    position_admin: 480,
    positionByType: {
      MinibusCityIntercity: 330,
      MinibusTouristic: 440,
      AutobusNormalFloor2Axle: 460,
      AutobusNormalFloor3Axle: 450,
      AutobusLowFloorLowEntry8_12Mt: 360,
      Autobus18Mt: 380,
      DoubleDecker: 470
    },
    positionAdminByType: {
      MinibusCityIntercity: 350,
      MinibusTouristic: 460,
      AutobusNormalFloor2Axle: 480,
      AutobusNormalFloor3Axle: 470,
      AutobusLowFloorLowEntry8_12Mt: 380,
      Autobus18Mt: 400,
      DoubleDecker: 490
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Reverse Seats From Driver Position",
    group: "interiors",
    description: "A photo showing the interior seats in reverse view, including driver seat height.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !0
  },
  photo_interior_reverse_view_from_middle_aisle: {
    name: "photo_interior_reverse_view_from_middle_aisle",
    position: 440,
    position_admin: 490,
    positionByType: {
      AutobusNormalFloor2Axle: 470,
      AutobusNormalFloor3Axle: 460,
      AutobusLowFloorLowEntry8_12Mt: 370,
      Autobus18Mt: 400,
      DoubleDecker: 480
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 490,
      AutobusNormalFloor3Axle: 480,
      AutobusLowFloorLowEntry8_12Mt: 390,
      Autobus18Mt: 420,
      DoubleDecker: 500
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Reverse Seats From Middle Position",
    group: "interiors",
    description: "A reverse view photo from the middle aisle of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila: {
    name: "photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila",
    position: 450,
    position_admin: 500,
    positionByType: {
      MinibusCityIntercity: 340,
      MinibusTouristic: 450,
      AutobusNormalFloor2Axle: 480,
      AutobusNormalFloor3Axle: 470,
      AutobusLowFloorLowEntry8_12Mt: 380,
      Autobus18Mt: 410,
      DoubleDecker: 490
    },
    positionAdminByType: {
      MinibusCityIntercity: 360,
      MinibusTouristic: 470,
      AutobusNormalFloor2Axle: 500,
      AutobusNormalFloor3Axle: 490,
      AutobusLowFloorLowEntry8_12Mt: 400,
      Autobus18Mt: 430,
      DoubleDecker: 510
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Forward Seats From End Position",
    group: "interiors",
    description: "A forward view photo showing all seats, focusing on the height of the last row.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_overhead_compartments: {
    name: "photo_overhead_compartments",
    position: 460,
    position_admin: 510,
    positionByType: {
      MinibusCityIntercity: 350,
      MinibusTouristic: 460,
      AutobusNormalFloor2Axle: 490,
      AutobusNormalFloor3Axle: 480,
      AutobusLowFloorLowEntry8_12Mt: 390,
      Autobus18Mt: 420,
      DoubleDecker: 500
    },
    positionAdminByType: {
      MinibusCityIntercity: 370,
      MinibusTouristic: 480,
      AutobusNormalFloor2Axle: 510,
      AutobusNormalFloor3Axle: 500,
      AutobusLowFloorLowEntry8_12Mt: 410,
      Autobus18Mt: 440,
      DoubleDecker: 520
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle"],
    label: "Overhead Compartments",
    group: "interiors",
    description: "A photo showing the overhead compartments inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_toilette: {
    name: "photo_accessories_toilette",
    position: 470,
    position_admin: 520,
    positionByType: { AutobusNormalFloor2Axle: 510, AutobusNormalFloor3Axle: 500, DoubleDecker: 520 },
    positionAdminByType: { AutobusNormalFloor2Axle: 530, AutobusNormalFloor3Axle: 520, DoubleDecker: 540 },
    label: "Toilette",
    group: "interiors",
    description: "A photo showing the toilette accessories inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_interior_forward_view_from_middle_aisle: {
    name: "photo_interior_forward_view_from_middle_aisle",
    position: 480,
    position_admin: 530,
    positionByType: {
      AutobusNormalFloor2Axle: 500,
      AutobusNormalFloor3Axle: 490,
      AutobusLowFloorLowEntry8_12Mt: 400,
      Autobus18Mt: 430,
      DoubleDecker: 510
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 520,
      AutobusNormalFloor3Axle: 510,
      AutobusLowFloorLowEntry8_12Mt: 420,
      Autobus18Mt: 450,
      DoubleDecker: 530
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Forward Seats From Middle Position",
    group: "interiors",
    description: "A forward view photo from the middle aisle of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_floor: {
    name: "photo_hatches_floor",
    position: 490,
    position_admin: 535,
    label: "floor hatches photo",
    group: "interiors",
    description: "A photo of the floor hatches in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_central_seat_with_safety_belt_fastened: {
    name: "photo_central_seat_with_safety_belt_fastened",
    position: 500,
    position_admin: 540,
    label: "central seat safety belt",
    group: "interiors",
    description: "A photo showing the central seat with the safety belt fastened.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_internal_if_present_only_18mt: {
    name: "turntable_photo_internal_if_present_only_18mt",
    position: 510,
    position_admin: 550,
    positionByType: { Autobus18Mt: 390 },
    positionAdminByType: { Autobus18Mt: 410 },
    requiredFor: ["Autobus18Mt"],
    label: "Turntable Internal",
    group: "interiors",
    description: "An internal photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_1: {
    name: "photo_hatches_roof_1",
    position: 520,
    position_admin: 560,
    positionByType: {
      MinibusCityIntercity: 360,
      MinibusTouristic: 470,
      AutobusNormalFloor2Axle: 520,
      AutobusNormalFloor3Axle: 510,
      AutobusLowFloorLowEntry8_12Mt: 410,
      Autobus18Mt: 440,
      DoubleDecker: 780
    },
    positionAdminByType: {
      MinibusCityIntercity: 380,
      MinibusTouristic: 490,
      AutobusNormalFloor2Axle: 540,
      AutobusNormalFloor3Axle: 530,
      AutobusLowFloorLowEntry8_12Mt: 430,
      Autobus18Mt: 460,
      DoubleDecker: 800
    },
    requiredFor: ["MinibusTouristic"],
    label: "Roof Hatch 1",
    group: "interiors",
    description: "A photo of the roof hatch number 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_2: {
    name: "photo_hatches_roof_2",
    position: 530,
    position_admin: 570,
    positionByType: {
      MinibusCityIntercity: 370,
      MinibusTouristic: 480,
      AutobusNormalFloor2Axle: 530,
      AutobusNormalFloor3Axle: 520,
      AutobusLowFloorLowEntry8_12Mt: 420,
      Autobus18Mt: 450,
      DoubleDecker: 790
    },
    positionAdminByType: {
      MinibusCityIntercity: 390,
      MinibusTouristic: 500,
      AutobusNormalFloor2Axle: 550,
      AutobusNormalFloor3Axle: 540,
      AutobusLowFloorLowEntry8_12Mt: 440,
      Autobus18Mt: 470,
      DoubleDecker: 810
    },
    requiredFor: ["MinibusTouristic"],
    label: "Roof Hatch 2",
    group: "interiors",
    description: "A photo of the roof hatch number 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_3: {
    name: "photo_hatches_roof_3",
    position: 540,
    position_admin: 575,
    positionByType: {
      MinibusTouristic: 490,
      AutobusNormalFloor2Axle: 540,
      AutobusNormalFloor3Axle: 530,
      AutobusLowFloorLowEntry8_12Mt: 430,
      Autobus18Mt: 460,
      DoubleDecker: 800
    },
    positionAdminByType: {
      MinibusTouristic: 510,
      AutobusNormalFloor2Axle: 560,
      AutobusNormalFloor3Axle: 550,
      AutobusLowFloorLowEntry8_12Mt: 450,
      Autobus18Mt: 480,
      DoubleDecker: 820
    },
    label: "Roof Hatch 3",
    group: "interiors",
    description: "A photo of the roof hatch number 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_disabled_area: {
    name: "photo_disabled_area",
    position: 550,
    position_admin: 580,
    positionByType: {
      MinibusCityIntercity: 380,
      AutobusNormalFloor2Axle: 550,
      AutobusNormalFloor3Axle: 540,
      AutobusLowFloorLowEntry8_12Mt: 440,
      Autobus18Mt: 470,
      DoubleDecker: 530
    },
    positionAdminByType: {
      MinibusCityIntercity: 400,
      AutobusNormalFloor2Axle: 570,
      AutobusNormalFloor3Axle: 560,
      AutobusLowFloorLowEntry8_12Mt: 460,
      Autobus18Mt: 490,
      DoubleDecker: 550
    },
    requiredFor: ["MinibusCityIntercity", "Autobus18Mt"],
    label: "Disabled Area",
    group: "interiors",
    description: "A photo showing the designated disabled area in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_folding_seat: {
    name: "photo_folding_seat",
    position: 560,
    position_admin: 590,
    positionByType: {
      MinibusCityIntercity: 390,
      AutobusNormalFloor2Axle: 560,
      AutobusNormalFloor3Axle: 550,
      AutobusLowFloorLowEntry8_12Mt: 450,
      Autobus18Mt: 480,
      DoubleDecker: 540
    },
    positionAdminByType: {
      MinibusCityIntercity: 410,
      AutobusNormalFloor2Axle: 580,
      AutobusNormalFloor3Axle: 570,
      AutobusLowFloorLowEntry8_12Mt: 470,
      Autobus18Mt: 500,
      DoubleDecker: 560
    },
    label: "Folding Seats",
    group: "interiors",
    description: "A photo showing the folding seat in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_single_seat: {
    name: "photo_detail_of_single_seat",
    position: 570,
    position_admin: 620,
    positionByType: {
      MinibusCityIntercity: 400,
      MinibusTouristic: 500,
      AutobusNormalFloor2Axle: 570,
      AutobusNormalFloor3Axle: 560,
      AutobusLowFloorLowEntry8_12Mt: 460,
      Autobus18Mt: 490,
      DoubleDecker: 550
    },
    positionAdminByType: {
      MinibusCityIntercity: 420,
      MinibusTouristic: 520,
      AutobusNormalFloor2Axle: 590,
      AutobusNormalFloor3Axle: 580,
      AutobusLowFloorLowEntry8_12Mt: 480,
      Autobus18Mt: 510,
      DoubleDecker: 570
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Seats",
    group: "interiors",
    description: "A detailed photo of a single seat in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_mesh: {
    name: "photo_detail_of_mesh",
    position: 580,
    position_admin: 630,
    positionByType: { MinibusTouristic: 510, AutobusNormalFloor2Axle: 590, AutobusNormalFloor3Axle: 580, DoubleDecker: 570 },
    positionAdminByType: { MinibusTouristic: 530, AutobusNormalFloor2Axle: 610, AutobusNormalFloor3Axle: 600, DoubleDecker: 590 },
    label: "Mesh",
    group: "interiors",
    description: "A detailed photo of the mesh inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_table_detail: {
    name: "photo_table_detail",
    position: 590,
    position_admin: 640,
    positionByType: { MinibusTouristic: 520, AutobusNormalFloor2Axle: 600, AutobusNormalFloor3Axle: 590, DoubleDecker: 580 },
    positionAdminByType: { MinibusTouristic: 540, AutobusNormalFloor2Axle: 620, AutobusNormalFloor3Axle: 610, DoubleDecker: 600 },
    label: "Table",
    group: "interiors",
    description: "A detailed photo of the table inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_charging_usb_detail: {
    name: "photo_charging_usb_detail",
    position: 600,
    position_admin: 650,
    positionByType: { MinibusTouristic: 530, AutobusNormalFloor2Axle: 610, AutobusNormalFloor3Axle: 600, DoubleDecker: 590 },
    positionAdminByType: { MinibusTouristic: 550, AutobusNormalFloor2Axle: 630, AutobusNormalFloor3Axle: 620, DoubleDecker: 610 },
    label: "Usb Charging",
    group: "interiors",
    description: "A detailed photo showing the USB charging ports.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_armrest_detail: {
    name: "photo_armrest_detail",
    position: 610,
    position_admin: 660,
    positionByType: { MinibusTouristic: 540, AutobusNormalFloor2Axle: 580, AutobusNormalFloor3Axle: 570, DoubleDecker: 560 },
    positionAdminByType: { MinibusTouristic: 560, AutobusNormalFloor2Axle: 600, AutobusNormalFloor3Axle: 590, DoubleDecker: 580 },
    label: "Armrest",
    group: "interiors",
    description: "A detailed photo of the armrest in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_footrest_detail: {
    name: "photo_footrest_detail",
    position: 620,
    position_admin: 670,
    positionByType: { MinibusTouristic: 550, AutobusNormalFloor2Axle: 620, AutobusNormalFloor3Axle: 610, DoubleDecker: 600 },
    positionAdminByType: { MinibusTouristic: 570, AutobusNormalFloor2Axle: 640, AutobusNormalFloor3Axle: 630, DoubleDecker: 620 },
    label: "Footrest",
    group: "interiors",
    description: "A detailed photo of the footrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_detail: {
    name: "photo_monitor_detail",
    position: 630,
    position_admin: 680,
    positionByType: { MinibusTouristic: 560, AutobusNormalFloor2Axle: 640, AutobusNormalFloor3Axle: 630, DoubleDecker: 620 },
    positionAdminByType: { MinibusTouristic: 580, AutobusNormalFloor2Axle: 660, AutobusNormalFloor3Axle: 650, DoubleDecker: 640 },
    label: "Monitor",
    group: "interiors",
    description: "A detailed photo of the monitor in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_outlets_di_current_detail: {
    name: "photo_outlets_di_current_detail",
    position: 640,
    position_admin: 690,
    positionByType: { MinibusTouristic: 570, AutobusNormalFloor2Axle: 630, AutobusNormalFloor3Axle: 620, DoubleDecker: 610 },
    positionAdminByType: { MinibusTouristic: 590, AutobusNormalFloor2Axle: 650, AutobusNormalFloor3Axle: 640, DoubleDecker: 630 },
    label: "Power Outlets",
    group: "interiors",
    description: "A detailed photo of the power outlets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_coffee_machine_accessories: {
    name: "photo_coffee_machine_accessories",
    position: 650,
    position_admin: 710,
    positionByType: { MinibusTouristic: 390, AutobusNormalFloor2Axle: 430, AutobusNormalFloor3Axle: 420, DoubleDecker: 440 },
    positionAdminByType: { MinibusTouristic: 410, AutobusNormalFloor2Axle: 450, AutobusNormalFloor3Axle: 440, DoubleDecker: 460 },
    label: "Coffee Machine",
    group: "interiors",
    description: "A photo of the coffee machine accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_brackets_seats: {
    name: "photo_brackets_seats",
    position: 660,
    position_admin: 710,
    positionByType: {
      MinibusCityIntercity: 410,
      MinibusTouristic: 580,
      AutobusNormalFloor2Axle: 650,
      AutobusNormalFloor3Axle: 640,
      AutobusLowFloorLowEntry8_12Mt: 470,
      Autobus18Mt: 500,
      DoubleDecker: 660
    },
    positionAdminByType: {
      MinibusCityIntercity: 430,
      MinibusTouristic: 600,
      AutobusNormalFloor2Axle: 670,
      AutobusNormalFloor3Axle: 660,
      AutobusLowFloorLowEntry8_12Mt: 490,
      Autobus18Mt: 520,
      DoubleDecker: 680
    },
    label: "Seats Bracket",
    group: "interiors",
    description: "A photo showing the seat brackets in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_cameras: {
    name: "photo_accessories_cameras",
    position: 670,
    position_admin: 720,
    positionByType: {
      MinibusCityIntercity: 420,
      MinibusTouristic: 590,
      AutobusNormalFloor2Axle: 660,
      AutobusNormalFloor3Axle: 650,
      AutobusLowFloorLowEntry8_12Mt: 480,
      Autobus18Mt: 510,
      DoubleDecker: 670
    },
    positionAdminByType: {
      MinibusCityIntercity: 440,
      MinibusTouristic: 610,
      AutobusNormalFloor2Axle: 680,
      AutobusNormalFloor3Axle: 670,
      AutobusLowFloorLowEntry8_12Mt: 500,
      Autobus18Mt: 530,
      DoubleDecker: 690
    },
    label: "Camera",
    group: "interiors",
    description: "A photo showing the camera accessories inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  jack_e_keys_for_driver: {
    name: "jack_e_keys_for_driver",
    position: 680,
    position_admin: 730,
    label: "jack and driver keys",
    group: "interiors",
    description: "A photo showing the jack and keys for the driver.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  // Tire sizes
  spare_wheel: {
    name: "spare_wheel",
    position: 690,
    position_admin: 20,
    positionByType: {
      MinibusTouristic: 960,
      AutobusNormalFloor2Axle: 1040,
      AutobusNormalFloor3Axle: 1140,
      AutobusLowFloorLowEntry8_12Mt: 860,
      DoubleDecker: 1310
    },
    positionAdminByType: {
      MinibusTouristic: 980,
      AutobusNormalFloor2Axle: 1060,
      AutobusNormalFloor3Axle: 1160,
      AutobusLowFloorLowEntry8_12Mt: 880,
      DoubleDecker: 1330
    },
    requiredFor: ["MinibusTouristic", "AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "DoubleDecker"],
    label: "Spare Tyre",
    group: "tire-sizes",
    description: "A photo of the spare wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_front_left_measurements: {
    name: "photo_tire_front_left_measurements",
    position: 700,
    position_admin: 50,
    positionByType: {
      MinibusCityIntercity: 800,
      MinibusTouristic: 980,
      AutobusNormalFloor2Axle: 1060,
      AutobusNormalFloor3Axle: 1160,
      AutobusLowFloorLowEntry8_12Mt: 880,
      Autobus18Mt: 1060,
      DoubleDecker: 1330
    },
    positionAdminByType: {
      MinibusCityIntercity: 820,
      MinibusTouristic: 1e3,
      AutobusNormalFloor2Axle: 1080,
      AutobusNormalFloor3Axle: 1180,
      AutobusLowFloorLowEntry8_12Mt: 900,
      Autobus18Mt: 1080,
      DoubleDecker: 1350
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo showing the measurements of the front left tire.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_rear_left: {
    name: "photo_tire_rear_left",
    position: 710,
    position_admin: 110,
    positionByType: {
      MinibusCityIntercity: 820,
      MinibusTouristic: 1e3,
      AutobusNormalFloor2Axle: 1080,
      AutobusNormalFloor3Axle: 1180,
      AutobusLowFloorLowEntry8_12Mt: 900,
      Autobus18Mt: 1080,
      DoubleDecker: 1350
    },
    positionAdminByType: {
      MinibusCityIntercity: 840,
      MinibusTouristic: 1020,
      AutobusNormalFloor2Axle: 1100,
      AutobusNormalFloor3Axle: 1200,
      AutobusLowFloorLowEntry8_12Mt: 920,
      Autobus18Mt: 1100,
      DoubleDecker: 1370
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the first axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_right",
    position: 720,
    position_admin: 760,
    positionByType: {
      MinibusCityIntercity: 830,
      MinibusTouristic: 1010,
      AutobusNormalFloor2Axle: 1090,
      AutobusNormalFloor3Axle: 1190,
      AutobusLowFloorLowEntry8_12Mt: 910,
      Autobus18Mt: 1090,
      DoubleDecker: 1360
    },
    positionAdminByType: {
      MinibusCityIntercity: 850,
      MinibusTouristic: 1030,
      AutobusNormalFloor2Axle: 1110,
      AutobusNormalFloor3Axle: 1210,
      AutobusLowFloorLowEntry8_12Mt: 930,
      Autobus18Mt: 1110,
      DoubleDecker: 1380
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Second Axle Left Side: Complete Wheel",
    group: "tire-sizes",
    description: "A photo of the complete wheel on the second axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_left",
    position: 730,
    position_admin: 1190,
    positionByType: {
      MinibusCityIntercity: 850,
      MinibusTouristic: 1030,
      AutobusNormalFloor2Axle: 1110,
      AutobusNormalFloor3Axle: 1210,
      AutobusLowFloorLowEntry8_12Mt: 930,
      Autobus18Mt: 1110,
      DoubleDecker: 1380
    },
    positionAdminByType: {
      MinibusCityIntercity: 870,
      MinibusTouristic: 1050,
      AutobusNormalFloor2Axle: 1130,
      AutobusNormalFloor3Axle: 1230,
      AutobusLowFloorLowEntry8_12Mt: 950,
      Autobus18Mt: 1130,
      DoubleDecker: 1400
    },
    label: "Second Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of the tyre thickness on the second axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_left",
    position: 740,
    position_admin: 1190,
    positionByType: { AutobusNormalFloor3Axle: 1230, Autobus18Mt: 1130, DoubleDecker: 1400 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1250, Autobus18Mt: 1150, DoubleDecker: 1420 },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Left Side: Complete Wheel",
    group: "tire-sizes",
    description: "A photo of the complete wheel on the third axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_right",
    position: 750,
    position_admin: 1200,
    positionByType: { AutobusNormalFloor3Axle: 1250, Autobus18Mt: 1150, DoubleDecker: 1420 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1270, Autobus18Mt: 1170, DoubleDecker: 1440 },
    label: "Third Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of the tyre thickness on the third axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_left",
    position: 760,
    position_admin: 1210,
    positionByType: { AutobusNormalFloor3Axle: 1270, Autobus18Mt: 1170, DoubleDecker: 1440 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1290, Autobus18Mt: 1190, DoubleDecker: 1460 },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the third axle, right side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_right",
    position: 770,
    position_admin: 1220,
    positionByType: {
      MinibusCityIntercity: 880,
      MinibusTouristic: 1060,
      AutobusNormalFloor2Axle: 1140,
      AutobusNormalFloor3Axle: 1290,
      AutobusLowFloorLowEntry8_12Mt: 960,
      Autobus18Mt: 1190,
      DoubleDecker: 1460
    },
    positionAdminByType: {
      MinibusCityIntercity: 900,
      MinibusTouristic: 1080,
      AutobusNormalFloor2Axle: 1160,
      AutobusNormalFloor3Axle: 1310,
      AutobusLowFloorLowEntry8_12Mt: 980,
      Autobus18Mt: 1210,
      DoubleDecker: 1480
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the first axle, right side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Undercarriage
  photo_undercarriage_front_part_from_front: {
    name: "photo_undercarriage_front_part_from_front",
    position: 780,
    position_admin: 740,
    positionByType: {
      MinibusCityIntercity: 440,
      MinibusTouristic: 610,
      AutobusNormalFloor2Axle: 690,
      AutobusNormalFloor3Axle: 680,
      AutobusLowFloorLowEntry8_12Mt: 510,
      Autobus18Mt: 540,
      DoubleDecker: 850
    },
    positionAdminByType: {
      MinibusCityIntercity: 460,
      MinibusTouristic: 630,
      AutobusNormalFloor2Axle: 710,
      AutobusNormalFloor3Axle: 700,
      AutobusLowFloorLowEntry8_12Mt: 530,
      Autobus18Mt: 560,
      DoubleDecker: 870
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor2Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Front Undercarriage",
    group: "undercarriage",
    description: "A photo showing the front part of the undercarriage from the front.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_right: {
    name: "photo_undercarriage_axle_front_side_right",
    position: 790,
    position_admin: 770,
    positionByType: {
      MinibusCityIntercity: 510,
      MinibusTouristic: 680,
      AutobusNormalFloor2Axle: 710,
      AutobusNormalFloor3Axle: 700,
      AutobusLowFloorLowEntry8_12Mt: 530,
      Autobus18Mt: 560,
      DoubleDecker: 870
    },
    positionAdminByType: {
      MinibusCityIntercity: 530,
      MinibusTouristic: 700,
      AutobusNormalFloor2Axle: 730,
      AutobusNormalFloor3Axle: 720,
      AutobusLowFloorLowEntry8_12Mt: 550,
      Autobus18Mt: 580,
      DoubleDecker: 890
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Right Side",
    group: "undercarriage",
    description: "A photo of the front axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_right: {
    name: "photo_front_discs_right",
    position: 800,
    position_admin: 780,
    positionByType: {
      MinibusCityIntercity: 520,
      MinibusTouristic: 690,
      AutobusNormalFloor2Axle: 720,
      AutobusNormalFloor3Axle: 710,
      AutobusLowFloorLowEntry8_12Mt: 540,
      Autobus18Mt: 570,
      DoubleDecker: 880
    },
    positionAdminByType: {
      MinibusCityIntercity: 540,
      MinibusTouristic: 710,
      AutobusNormalFloor2Axle: 740,
      AutobusNormalFloor3Axle: 730,
      AutobusLowFloorLowEntry8_12Mt: 560,
      Autobus18Mt: 590,
      DoubleDecker: 900
    },
    label: "First Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_right: {
    name: "photo_front_brake_calipers_right",
    position: 810,
    position_admin: 790,
    positionByType: {
      MinibusCityIntercity: 530,
      MinibusTouristic: 700,
      AutobusNormalFloor2Axle: 730,
      AutobusNormalFloor3Axle: 720,
      AutobusLowFloorLowEntry8_12Mt: 550,
      Autobus18Mt: 580,
      DoubleDecker: 890
    },
    positionAdminByType: {
      MinibusCityIntercity: 550,
      MinibusTouristic: 720,
      AutobusNormalFloor2Axle: 750,
      AutobusNormalFloor3Axle: 740,
      AutobusLowFloorLowEntry8_12Mt: 570,
      Autobus18Mt: 600,
      DoubleDecker: 910
    },
    label: "First Axle Brake Calipers Right Side",
    group: "undercarriage",
    description: "A photo of the right front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_right: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_right",
    position: 820,
    position_admin: 800,
    positionByType: {
      MinibusCityIntercity: 540,
      MinibusTouristic: 710,
      AutobusNormalFloor2Axle: 740,
      AutobusNormalFloor3Axle: 730,
      AutobusLowFloorLowEntry8_12Mt: 560,
      Autobus18Mt: 590,
      DoubleDecker: 900
    },
    positionAdminByType: {
      MinibusCityIntercity: 560,
      MinibusTouristic: 730,
      AutobusNormalFloor2Axle: 760,
      AutobusNormalFloor3Axle: 750,
      AutobusLowFloorLowEntry8_12Mt: 580,
      Autobus18Mt: 610,
      DoubleDecker: 920
    },
    label: "First Axle Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right",
    position: 830,
    position_admin: 810,
    positionByType: {
      MinibusCityIntercity: 550,
      MinibusTouristic: 720,
      AutobusNormalFloor2Axle: 750,
      AutobusNormalFloor3Axle: 740,
      AutobusLowFloorLowEntry8_12Mt: 570,
      Autobus18Mt: 600,
      DoubleDecker: 910
    },
    positionAdminByType: {
      MinibusCityIntercity: 570,
      MinibusTouristic: 740,
      AutobusNormalFloor2Axle: 770,
      AutobusNormalFloor3Axle: 760,
      AutobusLowFloorLowEntry8_12Mt: 590,
      Autobus18Mt: 620,
      DoubleDecker: 930
    },
    label: "First Axle Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_central: {
    name: "photo_undercarriage_axle_front_central",
    position: 840,
    position_admin: 820,
    positionByType: {
      MinibusCityIntercity: 500,
      MinibusTouristic: 670,
      AutobusNormalFloor2Axle: 700,
      AutobusNormalFloor3Axle: 690,
      AutobusLowFloorLowEntry8_12Mt: 520,
      Autobus18Mt: 550,
      DoubleDecker: 860
    },
    positionAdminByType: {
      MinibusCityIntercity: 520,
      MinibusTouristic: 690,
      AutobusNormalFloor2Axle: 720,
      AutobusNormalFloor3Axle: 710,
      AutobusLowFloorLowEntry8_12Mt: 540,
      Autobus18Mt: 570,
      DoubleDecker: 880
    },
    label: "First Axle Central",
    group: "undercarriage",
    description: "A photo of the front axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_left: {
    name: "photo_undercarriage_axle_front_side_left",
    position: 850,
    position_admin: 830,
    positionByType: {
      MinibusCityIntercity: 560,
      MinibusTouristic: 730,
      AutobusNormalFloor2Axle: 760,
      AutobusNormalFloor3Axle: 750,
      AutobusLowFloorLowEntry8_12Mt: 580,
      Autobus18Mt: 610,
      DoubleDecker: 920
    },
    positionAdminByType: {
      MinibusCityIntercity: 580,
      MinibusTouristic: 750,
      AutobusNormalFloor2Axle: 780,
      AutobusNormalFloor3Axle: 770,
      AutobusLowFloorLowEntry8_12Mt: 600,
      Autobus18Mt: 630,
      DoubleDecker: 940
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Left Side",
    group: "undercarriage",
    description: "A photo of the front axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_left: {
    name: "photo_front_discs_left",
    position: 860,
    position_admin: 840,
    positionByType: {
      MinibusCityIntercity: 570,
      MinibusTouristic: 740,
      AutobusNormalFloor2Axle: 770,
      AutobusNormalFloor3Axle: 760,
      AutobusLowFloorLowEntry8_12Mt: 590,
      Autobus18Mt: 620,
      DoubleDecker: 930
    },
    positionAdminByType: {
      MinibusCityIntercity: 590,
      MinibusTouristic: 760,
      AutobusNormalFloor2Axle: 790,
      AutobusNormalFloor3Axle: 780,
      AutobusLowFloorLowEntry8_12Mt: 610,
      Autobus18Mt: 640,
      DoubleDecker: 950
    },
    label: "First Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_left: {
    name: "photo_front_brake_calipers_left",
    position: 870,
    position_admin: 850,
    positionByType: {
      MinibusCityIntercity: 580,
      MinibusTouristic: 750,
      AutobusNormalFloor2Axle: 780,
      AutobusNormalFloor3Axle: 770,
      AutobusLowFloorLowEntry8_12Mt: 600,
      Autobus18Mt: 630,
      DoubleDecker: 940
    },
    positionAdminByType: {
      MinibusCityIntercity: 600,
      MinibusTouristic: 770,
      AutobusNormalFloor2Axle: 800,
      AutobusNormalFloor3Axle: 790,
      AutobusLowFloorLowEntry8_12Mt: 620,
      Autobus18Mt: 650,
      DoubleDecker: 960
    },
    label: "First Axle Brake Calipers Left Side",
    group: "undercarriage",
    description: "A photo of the left front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_left: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_left",
    position: 880,
    position_admin: 860,
    positionByType: {
      MinibusCityIntercity: 590,
      MinibusTouristic: 760,
      AutobusNormalFloor2Axle: 790,
      AutobusNormalFloor3Axle: 780,
      AutobusLowFloorLowEntry8_12Mt: 610,
      Autobus18Mt: 640,
      DoubleDecker: 950
    },
    positionAdminByType: {
      MinibusCityIntercity: 610,
      MinibusTouristic: 780,
      AutobusNormalFloor2Axle: 810,
      AutobusNormalFloor3Axle: 800,
      AutobusLowFloorLowEntry8_12Mt: 630,
      Autobus18Mt: 660,
      DoubleDecker: 970
    },
    label: "First Axle Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left",
    position: 890,
    position_admin: 870,
    positionByType: {
      MinibusCityIntercity: 600,
      MinibusTouristic: 770,
      AutobusNormalFloor2Axle: 800,
      AutobusNormalFloor3Axle: 790,
      AutobusLowFloorLowEntry8_12Mt: 620,
      Autobus18Mt: 650,
      DoubleDecker: 960
    },
    positionAdminByType: {
      MinibusCityIntercity: 620,
      MinibusTouristic: 790,
      AutobusNormalFloor2Axle: 820,
      AutobusNormalFloor3Axle: 810,
      AutobusLowFloorLowEntry8_12Mt: 640,
      Autobus18Mt: 670,
      DoubleDecker: 980
    },
    label: "First Axle Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_central: {
    name: "photo_undercarriage_central",
    position: 900,
    position_admin: 880,
    positionByType: {
      MinibusCityIntercity: 610,
      MinibusTouristic: 780,
      AutobusNormalFloor2Axle: 810,
      AutobusNormalFloor3Axle: 800,
      AutobusLowFloorLowEntry8_12Mt: 630,
      Autobus18Mt: 660,
      DoubleDecker: 970
    },
    positionAdminByType: {
      MinibusCityIntercity: 630,
      MinibusTouristic: 800,
      AutobusNormalFloor2Axle: 830,
      AutobusNormalFloor3Axle: 820,
      AutobusLowFloorLowEntry8_12Mt: 650,
      Autobus18Mt: 680,
      DoubleDecker: 990
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Central Undercarriage",
    group: "undercarriage",
    description: "A photo of the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_right: {
    name: "photo_discs_axle_central_right",
    position: 910,
    position_admin: 890,
    positionByType: {
      MinibusCityIntercity: 640,
      MinibusTouristic: 810,
      AutobusNormalFloor2Axle: 840,
      AutobusNormalFloor3Axle: 830,
      AutobusLowFloorLowEntry8_12Mt: 660,
      Autobus18Mt: 690,
      DoubleDecker: 1e3
    },
    positionAdminByType: {
      MinibusCityIntercity: 660,
      MinibusTouristic: 830,
      AutobusNormalFloor2Axle: 860,
      AutobusNormalFloor3Axle: 850,
      AutobusLowFloorLowEntry8_12Mt: 680,
      Autobus18Mt: 710,
      DoubleDecker: 1020
    },
    label: "Second Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_right: {
    name: "photo_caliper_brakes_axle_central_right",
    position: 920,
    position_admin: 900,
    positionByType: {
      MinibusCityIntercity: 650,
      MinibusTouristic: 820,
      AutobusNormalFloor2Axle: 850,
      AutobusNormalFloor3Axle: 840,
      AutobusLowFloorLowEntry8_12Mt: 670,
      Autobus18Mt: 700,
      DoubleDecker: 1010
    },
    positionAdminByType: {
      MinibusCityIntercity: 670,
      MinibusTouristic: 840,
      AutobusNormalFloor2Axle: 870,
      AutobusNormalFloor3Axle: 860,
      AutobusLowFloorLowEntry8_12Mt: 690,
      Autobus18Mt: 720,
      DoubleDecker: 1030
    },
    label: "Second Axle Caliper Brakes Right Side",
    group: "undercarriage",
    description: "A photo of the right brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_1",
    position: 930,
    position_admin: 910,
    label: "Second Axle Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_2",
    position: 940,
    position_admin: 920,
    label: "Second Axle Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1",
    position: 950,
    position_admin: 930,
    positionByType: {
      MinibusCityIntercity: 670,
      MinibusTouristic: 840,
      AutobusNormalFloor2Axle: 870,
      AutobusNormalFloor3Axle: 860,
      AutobusLowFloorLowEntry8_12Mt: 690,
      Autobus18Mt: 720,
      DoubleDecker: 1030
    },
    positionAdminByType: {
      MinibusCityIntercity: 690,
      MinibusTouristic: 860,
      AutobusNormalFloor2Axle: 890,
      AutobusNormalFloor3Axle: 880,
      AutobusLowFloorLowEntry8_12Mt: 710,
      Autobus18Mt: 740,
      DoubleDecker: 1050
    },
    label: "Second Axle First Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the first right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2",
    position: 960,
    position_admin: 940,
    positionByType: {
      MinibusCityIntercity: 690,
      MinibusTouristic: 860,
      AutobusNormalFloor2Axle: 890,
      AutobusNormalFloor3Axle: 880,
      AutobusLowFloorLowEntry8_12Mt: 710,
      Autobus18Mt: 740,
      DoubleDecker: 1050
    },
    positionAdminByType: {
      MinibusCityIntercity: 710,
      MinibusTouristic: 880,
      AutobusNormalFloor2Axle: 910,
      AutobusNormalFloor3Axle: 900,
      AutobusLowFloorLowEntry8_12Mt: 730,
      Autobus18Mt: 760,
      DoubleDecker: 1070
    },
    label: "Second Axle Second Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the second right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_left: {
    name: "photo_discs_axle_central_left",
    position: 970,
    position_admin: 950,
    positionByType: {
      MinibusCityIntercity: 710,
      MinibusTouristic: 880,
      AutobusNormalFloor2Axle: 910,
      AutobusNormalFloor3Axle: 900,
      AutobusLowFloorLowEntry8_12Mt: 730,
      Autobus18Mt: 760,
      DoubleDecker: 1070
    },
    positionAdminByType: {
      MinibusCityIntercity: 730,
      MinibusTouristic: 900,
      AutobusNormalFloor2Axle: 930,
      AutobusNormalFloor3Axle: 920,
      AutobusLowFloorLowEntry8_12Mt: 750,
      Autobus18Mt: 780,
      DoubleDecker: 1090
    },
    label: "Second Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_left: {
    name: "photo_caliper_brakes_axle_central_left",
    position: 980,
    position_admin: 960,
    positionByType: {
      MinibusCityIntercity: 720,
      MinibusTouristic: 890,
      AutobusNormalFloor2Axle: 920,
      AutobusNormalFloor3Axle: 910,
      AutobusLowFloorLowEntry8_12Mt: 740,
      Autobus18Mt: 770,
      DoubleDecker: 1080
    },
    positionAdminByType: {
      MinibusCityIntercity: 740,
      MinibusTouristic: 910,
      AutobusNormalFloor2Axle: 940,
      AutobusNormalFloor3Axle: 930,
      AutobusLowFloorLowEntry8_12Mt: 760,
      Autobus18Mt: 790,
      DoubleDecker: 1100
    },
    label: "Second Axle Caliper Brakes Left Side",
    group: "undercarriage",
    description: "A photo of the left brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_1",
    position: 990,
    position_admin: 970,
    positionByType: {
      MinibusCityIntercity: 730,
      MinibusTouristic: 900,
      AutobusNormalFloor2Axle: 930,
      AutobusNormalFloor3Axle: 920,
      AutobusLowFloorLowEntry8_12Mt: 750,
      Autobus18Mt: 780,
      DoubleDecker: 1090
    },
    positionAdminByType: {
      MinibusCityIntercity: 750,
      MinibusTouristic: 920,
      AutobusNormalFloor2Axle: 950,
      AutobusNormalFloor3Axle: 940,
      AutobusLowFloorLowEntry8_12Mt: 770,
      Autobus18Mt: 800,
      DoubleDecker: 1110
    },
    label: "Second Axle First Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the first left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_first_shock_absorbers_right_side: {
    name: "photo_second_axle_first_shock_absorbers_right_side",
    position: 995,
    position_admin: 995,
    positionByType: {
      MinibusCityIntercity: 660,
      MinibusTouristic: 830,
      AutobusNormalFloor2Axle: 860,
      AutobusNormalFloor3Axle: 850,
      AutobusLowFloorLowEntry8_12Mt: 680,
      Autobus18Mt: 710,
      DoubleDecker: 1020
    },
    positionAdminByType: {
      MinibusCityIntercity: 680,
      MinibusTouristic: 850,
      AutobusNormalFloor2Axle: 880,
      AutobusNormalFloor3Axle: 870,
      AutobusLowFloorLowEntry8_12Mt: 700,
      Autobus18Mt: 730,
      DoubleDecker: 1040
    },
    label: "Second Axle First Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1",
    position: 1e3,
    position_admin: 980,
    positionByType: {
      MinibusCityIntercity: 740,
      MinibusTouristic: 910,
      AutobusNormalFloor2Axle: 940,
      AutobusNormalFloor3Axle: 930,
      AutobusLowFloorLowEntry8_12Mt: 760,
      Autobus18Mt: 790,
      DoubleDecker: 1100
    },
    positionAdminByType: {
      MinibusCityIntercity: 760,
      MinibusTouristic: 930,
      AutobusNormalFloor2Axle: 960,
      AutobusNormalFloor3Axle: 950,
      AutobusLowFloorLowEntry8_12Mt: 780,
      Autobus18Mt: 810,
      DoubleDecker: 1120
    },
    label: "Second Axle First Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the first left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_second_shock_absorbers_right_side: {
    name: "photo_second_axle_second_shock_absorbers_right_side",
    position: 1005,
    position_admin: 1005,
    positionByType: {
      MinibusCityIntercity: 680,
      MinibusTouristic: 850,
      AutobusNormalFloor2Axle: 880,
      AutobusNormalFloor3Axle: 870,
      AutobusLowFloorLowEntry8_12Mt: 700,
      Autobus18Mt: 730,
      DoubleDecker: 1040
    },
    positionAdminByType: {
      MinibusCityIntercity: 700,
      MinibusTouristic: 870,
      AutobusNormalFloor2Axle: 900,
      AutobusNormalFloor3Axle: 890,
      AutobusLowFloorLowEntry8_12Mt: 720,
      Autobus18Mt: 750,
      DoubleDecker: 1060
    },
    label: "Second Axle Second Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the second right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_2",
    position: 1010,
    position_admin: 990,
    positionByType: {
      MinibusCityIntercity: 750,
      MinibusTouristic: 920,
      AutobusNormalFloor2Axle: 950,
      AutobusNormalFloor3Axle: 940,
      AutobusLowFloorLowEntry8_12Mt: 770,
      Autobus18Mt: 800,
      DoubleDecker: 1110
    },
    positionAdminByType: {
      MinibusCityIntercity: 770,
      MinibusTouristic: 940,
      AutobusNormalFloor2Axle: 970,
      AutobusNormalFloor3Axle: 960,
      AutobusLowFloorLowEntry8_12Mt: 790,
      Autobus18Mt: 820,
      DoubleDecker: 1130
    },
    label: "Second Axle Second Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the second left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2",
    position: 1020,
    position_admin: 1e3,
    positionByType: {
      MinibusCityIntercity: 760,
      MinibusTouristic: 930,
      AutobusNormalFloor2Axle: 960,
      AutobusNormalFloor3Axle: 950,
      AutobusLowFloorLowEntry8_12Mt: 780,
      Autobus18Mt: 810,
      DoubleDecker: 1120
    },
    positionAdminByType: {
      MinibusCityIntercity: 780,
      MinibusTouristic: 950,
      AutobusNormalFloor2Axle: 980,
      AutobusNormalFloor3Axle: 970,
      AutobusLowFloorLowEntry8_12Mt: 800,
      Autobus18Mt: 830,
      DoubleDecker: 1140
    },
    label: "Second Axle Second Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the second left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_central: {
    name: "photo_undercarriage_axle_rear_central",
    position: 1030,
    position_admin: 1010,
    positionByType: {
      MinibusCityIntercity: 620,
      MinibusTouristic: 790,
      AutobusNormalFloor2Axle: 820,
      AutobusNormalFloor3Axle: 810,
      AutobusLowFloorLowEntry8_12Mt: 640,
      Autobus18Mt: 670,
      DoubleDecker: 980
    },
    positionAdminByType: {
      MinibusCityIntercity: 640,
      MinibusTouristic: 810,
      AutobusNormalFloor2Axle: 840,
      AutobusNormalFloor3Axle: 830,
      AutobusLowFloorLowEntry8_12Mt: 660,
      Autobus18Mt: 690,
      DoubleDecker: 1e3
    },
    label: "Second Axle Central",
    group: "undercarriage",
    description: "A photo of the second axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_right: {
    name: "photo_undercarriage_axle_rear_side_right",
    position: 1040,
    position_admin: 1020,
    positionByType: {
      MinibusCityIntercity: 700,
      MinibusTouristic: 870,
      AutobusNormalFloor2Axle: 900,
      AutobusNormalFloor3Axle: 890,
      AutobusLowFloorLowEntry8_12Mt: 720,
      Autobus18Mt: 750,
      DoubleDecker: 1060
    },
    positionAdminByType: {
      MinibusCityIntercity: 720,
      MinibusTouristic: 890,
      AutobusNormalFloor2Axle: 920,
      AutobusNormalFloor3Axle: 910,
      AutobusLowFloorLowEntry8_12Mt: 740,
      Autobus18Mt: 770,
      DoubleDecker: 1080
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Second Axle Left Side",
    group: "undercarriage",
    description: "A photo of the second axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_right_side: {
    name: "photo_second_axle_right_side",
    position: 1045,
    position_admin: 1045,
    positionByType: {
      MinibusCityIntercity: 630,
      MinibusTouristic: 800,
      AutobusNormalFloor2Axle: 830,
      AutobusNormalFloor3Axle: 820,
      AutobusLowFloorLowEntry8_12Mt: 650,
      Autobus18Mt: 680,
      DoubleDecker: 990
    },
    positionAdminByType: {
      MinibusCityIntercity: 650,
      MinibusTouristic: 820,
      AutobusNormalFloor2Axle: 850,
      AutobusNormalFloor3Axle: 840,
      AutobusLowFloorLowEntry8_12Mt: 670,
      Autobus18Mt: 700,
      DoubleDecker: 1010
    },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic", "AutobusNormalFloor2Axle", "DoubleDecker"],
    label: "Second Axle Right Side",
    group: "undercarriage",
    description: "A photo of the second axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_right: {
    name: "photo_discs_rear_right",
    position: 1050,
    position_admin: 1030,
    positionByType: { AutobusNormalFloor3Axle: 980, Autobus18Mt: 850, DoubleDecker: 1150 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1e3, Autobus18Mt: 870, DoubleDecker: 1170 },
    label: "Third Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_right: {
    name: "photo_caliper_brakes_rear_right",
    position: 1060,
    position_admin: 1040,
    positionByType: { AutobusNormalFloor3Axle: 990, Autobus18Mt: 860, DoubleDecker: 1160 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1010, Autobus18Mt: 880, DoubleDecker: 1180 },
    label: "Third Axle Caliper Brakes Right Side",
    group: "undercarriage",
    description: "A photo of the right caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_1: {
    name: "photo_rear_shock_absorbers_right_1",
    position: 1070,
    position_admin: 1050,
    positionByType: { AutobusNormalFloor3Axle: 1e3, Autobus18Mt: 870, DoubleDecker: 1170 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1020, Autobus18Mt: 890, DoubleDecker: 1190 },
    label: "Third Axle First Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_1: {
    name: "photo_rear_air_springs_if_present_right_1",
    position: 1080,
    position_admin: 1060,
    positionByType: { AutobusNormalFloor3Axle: 1010, Autobus18Mt: 880, DoubleDecker: 1180 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1030, Autobus18Mt: 900, DoubleDecker: 1200 },
    label: "Third Axle First Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_2: {
    name: "photo_rear_shock_absorbers_right_2",
    position: 1090,
    position_admin: 1070,
    positionByType: { Autobus18Mt: 890 },
    positionAdminByType: { Autobus18Mt: 910 },
    label: "Third Axle Second Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 2) axel 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_2: {
    name: "photo_rear_air_springs_if_present_right_2",
    position: 1100,
    position_admin: 1080,
    positionByType: { Autobus18Mt: 900 },
    positionAdminByType: { Autobus18Mt: 920 },
    label: "Third Axle Second Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 2) axel 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_right: {
    name: "photo_rear_leaf_spring_if_present_right",
    position: 1110,
    position_admin: 1090,
    label: "axel 2 leaf spring right",
    group: "undercarriage",
    description: "A photo of the right leaf spring if present axle 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_left: {
    name: "photo_undercarriage_axle_rear_side_left",
    position: 1120,
    position_admin: 1100,
    positionByType: {
      AutobusNormalFloor3Axle: 970,
      Autobus18Mt: 840,
      DoubleDecker: 1140
    },
    positionAdminByType: {
      AutobusNormalFloor3Axle: 990,
      Autobus18Mt: 860,
      DoubleDecker: 1160
    },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Right Side",
    group: "undercarriage",
    description: "A photo of the third axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_left: {
    name: "photo_discs_rear_left",
    position: 1130,
    position_admin: 1110,
    positionByType: { AutobusNormalFloor3Axle: 1030, Autobus18Mt: 920, DoubleDecker: 1200 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1050, Autobus18Mt: 940, DoubleDecker: 1220 },
    label: "Third Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_left: {
    name: "photo_caliper_brakes_rear_left",
    position: 1140,
    position_admin: 1120,
    positionByType: { AutobusNormalFloor3Axle: 1040, Autobus18Mt: 930, DoubleDecker: 1210 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1060, Autobus18Mt: 950, DoubleDecker: 1230 },
    label: "Third Axle Caliper Brakes Left Side",
    group: "undercarriage",
    description: "A photo of the left caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_1: {
    name: "photo_rear_shock_absorbers_left_1",
    position: 1150,
    position_admin: 1130,
    positionByType: { AutobusNormalFloor3Axle: 1050, Autobus18Mt: 940, DoubleDecker: 1220 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1070, Autobus18Mt: 960, DoubleDecker: 1240 },
    label: "Third Axle First Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_2: {
    name: "photo_rear_shock_absorbers_left_2",
    position: 1160,
    position_admin: 1140,
    positionByType: { Autobus18Mt: 960 },
    positionAdminByType: { Autobus18Mt: 980 },
    label: "Third Axle Second Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 2) axel 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_1: {
    name: "photo_rear_air_springs_if_present_left_1",
    position: 1170,
    position_admin: 1150,
    positionByType: { AutobusNormalFloor3Axle: 1060, Autobus18Mt: 950, DoubleDecker: 1230 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1080, Autobus18Mt: 970, DoubleDecker: 1250 },
    label: "Third Axle First Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left air springs if present (position 1) axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_2: {
    name: "photo_rear_air_springs_if_present_left_2",
    position: 1180,
    position_admin: 1160,
    positionByType: { Autobus18Mt: 970 },
    positionAdminByType: { Autobus18Mt: 990 },
    label: "Third Axle Second Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left rear air springs if present (position 2).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_left: {
    name: "photo_rear_leaf_spring_if_present_left",
    position: 1190,
    position_admin: 1170,
    label: "axel 3 leaf spring left",
    group: "undercarriage",
    description: "A photo of the left leaf spring if present. Axle 3",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_differential: {
    name: "photo_differential",
    position: 1200,
    position_admin: 1180,
    positionByType: {
      MinibusCityIntercity: 770,
      MinibusTouristic: 940,
      AutobusNormalFloor2Axle: 970,
      AutobusNormalFloor3Axle: 1070,
      AutobusLowFloorLowEntry8_12Mt: 790,
      Autobus18Mt: 980,
      DoubleDecker: 1240
    },
    positionAdminByType: {
      MinibusCityIntercity: 790,
      MinibusTouristic: 960,
      AutobusNormalFloor2Axle: 990,
      AutobusNormalFloor3Axle: 1090,
      AutobusLowFloorLowEntry8_12Mt: 810,
      Autobus18Mt: 1e3,
      DoubleDecker: 1260
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Differential",
    group: "undercarriage",
    description: "A photo of the vehicle's differential.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_gearbox: {
    name: "photo_gearbox",
    position: 1210,
    position_admin: 1230,
    positionByType: {
      MinibusCityIntercity: 450,
      MinibusTouristic: 620,
      AutobusNormalFloor2Axle: 990,
      AutobusNormalFloor3Axle: 1090,
      AutobusLowFloorLowEntry8_12Mt: 810,
      Autobus18Mt: 1e3,
      DoubleDecker: 1260
    },
    positionAdminByType: {
      MinibusCityIntercity: 470,
      MinibusTouristic: 640,
      AutobusNormalFloor2Axle: 1010,
      AutobusNormalFloor3Axle: 1110,
      AutobusLowFloorLowEntry8_12Mt: 830,
      Autobus18Mt: 1020,
      DoubleDecker: 1280
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Gearbox",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_gearbox: {
    name: "photo_plate_gearbox",
    position: 1220,
    position_admin: 1240,
    positionByType: {
      AutobusNormalFloor2Axle: 1e3,
      AutobusNormalFloor3Axle: 1100,
      AutobusLowFloorLowEntry8_12Mt: 820,
      Autobus18Mt: 1010,
      DoubleDecker: 1270
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 1020,
      AutobusNormalFloor3Axle: 1120,
      AutobusLowFloorLowEntry8_12Mt: 840,
      Autobus18Mt: 1030,
      DoubleDecker: 1290
    },
    label: "Gearbox Plate",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox plate.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driveshaft: {
    name: "photo_driveshaft",
    position: 1230,
    position_admin: 1250,
    positionByType: {
      MinibusCityIntercity: 480,
      MinibusTouristic: 650,
      AutobusNormalFloor2Axle: 980,
      AutobusNormalFloor3Axle: 1080,
      AutobusLowFloorLowEntry8_12Mt: 800,
      Autobus18Mt: 990,
      DoubleDecker: 1250
    },
    positionAdminByType: {
      MinibusCityIntercity: 500,
      MinibusTouristic: 670,
      AutobusNormalFloor2Axle: 1e3,
      AutobusNormalFloor3Axle: 1100,
      AutobusLowFloorLowEntry8_12Mt: 820,
      Autobus18Mt: 1010,
      DoubleDecker: 1270
    },
    label: "Driveshaft",
    group: "undercarriage",
    description: "A photo of the vehicle's driveshaft.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_engine_below_without_protection: {
    name: "photo_engine_below_without_protection",
    position: 1240,
    position_admin: 1260,
    positionByType: {
      MinibusCityIntercity: 460,
      MinibusTouristic: 630,
      AutobusNormalFloor2Axle: 1010,
      AutobusNormalFloor3Axle: 1110,
      AutobusLowFloorLowEntry8_12Mt: 830,
      Autobus18Mt: 1020,
      DoubleDecker: 1280
    },
    positionAdminByType: {
      MinibusCityIntercity: 480,
      MinibusTouristic: 650,
      AutobusNormalFloor2Axle: 1030,
      AutobusNormalFloor3Axle: 1130,
      AutobusLowFloorLowEntry8_12Mt: 850,
      Autobus18Mt: 1040,
      DoubleDecker: 1300
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"],
    label: "Engine Without Protection",
    group: "undercarriage",
    description: "A photo showing the engine from below without any protection.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_exhaust: {
    name: "photo_exhaust",
    position: 1250,
    position_admin: 1270,
    positionByType: {
      MinibusCityIntercity: 490,
      MinibusTouristic: 660,
      AutobusNormalFloor2Axle: 1020,
      AutobusNormalFloor3Axle: 1120,
      AutobusLowFloorLowEntry8_12Mt: 840,
      Autobus18Mt: 1030,
      DoubleDecker: 1290
    },
    positionAdminByType: {
      MinibusCityIntercity: 510,
      MinibusTouristic: 680,
      AutobusNormalFloor2Axle: 1040,
      AutobusNormalFloor3Axle: 1140,
      AutobusLowFloorLowEntry8_12Mt: 860,
      Autobus18Mt: 1050,
      DoubleDecker: 1310
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Exhaust",
    group: "undercarriage",
    description: "A photo showing the vehicle's exhaust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_axle_central_18_meters: {
    name: "photo_axle_central_18_meters",
    position: 1260,
    position_admin: 1280,
    label: "central axle (18m)",
    group: "undercarriage",
    description: "A photo of the central axle for 18-meter vehicles.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_bellows_turntable_18_meters: {
    name: "photo_bellows_turntable_18_meters",
    position: 1270,
    position_admin: 1290,
    positionByType: { Autobus18Mt: 820 },
    positionAdminByType: { Autobus18Mt: 840 },
    label: "Undercarriage Turntable",
    group: "undercarriage",
    description: "A photo showing the bellows of the turntable for 18-meter vehicles.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  // Technical Data
  photo_chassis_vin: {
    name: "photo_chassis_vin",
    position: 1280,
    position_admin: 1300,
    positionAdminByType: {
      MinibusCityIntercity: 10,
      MinibusTouristic: 10,
      AutobusNormalFloor2Axle: 10,
      AutobusNormalFloor3Axle: 10,
      AutobusLowFloorLowEntry8_12Mt: 10,
      Autobus18Mt: 10,
      DoubleDecker: 10
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Vin",
    group: "technical-data",
    description: "A photo of the vehicle's chassis VIN.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1,
    isInternal: !0
  },
  photo_any_devices_onboard_3: {
    name: "photo_any_devices_onboard_3",
    position: 1290,
    position_admin: 1310,
    positionByType: { MinibusCityIntercity: 110, MinibusTouristic: 100 },
    positionAdminByType: { MinibusCityIntercity: 130, MinibusTouristic: 120 },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic"],
    label: "Front Engine",
    group: "exteriors",
    description: "A photo of the engine at the front of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_fourth_door_open: {
    name: "photo_fourth_door_open",
    position: 145,
    position_admin: 145,
    positionByType: { Autobus18Mt: 170 },
    positionAdminByType: { Autobus18Mt: 190 },
    label: "Fourth Door Open",
    group: "exteriors",
    description: "A photo of: Fourth Door Open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_first_axle_left_side_complete_tyre: {
    name: "photo_first_axle_left_side_complete_tyre",
    position: 695,
    position_admin: 695,
    positionByType: {
      MinibusCityIntercity: 790,
      MinibusTouristic: 970,
      AutobusNormalFloor2Axle: 1050,
      AutobusNormalFloor3Axle: 1150,
      AutobusLowFloorLowEntry8_12Mt: 870,
      Autobus18Mt: 1050,
      DoubleDecker: 1320
    },
    positionAdminByType: {
      MinibusCityIntercity: 810,
      MinibusTouristic: 990,
      AutobusNormalFloor2Axle: 1070,
      AutobusNormalFloor3Axle: 1170,
      AutobusLowFloorLowEntry8_12Mt: 890,
      Autobus18Mt: 1070,
      DoubleDecker: 1340
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "First Axle Left Side: Complete Tyre",
    group: "tire-sizes",
    description: "A photo of: First Axle Left Side: Complete Tyre.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_first_axle_left_side_tyre_thickness: {
    name: "photo_first_axle_left_side_tyre_thickness",
    position: 705,
    position_admin: 705,
    positionByType: {
      MinibusCityIntercity: 810,
      MinibusTouristic: 990,
      AutobusNormalFloor2Axle: 1070,
      AutobusNormalFloor3Axle: 1170,
      AutobusLowFloorLowEntry8_12Mt: 890,
      Autobus18Mt: 1070,
      DoubleDecker: 1340
    },
    positionAdminByType: {
      MinibusCityIntercity: 830,
      MinibusTouristic: 1010,
      AutobusNormalFloor2Axle: 1090,
      AutobusNormalFloor3Axle: 1190,
      AutobusLowFloorLowEntry8_12Mt: 910,
      Autobus18Mt: 1090,
      DoubleDecker: 1360
    },
    label: "First Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of: First Axle Left Side: Tyre Thickness.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_left_side_tyre_size: {
    name: "photo_second_axle_left_side_tyre_size",
    position: 725,
    position_admin: 725,
    positionByType: {
      MinibusCityIntercity: 840,
      MinibusTouristic: 1020,
      AutobusNormalFloor2Axle: 1100,
      AutobusNormalFloor3Axle: 1200,
      AutobusLowFloorLowEntry8_12Mt: 920,
      Autobus18Mt: 1100,
      DoubleDecker: 1370
    },
    positionAdminByType: {
      MinibusCityIntercity: 860,
      MinibusTouristic: 1040,
      AutobusNormalFloor2Axle: 1120,
      AutobusNormalFloor3Axle: 1220,
      AutobusLowFloorLowEntry8_12Mt: 940,
      Autobus18Mt: 1120,
      DoubleDecker: 1390
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Second Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo of: Second Axle Left Side: Tyre Size.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_left_side_tyre_tread: {
    name: "photo_second_axle_left_side_tyre_tread",
    position: 735,
    position_admin: 735,
    positionByType: {
      MinibusCityIntercity: 860,
      MinibusTouristic: 1040,
      AutobusNormalFloor2Axle: 1120,
      AutobusNormalFloor3Axle: 1220,
      AutobusLowFloorLowEntry8_12Mt: 940,
      Autobus18Mt: 1120,
      DoubleDecker: 1390
    },
    positionAdminByType: {
      MinibusCityIntercity: 880,
      MinibusTouristic: 1060,
      AutobusNormalFloor2Axle: 1140,
      AutobusNormalFloor3Axle: 1240,
      AutobusLowFloorLowEntry8_12Mt: 960,
      Autobus18Mt: 1140,
      DoubleDecker: 1410
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Second Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Second Axle Left Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side_tyre_size: {
    name: "photo_third_axle_left_side_tyre_size",
    position: 745,
    position_admin: 745,
    positionByType: { AutobusNormalFloor3Axle: 1240, Autobus18Mt: 1140, DoubleDecker: 1410 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1260, Autobus18Mt: 1160, DoubleDecker: 1430 },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo of: Third Axle Left Side: Tyre Size.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side_tyre_tread: {
    name: "photo_third_axle_left_side_tyre_tread",
    position: 755,
    position_admin: 755,
    positionByType: { AutobusNormalFloor3Axle: 1260, Autobus18Mt: 1160, DoubleDecker: 1430 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1280, Autobus18Mt: 1180, DoubleDecker: 1450 },
    requiredFor: ["AutobusNormalFloor3Axle", "Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Third Axle Left Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_right_side_tyre_tread: {
    name: "photo_second_axle_right_side_tyre_tread",
    position: 765,
    position_admin: 765,
    positionByType: {
      MinibusCityIntercity: 870,
      MinibusTouristic: 1050,
      AutobusNormalFloor2Axle: 1130,
      AutobusNormalFloor3Axle: 1280,
      AutobusLowFloorLowEntry8_12Mt: 950,
      Autobus18Mt: 1180,
      DoubleDecker: 1450
    },
    positionAdminByType: {
      MinibusCityIntercity: 890,
      MinibusTouristic: 1070,
      AutobusNormalFloor2Axle: 1150,
      AutobusNormalFloor3Axle: 1300,
      AutobusLowFloorLowEntry8_12Mt: 970,
      Autobus18Mt: 1200,
      DoubleDecker: 1470
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Second Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Second Axle Right Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side: {
    name: "photo_third_axle_left_side",
    position: 1185,
    position_admin: 1185,
    positionByType: { AutobusNormalFloor3Axle: 1020, Autobus18Mt: 910, DoubleDecker: 1190 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1040, Autobus18Mt: 930, DoubleDecker: 1210 },
    requiredFor: ["Autobus18Mt", "DoubleDecker"],
    label: "Third Axle Left Side",
    group: "undercarriage",
    description: "A photo of: Third Axle Left Side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_central: {
    name: "photo_third_axle_central",
    position: 1195,
    position_admin: 1195,
    positionByType: { AutobusNormalFloor3Axle: 960, Autobus18Mt: 830, DoubleDecker: 1130 },
    positionAdminByType: { AutobusNormalFloor3Axle: 980, Autobus18Mt: 850, DoubleDecker: 1150 },
    label: "Third Axle Central",
    group: "undercarriage",
    description: "A photo of: Third Axle Central.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driver_door_open: {
    name: "photo_driver_door_open",
    position: 1300,
    position_admin: 1300,
    positionByType: { MinibusCityIntercity: 200, MinibusTouristic: 200 },
    positionAdminByType: { MinibusCityIntercity: 220, MinibusTouristic: 220 },
    requiredFor: ["MinibusTouristic"],
    label: "Driver Door Open",
    group: "exteriors",
    description: "A photo of: Driver Door Open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_doors_open: {
    name: "photo_rear_doors_open",
    position: 1310,
    position_admin: 1310,
    positionByType: { MinibusCityIntercity: 210, MinibusTouristic: 210 },
    positionAdminByType: { MinibusCityIntercity: 230, MinibusTouristic: 230 },
    requiredFor: ["MinibusTouristic"],
    label: "Rear Doors Open",
    group: "exteriors",
    description: "A photo of: Rear Doors Open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_electric_parking_brake: {
    name: "photo_electric_parking_brake",
    position: 1320,
    position_admin: 1320,
    positionByType: { MinibusCityIntercity: 470, MinibusTouristic: 640 },
    positionAdminByType: { MinibusCityIntercity: 490, MinibusTouristic: 660 },
    requiredFor: ["MinibusCityIntercity", "MinibusTouristic"],
    label: "Electric Parking Brake",
    group: "undercarriage",
    description: "A photo of: Electric Parking Brake.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_undercarriage: {
    name: "photo_rear_undercarriage",
    position: 1330,
    position_admin: 1330,
    positionByType: {
      MinibusCityIntercity: 780,
      MinibusTouristic: 950,
      AutobusNormalFloor2Axle: 1030,
      AutobusNormalFloor3Axle: 1130,
      AutobusLowFloorLowEntry8_12Mt: 850,
      Autobus18Mt: 1040,
      DoubleDecker: 1300
    },
    positionAdminByType: {
      MinibusCityIntercity: 800,
      MinibusTouristic: 970,
      AutobusNormalFloor2Axle: 1050,
      AutobusNormalFloor3Axle: 1150,
      AutobusLowFloorLowEntry8_12Mt: 870,
      Autobus18Mt: 1060,
      DoubleDecker: 1320
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Rear Undercarriage",
    group: "undercarriage",
    description: "A photo of: Rear Undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_1: {
    name: "photo_luggage_rear_1",
    position: 1340,
    position_admin: 1340,
    positionByType: { MinibusTouristic: 250 },
    positionAdminByType: { MinibusTouristic: 270 },
    label: "Luggage Rear 1",
    group: "exteriors",
    description: "A photo of: Luggage Rear 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_2: {
    name: "photo_luggage_rear_2",
    position: 1350,
    position_admin: 1350,
    positionByType: { MinibusTouristic: 260 },
    positionAdminByType: { MinibusTouristic: 280 },
    label: "Luggage Rear 2",
    group: "exteriors",
    description: "A photo of: Luggage Rear 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_3: {
    name: "photo_luggage_rear_3",
    position: 1360,
    position_admin: 1360,
    positionByType: { MinibusTouristic: 270 },
    positionAdminByType: { MinibusTouristic: 290 },
    label: "Luggage Rear 3",
    group: "exteriors",
    description: "A photo of: Luggage Rear 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rack_right: {
    name: "photo_luggage_rack_right",
    position: 1370,
    position_admin: 1370,
    positionByType: { MinibusTouristic: 280, DoubleDecker: 280 },
    positionAdminByType: { MinibusTouristic: 300, DoubleDecker: 300 },
    requiredFor: ["MinibusTouristic"],
    label: "Luggage Rack Right",
    group: "exteriors",
    description: "A photo of: Luggage Rack Right.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_refrigerator: {
    name: "photo_refrigerator",
    position: 1380,
    position_admin: 1380,
    positionByType: { MinibusTouristic: 400, AutobusNormalFloor2Axle: 440, AutobusNormalFloor3Axle: 430, DoubleDecker: 450 },
    positionAdminByType: { MinibusTouristic: 420, AutobusNormalFloor2Axle: 460, AutobusNormalFloor3Axle: 450, DoubleDecker: 470 },
    label: "Refrigerator",
    group: "interiors",
    description: "A photo of: Refrigerator.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_suppression_nozzles: {
    name: "photo_fire_suppression_nozzles",
    position: 1390,
    position_admin: 1390,
    positionByType: {
      AutobusNormalFloor2Axle: 170,
      AutobusNormalFloor3Axle: 170,
      AutobusLowFloorLowEntry8_12Mt: 180,
      Autobus18Mt: 200,
      DoubleDecker: 180
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 190,
      AutobusNormalFloor3Axle: 190,
      AutobusLowFloorLowEntry8_12Mt: 200,
      Autobus18Mt: 220,
      DoubleDecker: 200
    },
    label: "Fire Suppression Nozzles",
    group: "exteriors",
    description: "A photo of: Fire Suppression Nozzles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driver_s_bunk: {
    name: "photo_driver_s_bunk",
    position: 1400,
    position_admin: 1400,
    positionByType: { AutobusNormalFloor2Axle: 270, AutobusNormalFloor3Axle: 270, DoubleDecker: 290 },
    positionAdminByType: { AutobusNormalFloor2Axle: 290, AutobusNormalFloor3Axle: 290, DoubleDecker: 310 },
    label: "Driver's Bunk",
    group: "exteriors",
    description: "A photo of: Driver's Bunk.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_onboard_device_3_left_side: {
    name: "photo_onboard_device_3_left_side",
    position: 1410,
    position_admin: 1410,
    positionByType: {
      AutobusNormalFloor2Axle: 390,
      AutobusNormalFloor3Axle: 380,
      AutobusLowFloorLowEntry8_12Mt: 330,
      Autobus18Mt: 350,
      DoubleDecker: 400
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 410,
      AutobusNormalFloor3Axle: 400,
      AutobusLowFloorLowEntry8_12Mt: 350,
      Autobus18Mt: 370,
      DoubleDecker: 420
    },
    requiredFor: ["AutobusNormalFloor2Axle"],
    label: "Onboard Device 3 Left Side",
    group: "interiors",
    description: "A photo of: Onboard Device 3 Left Side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_2: {
    name: "photo_monitor_2",
    position: 1420,
    position_admin: 1420,
    positionByType: { DoubleDecker: 630 },
    positionAdminByType: { DoubleDecker: 650 },
    label: "Monitor 2",
    group: "interiors",
    description: "A photo of: Monitor 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_monitor_3: {
    name: "photo_monitor_3",
    position: 1430,
    position_admin: 1430,
    positionByType: { DoubleDecker: 640 },
    positionAdminByType: { DoubleDecker: 660 },
    label: "Monitor 3",
    group: "interiors",
    description: "A photo of: Monitor 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_monitor_4: {
    name: "photo_monitor_4",
    position: 1440,
    position_admin: 1440,
    positionByType: { DoubleDecker: 650 },
    positionAdminByType: { DoubleDecker: 670 },
    label: "Monitor 4",
    group: "interiors",
    description: "A photo of: Monitor 4.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_refrigerator: {
    name: "photo_second_refrigerator",
    position: 1450,
    position_admin: 1450,
    positionByType: { DoubleDecker: 680 },
    positionAdminByType: { DoubleDecker: 700 },
    label: "Second Refrigerator",
    group: "interiors",
    description: "A photo of: Second Refrigerator.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_kitchen: {
    name: "photo_kitchen",
    position: 1460,
    position_admin: 1460,
    positionByType: { DoubleDecker: 690 },
    positionAdminByType: { DoubleDecker: 710 },
    label: "Kitchen",
    group: "interiors",
    description: "A photo of: Kitchen.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_ladder_1: {
    name: "photo_ladder_1",
    position: 1470,
    position_admin: 1470,
    positionByType: { DoubleDecker: 720 },
    positionAdminByType: { DoubleDecker: 740 },
    requiredFor: ["DoubleDecker"],
    label: "Ladder 1",
    group: "interiors",
    description: "A photo of: Ladder 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_ladder_2: {
    name: "photo_ladder_2",
    position: 1480,
    position_admin: 1480,
    positionByType: { DoubleDecker: 730 },
    positionAdminByType: { DoubleDecker: 750 },
    requiredFor: ["DoubleDecker"],
    label: "Ladder 2",
    group: "interiors",
    description: "A photo of: Ladder 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_reverse_seats_from_windscreen_position: {
    name: "photo_second_floor_reverse_seats_from_windscreen_position",
    position: 1490,
    position_admin: 1490,
    positionByType: { DoubleDecker: 740 },
    positionAdminByType: { DoubleDecker: 760 },
    requiredFor: ["DoubleDecker"],
    label: "Second Floor: Reverse Seats From Windscreen Position",
    group: "interiors",
    description: "A photo of: Second Floor: Reverse Seats From Windscreen Position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_reverse_seats_from_middle_position: {
    name: "photo_second_floor_reverse_seats_from_middle_position",
    position: 1500,
    position_admin: 1500,
    positionByType: { DoubleDecker: 750 },
    positionAdminByType: { DoubleDecker: 770 },
    requiredFor: ["DoubleDecker"],
    label: "Second Floor: Reverse Seats From Middle Position",
    group: "interiors",
    description: "A photo of: Second Floor: Reverse Seats From Middle Position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_forward_seats_from_end_position: {
    name: "photo_second_floor_forward_seats_from_end_position",
    position: 1510,
    position_admin: 1510,
    positionByType: { DoubleDecker: 760 },
    positionAdminByType: { DoubleDecker: 780 },
    requiredFor: ["DoubleDecker"],
    label: "Second Floor: Forward Seats From End Position",
    group: "interiors",
    description: "A photo of: Second Floor: Forward Seats From End Position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_overhead_compartments: {
    name: "photo_second_floor_overhead_compartments",
    position: 1520,
    position_admin: 1520,
    positionByType: { DoubleDecker: 770 },
    positionAdminByType: { DoubleDecker: 790 },
    label: "Second Floor: Overhead Compartments",
    group: "interiors",
    description: "A photo of: Second Floor: Overhead compartments.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_monitor_1: {
    name: "photo_second_floor_monitor_1",
    position: 1530,
    position_admin: 1530,
    positionByType: { DoubleDecker: 810 },
    positionAdminByType: { DoubleDecker: 830 },
    label: "Second Floor: Monitor 1",
    group: "interiors",
    description: "A photo of: Second Floor: Monitor 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_monitor_2: {
    name: "photo_second_floor_monitor_2",
    position: 1540,
    position_admin: 1540,
    positionByType: { DoubleDecker: 820 },
    positionAdminByType: { DoubleDecker: 840 },
    label: "Second Floor: Monitor 2",
    group: "interiors",
    description: "A photo of: Second Floor: Monitor 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_windscreen_from_right_side: {
    name: "photo_windscreen_from_right_side",
    position: 1620,
    position_admin: 1620,
    positionByType: {
      MinibusCityIntercity: 30,
      MinibusTouristic: 30,
      AutobusNormalFloor2Axle: 30,
      AutobusNormalFloor3Axle: 30,
      AutobusLowFloorLowEntry8_12Mt: 30,
      Autobus18Mt: 30,
      DoubleDecker: 30
    },
    positionAdminByType: {
      MinibusCityIntercity: 50,
      MinibusTouristic: 50,
      AutobusNormalFloor2Axle: 50,
      AutobusNormalFloor3Axle: 50,
      AutobusLowFloorLowEntry8_12Mt: 50,
      Autobus18Mt: 50,
      DoubleDecker: 50
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Windscreen From Right Side",
    group: "exteriors",
    description: "A photo of: Windscreen From Right Side.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_windscreen_from_left_side: {
    name: "photo_windscreen_from_left_side",
    position: 1630,
    position_admin: 1630,
    positionByType: {
      MinibusCityIntercity: 40,
      MinibusTouristic: 40,
      AutobusNormalFloor2Axle: 40,
      AutobusNormalFloor3Axle: 40,
      AutobusLowFloorLowEntry8_12Mt: 40,
      Autobus18Mt: 40,
      DoubleDecker: 40
    },
    positionAdminByType: {
      MinibusCityIntercity: 60,
      MinibusTouristic: 60,
      AutobusNormalFloor2Axle: 60,
      AutobusNormalFloor3Axle: 60,
      AutobusLowFloorLowEntry8_12Mt: 60,
      Autobus18Mt: 60,
      DoubleDecker: 60
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ],
    label: "Windscreen From Left Side",
    group: "exteriors",
    description: "A photo of: Windscreen From Left Side.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_upper_windscreen: {
    name: "photo_upper_windscreen",
    position: 1640,
    position_admin: 1640,
    positionByType: { DoubleDecker: 50 },
    positionAdminByType: { DoubleDecker: 70 },
    requiredFor: ["DoubleDecker"],
    label: "Upper Windscreen",
    group: "exteriors",
    description: "A photo of: Upper Windscreen.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  }
}, QT = {
  photo_cover_base: {
    name: "photo_cover_base",
    position: 2e3,
    position_admin: 2e3,
    label: "Base cover photo",
    group: "cover",
    description: "The photo displayed in the listing page (default: photo_3_4_front_side_right_doors_closed)",
    performTextInpaint: !0
  },
  photo_cover_hover: {
    name: "photo_cover_hover",
    position: 2010,
    position_admin: 2010,
    label: "Hover cover photo",
    group: "cover",
    description: "The photo usually on mouse hover in the listing page, (default: photo_front)",
    performTextInpaint: !0
  }
}, By = {
  video_internal_second_floor_reverse_seats_full: {
    name: "video_internal_second_floor_reverse_seats_full",
    label: "Video: Internal-Second Floor: Reverse Seats From Windscreen Position to the End Of The Vehicle",
    group: "interiors",
    isInternal: !1,
    positionByType: { DoubleDecker: 830 },
    positionAdminByType: { DoubleDecker: 850 },
    requiredFor: ["DoubleDecker"]
  },
  video_internal_second_floor_second: {
    name: "video_internal_second_floor_second",
    label: "Video: Internal-Second Floor-Second Video",
    group: "interiors",
    isInternal: !1,
    positionByType: { DoubleDecker: 840 },
    positionAdminByType: { DoubleDecker: 860 },
    requiredFor: ["DoubleDecker"]
  },
  video_engine_working: {
    name: "video_engine_working",
    label: "Video: Engine Working",
    group: "exteriors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 120,
      MinibusTouristic: 110,
      AutobusNormalFloor2Axle: 180,
      AutobusNormalFloor3Axle: 180,
      AutobusLowFloorLowEntry8_12Mt: 190,
      Autobus18Mt: 210,
      DoubleDecker: 190
    },
    positionAdminByType: {
      MinibusCityIntercity: 140,
      MinibusTouristic: 130,
      AutobusNormalFloor2Axle: 200,
      AutobusNormalFloor3Axle: 200,
      AutobusLowFloorLowEntry8_12Mt: 210,
      Autobus18Mt: 230,
      DoubleDecker: 210
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ]
  },
  video_wheelchair_ramp_working: {
    name: "video_wheelchair_ramp_working",
    label: "Video: Automatic Wheelchair Ramp Working",
    group: "exteriors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 170,
      MinibusTouristic: 170,
      AutobusNormalFloor2Axle: 210,
      AutobusNormalFloor3Axle: 210,
      AutobusLowFloorLowEntry8_12Mt: 220,
      Autobus18Mt: 240,
      DoubleDecker: 220
    },
    positionAdminByType: {
      MinibusCityIntercity: 190,
      MinibusTouristic: 190,
      AutobusNormalFloor2Axle: 230,
      AutobusNormalFloor3Axle: 230,
      AutobusLowFloorLowEntry8_12Mt: 240,
      Autobus18Mt: 260,
      DoubleDecker: 240
    }
  },
  video_internal_driver_to_end: {
    name: "video_internal_driver_to_end",
    label: "Video: Internal-From Driver Position To The End Of The Vehicle",
    group: "interiors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 430,
      MinibusTouristic: 600,
      AutobusNormalFloor2Axle: 670,
      AutobusNormalFloor3Axle: 660,
      AutobusLowFloorLowEntry8_12Mt: 490,
      Autobus18Mt: 520,
      DoubleDecker: 700
    },
    positionAdminByType: {
      MinibusCityIntercity: 450,
      MinibusTouristic: 620,
      AutobusNormalFloor2Axle: 690,
      AutobusNormalFloor3Axle: 680,
      AutobusLowFloorLowEntry8_12Mt: 510,
      Autobus18Mt: 540,
      DoubleDecker: 720
    },
    requiredFor: [
      "MinibusCityIntercity",
      "MinibusTouristic",
      "AutobusNormalFloor2Axle",
      "AutobusNormalFloor3Axle",
      "AutobusLowFloorLowEntry8_12Mt",
      "Autobus18Mt",
      "DoubleDecker"
    ]
  },
  video_internal_second: {
    name: "video_internal_second",
    label: "Video: Internal-Second Video",
    group: "interiors",
    isInternal: !1,
    positionByType: {
      AutobusNormalFloor2Axle: 680,
      AutobusNormalFloor3Axle: 670,
      AutobusLowFloorLowEntry8_12Mt: 500,
      Autobus18Mt: 530,
      DoubleDecker: 710
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 700,
      AutobusNormalFloor3Axle: 690,
      AutobusLowFloorLowEntry8_12Mt: 520,
      Autobus18Mt: 550,
      DoubleDecker: 730
    },
    requiredFor: ["AutobusNormalFloor2Axle", "AutobusNormalFloor3Axle", "AutobusLowFloorLowEntry8_12Mt", "Autobus18Mt", "DoubleDecker"]
  },
  video_warranty: {
    name: "video_warranty",
    label: "Video: Fleequid Internal Use Video",
    group: "exteriors",
    isInternal: !0,
    positionAdminByType: {
      MinibusCityIntercity: 910,
      MinibusTouristic: 14500,
      AutobusNormalFloor2Axle: 14500,
      AutobusNormalFloor3Axle: 14500,
      AutobusLowFloorLowEntry8_12Mt: 14500,
      Autobus18Mt: 14500,
      DoubleDecker: 14500
    }
  }
}, Ry = [
  {
    name: "Baden-Württemberg",
    code: "DE-BW",
    provinces: [{ name: "Baden-Württemberg", code: "BW" }]
  },
  {
    name: "Bayern",
    code: "DE-BY",
    provinces: [{ name: "Bayern", code: "BY" }]
  },
  {
    name: "Berlin",
    code: "DE-BE",
    provinces: [{ name: "Berlin", code: "BE" }]
  },
  {
    name: "Brandenburg",
    code: "DE-BB",
    provinces: [{ name: "Brandenburg", code: "BB" }]
  },
  {
    name: "Bremen",
    code: "DE-HB",
    provinces: [{ name: "Bremen", code: "HB" }]
  },
  {
    name: "Hamburg",
    code: "DE-HH",
    provinces: [{ name: "Hamburg", code: "HH" }]
  },
  {
    name: "Hessen",
    code: "DE-HE",
    provinces: [{ name: "Hessen", code: "HE" }]
  },
  {
    name: "Mecklenburg-Vorpommern",
    code: "DE-MV",
    provinces: [{ name: "Mecklenburg-Vorpommern", code: "MV" }]
  },
  {
    name: "Niedersachsen",
    code: "DE-NI",
    provinces: [{ name: "Niedersachsen", code: "NI" }]
  },
  {
    name: "Nordrhein-Westfalen",
    code: "DE-NW",
    provinces: [{ name: "Nordrhein-Westfalen", code: "NW" }]
  },
  {
    name: "Rheinland-Pfalz",
    code: "DE-RP",
    provinces: [{ name: "Rheinland-Pfalz", code: "RP" }]
  },
  {
    name: "Saarland",
    code: "DE-SL",
    provinces: [{ name: "Saarland", code: "SL" }]
  },
  {
    name: "Sachsen",
    code: "DE-SN",
    provinces: [{ name: "Sachsen", code: "SN" }]
  },
  {
    name: "Sachsen-Anhalt",
    code: "DE-ST",
    provinces: [{ name: "Sachsen-Anhalt", code: "ST" }]
  },
  {
    name: "Schleswig-Holstein",
    code: "DE-SH",
    provinces: [{ name: "Schleswig-Holstein", code: "SH" }]
  },
  {
    name: "Thüringen",
    code: "DE-TH",
    provinces: [{ name: "Thüringen", code: "TH" }]
  }
], Py = [
  {
    name: "Abruzzo",
    code: "IT-65",
    regionMacro: "center",
    provinces: [
      { name: "L'Aquila", code: "AQ" },
      { name: "Chieti", code: "CH" },
      { name: "Pescara", code: "PE" },
      { name: "Teramo", code: "TE" }
    ]
  },
  {
    name: "Basilicata",
    code: "IT-77",
    regionMacro: "south",
    provinces: [
      { name: "Matera", code: "MT" },
      { name: "Potenza", code: "PZ" }
    ]
  },
  {
    name: "Calabria",
    code: "IT-78",
    regionMacro: "south",
    provinces: [
      { name: "Cosenza", code: "CS" },
      { name: "Catanzaro", code: "CZ" },
      { name: "Crotone", code: "KR" },
      { name: "Reggio Calabria", code: "RC" },
      { name: "Vibo Valentia", code: "VV" }
    ]
  },
  {
    name: "Campania",
    code: "IT-72",
    regionMacro: "south",
    provinces: [
      { name: "Avellino", code: "AV" },
      { name: "Benevento", code: "BN" },
      { name: "Caserta", code: "CE" },
      { name: "Napoli", code: "NA" },
      { name: "Salerno", code: "SA" }
    ]
  },
  {
    name: "Emilia-Romagna",
    code: "IT-45",
    regionMacro: "north",
    provinces: [
      { name: "Bologna", code: "BO" },
      { name: "Forlì-Cesena", code: "FC" },
      { name: "Ferrara", code: "FE" },
      { name: "Modena", code: "MO" },
      { name: "Piacenza", code: "PC" },
      { name: "Parma", code: "PR" },
      { name: "Ravenna", code: "RA" },
      { name: "Reggio Emilia", code: "RE" },
      { name: "Rimini", code: "RN" }
    ]
  },
  {
    name: "Friuli-Venezia Giulia",
    code: "IT-36",
    regionMacro: "north",
    provinces: [
      { name: "Gorizia", code: "GO" },
      { name: "Pordenone", code: "PN" },
      { name: "Trieste", code: "TS" },
      { name: "Udine", code: "UD" }
    ]
  },
  {
    name: "Lazio",
    code: "IT-62",
    regionMacro: "center",
    provinces: [
      { name: "Frosinone", code: "FR" },
      { name: "Latina", code: "LT" },
      { name: "Rieti", code: "RI" },
      { name: "Roma", code: "RM" },
      { name: "Viterbo", code: "VT" }
    ]
  },
  {
    name: "Liguria",
    code: "IT-42",
    regionMacro: "north",
    provinces: [
      { name: "Genova", code: "GE" },
      { name: "Imperia", code: "IM" },
      { name: "La Spezia", code: "SP" },
      { name: "Savona", code: "SV" }
    ]
  },
  {
    name: "Lombardia",
    code: "IT-25",
    regionMacro: "north",
    provinces: [
      { name: "Bergamo", code: "BG" },
      { name: "Brescia", code: "BS" },
      { name: "Como", code: "CO" },
      { name: "Cremona", code: "CR" },
      { name: "Lecco", code: "LC" },
      { name: "Lodi", code: "LO" },
      { name: "Monza e della Brianza", code: "MB" },
      { name: "Milano", code: "MI" },
      { name: "Mantova", code: "MN" },
      { name: "Pavia", code: "PV" },
      { name: "Sondrio", code: "SO" },
      { name: "Varese", code: "VA" }
    ]
  },
  {
    name: "Marche",
    code: "IT-57",
    regionMacro: "center",
    provinces: [
      { name: "Ancona", code: "AN" },
      { name: "Ascoli Piceno", code: "AP" },
      { name: "Fermo", code: "FM" },
      { name: "Macerata", code: "MC" },
      { name: "Pesaro e Urbino", code: "PU" }
    ]
  },
  {
    name: "Molise",
    code: "IT-67",
    regionMacro: "south",
    provinces: [
      { name: "Campobasso", code: "CB" },
      { name: "Isernia", code: "IS" }
    ]
  },
  {
    name: "Piemonte",
    code: "IT-21",
    regionMacro: "north",
    provinces: [
      { name: "Alessandria", code: "AL" },
      { name: "Asti", code: "AT" },
      { name: "Biella", code: "BI" },
      { name: "Cuneo", code: "CN" },
      { name: "Novara", code: "NO" },
      { name: "Torino", code: "TO" },
      { name: "Verbano-Cusio-Ossola", code: "VB" },
      { name: "Vercelli", code: "VC" }
    ]
  },
  {
    name: "Puglia",
    code: "IT-75",
    regionMacro: "south",
    provinces: [
      { name: "Bari", code: "BA" },
      { name: "Brindisi", code: "BR" },
      { name: "Barletta-Andria-Trani", code: "BT" },
      { name: "Foggia", code: "FG" },
      { name: "Lecce", code: "LE" },
      { name: "Taranto", code: "TA" }
    ]
  },
  {
    name: "Sardegna",
    code: "IT-88",
    regionMacro: "excluded",
    provinces: [
      { name: "Cagliari", code: "CA" },
      { name: "Nuoro", code: "NU" },
      { name: "Oristano", code: "OR" },
      { name: "Sassari", code: "SS" },
      { name: "Carbonia-Iglesias", code: "CI" },
      { name: "Olbia-Tempio", code: "OT" },
      { name: "Medio Campidano", code: "VS" },
      { name: "Ogliastra", code: "OG" }
    ]
  },
  {
    name: "Sicilia",
    code: "IT-82",
    regionMacro: "excluded",
    provinces: [
      { name: "Agrigento", code: "AG" },
      { name: "Caltanissetta", code: "CL" },
      { name: "Catania", code: "CT" },
      { name: "Enna", code: "EN" },
      { name: "Messina", code: "ME" },
      { name: "Palermo", code: "PA" },
      { name: "Ragusa", code: "RG" },
      { name: "Siracusa", code: "SR" },
      { name: "Trapani", code: "TP" }
    ]
  },
  {
    name: "Toscana",
    code: "IT-52",
    regionMacro: "center",
    provinces: [
      { name: "Arezzo", code: "AR" },
      { name: "Firenze", code: "FI" },
      { name: "Grosseto", code: "GR" },
      { name: "Livorno", code: "LI" },
      { name: "Lucca", code: "LU" },
      { name: "Massa-Carrara", code: "MS" },
      { name: "Pisa", code: "PI" },
      { name: "Prato", code: "PO" },
      { name: "Pistoia", code: "PT" },
      { name: "Siena", code: "SI" }
    ]
  },
  {
    name: "Trentino-Alto Adige, Trentino-Südtirol",
    code: "IT-32",
    regionMacro: "north",
    provinces: [
      { name: "Bolzano", code: "BZ" },
      { name: "Trento", code: "TN" }
    ]
  },
  {
    name: "Umbria",
    code: "IT-55",
    regionMacro: "center",
    provinces: [
      { name: "Perugia", code: "PG" },
      { name: "Terni", code: "TR" }
    ]
  },
  { name: "Valle d'Aosta, Vallée d'Aoste", code: "IT-23", regionMacro: "north", provinces: [{ name: "Aosta", code: "AO" }] },
  {
    name: "Veneto",
    code: "IT-34",
    regionMacro: "north",
    provinces: [
      { name: "Belluno", code: "BL" },
      { name: "Padova", code: "PD" },
      { name: "Rovigo", code: "RO" },
      { name: "Treviso", code: "TV" },
      { name: "Venezia", code: "VE" },
      { name: "Vicenza", code: "VI" },
      { name: "Verona", code: "VR" }
    ]
  }
], zy = [
  {
    name: "Dolnośląskie",
    code: "PL-02",
    provinces: [{ name: "Dolnośląskie", code: "DS" }]
  },
  {
    name: "Kujawsko-Pomorskie",
    code: "PL-04",
    provinces: [{ name: "Kujawsko-Pomorskie", code: "KP" }]
  },
  {
    name: "Lubelskie",
    code: "PL-06",
    provinces: [{ name: "Lubelskie", code: "LU" }]
  },
  {
    name: "Lubuskie",
    code: "PL-08",
    provinces: [{ name: "Lubuskie", code: "LB" }]
  },
  {
    name: "Łódzkie",
    code: "PL-10",
    provinces: [{ name: "Łódzkie", code: "LD" }]
  },
  {
    name: "Małopolskie",
    code: "PL-12",
    provinces: [{ name: "Małopolskie", code: "MP" }]
  },
  {
    name: "Mazowieckie",
    code: "PL-14",
    provinces: [{ name: "Mazowieckie", code: "MZ" }]
  },
  {
    name: "Opolskie",
    code: "PL-16",
    provinces: [{ name: "Opolskie", code: "OP" }]
  },
  {
    name: "Podkarpackie",
    code: "PL-18",
    provinces: [{ name: "Podkarpackie", code: "PK" }]
  },
  {
    name: "Podlaskie",
    code: "PL-20",
    provinces: [{ name: "Podlaskie", code: "PD" }]
  },
  {
    name: "Pomorskie",
    code: "PL-22",
    provinces: [{ name: "Pomorskie", code: "PM" }]
  },
  {
    name: "Śląskie",
    code: "PL-24",
    provinces: [{ name: "Śląskie", code: "SL" }]
  },
  {
    name: "Świętokrzyskie",
    code: "PL-26",
    provinces: [{ name: "Świętokrzyskie", code: "SK" }]
  },
  {
    name: "Warmińsko-Mazurskie",
    code: "PL-28",
    provinces: [{ name: "Warmińsko-Mazurskie", code: "WM" }]
  },
  {
    name: "Wielkopolskie",
    code: "PL-30",
    provinces: [{ name: "Wielkopolskie", code: "WP" }]
  },
  {
    name: "Zachodniopomorskie",
    code: "PL-32",
    provinces: [{ name: "Zachodniopomorskie", code: "ZP" }]
  }
], Oy = [
  {
    name: "Andalucía",
    code: "ES-AN",
    provinces: [
      { name: "Almería", code: "AL" },
      { name: "Cádiz", code: "CA" },
      { name: "Córdoba", code: "CO" },
      { name: "Granada", code: "GR" },
      { name: "Huelva", code: "H" },
      { name: "Jaén", code: "J" },
      { name: "Málaga", code: "MA" },
      { name: "Sevilla", code: "SE" }
    ]
  },
  {
    name: "Aragón",
    code: "ES-AR",
    provinces: [
      { name: "Huesca", code: "HU" },
      { name: "Teruel", code: "TE" },
      { name: "Zaragoza", code: "Z" }
    ]
  },
  {
    name: "Asturias",
    code: "ES-AS",
    provinces: [{ name: "Asturias", code: "AS" }]
  },
  {
    name: "Islas Baleares",
    code: "ES-IB",
    provinces: [{ name: "Islas Baleares", code: "IB" }]
  },
  {
    name: "País Vasco",
    code: "ES-PV",
    provinces: [
      { name: "Álava", code: "VI" },
      { name: "Bizkaia", code: "BI" },
      { name: "Gipuzkoa", code: "SS" }
    ]
  },
  {
    name: "Canarias",
    code: "ES-CN",
    provinces: [
      { name: "Las Palmas", code: "GC" },
      { name: "Santa Cruz de Tenerife", code: "TF" }
    ]
  },
  {
    name: "Cantabria",
    code: "ES-CB",
    provinces: [{ name: "Cantabria", code: "CB" }]
  },
  {
    name: "Castilla y León",
    code: "ES-CL",
    provinces: [
      { name: "Ávila", code: "AV" },
      { name: "Burgos", code: "BU" },
      { name: "León", code: "LE" },
      { name: "Palencia", code: "P" },
      { name: "Salamanca", code: "SA" },
      { name: "Segovia", code: "SG" },
      { name: "Soria", code: "SO" },
      { name: "Valladolid", code: "VA" },
      { name: "Zamora", code: "ZA" }
    ]
  },
  {
    name: "Castilla-La Mancha",
    code: "ES-CM",
    provinces: [
      { name: "Albacete", code: "AB" },
      { name: "Ciudad Real", code: "CR" },
      { name: "Cuenca", code: "CU" },
      { name: "Guadalajara", code: "GU" },
      { name: "Toledo", code: "TO" }
    ]
  },
  {
    name: "Cataluña",
    code: "ES-CT",
    provinces: [
      { name: "Barcelona", code: "B" },
      { name: "Girona", code: "GI" },
      { name: "Lleida", code: "L" },
      { name: "Tarragona", code: "T" }
    ]
  },
  {
    name: "Extremadura",
    code: "ES-EX",
    provinces: [
      { name: "Badajoz", code: "BA" },
      { name: "Cáceres", code: "CC" }
    ]
  },
  {
    name: "Galicia",
    code: "ES-GA",
    provinces: [
      { name: "A Coruña", code: "C" },
      { name: "Lugo", code: "LU" },
      { name: "Ourense", code: "OR" },
      { name: "Pontevedra", code: "PO" }
    ]
  },
  {
    name: "La Rioja",
    code: "ES-RI",
    provinces: [{ name: "La Rioja", code: "RI" }]
  },
  {
    name: "Comunidad de Madrid",
    code: "ES-MD",
    provinces: [{ name: "Madrid", code: "MD" }]
  },
  {
    name: "Región de Murcia",
    code: "ES-MC",
    provinces: [{ name: "Murcia", code: "MC" }]
  },
  {
    name: "Navarra",
    code: "ES-NC",
    provinces: [{ name: "Navarra", code: "NC" }]
  },
  {
    name: "Comunidad Valenciana",
    code: "ES-VC",
    provinces: [
      { name: "Alicante", code: "A" },
      { name: "Castellón", code: "CS" },
      { name: "Valencia", code: "V" }
    ]
  },
  {
    name: "Ceuta",
    code: "ES-CE",
    provinces: [{ name: "Ceuta", code: "CE" }]
  },
  {
    name: "Melilla",
    code: "ES-ML",
    provinces: [{ name: "Melilla", code: "ML" }]
  }
], Ki = {
  AD: {
    i18nNames: {
      en: "Andorra",
      it: "Andorra",
      es: "Andorra",
      de: "Andorra",
      pl: "Andora",
      fr: "Andorre",
      nl: "Andorra",
      pt: "Andorra",
      cs: "Andorra",
      ro: "Andorra",
      ru: "Андорра"
    },
    rootIddCode: "+376",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[A-Z]-\\d{6}-[A-Z]$",
    taxIdExample: "X-123456-Y"
  },
  AE: {
    i18nNames: {
      en: "United Arab Emirates",
      es: "Emiratos Árabes Unidos",
      it: "Emirati Arabi Uniti",
      de: "Vereinigte Arabische Emirate",
      pl: "Zjednoczone Emiraty Arabskie",
      fr: "Émirats arabes unis",
      nl: "Verenigde Arabische Emiraten",
      pt: "Emirados Árabes Unidos",
      cs: "Spojené arabské emiráty",
      ro: "Emiratele Arabe Unite",
      ru: "Объединённые Арабские Эмираты"
    },
    rootIddCode: "+971",
    continent: "Asia",
    taxIdMandatory: !1,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  AF: {
    i18nNames: {
      en: "Afghanistan",
      it: "Afghanistan",
      es: "Afganistán",
      de: "Afghanistan",
      pl: "Afganistan",
      fr: "Afghanistan",
      nl: "Afghanistan",
      pt: "Afeganistão",
      cs: "Afghánistán",
      ro: "Afganistan",
      ru: "Афганистан"
    },
    rootIddCode: "+93",
    continent: "Asia"
  },
  AG: {
    i18nNames: {
      en: "Antigua and Barbuda",
      es: "Antigua y Barbuda",
      it: "Antigua e Barbuda",
      de: "Antigua und Barbuda",
      pl: "Antigua i Barbuda",
      fr: "Antigua-et-Barbuda",
      nl: "Antigua en Barbuda",
      pt: "Antígua e Barbuda",
      cs: "Antigua a Barbuda",
      ro: "Antigua și Barbuda",
      ru: "Антигуа и Барбуда"
    },
    rootIddCode: "+1268",
    continent: "NorthAmerica"
  },
  AI: {
    i18nNames: {
      en: "Anguilla",
      it: "Anguilla",
      es: "Anguila",
      de: "Anguilla",
      pl: "Anguilla",
      fr: "Anguilla",
      nl: "Anguilla",
      pt: "Anguila",
      cs: "Anguilla",
      ro: "Anguilla",
      ru: "Ангилья"
    },
    rootIddCode: "+1264",
    continent: "NorthAmerica"
  },
  AL: {
    i18nNames: {
      en: "Albania",
      it: "Albania",
      es: "Albania",
      de: "Albanien",
      pl: "Albania",
      fr: "Albanie",
      nl: "Albanië",
      pt: "Albânia",
      cs: "Albánie",
      ro: "Albania",
      ru: "Албания"
    },
    rootIddCode: "+355",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[JKLM]\\d{8}[A-Z]$",
    taxIdExample: "J12345678K"
  },
  AM: {
    i18nNames: {
      en: "Armenia",
      it: "Armenia",
      es: "Armenia",
      de: "Armenien",
      pl: "Armenia",
      fr: "Arménie",
      nl: "Armenië",
      pt: "Arménia",
      cs: "Arménie",
      ro: "Armenia",
      ru: "Армения"
    },
    rootIddCode: "+374",
    continent: "Asia"
  },
  AO: {
    i18nNames: {
      en: "Angola",
      it: "Angola",
      es: "Angola",
      de: "Angola",
      pl: "Angola",
      fr: "Angola",
      nl: "Angola",
      pt: "Angola",
      cs: "Angola",
      ro: "Angola",
      ru: "Ангола"
    },
    rootIddCode: "+244",
    continent: "Africa"
  },
  AQ: {
    i18nNames: {
      en: "Antarctica",
      it: "Antartide",
      es: "Antártida",
      de: "Antarktis",
      pl: "Antarktyka",
      fr: "Antarctique",
      nl: "Antarctica",
      pt: "Antártica",
      cs: "Antarktida",
      ro: "Antarctica",
      ru: "Антарктида"
    },
    rootIddCode: "undefined",
    continent: "Antarctica"
  },
  AR: {
    i18nNames: {
      en: "Argentina",
      it: "Argentina",
      es: "Argentina",
      de: "Argentinien",
      pl: "Argentyna",
      fr: "Argentine",
      nl: "Argentinië",
      pt: "Argentina",
      cs: "Argentina",
      ro: "Argentina",
      ru: "Аргентина"
    },
    rootIddCode: "+54",
    continent: "SouthAmerica"
  },
  AS: {
    i18nNames: {
      en: "American Samoa",
      it: "Samoa Americane",
      es: "Samoa Americana",
      de: "Amerikanisch-Samoa",
      pl: "Samoa Amerykańskie",
      fr: "Samoa américaines",
      nl: "Amerikaans-Samoa",
      pt: "Samoa Americana",
      cs: "Americká Samoa",
      ro: "Samoa Americană",
      ru: "Американское Самоа"
    },
    rootIddCode: "+1684",
    continent: "Oceania"
  },
  AT: {
    i18nNames: {
      en: "Austria",
      it: "Austria",
      es: "Austria",
      de: "Österreich",
      pl: "Austria",
      fr: "Autriche",
      nl: "Oostenrijk",
      pt: "Áustria",
      cs: "Rakousko",
      ro: "Austria",
      ru: "Австрия"
    },
    rootIddCode: "+43",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^ATU\\d{8}$",
    taxIdExample: "ATU12345678"
  },
  AU: {
    i18nNames: {
      en: "Australia",
      it: "Australia",
      es: "Australia",
      de: "Australien",
      pl: "Australia",
      fr: "Australie",
      nl: "Australië",
      pt: "Austrália",
      cs: "Austrálie",
      ro: "Australia",
      ru: "Австралия"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  AW: {
    i18nNames: {
      en: "Aruba",
      it: "Aruba",
      es: "Aruba",
      de: "Aruba",
      pl: "Aruba",
      fr: "Aruba",
      nl: "Aruba",
      pt: "Aruba",
      cs: "Aruba",
      ro: "Aruba",
      ru: "Аруба"
    },
    rootIddCode: "+297",
    continent: "NorthAmerica"
  },
  AX: {
    i18nNames: {
      en: "Åland Islands",
      it: "Isole Aland",
      es: "Islas Åland",
      de: "Ålandinseln",
      pl: "Wyspy Alandzkie",
      fr: "Îles Åland",
      nl: "Ålandeilanden",
      pt: "Ilhas Åland",
      cs: "Ålandské ostrovy",
      ro: "Insulele Åland",
      ru: "Аландские острова"
    },
    rootIddCode: "+35818",
    continent: "Europe",
    blocMemberships: ["EU"]
  },
  AZ: {
    i18nNames: {
      en: "Azerbaijan",
      it: "Azerbaijan",
      es: "Azerbaiyán",
      de: "Aserbaidschan",
      pl: "Azerbejdżan",
      fr: "Azerbaïdjan",
      nl: "Azerbeidzjan",
      pt: "Azerbaijão",
      cs: "Ázerbájdžán",
      ro: "Azerbaidjan",
      ru: "Азербайджан"
    },
    rootIddCode: "+994",
    continent: "Asia"
  },
  BB: {
    i18nNames: {
      en: "Barbados",
      it: "Barbados",
      es: "Barbados",
      de: "Barbados",
      pl: "Barbados",
      fr: "Barbade",
      nl: "Barbados",
      pt: "Barbados",
      cs: "Barbados",
      ro: "Barbados",
      ru: "Барбадос"
    },
    rootIddCode: "+1246",
    continent: "NorthAmerica"
  },
  BD: {
    i18nNames: {
      en: "Bangladesh",
      it: "Bangladesh",
      es: "Bangladés",
      de: "Bangladesch",
      pl: "Bangladesz",
      fr: "Bangladesh",
      nl: "Bangladesh",
      pt: "Bangladesh",
      cs: "Bangladéš",
      ro: "Bangladesh",
      ru: "Бангладеш"
    },
    rootIddCode: "+880",
    continent: "Asia"
  },
  BE: {
    i18nNames: {
      en: "Belgium",
      it: "Belgio",
      es: "Bélgica",
      de: "Belgien",
      pl: "Belgia",
      fr: "Belgique",
      nl: "België",
      pt: "Bélgica",
      cs: "Belgie",
      ro: "Belgia",
      ru: "Бельгия"
    },
    rootIddCode: "+32",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BE\\d{10}$",
    taxIdExample: "BE0123456789"
  },
  BF: {
    i18nNames: {
      en: "Burkina Faso",
      it: "Burkina Faso",
      es: "Burkina Faso",
      de: "Burkina Faso",
      pl: "Burkina Faso",
      fr: "Burkina Faso",
      nl: "Burkina Faso",
      pt: "Burquina Faso",
      cs: "Burkina Faso",
      ro: "Burkina Faso",
      ru: "Буркина-Фасо"
    },
    rootIddCode: "+226",
    continent: "Africa"
  },
  BG: {
    i18nNames: {
      en: "Bulgaria",
      it: "Bulgaria",
      es: "Bulgaria",
      de: "Bulgarien",
      pl: "Bułgaria",
      fr: "Bulgarie",
      nl: "Bulgarije",
      pt: "Bulgária",
      cs: "Bulharsko",
      ro: "Bulgaria",
      ru: "Болгария"
    },
    rootIddCode: "+359",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BG(\\d{9}|\\d{10})$",
    taxIdExample: "BG123456789"
  },
  BH: {
    i18nNames: {
      en: "Bahrain",
      it: "Bahrein",
      es: "Baréin",
      de: "Bahrain",
      pl: "Bahrajn",
      fr: "Bahreïn",
      nl: "Bahrein",
      pt: "Bahrein",
      cs: "Bahrajn",
      ro: "Bahrein",
      ru: "Бахрейн"
    },
    rootIddCode: "+973",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BI: {
    i18nNames: {
      en: "Burundi",
      it: "Burundi",
      es: "Burundi",
      de: "Burundi",
      pl: "Burundi",
      fr: "Burundi",
      nl: "Burundi",
      pt: "Burundi",
      cs: "Burundi",
      ro: "Burundi",
      ru: "Бурунди"
    },
    rootIddCode: "+257",
    continent: "Africa"
  },
  BJ: {
    i18nNames: {
      en: "Benin",
      it: "Benin",
      es: "Benín",
      de: "Benin",
      pl: "Benin",
      fr: "Bénin",
      nl: "Benin",
      pt: "Benim",
      cs: "Benin",
      ro: "Benin",
      ru: "Бенин"
    },
    rootIddCode: "+229",
    continent: "Africa"
  },
  BL: {
    i18nNames: {
      en: "Saint Barthélemy",
      es: "San Bartolomé",
      it: "Antille Francesi",
      de: "Saint-Barthélemy",
      pl: "Saint-Barthélemy",
      fr: "Saint-Barthélemy",
      nl: "Saint-Barthélemy",
      pt: "São Bartolomeu",
      cs: "Svatý Bartoloměj",
      ro: "Sfântul Bartolomeu",
      ru: "Сен-Бартелеми"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  BM: {
    i18nNames: {
      en: "Bermuda",
      it: "Bermuda",
      es: "Bermudas",
      de: "Bermuda",
      pl: "Bermudy",
      fr: "Bermudes",
      nl: "Bermuda",
      pt: "Bermudas",
      cs: "Bermudy",
      ro: "Bermuda",
      ru: "Бермуды"
    },
    rootIddCode: "+1441",
    continent: "NorthAmerica"
  },
  BN: {
    i18nNames: {
      en: "Brunei",
      it: "Brunei",
      es: "Brunéi",
      de: "Brunei",
      pl: "Brunei",
      fr: "Brunei",
      nl: "Brunei",
      pt: "Brunei",
      cs: "Brunej",
      ro: "Brunei",
      ru: "Бруней"
    },
    rootIddCode: "+673",
    continent: "Asia"
  },
  BO: {
    i18nNames: {
      en: "Bolivia",
      it: "Bolivia",
      es: "Bolivia",
      de: "Bolivien",
      pl: "Boliwia",
      fr: "Bolivie",
      nl: "Bolivia",
      pt: "Bolívia",
      cs: "Bolívie",
      ro: "Bolivia",
      ru: "Боливия"
    },
    rootIddCode: "+591",
    continent: "SouthAmerica"
  },
  BQ: {
    i18nNames: {
      en: "Caribbean Netherlands",
      es: "Bonaire, San Eustaquio y Saba",
      it: "Paesi Bassi caraibici",
      de: "Karibische Niederlande",
      pl: "Niderlandy Karaibskie",
      fr: "Pays-Bas caribéens",
      nl: "Caribisch Nederland",
      pt: "Países Baixos Caribenhos",
      cs: "Karibské Nizozemsko",
      ro: "Antilele Olandeze",
      ru: "Карибские Нидерланды"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  BR: {
    i18nNames: {
      en: "Brazil",
      it: "Brasile",
      es: "Brasil",
      de: "Brasilien",
      pl: "Brazylia",
      fr: "Brésil",
      nl: "Brazilië",
      pt: "Brasil",
      cs: "Brazílie",
      ro: "Brazilia",
      ru: "Бразилия"
    },
    rootIddCode: "+55",
    continent: "SouthAmerica"
  },
  BS: {
    i18nNames: {
      en: "Bahamas",
      it: "Bahamas",
      es: "Bahamas",
      de: "Bahamas",
      pl: "Bahamy",
      fr: "Bahamas",
      nl: "Bahama's",
      pt: "Bahamas",
      cs: "Bahamy",
      ro: "Bahamas",
      ru: "Багамы"
    },
    rootIddCode: "+1242",
    continent: "NorthAmerica"
  },
  BT: {
    i18nNames: {
      en: "Bhutan",
      it: "Bhutan",
      es: "Bután",
      de: "Bhutan",
      pl: "Bhutan",
      fr: "Bhoutan",
      nl: "Bhutan",
      pt: "Butão",
      cs: "Bhútán",
      ro: "Bhutan",
      ru: "Бутан"
    },
    rootIddCode: "+975",
    continent: "Asia"
  },
  BV: {
    i18nNames: {
      en: "Bouvet Island",
      it: "Isola Bouvet",
      es: "Isla Bouvet",
      de: "Bouvetinsel",
      pl: "Wyspa Bouveta",
      fr: "Île Bouvet",
      nl: "Bouveteiland",
      pt: "Ilha Bouvet",
      cs: "Bouvetův ostrov",
      ro: "Insula Bouvet",
      ru: "Остров Буве"
    },
    rootIddCode: "+47",
    continent: "Antarctica"
  },
  BW: {
    i18nNames: {
      en: "Botswana",
      it: "Botswana",
      es: "Botsuana",
      de: "Botswana",
      pl: "Botswana",
      fr: "Botswana",
      nl: "Botswana",
      pt: "Botsuana",
      cs: "Botswana",
      ro: "Botswana",
      ru: "Ботсвана"
    },
    rootIddCode: "+267",
    continent: "Africa"
  },
  BY: {
    i18nNames: {
      en: "Belarus",
      it: "Bielorussia",
      es: "Bielorrusia",
      de: "Weißrussland",
      pl: "Białoruś",
      fr: "Biélorussie",
      nl: "Wit-Rusland",
      pt: "Bielorrússia",
      cs: "Bělorusko",
      ro: "Belarus",
      ru: "Беларусь"
    },
    rootIddCode: "+375",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  BZ: {
    i18nNames: {
      en: "Belize",
      it: "Belize",
      es: "Belice",
      de: "Belize",
      pl: "Belize",
      fr: "Belize",
      nl: "Belize",
      pt: "Belize",
      cs: "Belize",
      ro: "Belize",
      ru: "Белиз"
    },
    rootIddCode: "+501",
    continent: "NorthAmerica"
  },
  CA: {
    i18nNames: {
      en: "Canada",
      it: "Canada",
      es: "Canadá",
      de: "Kanada",
      pl: "Kanada",
      fr: "Canada",
      nl: "Canada",
      pt: "Canadá",
      cs: "Kanada",
      ro: "Canada",
      ru: "Канада"
    },
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
    rootIddCode: "+1",
    continent: "NorthAmerica"
  },
  CC: {
    i18nNames: {
      en: "Cocos (Keeling) Islands",
      es: "Islas Cocos",
      it: "Isole Cocos e Keeling",
      de: "Kokosinseln",
      pl: "Wyspy Kokosowe",
      fr: "Îles Cocos",
      nl: "Cocoseilanden",
      pt: "Ilhas Cocos (Keeling)",
      cs: "Kokosové ostrovy",
      ro: "Insulele Cocos (Keeling)",
      ru: "Кокосовые (Килинг) острова"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CD: {
    i18nNames: {
      en: "DR Congo",
      it: "Congo (Rep. Dem.)",
      es: "República Democrática del Congo",
      de: "Demokratische Republik Kongo",
      pl: "Demokratyczna Republika Konga",
      fr: "RDC (République Démocratique du Congo)",
      nl: "Congo (DRC)",
      pt: "RD Congo",
      cs: "Demokratická republika Kongo",
      ro: "Congo (R.D.)",
      ru: "Демократическая Республика Конго"
    },
    rootIddCode: "+243",
    continent: "Africa"
  },
  CF: {
    i18nNames: {
      en: "Central African Republic",
      es: "República Centroafricana",
      it: "Repubblica Centrafricana",
      de: "Zentralafrikanische Republik",
      pl: "Republika Środkowoafrykańska",
      fr: "République centrafricaine",
      nl: "Centraal-Afrikaanse Republiek",
      pt: "República Centro-Africana",
      cs: "Středoafrická republika",
      ro: "Republica Centrafricană",
      ru: "Центральноафриканская Республика"
    },
    rootIddCode: "+236",
    continent: "Africa"
  },
  CG: {
    i18nNames: {
      en: "Republic of the Congo",
      it: "Congo",
      es: "República del Congo",
      de: "Republik Kongo",
      pl: "Kongo",
      fr: "République du Congo",
      nl: "Republiek Congo",
      pt: "República do Congo",
      cs: "Republika Kongo",
      ro: "Republica Congo",
      ru: "Республика Конго"
    },
    rootIddCode: "+242",
    continent: "Africa"
  },
  CH: {
    i18nNames: {
      en: "Switzerland",
      it: "Svizzera",
      es: "Suiza",
      de: "Schweiz",
      pl: "Szwajcaria",
      fr: "Suisse",
      nl: "Zwitserland",
      pt: "Suíça",
      cs: "Švýcarsko",
      ro: "Elveția",
      ru: "Швейцария"
    },
    rootIddCode: "+41",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^CHE\\d{9}(MWST|TVA|IVA)?$",
    taxIdExample: "CHE123456789MWST"
  },
  CI: {
    i18nNames: {
      en: "Ivory Coast",
      it: "Costa d'Avorio",
      es: "Costa de Marfil",
      de: "Elfenbeinküste",
      pl: "Wybrzeże Kości Słoniowej",
      fr: "Côte d'Ivoire",
      nl: "Ivoorkust",
      pt: "Costa do Marfim",
      cs: "Pobřeží slonoviny",
      ro: "Coasta de Fildeș",
      ru: "Кот-д’Ивуар"
    },
    rootIddCode: "+225",
    continent: "Africa"
  },
  CK: {
    i18nNames: {
      en: "Cook Islands",
      it: "Isole Cook",
      es: "Islas Cook",
      de: "Cookinseln",
      pl: "Wyspy Cooka",
      fr: "Îles Cook",
      nl: "Cookeilanden",
      pt: "Ilhas Cook",
      cs: "Cookovy ostrovy",
      ro: "Insulele Cook",
      ru: "Острова Кука"
    },
    rootIddCode: "+682",
    continent: "Oceania"
  },
  CL: {
    i18nNames: {
      en: "Chile",
      it: "Cile",
      es: "Chile",
      de: "Chile",
      pl: "Chile",
      fr: "Chili",
      nl: "Chili",
      pt: "Chile",
      cs: "Chile",
      ro: "Chile",
      ru: "Чили"
    },
    rootIddCode: "+56",
    continent: "SouthAmerica"
  },
  CM: {
    i18nNames: {
      en: "Cameroon",
      it: "Camerun",
      es: "Camerún",
      de: "Kamerun",
      pl: "Kamerun",
      fr: "Cameroun",
      nl: "Kameroen",
      pt: "Camarões",
      cs: "Kamerun",
      ro: "Camerun",
      ru: "Камерун"
    },
    rootIddCode: "+237",
    continent: "Africa"
  },
  CN: {
    i18nNames: {
      en: "China",
      it: "Cina",
      es: "China",
      de: "China",
      pl: "Chiny",
      fr: "Chine",
      nl: "China",
      pt: "China",
      cs: "Čína",
      ro: "China",
      ru: "Китай"
    },
    rootIddCode: "+86",
    continent: "Asia"
  },
  CO: {
    i18nNames: {
      en: "Colombia",
      it: "Colombia",
      es: "Colombia",
      de: "Kolumbien",
      pl: "Kolumbia",
      fr: "Colombie",
      nl: "Colombia",
      pt: "Colômbia",
      cs: "Kolumbie",
      ro: "Columbia",
      ru: "Колумбия"
    },
    rootIddCode: "+57",
    continent: "SouthAmerica"
  },
  CR: {
    i18nNames: {
      en: "Costa Rica",
      it: "Costa Rica",
      es: "Costa Rica",
      de: "Costa Rica",
      pl: "Kostaryka",
      fr: "Costa Rica",
      nl: "Costa Rica",
      pt: "Costa Rica",
      cs: "Kostarika",
      ro: "Costa Rica",
      ru: "Коста-Рика"
    },
    rootIddCode: "+506",
    continent: "NorthAmerica"
  },
  CU: {
    i18nNames: {
      en: "Cuba",
      it: "Cuba",
      es: "Cuba",
      de: "Kuba",
      pl: "Kuba",
      fr: "Cuba",
      nl: "Cuba",
      pt: "Cuba",
      cs: "Kuba",
      ro: "Cuba",
      ru: "Куба"
    },
    rootIddCode: "+53",
    continent: "NorthAmerica"
  },
  CV: {
    i18nNames: {
      en: "Cape Verde",
      it: "Capo Verde",
      es: "Cabo Verde",
      de: "Kap Verde",
      pl: "Republika Zielonego Przylądka",
      fr: "Cap-Vert",
      nl: "Kaapverdië",
      pt: "Cabo Verde",
      cs: "Kapverdy",
      ro: "Capul Verde",
      ru: "Кабо-Верде"
    },
    rootIddCode: "+238",
    continent: "Africa"
  },
  CW: {
    i18nNames: {
      en: "Curaçao",
      it: "Curaçao",
      es: "Curazao",
      de: "Curaçao",
      pl: "Curaçao",
      fr: "Curaçao",
      nl: "Curaçao",
      pt: "Curaçau",
      cs: "Curaçao",
      ro: "Curaçao",
      ru: "Кюрасао"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  CX: {
    i18nNames: {
      en: "Christmas Island",
      es: "Isla Christmas",
      it: "Isola di Natale",
      de: "Weihnachtsinsel",
      pl: "Wyspa Bożego Narodzenia",
      fr: "Île Christmas",
      nl: "Christmaseiland",
      pt: "Ilha Christmas",
      cs: "Vánoční ostrov",
      ro: "Insula Christmas",
      ru: "Остров Рождества"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CY: {
    i18nNames: {
      en: "Cyprus",
      it: "Cipro",
      es: "Chipre",
      de: "Zypern",
      pl: "Cypr",
      fr: "Chypre",
      nl: "Cyprus",
      pt: "Chipre",
      cs: "Kypr",
      ro: "Cipru",
      ru: "Кипр"
    },
    rootIddCode: "+357",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CY\\d{8}[A-Z]$",
    taxIdExample: "CY12345678A"
  },
  CZ: {
    i18nNames: {
      en: "Czech Republic",
      it: "Repubblica Ceca",
      es: "República Checa",
      de: "Tschechische Republik",
      pl: "Czechy",
      fr: "République tchèque",
      nl: "Tsjechië",
      pt: "República Checa",
      cs: "Česko",
      ro: "Republica Cehă",
      ru: "Чешская Республика"
    },
    rootIddCode: "+420",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CZ(\\d{8}|\\d{9}|\\d{10})$",
    taxIdExample: "CZ12345678"
  },
  DE: {
    i18nNames: {
      en: "Germany",
      it: "Germania",
      es: "Alemania",
      de: "Deutschland",
      pl: "Niemcy",
      fr: "Allemagne",
      nl: "Duitsland",
      pt: "Alemanha",
      cs: "Německo",
      ro: "Germania",
      ru: "Германия"
    },
    rootIddCode: "+49",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: Ry,
    taxIdMandatory: !1,
    taxIdPattern: "^DE\\d{9}$",
    taxIdExample: "DE123456789"
  },
  DJ: {
    i18nNames: {
      en: "Djibouti",
      it: "Gibuti",
      es: "Yibuti",
      de: "Dschibuti",
      pl: "Dżibuti",
      fr: "Djibouti",
      nl: "Djibouti",
      pt: "Djibuti",
      cs: "Džibutsko",
      ro: "Djibouti",
      ru: "Джибути"
    },
    rootIddCode: "+253",
    continent: "Africa"
  },
  DK: {
    i18nNames: {
      en: "Denmark",
      it: "Danimarca",
      es: "Dinamarca",
      de: "Dänemark",
      pl: "Dania",
      fr: "Danemark",
      nl: "Denemarken",
      pt: "Dinamarca",
      cs: "Dánsko",
      ro: "Danemarca",
      ru: "Дания"
    },
    rootIddCode: "+45",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^DK\\d{8}$",
    taxIdExample: "DK12345678"
  },
  DM: {
    i18nNames: {
      en: "Dominica",
      it: "Dominica",
      es: "Dominica",
      de: "Dominica",
      pl: "Dominika",
      fr: "Dominique",
      nl: "Dominica",
      pt: "Dominica",
      cs: "Dominika",
      ro: "Dominica",
      ru: "Доминика"
    },
    rootIddCode: "+1767",
    continent: "NorthAmerica"
  },
  DO: {
    i18nNames: {
      en: "Dominican Republic",
      es: "República Dominicana",
      it: "Repubblica Dominicana",
      de: "Dominikanische Republik",
      pl: "Dominikana",
      fr: "République dominicaine",
      nl: "Dominicaanse Republiek",
      pt: "República Dominicana",
      cs: "Dominikánská republika",
      ro: "Republica Dominicană",
      ru: "Доминиканская Республика"
    },
    rootIddCode: "+1849",
    continent: "NorthAmerica"
  },
  DZ: {
    i18nNames: {
      en: "Algeria",
      it: "Algeria",
      es: "Argelia",
      de: "Algerien",
      pl: "Algieria",
      fr: "Algérie",
      nl: "Algerije",
      pt: "Argélia",
      cs: "Alžírsko",
      ro: "Algeria",
      ru: "Алжир"
    },
    rootIddCode: "+213",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{15}|\\d{20})$",
    taxIdExample: "123456789012345"
  },
  EC: {
    i18nNames: {
      en: "Ecuador",
      it: "Ecuador",
      es: "Ecuador",
      de: "Ecuador",
      pl: "Ekwador",
      fr: "Équateur",
      nl: "Ecuador",
      pt: "Equador",
      cs: "Ekvádor",
      ro: "Ecuador",
      ru: "Эквадор"
    },
    rootIddCode: "+593",
    continent: "SouthAmerica"
  },
  EE: {
    i18nNames: {
      en: "Estonia",
      it: "Estonia",
      es: "Estonia",
      de: "Estland",
      pl: "Estonia",
      fr: "Estonie",
      nl: "Estland",
      pt: "Estónia",
      cs: "Estonsko",
      ro: "Estonia",
      ru: "Эстония"
    },
    rootIddCode: "+372",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EE\\d{9}$",
    taxIdExample: "EE123456789"
  },
  EG: {
    i18nNames: {
      en: "Egypt",
      it: "Egitto",
      es: "Egipto",
      de: "Ägypten",
      pl: "Egipt",
      fr: "Égypte",
      nl: "Egypte",
      pt: "Egito",
      cs: "Egypt",
      ro: "Egipt",
      ru: "Египет"
    },
    rootIddCode: "+20",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  EH: {
    i18nNames: {
      en: "Western Sahara",
      it: "Sahara Occidentale",
      es: "Sáhara Occidental",
      de: "Westsahara",
      pl: "Sahara Zachodnia",
      fr: "Sahara occidental",
      nl: "Westelijke Sahara",
      pt: "Saara Ocidental",
      cs: "Západní Sahara",
      ro: "Sahara Occidentală",
      ru: "Западная Сахара"
    },
    rootIddCode: "+2125289",
    continent: "Africa"
  },
  ER: {
    i18nNames: {
      en: "Eritrea",
      it: "Eritrea",
      es: "Eritrea",
      de: "Eritrea",
      pl: "Erytrea",
      fr: "Érythrée",
      nl: "Eritrea",
      pt: "Eritreia",
      cs: "Eritrea",
      ro: "Eritreea",
      ru: "Эритрея"
    },
    rootIddCode: "+291",
    continent: "Africa"
  },
  ES: {
    i18nNames: {
      en: "Spain",
      it: "Spagna",
      es: "España",
      de: "Spanien",
      pl: "Hiszpania",
      fr: "Espagne",
      nl: "Spanje",
      pt: "Espanha",
      cs: "Španělsko",
      ro: "Spania",
      ru: "Испания"
    },
    rootIddCode: "+34",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: Oy,
    taxIdMandatory: !0,
    taxIdPattern: "^ES[A-Z0-9]\\d{7}[A-Z0-9]$",
    taxIdExample: "ESX1234567Y"
  },
  ET: {
    i18nNames: {
      en: "Ethiopia",
      it: "Etiopia",
      es: "Etiopía",
      de: "Äthiopien",
      pl: "Etiopia",
      fr: "Éthiopie",
      nl: "Ethiopië",
      pt: "Etiópia",
      cs: "Etiopie",
      ro: "Etiopia",
      ru: "Эфиопия"
    },
    rootIddCode: "+251",
    continent: "Africa"
  },
  FI: {
    i18nNames: {
      en: "Finland",
      it: "Finlandia",
      es: "Finlandia",
      de: "Finnland",
      pl: "Finlandia",
      fr: "Finlande",
      nl: "Finland",
      pt: "Finlândia",
      cs: "Finsko",
      ro: "Finlanda",
      ru: "Финляндия"
    },
    rootIddCode: "+358",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FI\\d{8}$",
    taxIdExample: "FI12345678"
  },
  FJ: {
    i18nNames: {
      en: "Fiji",
      it: "Figi",
      es: "Fiyi",
      de: "Fidschi",
      pl: "Fidżi",
      fr: "Fidji",
      nl: "Fiji",
      pt: "Fiji",
      cs: "Fidži",
      ro: "Fiji",
      ru: "Фиджи"
    },
    rootIddCode: "+679",
    continent: "Oceania"
  },
  FK: {
    i18nNames: {
      en: "Falkland Islands",
      es: "Islas Malvinas",
      it: "Isole Falkland o Isole Malvine",
      de: "Falklandinseln",
      pl: "Wyspy Falklandzkie",
      fr: "Îles Falkland",
      nl: "Falklandeilanden",
      pt: "Ilhas Malvinas",
      cs: "Falklandské ostrovy",
      ro: "Insulele Falkland",
      ru: "Фолклендские острова"
    },
    rootIddCode: "+500",
    continent: "SouthAmerica"
  },
  FM: {
    i18nNames: {
      en: "Micronesia",
      it: "Micronesia",
      es: "Estados Federados de Micronesia",
      de: "Mikronesien",
      pl: "Mikronezja",
      fr: "Micronésie",
      nl: "Micronesië",
      pt: "Micronésia",
      cs: "Mikronésie",
      ro: "Micronezia",
      ru: "Микронезия"
    },
    rootIddCode: "+691",
    continent: "Oceania"
  },
  FO: {
    i18nNames: {
      en: "Faroe Islands",
      it: "Isole Far Oer",
      es: "Islas Feroe",
      de: "Färöer-Inseln",
      pl: "Wyspy Owcze",
      fr: "Îles Féroé",
      nl: "Faeröer",
      pt: "Ilhas Faroé",
      cs: "Faerské ostrovy",
      ro: "Insulele Feroe",
      ru: "Фарерские острова"
    },
    rootIddCode: "+298",
    continent: "Europe"
  },
  FR: {
    i18nNames: {
      en: "France",
      it: "Francia",
      es: "Francia",
      de: "Frankreich",
      pl: "Francja",
      fr: "France",
      nl: "Frankrijk",
      pt: "França",
      cs: "Francie",
      ro: "Franța",
      ru: "Франция"
    },
    rootIddCode: "+33",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR1A123456789"
  },
  GA: {
    i18nNames: {
      en: "Gabon",
      it: "Gabon",
      es: "Gabón",
      de: "Gabun",
      pl: "Gabon",
      fr: "Gabon",
      nl: "Gabon",
      pt: "Gabão",
      cs: "Gabon",
      ro: "Gabon",
      ru: "Габон"
    },
    rootIddCode: "+241",
    continent: "Africa"
  },
  GB: {
    i18nNames: {
      en: "United Kingdom",
      it: "Regno Unito",
      es: "Reino Unido",
      de: "Vereinigtes Königreich",
      pl: "Zjednoczone Królestwo",
      fr: "Royaume-Uni",
      nl: "Verenigd Koninkrijk",
      pt: "Reino Unido",
      cs: "Spojené království",
      ro: "Regatul Unit",
      ru: "Великобритания"
    },
    rootIddCode: "+44",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^GB(\\d{9}|\\d{12}|GD(0\\d{2}|[1-4]\\d{2})|HA([5-9]\\d{2}))$",
    taxIdExample: "GB123456789"
  },
  GD: {
    i18nNames: {
      en: "Grenada",
      it: "Grenada",
      es: "Granada",
      de: "Grenada",
      pl: "Grenada",
      fr: "Grenade",
      nl: "Grenada",
      pt: "Granada",
      cs: "Grenada",
      ro: "Grenada",
      ru: "Гренада"
    },
    rootIddCode: "+1473",
    continent: "NorthAmerica"
  },
  GE: {
    i18nNames: {
      en: "Georgia",
      it: "Georgia",
      es: "Georgia",
      de: "Georgien",
      pl: "Gruzja",
      fr: "Géorgie",
      nl: "Georgië",
      pt: "Geórgia",
      cs: "Gruzie",
      ro: "Georgia",
      ru: "Грузия"
    },
    rootIddCode: "+995",
    continent: "Europe"
  },
  GF: {
    i18nNames: {
      en: "French Guiana",
      it: "Guyana francese",
      es: "Guayana Francesa",
      de: "Französisch-Guayana",
      pl: "Gujana Francuska",
      fr: "Guyane française",
      nl: "Frans-Guyana",
      pt: "Guiana Francesa",
      cs: "Francouzská Guyana",
      ro: "Guyana Franceză",
      ru: "Французская Гвиана"
    },
    rootIddCode: "+594",
    continent: "SouthAmerica",
    blocMemberships: ["EU"]
  },
  GG: {
    i18nNames: {
      en: "Guernsey",
      it: "Guernsey",
      es: "Guernsey",
      de: "Guernsey",
      pl: "Guernsey",
      fr: "Guernesey",
      nl: "Guernsey",
      pt: "Guernsey",
      cs: "Guernsey",
      ro: "Guernsey",
      ru: "Гернси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  GH: {
    i18nNames: {
      en: "Ghana",
      it: "Ghana",
      es: "Ghana",
      de: "Ghana",
      pl: "Ghana",
      fr: "Ghana",
      nl: "Ghana",
      pt: "Gana",
      cs: "Ghana",
      ro: "Ghana",
      ru: "Гана"
    },
    rootIddCode: "+233",
    continent: "Africa"
  },
  GI: {
    i18nNames: {
      en: "Gibraltar",
      it: "Gibilterra",
      es: "Gibraltar",
      de: "Gibraltar",
      pl: "Gibraltar",
      fr: "Gibraltar",
      nl: "Gibraltar",
      pt: "Gibraltar",
      cs: "Gibraltar",
      ro: "Gibraltar",
      ru: "Гибралтар"
    },
    rootIddCode: "+350",
    continent: "Europe"
  },
  GL: {
    i18nNames: {
      en: "Greenland",
      it: "Groenlandia",
      es: "Groenlandia",
      de: "Grönland",
      pl: "Grenlandia",
      fr: "Groenland",
      nl: "Groenland",
      pt: "Gronelândia",
      cs: "Grónsko",
      ro: "Groenlanda",
      ru: "Гренландия"
    },
    rootIddCode: "+299",
    continent: "NorthAmerica"
  },
  GM: {
    i18nNames: {
      en: "Gambia",
      it: "Gambia",
      es: "Gambia",
      de: "Gambia",
      pl: "Gambia",
      fr: "Gambie",
      nl: "Gambia",
      pt: "Gâmbia",
      cs: "Gambie",
      ro: "Gambia",
      ru: "Гамбия"
    },
    rootIddCode: "+220",
    continent: "Africa"
  },
  GN: {
    i18nNames: {
      en: "Guinea",
      it: "Guinea",
      es: "Guinea",
      de: "Guinea",
      pl: "Gwinea",
      fr: "Guinée",
      nl: "Guinee",
      pt: "Guiné",
      cs: "Guinea",
      ro: "Guineea",
      ru: "Гвинея"
    },
    rootIddCode: "+224",
    continent: "Africa"
  },
  GP: {
    i18nNames: {
      en: "Guadeloupe",
      it: "Guadeloupa",
      es: "Guadalupe",
      de: "Guadeloupe",
      pl: "Gwadelupa",
      fr: "Guadeloupe",
      nl: "Guadeloupe",
      pt: "Guadalupe",
      cs: "Guadeloupe",
      ro: "Guadelupa",
      ru: "Гваделупа"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  GQ: {
    i18nNames: {
      en: "Equatorial Guinea",
      es: "Guinea Ecuatorial",
      it: "Guinea Equatoriale",
      de: "Äquatorialguinea",
      pl: "Gwinea Równikowa",
      fr: "Guinée équatoriale",
      nl: "Equatoriaal-Guinea",
      pt: "Guiné Equatorial",
      cs: "Rovníková Guinea",
      ro: "Guineea Ecuatorială",
      ru: "Экваториальная Гвинея"
    },
    rootIddCode: "+240",
    continent: "Africa"
  },
  GR: {
    i18nNames: {
      en: "Greece",
      it: "Grecia",
      es: "Grecia",
      de: "Griechenland",
      pl: "Grecja",
      fr: "Grèce",
      nl: "Griekenland",
      pt: "Grécia",
      cs: "Řecko",
      ro: "Grecia",
      ru: "Греция"
    },
    rootIddCode: "+30",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EL\\d{9}$",
    taxIdExample: "EL123456789"
  },
  GS: {
    i18nNames: {
      en: "South Georgia",
      it: "Georgia del Sud e Isole Sandwich Meridionali",
      es: "Islas Georgias del Sur y Sandwich del Sur",
      de: "Südgeorgien",
      pl: "Georgia Południowa",
      fr: "Géorgie du Sud et îles Sandwich du Sud",
      nl: "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      pt: "Geórgia do Sul e Ilhas Sandwich do Sul",
      cs: "Jižní Georgie a Jižní Sandwichovy ostrovy",
      ro: "Georgia de Sud și Insulele Sandwich de Sud",
      ru: "Южная Георгия и Южные Сандвичевы острова"
    },
    rootIddCode: "+500",
    continent: "Oceania"
  },
  GT: {
    i18nNames: {
      en: "Guatemala",
      it: "Guatemala",
      es: "Guatemala",
      de: "Guatemala",
      pl: "Gwatemala",
      fr: "Guatemala",
      nl: "Guatemala",
      pt: "Guatemala",
      cs: "Guatemala",
      ro: "Guatemala",
      ru: "Гватемала"
    },
    rootIddCode: "+502",
    continent: "NorthAmerica"
  },
  GU: {
    i18nNames: {
      en: "Guam",
      it: "Guam",
      es: "Guam",
      de: "Guam",
      pl: "Guam",
      fr: "Guam",
      nl: "Guam",
      pt: "Guam",
      cs: "Guam",
      ro: "Guam",
      ru: "Гуам"
    },
    rootIddCode: "+1671",
    continent: "NorthAmerica"
  },
  GW: {
    i18nNames: {
      en: "Guinea-Bissau",
      it: "Guinea-Bissau",
      es: "Guinea-Bisáu",
      de: "Guinea-Bissau",
      pl: "Gwinea-Bissau",
      fr: "Guinée-Bissau",
      nl: "Guinee-Bissau",
      pt: "Guiné-Bissau",
      cs: "Guinea-Bissau",
      ro: "Guineea-Bissau",
      ru: "Гвинея-Бисау"
    },
    rootIddCode: "+245",
    continent: "Africa"
  },
  GY: {
    i18nNames: {
      en: "Guyana",
      it: "Guyana",
      es: "Guyana",
      de: "Guyana",
      pl: "Gujana",
      fr: "Guyana",
      nl: "Guyana",
      pt: "Guiana",
      cs: "Guyana",
      ro: "Guyana",
      ru: "Гайана"
    },
    rootIddCode: "+592",
    continent: "NorthAmerica"
  },
  HK: {
    i18nNames: {
      en: "Hong Kong",
      it: "Hong Kong",
      es: "Hong Kong",
      de: "Hongkong",
      pl: "Hongkong",
      fr: "Hong Kong",
      nl: "Hongkong",
      pt: "Hong Kong",
      cs: "Hongkong",
      ro: "Hong Kong",
      ru: "Гонконг"
    },
    rootIddCode: "+852",
    continent: "Asia"
  },
  HM: {
    i18nNames: {
      en: "Heard Island and McDonald Islands",
      es: "Islas Heard y McDonald",
      it: "Isole Heard e McDonald",
      de: "Heard und McDonaldinseln",
      pl: "Wyspy Heard i McDonalda",
      fr: "Îles Heard et McDonald",
      nl: "Heard en McDonaldeilanden",
      pt: "Ilhas Heard e McDonald",
      cs: "Heardův ostrov a McDonaldovy ostrovy",
      ro: "Insula Heard și Insulele McDonald",
      ru: "Остров Херд и острова Макдональд"
    },
    rootIddCode: "undefined",
    continent: "Oceania"
  },
  HN: {
    i18nNames: {
      en: "Honduras",
      it: "Honduras",
      es: "Honduras",
      de: "Honduras",
      pl: "Honduras",
      fr: "Honduras",
      nl: "Honduras",
      pt: "Honduras",
      cs: "Honduras",
      ro: "Honduras",
      ru: "Гондурас"
    },
    rootIddCode: "+504",
    continent: "NorthAmerica"
  },
  HR: {
    i18nNames: {
      en: "Croatia",
      it: "Croazia",
      es: "Croacia",
      de: "Kroatien",
      pl: "Chorwacja",
      fr: "Croatie",
      nl: "Kroatië",
      pt: "Croácia",
      cs: "Chorvatsko",
      ro: "Croația",
      ru: "Хорватия"
    },
    rootIddCode: "+385",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HR\\d{11}$",
    taxIdExample: "HR12345678901"
  },
  HT: {
    i18nNames: {
      en: "Haiti",
      it: "Haiti",
      es: "Haití",
      de: "Haiti",
      pl: "Haiti",
      fr: "Haïti",
      nl: "Haïti",
      pt: "Haiti",
      cs: "Haiti",
      ro: "Haiti",
      ru: "Гаити"
    },
    rootIddCode: "+509",
    continent: "NorthAmerica"
  },
  HU: {
    i18nNames: {
      en: "Hungary",
      it: "Ungheria",
      es: "Hungría",
      de: "Ungarn",
      pl: "Węgry",
      fr: "Hongrie",
      nl: "Hongarije",
      pt: "Hungria",
      cs: "Maďarsko",
      ro: "Ungaria",
      ru: "Венгрия"
    },
    rootIddCode: "+36",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HU\\d{8}$",
    taxIdExample: "HU12345678"
  },
  ID: {
    i18nNames: {
      en: "Indonesia",
      it: "Indonesia",
      es: "Indonesia",
      de: "Indonesien",
      pl: "Indonezja",
      fr: "Indonésie",
      nl: "Indonesië",
      pt: "Indonésia",
      cs: "Indonésie",
      ro: "Indonezia",
      ru: "Индонезия"
    },
    rootIddCode: "+62",
    continent: "Asia"
  },
  IE: {
    i18nNames: {
      en: "Ireland",
      it: "Irlanda",
      es: "Irlanda",
      de: "Irland",
      pl: "Irlandia",
      fr: "Irlande",
      nl: "Ierland",
      pt: "Irlanda",
      cs: "Irsko",
      ro: "Irlanda",
      ru: "Ирландия"
    },
    rootIddCode: "+353",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^IE\\d{7}[A-Z]{1,2}$",
    taxIdExample: "IE1234567A"
  },
  IL: {
    i18nNames: {
      en: "Israel",
      it: "Israele",
      es: "Israel",
      de: "Israel",
      pl: "Израиль",
      fr: "Israël",
      nl: "Israël",
      pt: "Israel",
      cs: "Izrael",
      ro: "Israel",
      ru: "Израиль"
    },
    rootIddCode: "+972",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  IM: {
    i18nNames: {
      en: "Isle of Man",
      it: "Isola di Man",
      es: "Isla de Man",
      de: "Isle of Man",
      pl: "Wyspa Man",
      fr: "Île de Man",
      nl: "Isle of Man",
      pt: "Ilha de Man",
      cs: "Ostrov Man",
      ro: "Insula Man",
      ru: "Остров Мэн"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  IN: {
    i18nNames: {
      en: "India",
      it: "India",
      es: "India",
      de: "Indien",
      pl: "Indie",
      fr: "Inde",
      nl: "India",
      pt: "Índia",
      cs: "Indie",
      ro: "India",
      ru: "Индия"
    },
    rootIddCode: "+91",
    continent: "Asia"
  },
  IO: {
    i18nNames: {
      en: "British Indian Ocean Territory",
      es: "Territorio Británico del Océano Índico",
      it: "Territorio britannico dell'oceano indiano",
      de: "Britisches Territorium im Indischen Ozean",
      pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
      fr: "Territoire britannique de l'océan Indien",
      nl: "Brits Indische Oceaanterritorium",
      pt: "Território Britânico do Oceano Índico",
      cs: "Britské indickooceánské území",
      ro: "Teritoriul Britanic din Oceanul Indian",
      ru: "Британская территория в Индийском океане"
    },
    rootIddCode: "+246",
    continent: "Asia"
  },
  IQ: {
    i18nNames: {
      en: "Iraq",
      it: "Iraq",
      es: "Irak",
      de: "Ирак",
      pl: "Irak",
      fr: "Irak",
      nl: "Irak",
      pt: "Iraque",
      cs: "Irák",
      ro: "Irak",
      ru: "Ирак"
    },
    rootIddCode: "+964",
    continent: "Asia"
  },
  IR: {
    i18nNames: {
      en: "Iran",
      it: "Iran",
      es: "Irán",
      de: "Iran",
      pl: "Iran",
      fr: "Iran",
      nl: "Iran",
      pt: "Irã",
      cs: "Írán",
      ro: "Iran",
      ru: "Иран"
    },
    rootIddCode: "+98",
    continent: "Asia"
  },
  IS: {
    i18nNames: {
      en: "Iceland",
      it: "Islanda",
      es: "Islandia",
      de: "Island",
      pl: "Islandia",
      fr: "Islande",
      nl: "IJsland",
      pt: "Islândia",
      cs: "Island",
      ro: "Islanda",
      ru: "Исландия"
    },
    rootIddCode: "+354",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^IS\\d{5,6}$",
    taxIdExample: "IS123456"
  },
  IT: {
    i18nNames: {
      en: "Italy",
      it: "Italia",
      es: "Italia",
      de: "Italien",
      pl: "Włochy",
      fr: "Italie",
      nl: "Italie",
      pt: "Itália",
      cs: "Itálie",
      ro: "Italia",
      ru: "Италия"
    },
    rootIddCode: "+39",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: Py,
    taxIdMandatory: !0,
    taxIdPattern: "^IT\\d{11}$",
    taxIdExample: "IT12345678901"
  },
  JE: {
    i18nNames: {
      en: "Jersey",
      it: "Isola di Jersey",
      es: "Jersey",
      de: "Jersey",
      pl: "Jersey",
      fr: "Jersey",
      nl: "Jersey",
      pt: "Jersey",
      cs: "Jersey",
      ro: "Jersey",
      ru: "Джерси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  JM: {
    i18nNames: {
      en: "Jamaica",
      it: "Giamaica",
      es: "Jamaica",
      de: "Jamaika",
      pl: "Jamajka",
      fr: "Jamaïque",
      nl: "Jamaica",
      pt: "Jamaica",
      cs: "Jamajka",
      ro: "Jamaica",
      ru: "Ямайка"
    },
    rootIddCode: "+1876",
    continent: "NorthAmerica"
  },
  JO: {
    i18nNames: {
      en: "Jordan",
      it: "Giordania",
      es: "Jordania",
      de: "Jordanien",
      pl: "Jordania",
      fr: "Jordanie",
      nl: "Jordanië",
      pt: "Jordânia",
      cs: "Jordánsko",
      ro: "Iordania",
      ru: "Иордания"
    },
    rootIddCode: "+962",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{7}$",
    taxIdExample: "1234567"
  },
  JP: {
    i18nNames: {
      en: "Japan",
      it: "Giappone",
      es: "Japón",
      de: "Japan",
      pl: "Japonia",
      fr: "Japon",
      nl: "Japan",
      pt: "Japão",
      cs: "Japonsko",
      ro: "Japonia",
      ru: "Япония"
    },
    rootIddCode: "+81",
    continent: "Asia"
  },
  KE: {
    i18nNames: {
      en: "Kenya",
      it: "Kenya",
      es: "Kenia",
      de: "Kenia",
      pl: "Kenia",
      fr: "Kenya",
      nl: "Kenia",
      pt: "Quênia",
      cs: "Keňa",
      ro: "Kenya",
      ru: "Кения"
    },
    rootIddCode: "+254",
    continent: "Africa"
  },
  KG: {
    i18nNames: {
      en: "Kyrgyzstan",
      it: "Kirghizistan",
      es: "Kirguistán",
      de: "Kirgisistan",
      pl: "Kirgistan",
      fr: "Kirghizistan",
      nl: "Kirgizië",
      pt: "Quirguistão",
      cs: "Kyrgyzstán",
      ro: "Kârgâzstan",
      ru: "Киргизия"
    },
    rootIddCode: "+996",
    continent: "Asia"
  },
  KH: {
    i18nNames: {
      en: "Cambodia",
      it: "Cambogia",
      es: "Camboya",
      de: "Kambodscha",
      pl: "Kambodża",
      fr: "Cambodge",
      nl: "Cambodja",
      pt: "Camboja",
      cs: "Kambodža",
      ro: "Cambodgia",
      ru: "Камбоджа"
    },
    rootIddCode: "+855",
    continent: "Asia"
  },
  KI: {
    i18nNames: {
      en: "Kiribati",
      it: "Kiribati",
      es: "Kiribati",
      de: "Kiribati",
      pl: "Kiribati",
      fr: "Kiribati",
      nl: "Kiribati",
      pt: "Kiribati",
      cs: "Kiribati",
      ro: "Kiribati",
      ru: "Кирибати"
    },
    rootIddCode: "+686",
    continent: "Oceania"
  },
  KM: {
    i18nNames: {
      en: "Comoros",
      it: "Comore",
      es: "Comoras",
      de: "Komoren",
      pl: "Komory",
      fr: "Comores",
      nl: "Comoren",
      pt: "Comores",
      cs: "Komory",
      ro: "Comore",
      ru: "Коморы"
    },
    rootIddCode: "+269",
    continent: "Africa"
  },
  KN: {
    i18nNames: {
      en: "Saint Kitts and Nevis",
      es: "San Cristóbal y Nieves",
      it: "Saint Kitts e Nevis",
      de: "St. Kitts und Nevis",
      pl: "Saint Kitts i Nevis",
      fr: "Saint-Christophe-et-Niévès",
      nl: "Saint Kitts en Nevis",
      pt: "São Cristóvão e Névis",
      cs: "Svatý Kryštof a Nevis",
      ro: "Sfântul Kitts și Nevis",
      ru: "Сент-Китс и Невис"
    },
    rootIddCode: "+1869",
    continent: "NorthAmerica"
  },
  KP: {
    i18nNames: {
      en: "North Korea",
      it: "Corea del Nord",
      es: "Corea del Norte",
      de: "Nordkorea",
      pl: "Korea Północna",
      fr: "Corée du Nord",
      nl: "Noord-Korea",
      pt: "Coreia do Norte",
      cs: "Severní Korea",
      ro: "Coreea de Nord",
      ru: "Северная Корея"
    },
    rootIddCode: "+850",
    continent: "Asia"
  },
  KR: {
    i18nNames: {
      en: "South Korea",
      it: "Corea del Sud",
      es: "Corea del Sur",
      de: "Südkorea",
      pl: "Korea Południowa",
      fr: "Corée du Sud",
      nl: "Zuid-Korea",
      pt: "Coreia do Sul",
      cs: "Jižní Korea",
      ro: "Coreea de Sud",
      ru: "Южная Корея"
    },
    rootIddCode: "+82",
    continent: "Asia"
  },
  KW: {
    i18nNames: {
      en: "Kuwait",
      it: "Kuwait",
      es: "Kuwait",
      de: "Kuwait",
      pl: "Kuwejt",
      fr: "Koweït",
      nl: "Кувейт",
      pt: "Kuwait",
      cs: "Kuvajt",
      ro: "Kuweit",
      ru: "Кувейт"
    },
    rootIddCode: "+965",
    continent: "Asia"
  },
  KY: {
    i18nNames: {
      en: "Cayman Islands",
      it: "Isole Cayman",
      es: "Islas Caimán",
      de: "Kaimaninseln",
      pl: "Kajmany",
      fr: "Îles Caïmans",
      nl: "Kaaimaneilanden",
      pt: "Ilhas Cayman",
      cs: "Kajmanské ostrovy",
      ro: "Insulele Cayman",
      ru: "Каймановы острова"
    },
    rootIddCode: "+1345",
    continent: "NorthAmerica"
  },
  KZ: {
    i18nNames: {
      en: "Kazakhstan",
      it: "Kazakistan",
      es: "Kazajistán",
      de: "Kasachstan",
      pl: "Kazachstan",
      fr: "Kazakhstan",
      nl: "Kazachstan",
      pt: "Cazaquistão",
      cs: "Kazachstán",
      ro: "Kazahstan",
      ru: "Казахстан"
    },
    rootIddCode: "+77",
    continent: "Asia"
  },
  LA: {
    i18nNames: {
      en: "Laos",
      it: "Laos",
      es: "Laos",
      de: "Laos",
      pl: "Laos",
      fr: "Laos",
      nl: "Laos",
      pt: "Laos",
      cs: "Laos",
      ro: "Laos",
      ru: "Лаос"
    },
    rootIddCode: "+856",
    continent: "Asia"
  },
  LB: {
    i18nNames: {
      en: "Lebanon",
      it: "Libano",
      es: "Líbano",
      de: "Libanon",
      pl: "Liban",
      fr: "Liban",
      nl: "Libanon",
      pt: "Líbano",
      cs: "Libanon",
      ro: "Liban",
      ru: "Ливан"
    },
    rootIddCode: "+961",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{1,15}(-(601|603|604))?$",
    taxIdExample: "123456789-601"
  },
  LC: {
    i18nNames: {
      en: "Saint Lucia",
      it: "Santa Lucia",
      es: "Santa Lucía",
      de: "St. Lucia",
      pl: "Saint Lucia",
      fr: "Sainte-Lucie",
      nl: "Saint Lucia",
      pt: "Santa Lúcia",
      cs: "Svatá Lucie",
      ro: "Sfânta Lucia",
      ru: "Сент-Люсия"
    },
    rootIddCode: "+1758",
    continent: "NorthAmerica"
  },
  LI: {
    i18nNames: {
      en: "Liechtenstein",
      it: "Liechtenstein",
      es: "Liechtenstein",
      de: "Liechtenstein",
      pl: "Liechtenstein",
      fr: "Liechtenstein",
      nl: "Liechtenstein",
      pt: "Liechtenstein",
      cs: "Lichtenštejnsko",
      ro: "Liechtenstein",
      ru: "Лихтенштейн"
    },
    rootIddCode: "+423",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{5}$",
    taxIdExample: "12345"
  },
  LK: {
    i18nNames: {
      en: "Sri Lanka",
      it: "Sri Lanka",
      es: "Sri Lanka",
      de: "Sri Lanka",
      pl: "Sri Lanka",
      fr: "Sri Lanka",
      nl: "Sri Lanka",
      pt: "Sri Lanka",
      cs: "Srí Lanka",
      ro: "Sri Lanka",
      ru: "Шри-Ланка"
    },
    rootIddCode: "+94",
    continent: "Asia"
  },
  LR: {
    i18nNames: {
      en: "Liberia",
      it: "Liberia",
      es: "Liberia",
      de: "Liberia",
      pl: "Liberia",
      fr: "Libéria",
      nl: "Liberia",
      pt: "Libéria",
      cs: "Libérie",
      ro: "Liberia",
      ru: "Либерия"
    },
    rootIddCode: "+231",
    continent: "Africa"
  },
  LS: {
    i18nNames: {
      en: "Lesotho",
      it: "Lesotho",
      es: "Lesoto",
      de: "Lesotho",
      pl: "Lesotho",
      fr: "Lesotho",
      nl: "Lesotho",
      pt: "Lesoto",
      cs: "Lesotho",
      ro: "Lesotho",
      ru: "Лесото"
    },
    rootIddCode: "+266",
    continent: "Africa"
  },
  LT: {
    i18nNames: {
      en: "Lithuania",
      it: "Lituania",
      es: "Lituania",
      de: "Litauen",
      pl: "Litwa",
      fr: "Lituanie",
      nl: "Litouwen",
      pt: "Lituânia",
      cs: "Litva",
      ro: "Lituania",
      ru: "Литва"
    },
    rootIddCode: "+370",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LT(\\d{9}|\\d{12})$",
    taxIdExample: "LT123456789"
  },
  LU: {
    i18nNames: {
      en: "Luxembourg",
      it: "Lussemburgo",
      es: "Luxemburgo",
      de: "Luxemburg",
      pl: "Luksemburg",
      fr: "Luxembourg",
      nl: "Luxemburg",
      pt: "Luxemburgo",
      cs: "Lucembursko",
      ro: "Luxemburg",
      ru: "Люксембург"
    },
    rootIddCode: "+352",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LU\\d{8}$",
    taxIdExample: "LU12345678"
  },
  LV: {
    i18nNames: {
      en: "Latvia",
      it: "Lettonia",
      es: "Letonia",
      de: "Lettland",
      pl: "Łotwa",
      fr: "Lettonie",
      nl: "Letland",
      pt: "Letónia",
      cs: "Lotyšsko",
      ro: "Letonia",
      ru: "Латвия"
    },
    rootIddCode: "+371",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LV\\d{11}$",
    taxIdExample: "LV12345678901"
  },
  LY: {
    i18nNames: {
      en: "Libya",
      it: "Libia",
      es: "Libia",
      de: "Libyen",
      pl: "Libia",
      fr: "Libye",
      nl: "Libië",
      pt: "Líbia",
      cs: "Libye",
      ro: "Libia",
      ru: "Ливия"
    },
    rootIddCode: "+218",
    continent: "Africa"
  },
  MA: {
    i18nNames: {
      en: "Morocco",
      it: "Marocco",
      es: "Marruecos",
      de: "Marokko",
      pl: "Maroko",
      fr: "Maroc",
      nl: "Marokko",
      pt: "Marrocos",
      cs: "Maroko",
      ro: "Maroc",
      ru: "Марокко"
    },
    rootIddCode: "+212",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MC: {
    i18nNames: {
      en: "Monaco",
      it: "Principato di Monaco",
      es: "Mónaco",
      de: "Monaco",
      pl: "Monako",
      fr: "Monaco",
      nl: "Monaco",
      pt: "Mônaco",
      cs: "Monako",
      ro: "Monaco",
      ru: "Монако"
    },
    rootIddCode: "+377",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR9Z123456789"
  },
  MD: {
    i18nNames: {
      en: "Moldova",
      it: "Moldavia",
      es: "Moldavia",
      de: "Moldawien",
      pl: "Mołdawia",
      fr: "Moldavie",
      nl: "Moldavië",
      pt: "Moldávia",
      cs: "Moldavsko",
      ro: "Moldova",
      ru: "Молдова"
    },
    rootIddCode: "+373",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^MD\\d{7}$",
    taxIdExample: "MD1234567"
  },
  ME: {
    i18nNames: {
      en: "Montenegro",
      it: "Montenegro",
      es: "Montenegro",
      de: "Montenegro",
      pl: "Czarnogóra",
      fr: "Monténégro",
      nl: "Montenegro",
      pt: "Montenegro",
      cs: "Černá Hora",
      ro: "Muntenegru",
      ru: "Черногория"
    },
    rootIddCode: "+382",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MF: {
    i18nNames: {
      en: "Saint Martin",
      it: "Saint Martin",
      es: "San Martín (parte francesa)",
      de: "Saint-Martin",
      pl: "Saint-Martin",
      fr: "Saint-Martin",
      nl: "Saint Martin",
      pt: "São Martinho",
      cs: "Saint-Martin",
      ro: "Sfântul Martin",
      ru: "Сен-Мартен"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  MG: {
    i18nNames: {
      en: "Madagascar",
      it: "Madagascar",
      es: "Madagascar",
      de: "Madagaskar",
      pl: "Madagaskar",
      fr: "Madagascar",
      nl: "Madagaskar",
      pt: "Madagáscar",
      cs: "Madagaskar",
      ro: "Madagascar",
      ru: "Мадагаскар"
    },
    rootIddCode: "+261",
    continent: "Africa"
  },
  MH: {
    i18nNames: {
      en: "Marshall Islands",
      es: "Islas Marshall",
      it: "Isole Marshall",
      de: "Marshallinseln",
      pl: "Wyspy Marshalla",
      fr: "Îles Marshall",
      nl: "Marshalleilanden",
      pt: "Ilhas Marshall",
      cs: "Marshallovy ostrovy",
      ro: "Insulele Marshall",
      ru: "Маршалловы Острова"
    },
    rootIddCode: "+692",
    continent: "Oceania"
  },
  MK: {
    i18nNames: {
      en: "North Macedonia",
      it: "Macedonia del Nord",
      es: "Macedonia del Norte",
      de: "Nordmazedonien",
      pl: "Macedonia Północna",
      fr: "Macédoine du Nord",
      nl: "Noord-Macedonië",
      pt: "Macedônia do Norte",
      cs: "Severní Makedonie",
      ro: "Macedonia de Nord",
      ru: "Северная Македония"
    },
    rootIddCode: "+389",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{13}$",
    taxIdExample: "1234567890123"
  },
  ML: {
    i18nNames: {
      en: "Mali",
      it: "Mali",
      es: "Malí",
      de: "Mali",
      pl: "Mali",
      fr: "Mali",
      nl: "Mali",
      pt: "Mali",
      cs: "Mali",
      ro: "Mali",
      ru: "Мали"
    },
    rootIddCode: "+223",
    continent: "Africa"
  },
  MM: {
    i18nNames: {
      en: "Myanmar",
      it: "Birmania",
      es: "Birmania",
      de: "Myanmar",
      pl: "Mjanma",
      fr: "Birmanie",
      nl: "Myanmar",
      pt: "Mianmar",
      cs: "Myanmar",
      ro: "Myanmar",
      ru: "Мьянма"
    },
    rootIddCode: "+95",
    continent: "Asia"
  },
  MN: {
    i18nNames: {
      en: "Mongolia",
      it: "Mongolia",
      es: "Mongolia",
      de: "Mongolei",
      pl: "Mongolia",
      fr: "Mongolie",
      nl: "Mongolië",
      pt: "Mongólia",
      cs: "Mongolsko",
      ro: "Mongolia",
      ru: "Монголия"
    },
    rootIddCode: "+976",
    continent: "Asia"
  },
  MO: {
    i18nNames: {
      en: "Macau",
      it: "Macao",
      es: "Macao",
      de: "Macau",
      pl: "Makau",
      fr: "Macao",
      nl: "Macau",
      pt: "Macau",
      cs: "Macao",
      ro: "Macao",
      ru: "Макао"
    },
    rootIddCode: "+853",
    continent: "Asia"
  },
  MP: {
    i18nNames: {
      en: "Northern Mariana Islands",
      es: "Islas Marianas del Norte",
      it: "Isole Marianne Settentrionali",
      de: "Nördliche Marianen",
      pl: "Mariany Północne",
      fr: "Îles Mariannes du Nord",
      nl: "Noordelijke Marianen",
      pt: "Ilhas Marianas do Norte",
      cs: "Severní Mariany",
      ro: "Insulele Mariane de Nord",
      ru: "Северные Марианские острова"
    },
    rootIddCode: "+1670",
    continent: "NorthAmerica"
  },
  MQ: {
    i18nNames: {
      en: "Martinique",
      it: "Martinica",
      es: "Martinica",
      de: "Martinique",
      pl: "Martynika",
      fr: "Martinique",
      nl: "Martinique",
      pt: "Martinica",
      cs: "Martinik",
      ro: "Martinica",
      ru: "Мартиника"
    },
    rootIddCode: "+596",
    continent: "NorthAmerica"
  },
  MR: {
    i18nNames: {
      en: "Mauritania",
      it: "Mauritania",
      es: "Mauritania",
      de: "Mauretanien",
      pl: "Mauretania",
      fr: "Mauritanie",
      nl: "Mauritanië",
      pt: "Mauritânia",
      cs: "Mauritánie",
      ro: "Mauritania",
      ru: "Мавритания"
    },
    rootIddCode: "+222",
    continent: "Africa"
  },
  MS: {
    i18nNames: {
      en: "Montserrat",
      it: "Montserrat",
      es: "Montserrat",
      de: "Montserrat",
      pl: "Montserrat",
      fr: "Montserrat",
      nl: "Montserrat",
      pt: "Montserrat",
      cs: "Montserrat",
      ro: "Montserrat",
      ru: "Монтсеррат"
    },
    rootIddCode: "+1664",
    continent: "NorthAmerica"
  },
  MT: {
    i18nNames: {
      en: "Malta",
      it: "Malta",
      es: "Malta",
      de: "Malta",
      pl: "Malta",
      fr: "Malte",
      nl: "Malta",
      pt: "Malta",
      cs: "Malta",
      ro: "Malta",
      ru: "Мальта"
    },
    rootIddCode: "+356",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^MT\\d{8}$",
    taxIdExample: "MT12345678"
  },
  MU: {
    i18nNames: {
      en: "Mauritius",
      it: "Mauritius",
      es: "Mauricio",
      de: "Mauritius",
      pl: "Mauritius",
      fr: "Île Maurice",
      nl: "Mauritius",
      pt: "Maurício",
      cs: "Mauricius",
      ro: "Mauritius",
      ru: "Маврикий"
    },
    rootIddCode: "+230",
    continent: "Africa"
  },
  MV: {
    i18nNames: {
      en: "Maldives",
      it: "Maldive",
      es: "Maldivas",
      de: "Malediven",
      pl: "Malediwy",
      fr: "Maldives",
      nl: "Maldiven",
      pt: "Maldivas",
      cs: "Maledivy",
      ro: "Maldive",
      ru: "Мальдивы"
    },
    rootIddCode: "+960",
    continent: "Asia"
  },
  MW: {
    i18nNames: {
      en: "Malawi",
      it: "Malawi",
      es: "Malaui",
      de: "Malawi",
      pl: "Malawi",
      fr: "Malawi",
      nl: "Malawi",
      pt: "Maláui",
      cs: "Malawi",
      ro: "Malawi",
      ru: "Малави"
    },
    rootIddCode: "+265",
    continent: "Africa"
  },
  MX: {
    i18nNames: {
      en: "Mexico",
      it: "Messico",
      es: "México",
      de: "Mexiko",
      pl: "Meksyk",
      fr: "Mexique",
      nl: "Mexico",
      pt: "México",
      cs: "Mexiko",
      ro: "Mexic",
      ru: "Мексика"
    },
    rootIddCode: "+52",
    continent: "NorthAmerica"
  },
  MY: {
    i18nNames: {
      en: "Malaysia",
      it: "Malesia",
      es: "Malasia",
      de: "Malaysia",
      pl: "Malezja",
      fr: "Malaisie",
      nl: "Maleisië",
      pt: "Malásia",
      cs: "Malajsie",
      ro: "Malaezia",
      ru: "Малайзия"
    },
    rootIddCode: "+60",
    continent: "Asia"
  },
  MZ: {
    i18nNames: {
      en: "Mozambique",
      it: "Mozambico",
      es: "Mozambique",
      de: "Mosambik",
      pl: "Mozambik",
      fr: "Mozambique",
      nl: "Mozambique",
      pt: "Moçambique",
      cs: "Mosambik",
      ro: "Mozambic",
      ru: "Мозамбик"
    },
    rootIddCode: "+258",
    continent: "Africa"
  },
  NA: {
    i18nNames: {
      en: "Namibia",
      it: "Namibia",
      es: "Namibia",
      de: "Namibia",
      pl: "Namibia",
      fr: "Namibie",
      nl: "Namibië",
      pt: "Namíbia",
      cs: "Namibie",
      ro: "Namibia",
      ru: "Намибия"
    },
    rootIddCode: "+264",
    continent: "Africa"
  },
  NC: {
    i18nNames: {
      en: "New Caledonia",
      it: "Nuova Caledonia",
      es: "Nueva Caledonia",
      de: "Neukaledonien",
      pl: "Nowa Kaledonia",
      fr: "Nouvelle-Calédonie",
      nl: "Nieuw-Caledonië",
      pt: "Nova Caledônia",
      cs: "Nová Kaledonie",
      ro: "Noua Caledonie",
      ru: "Новая Каледония"
    },
    rootIddCode: "+687",
    continent: "Oceania"
  },
  NE: {
    i18nNames: {
      en: "Niger",
      it: "Niger",
      es: "Níger",
      de: "Niger",
      pl: "Niger",
      fr: "Niger",
      nl: "Niger",
      pt: "Níger",
      cs: "Niger",
      ro: "Niger",
      ru: "Нигер"
    },
    rootIddCode: "+227",
    continent: "Africa"
  },
  NF: {
    i18nNames: {
      en: "Norfolk Island",
      it: "Isola Norfolk",
      es: "Isla Norfolk",
      de: "Norfolkinsel",
      pl: "Wyspa Norfolk",
      fr: "Île Norfolk",
      nl: "Norfolkeiland",
      pt: "Ilha Norfolk",
      cs: "Ostrov Norfolk",
      ro: "Insula Norfolk",
      ru: "Остров Норфолк"
    },
    rootIddCode: "+672",
    continent: "Oceania"
  },
  NG: {
    i18nNames: {
      en: "Nigeria",
      it: "Nigeria",
      es: "Nigeria",
      de: "Nigeria",
      pl: "Nigeria",
      fr: "Nigeria",
      nl: "Nigeria",
      pt: "Nigéria",
      cs: "Nigérie",
      ro: "Nigeria",
      ru: "Нигерия"
    },
    rootIddCode: "+234",
    continent: "Africa"
  },
  NI: {
    i18nNames: {
      en: "Nicaragua",
      it: "Nicaragua",
      es: "Nicaragua",
      de: "Nicaragua",
      pl: "Nikaragua",
      fr: "Nicaragua",
      nl: "Nicaragua",
      pt: "Nicarágua",
      cs: "Nikaragua",
      ro: "Nicaragua",
      ru: "Никарагуа"
    },
    rootIddCode: "+505",
    continent: "NorthAmerica"
  },
  NL: {
    i18nNames: {
      en: "Netherlands",
      it: "Paesi Bassi",
      es: "Países Bajos",
      de: "Niederlande",
      pl: "Holandia",
      fr: "Pays-Bas",
      nl: "Nederland",
      pt: "Países Baixos",
      cs: "Nizozemsko",
      ro: "Țările de Jos",
      ru: "Нидерланды"
    },
    rootIddCode: "+31",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^NL\\d{9}B\\d{2}$",
    taxIdExample: "NL123456789B01"
  },
  NO: {
    i18nNames: {
      en: "Norway",
      it: "Norvegia",
      es: "Noruega",
      de: "Norwegen",
      pl: "Norwegia",
      fr: "Norvège",
      nl: "Noorwegen",
      pt: "Noruega",
      cs: "Norsko",
      ro: "Norvegia",
      ru: "Норвегия"
    },
    rootIddCode: "+47",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^NO\\d{9}MVA$",
    taxIdExample: "NO123456789MVA"
  },
  NP: {
    i18nNames: {
      en: "Nepal",
      it: "Nepal",
      es: "Nepal",
      de: "Nepal",
      pl: "Nepal",
      fr: "Népal",
      nl: "Nepal",
      pt: "Nepal",
      cs: "Nepál",
      ro: "Nepal",
      ru: "Непал"
    },
    rootIddCode: "+977",
    continent: "Asia"
  },
  NR: {
    i18nNames: {
      en: "Nauru",
      it: "Nauru",
      es: "Nauru",
      de: "Nauru",
      pl: "Nauru",
      fr: "Nauru",
      nl: "Nauru",
      pt: "Nauru",
      cs: "Nauru",
      ro: "Nauru",
      ru: "Науру"
    },
    rootIddCode: "+674",
    continent: "Oceania"
  },
  NU: {
    i18nNames: {
      en: "Niue",
      it: "Niue",
      es: "Niue",
      de: "Niue",
      pl: "Niue",
      fr: "Niue",
      nl: "Niue",
      pt: "Niue",
      cs: "Niue",
      ro: "Niue",
      ru: "Ниуэ"
    },
    rootIddCode: "+683",
    continent: "Oceania"
  },
  NZ: {
    i18nNames: {
      en: "New Zealand",
      it: "Nuova Zelanda",
      es: "Nueva Zelanda",
      de: "Neuseeland",
      pl: "Nowa Zelandia",
      fr: "Nouvelle-Zélande",
      nl: "Nieuw-Zeeland",
      pt: "Nova Zelândia",
      cs: "Nový Zéland",
      ro: "Noua Zeelandă",
      ru: "Новая Зеландия"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  OM: {
    i18nNames: {
      en: "Oman",
      it: "Oman",
      es: "Omán",
      de: "Oman",
      pl: "Oman",
      fr: "Oman",
      nl: "Oman",
      pt: "Omã",
      cs: "Omán",
      ro: "Oman",
      ru: "Оман"
    },
    rootIddCode: "+968",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^OM\\d{10}$",
    taxIdExample: "OM1234567890"
  },
  PA: {
    i18nNames: {
      en: "Panama",
      it: "Panama",
      es: "Panamá",
      de: "Panama",
      pl: "Panama",
      fr: "Panama",
      nl: "Panama",
      pt: "Panamá",
      cs: "Panama",
      ro: "Panama",
      ru: "Панама"
    },
    rootIddCode: "+507",
    continent: "NorthAmerica"
  },
  PE: {
    i18nNames: {
      en: "Peru",
      it: "Perù",
      es: "Perú",
      de: "Peru",
      pl: "Peru",
      fr: "Pérou",
      nl: "Peru",
      pt: "Peru",
      cs: "Peru",
      ro: "Peru",
      ru: "Перу"
    },
    rootIddCode: "+51",
    continent: "SouthAmerica"
  },
  PF: {
    i18nNames: {
      en: "French Polynesia",
      es: "Polinesia Francesa",
      it: "Polinesia Francese",
      de: "Französisch-Polynesien",
      pl: "Polinezja Francuska",
      fr: "Polynésie française",
      nl: "Frans-Polynesië",
      pt: "Polinésia Francesa",
      cs: "Francouzská Polynésie",
      ro: "Polinezia Franceză",
      ru: "Французская Полинезия"
    },
    rootIddCode: "+689",
    continent: "Oceania"
  },
  PG: {
    i18nNames: {
      en: "Papua New Guinea",
      es: "Papúa Nueva Guinea",
      it: "Papua Nuova Guinea",
      de: "Papua-Neuguinea",
      pl: "Papua-Nowa Gwinea",
      fr: "Papouasie-Nouvelle-Guinée",
      nl: "Papoea-Nieuw-Guinea",
      pt: "Papua-Nova Guiné",
      cs: "Papua-Nová Guinea",
      ro: "Papua Noua Guinee",
      ru: "Папуа — Новая Гвинея"
    },
    rootIddCode: "+675",
    continent: "Oceania"
  },
  PH: {
    i18nNames: {
      en: "Philippines",
      it: "Filippine",
      es: "Filipinas",
      de: "Philippinen",
      pl: "Filipiny",
      fr: "Philippines",
      nl: "Filipijnen",
      pt: "Filipinas",
      cs: "Filipíny",
      ro: "Filipine",
      ru: "Филиппины"
    },
    rootIddCode: "+63",
    continent: "Asia"
  },
  PK: {
    i18nNames: {
      en: "Pakistan",
      it: "Pakistan",
      es: "Pakistán",
      de: "Pakistan",
      pl: "Pakistan",
      fr: "Pakistan",
      nl: "Pakistan",
      pt: "Paquistão",
      cs: "Pákistán",
      ro: "Pakistan",
      ru: "Пакистан"
    },
    rootIddCode: "+92",
    continent: "Asia"
  },
  PL: {
    i18nNames: {
      en: "Poland",
      it: "Polonia",
      es: "Polonia",
      de: "Polen",
      pl: "Polska",
      fr: "Pologne",
      nl: "Polen",
      pt: "Polónia",
      cs: "Polsko",
      ro: "Polonia",
      ru: "Польша"
    },
    rootIddCode: "+48",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: zy,
    taxIdMandatory: !0,
    taxIdPattern: "^PL\\d{10}$",
    taxIdExample: "PL1234567890"
  },
  PM: {
    i18nNames: {
      en: "Saint Pierre and Miquelon",
      es: "San Pedro y Miquelón",
      it: "Saint-Pierre e Miquelon",
      de: "Saint-Pierre und Miquelon",
      pl: "Saint-Pierre i Miquelon",
      fr: "Saint-Pierre-et-Miquelon",
      nl: "Saint-Pierre en Miquelon",
      pt: "Saint Pierre e Miquelon",
      cs: "Saint Pierre a Miquelon",
      ro: "Saint Pierre și Miquelon",
      ru: "Сен-Пьер и Микелон"
    },
    rootIddCode: "+508",
    continent: "NorthAmerica"
  },
  PN: {
    i18nNames: {
      en: "Pitcairn Islands",
      es: "Islas Pitcairn",
      it: "Isole Pitcairn",
      de: "Pitcairninseln",
      pl: "Wyspy Pitcairn",
      fr: "Îles Pitcairn",
      nl: "Pitcairneilanden",
      pt: "Ilhas Pitcairn",
      cs: "Pitcairnovy ostrovy",
      ro: "Insulele Pitcairn",
      ru: "Острова Питкэрн"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  PR: {
    i18nNames: {
      en: "Puerto Rico",
      it: "Porto Rico",
      es: "Puerto Rico",
      de: "Puerto Rico",
      pl: "Portoryko",
      fr: "Porto Rico",
      nl: "Puerto Rico",
      pt: "Porto Rico",
      cs: "Portoriko",
      ro: "Puerto Rico",
      ru: "Пуэрто-Рико"
    },
    rootIddCode: "+1939",
    continent: "NorthAmerica"
  },
  PS: {
    i18nNames: {
      en: "Palestine",
      it: "Palestina",
      es: "Palestina",
      de: "Palästina",
      pl: "Palestyna",
      fr: "Palestine",
      nl: "Palestina",
      pt: "Palestina",
      cs: "Palestina",
      ro: "Palestina",
      ru: "Палестина"
    },
    rootIddCode: "+970",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  PT: {
    i18nNames: {
      en: "Portugal",
      it: "Portogallo",
      es: "Portugal",
      de: "Portugal",
      pl: "Portugalia",
      fr: "Portugal",
      nl: "Portugal",
      pt: "Portugal",
      cs: "Portugalsko",
      ro: "Portugalia",
      ru: "Португалия"
    },
    rootIddCode: "+351",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^PT\\d{9}$",
    taxIdExample: "PT123456789"
  },
  PW: {
    i18nNames: {
      en: "Palau",
      it: "Palau",
      es: "Palaos",
      de: "Palau",
      pl: "Palau",
      fr: "Palaos",
      nl: "Palau",
      pt: "Palau",
      cs: "Palau",
      ro: "Palau",
      ru: "Палау"
    },
    rootIddCode: "+680",
    continent: "Oceania"
  },
  PY: {
    i18nNames: {
      en: "Paraguay",
      it: "Paraguay",
      es: "Paraguay",
      de: "Paraguay",
      pl: "Paragwaj",
      fr: "Paraguay",
      nl: "Paraguay",
      pt: "Paraguai",
      cs: "Paraguay",
      ro: "Paraguay",
      ru: "Парагвай"
    },
    rootIddCode: "+595",
    continent: "SouthAmerica"
  },
  QA: {
    i18nNames: {
      en: "Qatar",
      it: "Qatar",
      es: "Catar",
      de: "Katar",
      pl: "Katar",
      fr: "Qatar",
      nl: "Qatar",
      pt: "Catar",
      cs: "Katar",
      ro: "Qatar",
      ru: "Катар"
    },
    rootIddCode: "+974",
    continent: "Asia"
  },
  RE: {
    i18nNames: {
      en: "Réunion",
      it: "Riunione",
      es: "Reunión",
      de: "Réunion",
      pl: "Reunion",
      fr: "Réunion",
      nl: "Réunion",
      pt: "Reunião",
      cs: "Réunion",
      ro: "Réunion",
      ru: "Реюньон"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  RO: {
    i18nNames: {
      en: "Romania",
      it: "Romania",
      es: "Rumanía",
      de: "Rumänien",
      pl: "Rumunia",
      fr: "Roumanie",
      nl: "Roemenië",
      pt: "Romênia",
      cs: "Rumunsko",
      ro: "România",
      ru: "Румыния"
    },
    rootIddCode: "+40",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^RO\\d{2,10}$",
    taxIdExample: "RO123456"
  },
  RS: {
    i18nNames: {
      en: "Serbia",
      it: "Serbia",
      es: "Serbia",
      de: "Serbien",
      pl: "Serbia",
      fr: "Serbie",
      nl: "Servië",
      pt: "Sérvia",
      cs: "Srbsko",
      ro: "Serbia",
      ru: "Сербия"
    },
    rootIddCode: "+381",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  RU: {
    i18nNames: {
      en: "Russia",
      it: "Russia",
      es: "Rusia",
      de: "Russland",
      pl: "Rosja",
      fr: "Russie",
      nl: "Rusland",
      pt: "Rússia",
      cs: "Rusko",
      ro: "Rusia",
      ru: "Россия"
    },
    rootIddCode: "+79",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{10}$",
    taxIdExample: "1234567890"
  },
  RW: {
    i18nNames: {
      en: "Rwanda",
      it: "Ruanda",
      es: "Ruanda",
      de: "Ruanda",
      pl: "Rwanda",
      fr: "Rwanda",
      nl: "Rwanda",
      pt: "Ruanda",
      cs: "Rwanda",
      ro: "Rwanda",
      ru: "Руанда"
    },
    rootIddCode: "+250",
    continent: "Africa"
  },
  SA: {
    i18nNames: {
      en: "Saudi Arabia",
      it: "Arabia Saudita",
      es: "Arabia Saudita",
      de: "Saudi-Arabien",
      pl: "Arabia Saudyjska",
      fr: "Arabie Saoudite",
      nl: "Saoedi-Arabië",
      pt: "Arábia Saudita",
      cs: "Saúdská Arábie",
      ro: "Arabia Saudită",
      ru: "Саудовская Аравия"
    },
    rootIddCode: "+966",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BA: {
    i18nNames: {
      en: "Bosnia and Herzegovina",
      es: "Bosnia y Herzegovina",
      it: "Bosnia ed Erzegovina",
      de: "Bosnien und Herzegовина",
      pl: "Bośnia i Hercegowina",
      fr: "Bosnie-Herzégovine",
      nl: "Bosnië en Herzegovina",
      pt: "Bósnia e Herzegovina",
      cs: "Bosna a Hercegovina",
      ro: "Bosnia și Herțegovina",
      ru: "Босния и Герцеговина"
    },
    rootIddCode: "+387",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{12}|\\d{13})$",
    taxIdExample: "123456789012"
  },
  SB: {
    i18nNames: {
      en: "Solomon Islands",
      it: "Isole Salomone",
      es: "Islas Salomón",
      de: "Salomonen",
      pl: "Wyspy Salomona",
      fr: "Îles Salomon",
      nl: "Salomonseilanden",
      pt: "Ilhas Salomão",
      cs: "Šalamounovy ostrovy",
      ro: "Insulele Solomon",
      ru: "Соломоновы Острова"
    },
    rootIddCode: "+677",
    continent: "Oceania"
  },
  SC: {
    i18nNames: {
      en: "Seychelles",
      it: "Seychelles",
      es: "Seychelles",
      de: "Seychellen",
      pl: "Seszele",
      fr: "Seychelles",
      nl: "Seychellen",
      pt: "Seicheles",
      cs: "Seychely",
      ro: "Seychelles",
      ru: "Сейшельские Острова"
    },
    rootIddCode: "+248",
    continent: "Africa"
  },
  SD: {
    i18nNames: {
      en: "Sudan",
      it: "Sudan",
      es: "Sudán",
      de: "Sudan",
      pl: "Sudan",
      fr: "Soudan",
      nl: "Soedan",
      pt: "Sudão",
      cs: "Súdán",
      ro: "Sudan",
      ru: "Судан"
    },
    rootIddCode: "+249",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{12}$",
    taxIdExample: "123456789012"
  },
  SE: {
    i18nNames: {
      en: "Sweden",
      it: "Svezia",
      es: "Suecia",
      de: "Schweden",
      pl: "Szwecja",
      fr: "Suède",
      nl: "Zweden",
      pt: "Suécia",
      cs: "Švédsko",
      ro: "Suedia",
      ru: "Швеция"
    },
    rootIddCode: "+46",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SE\\d{12}$",
    taxIdExample: "SE123456789012"
  },
  SG: {
    i18nNames: {
      en: "Singapore",
      it: "Singapore",
      es: "Singapur",
      de: "Singapur",
      pl: "Singapur",
      fr: "Singapour",
      nl: "Singapore",
      pt: "Singapura",
      cs: "Singapur",
      ro: "Singapore",
      ru: "Сингапур"
    },
    rootIddCode: "+65",
    continent: "Asia"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  SH: {
    i18nNames: {
      en: "Saint Helena, Ascension and Tristan da Cunha",
      es: "Santa Elena",
      it: "Sant'Elena, Ascensione e Tristan da Cunha",
      de: "Sankt Helena, Ascension und Tristan da Cunha",
      pl: "Wyspa Świętej Heleny, Wniebowstąpienia i Tristan da Cunha",
      fr: "Sainte-Hélène, Ascension et Tristan da Cunha",
      nl: "Sint-Helena, Ascension en Tristan da Cunha",
      pt: "Santa Helena, Ascensão e Tristão da Cunha",
      cs: "Svatá Helena, Ascension a Tristan da Cunha",
      ro: "Sfânta Elena, Ascension și Tristan da Cunha",
      ru: "Остров Святой Елены, Вознесения и Тристан-да-Кунья"
    },
    rootIddCode: "+247",
    continent: "Africa"
  },
  SI: {
    i18nNames: {
      en: "Slovenia",
      it: "Slovenia",
      es: "Eslovenia",
      de: "Slowenien",
      pl: "Słowenia",
      fr: "Slovénie",
      nl: "Slovenië",
      pt: "Eslovênia",
      cs: "Slovinsko",
      ro: "Slovenia",
      ru: "Словения"
    },
    rootIddCode: "+386",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SI\\d{8}$",
    taxIdExample: "SI12345678"
  },
  SJ: {
    i18nNames: {
      en: "Svalbard and Jan Mayen",
      es: "Svalbard y Jan Mayen",
      it: "Svalbard e Jan Mayen",
      de: "Svalbard und Jan Mayen",
      pl: "Svalbard i Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      nl: "Spitsbergen en Jan Mayen",
      pt: "Svalbard e Jan Mayen",
      cs: "Špicberky a Jan Mayen",
      ro: "Svalbard și Jan Mayen",
      ru: "Шпицберген и Ян-Майен"
    },
    rootIddCode: "+4779",
    continent: "Europe"
  },
  SK: {
    i18nNames: {
      en: "Slovakia",
      it: "Slovacchia",
      es: "Eslovaquia",
      de: "Slowakei",
      pl: "Słowacja",
      fr: "Slovaquie",
      nl: "Slowakije",
      pt: "Eslováquia",
      cs: "Slovensko",
      ro: "Slovacia",
      ru: "Словакия"
    },
    rootIddCode: "+421",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SK\\d{10}$",
    taxIdExample: "SK1234567890"
  },
  SL: {
    i18nNames: {
      en: "Sierra Leone",
      it: "Sierra Leone",
      es: "Sierra Leona",
      de: "Sierra Leone",
      pl: "Sierra Leone",
      fr: "Sierra Leone",
      nl: "Sierra Leone",
      pt: "Serra Leoa",
      cs: "Sierra Leone",
      ro: "Sierra Leone",
      ru: "Сьерра-Леоне"
    },
    rootIddCode: "+232",
    continent: "Africa"
  },
  SM: {
    i18nNames: {
      en: "San Marino",
      it: "San Marino",
      es: "San Marino",
      de: "San Marino",
      pl: "San Marino",
      fr: "Saint-Marin",
      nl: "San Marino",
      pt: "San Marino",
      cs: "San Marino",
      ro: "San Marino",
      ru: "Сан-Марино"
    },
    rootIddCode: "+378",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^SM\\d{5}$",
    taxIdExample: "SM12345"
  },
  SN: {
    i18nNames: {
      en: "Senegal",
      it: "Senegal",
      es: "Senegal",
      de: "Senegal",
      pl: "Senegal",
      fr: "Sénégal",
      nl: "Senegal",
      pt: "Senegal",
      cs: "Senegal",
      ro: "Senegal",
      ru: "Сенегал"
    },
    rootIddCode: "+221",
    continent: "Africa"
  },
  SO: {
    i18nNames: {
      en: "Somalia",
      it: "Somalia",
      es: "Somalia",
      de: "Somalia",
      pl: "Somalia",
      fr: "Somalie",
      nl: "Somalië",
      pt: "Somália",
      cs: "Somálsko",
      ro: "Somalia",
      ru: "Сомали"
    },
    rootIddCode: "+252",
    continent: "Africa"
  },
  SR: {
    i18nNames: {
      en: "Suriname",
      it: "Suriname",
      es: "Surinam",
      de: "Suriname",
      pl: "Surinam",
      fr: "Suriname",
      nl: "Suriname",
      pt: "Suriname",
      cs: "Surinam",
      ro: "Surinam",
      ru: "Суринам"
    },
    rootIddCode: "+597",
    continent: "SouthAmerica"
  },
  SS: {
    i18nNames: {
      en: "South Sudan",
      it: "Sudan del sud",
      es: "Sudán del Sur",
      de: "Südsudan",
      pl: "Sudan Południowy",
      fr: "Soudan du Sud",
      nl: "Zuid-Soedan",
      pt: "Sudão do Sul",
      cs: "Jižní Súdán",
      ro: "Sudanul de Sud",
      ru: "Южный Судан"
    },
    rootIddCode: "+211",
    continent: "Africa"
  },
  ST: {
    i18nNames: {
      en: "São Tomé and Príncipe",
      es: "Santo Tomé y Príncipe",
      it: "São Tomé e Príncipe",
      de: "São Tomé und Príncipe",
      pl: "Wyspy Świętego Tomasza i Książęca",
      fr: "Sao Tomé-et-Principe",
      nl: "Sao Tomé en Principe",
      pt: "São Tomé e Príncipe",
      cs: "Svatý Tomáš a Princův ostrov",
      ro: "São Tomé și Príncipe",
      ru: "Сан-Томе и Принсипи"
    },
    rootIddCode: "+239",
    continent: "Africa"
  },
  SV: {
    i18nNames: {
      en: "El Salvador",
      it: "El Salvador",
      es: "El Salvador",
      de: "El Salvador",
      pl: "Salwador",
      fr: "Le Salvador",
      nl: "El Salvador",
      pt: "El Salvador",
      cs: "Salvador",
      ro: "El Salvador",
      ru: "Сальвадор"
    },
    rootIddCode: "+503",
    continent: "NorthAmerica"
  },
  SX: {
    i18nNames: {
      en: "Sint Maarten",
      it: "Sint Maarten",
      es: "San Martín (parte neerlandesa)",
      de: "Sint Maarten",
      pl: "Sint Maarten",
      fr: "Saint-Martin (partie néerlandaise)",
      nl: "Sint Maarten",
      pt: "Sint Maarten",
      cs: "Svatý Martin (nizozemská část)",
      ro: "Sint Maarten",
      ru: "Синт-Мартен"
    },
    rootIddCode: "+1721",
    continent: "NorthAmerica"
  },
  SY: {
    i18nNames: {
      en: "Syria",
      it: "Siria",
      es: "Siria",
      de: "Сирия",
      pl: "Syria",
      fr: "Syrie",
      nl: "Syrië",
      pt: "Síria",
      cs: "Sýrie",
      ro: "Siria",
      ru: "Сирия"
    },
    rootIddCode: "+963",
    continent: "Asia"
  },
  SZ: {
    i18nNames: {
      en: "Eswatini",
      it: "Swaziland",
      es: "Suazilandia",
      de: "Eswatini",
      pl: "Eswatini",
      fr: "Eswatini",
      nl: "Eswatini",
      pt: "Essuatíni",
      cs: "Eswatini",
      ro: "Eswatini",
      ru: "Эсватини"
    },
    rootIddCode: "+268",
    continent: "Africa"
  },
  TC: {
    i18nNames: {
      en: "Turks and Caicos Islands",
      es: "Islas Turcas y Caicos",
      it: "Isole Turks e Caicos",
      de: "Turks- und Caicosinseln",
      pl: "Turks i Caicos",
      fr: "Îles Turques-et-Caïques",
      nl: "Turks- en Caicoseilanden",
      pt: "Ilhas Turcas e Caicos",
      cs: "Ostrovy Turks a Caicos",
      ro: "Insulele Turks și Caicos",
      ru: "Теркс и Кайкос"
    },
    rootIddCode: "+1649",
    continent: "NorthAmerica"
  },
  TD: {
    i18nNames: {
      en: "Chad",
      it: "Ciad",
      es: "Chad",
      de: "Tschad",
      pl: "Czad",
      fr: "Tchad",
      nl: "Tsjaad",
      pt: "Chade",
      cs: "Čад",
      ro: "Ciad",
      ru: "Чад"
    },
    rootIddCode: "+235",
    continent: "Africa"
  },
  TF: {
    i18nNames: {
      en: "French Southern and Antarctic Lands",
      es: "Territorios Australes Franceses",
      it: "Territori Francesi del Sud",
      de: "Französische Süd- und Antarktisgebiete",
      pl: "Francuskie Terytoria Południowe i Antarktyczne",
      fr: "Terres australes et antarctiques françaises",
      nl: "Franse Zuidelijke en Antarctische Gebieden",
      pt: "Terras Austrais e Antárticas Francesas",
      cs: "Francouzská jižní a antarktická území",
      ro: "Teritoriile Australe și Antarctice Franceze",
      ru: "Французские южные и антарктические территории"
    },
    rootIddCode: "+262",
    continent: "Oceania"
  },
  TG: {
    i18nNames: {
      en: "Togo",
      it: "Togo",
      es: "Togo",
      de: "Togo",
      pl: "Togo",
      fr: "Togo",
      nl: "Togo",
      pt: "Togo",
      cs: "Togo",
      ro: "Togo",
      ru: "Того"
    },
    rootIddCode: "+228",
    continent: "Africa"
  },
  TH: {
    i18nNames: {
      en: "Thailand",
      it: "Tailandia",
      es: "Tailandia",
      de: "Thailand",
      pl: "Tajlandia",
      fr: "Thaïlande",
      nl: "Thailand",
      pt: "Tailândia",
      cs: "Thajsko",
      ro: "Thailanda",
      ru: "Таиланд"
    },
    rootIddCode: "+66",
    continent: "Asia"
  },
  TJ: {
    i18nNames: {
      en: "Tajikistan",
      it: "Tagikistan",
      es: "Tayikistán",
      de: "Tadschikistan",
      pl: "Tadżykistan",
      fr: "Tadjikistan",
      nl: "Tadzjikistan",
      pt: "Tajiquistão",
      cs: "Tádžikistán",
      ro: "Tadjikistan",
      ru: "Таджикистан"
    },
    rootIddCode: "+992",
    continent: "Asia"
  },
  TK: {
    i18nNames: {
      en: "Tokelau",
      it: "Isole Tokelau",
      es: "Tokelau",
      de: "Tokelau",
      pl: "Tokelau",
      fr: "Tokelau",
      nl: "Tokelau",
      pt: "Tokelau",
      cs: "Tokelau",
      ro: "Tokelau",
      ru: "Токелау"
    },
    rootIddCode: "+690",
    continent: "Oceania"
  },
  TL: {
    i18nNames: {
      en: "Timor-Leste",
      it: "Timor Est",
      es: "Timor-Leste",
      de: "Osttimor",
      pl: "Timor Wschodni",
      fr: "Timor oriental",
      nl: "Oost-Timor",
      pt: "Timor-Leste",
      cs: "Východní Timor",
      ro: "Timorul de Est",
      ru: "Восточный Тимор"
    },
    rootIddCode: "+670",
    continent: "Asia"
  },
  TM: {
    i18nNames: {
      en: "Turkmenistan",
      it: "Turkmenistan",
      es: "Turkmenistán",
      de: "Turkmenistan",
      pl: "Turkmenistan",
      fr: "Turkménistan",
      nl: "Turkmenistan",
      pt: "Turquemenistão",
      cs: "Turkmenistán",
      ro: "Turkmenistan",
      ru: "Туркменистан"
    },
    rootIddCode: "+993",
    continent: "Asia"
  },
  TN: {
    i18nNames: {
      en: "Tunisia",
      it: "Tunisia",
      es: "Túnez",
      de: "Tunesien",
      pl: "Tunezja",
      fr: "Tunisie",
      nl: "Tunesië",
      pt: "Tunísia",
      cs: "Tunisko",
      ro: "Tunisia",
      ru: "Тунис"
    },
    rootIddCode: "+216",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  TO: {
    i18nNames: {
      en: "Tonga",
      it: "Tonga",
      es: "Tonga",
      de: "Tonga",
      pl: "Tonga",
      fr: "Tonga",
      nl: "Tonga",
      pt: "Tonga",
      cs: "Tonga",
      ro: "Tonga",
      ru: "Тонга"
    },
    rootIddCode: "+676",
    continent: "Oceania"
  },
  TR: {
    i18nNames: {
      en: "Turkey",
      it: "Turchia",
      es: "Turquía",
      de: "Türkei",
      pl: "Turcja",
      fr: "Turquie",
      nl: "Turkije",
      pt: "Turquia",
      cs: "Turecko",
      ro: "Turcia",
      ru: "Турция"
    },
    rootIddCode: "+90",
    continent: "Europe"
  },
  TT: {
    i18nNames: {
      en: "Trinidad and Tobago",
      es: "Trinidad y Tobago",
      it: "Trinidad e Tobago",
      de: "Trinidad und Tobago",
      pl: "Trynidad i Tobago",
      fr: "Trinité-et-Tobago",
      nl: "Trinidad en Tobago",
      pt: "Trinidad e Tobago",
      cs: "Trinidad a Tobago",
      ro: "Trinidad și Tobago",
      ru: "Тринидад и Тобаго"
    },
    rootIddCode: "+1868",
    continent: "NorthAmerica"
  },
  TV: {
    i18nNames: {
      en: "Tuvalu",
      it: "Tuvalu",
      es: "Tuvalu",
      de: "Tuvalu",
      pl: "Tuvalu",
      fr: "Tuvalu",
      nl: "Tuvalu",
      pt: "Tuvalu",
      cs: "Tuvalu",
      ro: "Tuvalu",
      ru: "Тувалу"
    },
    rootIddCode: "+688",
    continent: "Oceania"
  },
  TW: {
    i18nNames: {
      en: "Taiwan",
      it: "Taiwan",
      es: "Taiwán",
      de: "Taiwan",
      pl: "Tajwan",
      fr: "Taïwan",
      nl: "Taiwan",
      pt: "Taiwan",
      cs: "Tchaj-wan",
      ro: "Taiwan",
      ru: "Тайвань"
    },
    rootIddCode: "+886",
    continent: "Asia"
  },
  TZ: {
    i18nNames: {
      en: "Tanzania",
      it: "Tanzania",
      es: "Tanzania",
      de: "Tansania",
      pl: "Tanzania",
      fr: "Tanzanie",
      nl: "Tanzania",
      pt: "Tanzânia",
      cs: "Tanzanie",
      ro: "Tanzania",
      ru: "Танзания"
    },
    rootIddCode: "+255",
    continent: "Africa"
  },
  UA: {
    i18nNames: {
      en: "Ukraine",
      it: "Ucraina",
      es: "Ucrania",
      de: "Ukraine",
      pl: "Ukraina",
      fr: "Ukraine",
      nl: "Oekraïne",
      pt: "Ucrânia",
      cs: "Ukrajina",
      ro: "Ucraina",
      ru: "Украина"
    },
    rootIddCode: "+380",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{8}|\\d{12})$",
    taxIdExample: "12345678"
  },
  UG: {
    i18nNames: {
      en: "Uganda",
      it: "Uganda",
      es: "Uganda",
      de: "Uganda",
      pl: "Uganda",
      fr: "Ouganda",
      nl: "Oeganda",
      pt: "Uganda",
      cs: "Uganda",
      ro: "Uganda",
      ru: "Уганда"
    },
    rootIddCode: "+256",
    continent: "Africa"
  },
  UM: {
    i18nNames: {
      en: "United States Minor Outlying Islands",
      es: "Islas menores alejadas de los Estados Unidos",
      it: "Isole minori esterne degli Stati Uniti d'America",
      de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
      pl: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      fr: "Îles mineures éloignées des États-Unis",
      nl: "Kleine afgelegen eilanden van de Verenigde Staten",
      pt: "Ilhas Menores Distantes dos EUA",
      cs: "Menší odlehlé ostrovy USA",
      ro: "Insulele S.U.A. din Oceanul Pacific",
      ru: "Внешние малые острова США"
    },
    rootIddCode: "+268",
    continent: "NorthAmerica"
  },
  US: {
    i18nNames: {
      en: "United States",
      it: "Stati Uniti d'America",
      es: "Estados Unidos",
      de: "Vereinigte Staaten",
      pl: "Stany Zjednoczone",
      fr: "États-Unis",
      nl: "Verenigde Staten",
      pt: "Estados Unidos",
      cs: "Spojené státy americké",
      ro: "Statele Unite ale Americii",
      ru: "Соединённые Штаты"
    },
    rootIddCode: "+1989",
    continent: "NorthAmerica"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  UY: {
    i18nNames: {
      en: "Uruguay",
      it: "Uruguay",
      es: "Uruguay",
      de: "Uruguay",
      pl: "Urugwaj",
      fr: "Uruguay",
      nl: "Uruguay",
      pt: "Uruguai",
      cs: "Uruguay",
      ro: "Uruguay",
      ru: "Уругвай"
    },
    rootIddCode: "+598",
    continent: "SouthAmerica"
  },
  UZ: {
    i18nNames: {
      en: "Uzbekistan",
      it: "Uzbekistan",
      es: "Uzbekistán",
      de: "Usbekistan",
      pl: "Uzbekistan",
      fr: "Ouzbékistan",
      nl: "Oezbekistan",
      pt: "Uzbequistão",
      cs: "Uzbekistán",
      ro: "Uzbekistan",
      ru: "Узбекистан"
    },
    rootIddCode: "+998",
    continent: "Asia"
  },
  VA: {
    i18nNames: {
      en: "Vatican City",
      it: "Città del Vaticano",
      es: "Ciudad del Vaticano",
      de: "Vatikanstadt",
      pl: "Watykan",
      fr: "Cité du Vatican",
      nl: "Vaticaanstad",
      pt: "Cidade do Vaticano",
      cs: "Vatikán",
      ro: "Vatican",
      ru: "Ватикан"
    },
    rootIddCode: "+379",
    continent: "Europe"
  },
  VC: {
    i18nNames: {
      en: "Saint Vincent and the Grenadines",
      es: "San Vicente y las Granadinas",
      it: "Saint Vincent e Grenadine",
      de: "St. Vincent und die Grenadinen",
      pl: "Saint Vincent i Grenadyny",
      fr: "Saint-Vincent-et-les-Grenadines",
      nl: "Saint Vincent en de Grenadines",
      pt: "São Vicente e Granadinas",
      cs: "Svatý Vincenc a Grenadiny",
      ro: "Sfântul Vincent și Grenadine",
      ru: "Сент-Винсент и Гренадины"
    },
    rootIddCode: "+1784",
    continent: "NorthAmerica"
  },
  VE: {
    i18nNames: {
      en: "Venezuela",
      it: "Venezuela",
      es: "Venezuela",
      de: "Venezuela",
      pl: "Wenezuela",
      fr: "Venezuela",
      nl: "Venezuela",
      pt: "Venezuela",
      cs: "Venezuela",
      ro: "Venezuela",
      ru: "Венесуэла"
    },
    rootIddCode: "+58",
    continent: "SouthAmerica"
  },
  VG: {
    i18nNames: {
      en: "British Virgin Islands",
      es: "Islas Vírgenes Británicas",
      it: "Isole Vergini Britanniche",
      de: "Britische Jungferninseln",
      pl: "Brytyjskie Wyspy Dziewicze",
      fr: "Îles Vierges britanniques",
      nl: "Britse Maagdeneilanden",
      pt: "Ilhas Virgens Britânicas",
      cs: "Britské Panenské ostrovy",
      ro: "Insulele Virgine Britanice",
      ru: "Британские Виргинские острова"
    },
    rootIddCode: "+1284",
    continent: "NorthAmerica"
  },
  VI: {
    i18nNames: {
      en: "United States Virgin Islands",
      es: "Islas Vírgenes de los Estados Unidos",
      it: "Isole Vergini americane",
      de: "Amerikanische Jungferninseln",
      pl: "Wyspy Dziewицze Stanów Зjednoczonych",
      fr: "Îles Vierges des États-Unis",
      nl: "Amerikaanse Maagdeneilanden",
      pt: "Ilhas Virgens dos Estados Unidos",
      cs: "Americké Panenské остроvy",
      ro: "Insulele Virgine Americane",
      ru: "Виргинские острова США"
    },
    rootIddCode: "+1340",
    continent: "NorthAmerica"
  },
  VN: {
    i18nNames: {
      en: "Vietnam",
      it: "Vietnam",
      es: "Vietnam",
      de: "Vietnam",
      pl: "Wietnam",
      fr: "Vietnam",
      nl: "Vietnam",
      pt: "Vietnã",
      cs: "Vietnam",
      ro: "Vietnam",
      ru: "Вьетнам"
    },
    rootIddCode: "+84",
    continent: "Asia"
  },
  VU: {
    i18nNames: {
      en: "Vanuatu",
      it: "Vanuatu",
      es: "Vanuatu",
      de: "Vanuatu",
      pl: "Vanuatu",
      fr: "Vanuatu",
      nl: "Vanuatu",
      pt: "Vanuatu",
      cs: "Vanuatu",
      ro: "Vanuatu",
      ru: "Вануату"
    },
    rootIddCode: "+678",
    continent: "Oceania"
  },
  WF: {
    i18nNames: {
      en: "Wallis and Futuna",
      es: "Wallis y Futuna",
      it: "Wallis e Futuna",
      de: "Wallis und Futuna",
      pl: "Wallis i Futuna",
      fr: "Wallis-et-Futuna",
      nl: "Wallis en Futuna",
      pt: "Wallis e Futuna",
      cs: "Wallis a Futuna",
      ro: "Wallis și Futuna",
      ru: "Уоллис и Футуна"
    },
    rootIddCode: "+681",
    continent: "Oceania"
  },
  WS: {
    i18nNames: {
      en: "Samoa",
      it: "Samoa",
      es: "Samoa",
      de: "Samoa",
      pl: "Samoa",
      fr: "Samoa",
      nl: "Samoa",
      pt: "Samoa",
      cs: "Samoa",
      ro: "Samoa",
      ru: "Самоа"
    },
    rootIddCode: "+685",
    continent: "Oceania"
  },
  XK: {
    i18nNames: {
      en: "Kosovo",
      it: "Kosovo",
      es: "Kosovo",
      de: "Kosovo",
      pl: "Kosowo",
      fr: "Kosovo",
      nl: "Kosovo",
      pt: "Kosovo",
      cs: "Kosovo",
      ro: "Kosovo",
      ru: "Косово"
    },
    rootIddCode: "+383",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  YE: {
    i18nNames: {
      en: "Yemen",
      it: "Yemen",
      es: "Yemen",
      de: "Jemen",
      pl: "Jemen",
      fr: "Yémen",
      nl: "Jemen",
      pt: "Iémen",
      cs: "Jemen",
      ro: "Yemen",
      ru: "Йемен"
    },
    rootIddCode: "+967",
    continent: "Asia"
  },
  YT: {
    i18nNames: {
      en: "Mayotte",
      it: "Mayotte",
      es: "Mayotte",
      de: "Mayotte",
      pl: "Majotta",
      fr: "Mayotte",
      nl: "Mayotte",
      pt: "Mayotte",
      cs: "Mayotte",
      ro: "Mayotte",
      ru: "Майотта"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  ZA: {
    i18nNames: {
      en: "South Africa",
      it: "Sud Africa",
      es: "Sudáfrica",
      de: "Südafrika",
      pl: "Republika Południowej Afryki",
      fr: "Afrique du Sud",
      nl: "Zuid-Afrika",
      pt: "África do Sul",
      cs: "Jihoafrická republika",
      ro: "Africa de Sud",
      ru: "Южная Африка"
    },
    rootIddCode: "+27",
    continent: "Africa"
  },
  ZM: {
    i18nNames: {
      en: "Zambia",
      it: "Zambia",
      es: "Zambia",
      de: "Sambia",
      pl: "Zambia",
      fr: "Zambie",
      nl: "Zambia",
      pt: "Zâmbia",
      cs: "Zambie",
      ro: "Zambia",
      ru: "Замбия"
    },
    rootIddCode: "+260",
    continent: "Africa"
  },
  ZW: {
    i18nNames: {
      en: "Zimbabwe",
      it: "Zimbabwe",
      es: "Zimbabue",
      de: "Simbabwe",
      pl: "Zimbabwe",
      fr: "Zimbabwe",
      nl: "Zimbabwe",
      pt: "Zimbábue",
      cs: "Zimbabwe",
      ro: "Zimbabwe",
      ru: "Зимбабве"
    },
    rootIddCode: "+263",
    continent: "Africa"
  }
}, eM = (o) => Ki[o].i18nNames.en;
function oM(...o) {
  const r = /* @__PURE__ */ new Set();
  for (const [n, a] of Object.entries(Ki))
    o.includes(a.continent) && r.add(n);
  return r;
}
const Pl = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  // Kosovo
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];
function tM(o) {
  if (Gy(o) !== !0)
    throw new Error(`'${o}' is not a valid ISO 3166-1 alpha-2 Country code`);
  return o;
}
function Gy(o) {
  return typeof o == "string" && Pl.includes(o);
}
const zl = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BQ: "BES",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CW: "CUW",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  BA: "BIH",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SX: "SXM",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "UNK",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
function qy(o) {
  return typeof o == "string" && Object.values(zl).includes(o);
}
function rM(o) {
  if (qy(o) !== !0)
    throw new Error(`'${o}' is not a valid ISO 3166-1 alpha-3 Country code`);
  return o;
}
function nM(o) {
  return zl[o];
}
const iM = 10 * 1024 * 1024, aM = "pdf", Uy = Object.fromEntries(
  Object.entries(Ki).map(([o, r]) => [
    o,
    ("regions" in r ? r.regions : []).flatMap(
      (n) => ("provinces" in n ? n.provinces : []).map((a) => a)
    )
  ])
), Zy = [
  "aa",
  "ab",
  "ae",
  "af",
  "ak",
  "am",
  "an",
  "ar",
  "as",
  "av",
  "ay",
  "az",
  "ba",
  "be",
  "bg",
  "bh",
  "bi",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "ca",
  "ce",
  "ch",
  "co",
  "cr",
  "cs",
  "cu",
  "cv",
  "cy",
  "da",
  "de",
  "dv",
  "dz",
  "ee",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fj",
  "fo",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gn",
  "gu",
  "gv",
  "ha",
  "he",
  "hi",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "hz",
  "ia",
  "id",
  "ie",
  "ig",
  "ii",
  "ik",
  "io",
  "is",
  "it",
  "iu",
  "ja",
  "jv",
  "ka",
  "kg",
  "ki",
  "kj",
  "kk",
  "kl",
  "km",
  "kn",
  "ko",
  "kr",
  "ks",
  "ku",
  "kv",
  "kw",
  "ky",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lo",
  "lt",
  "lu",
  "lv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "na",
  "nb",
  "nd",
  "ne",
  "ng",
  "nl",
  "nn",
  "no",
  "nr",
  "nv",
  "ny",
  "oc",
  "oj",
  "om",
  "or",
  "os",
  "pa",
  "pi",
  "pl",
  "ps",
  "pt",
  "qu",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sc",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr",
  "ss",
  "st",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "tg",
  "th",
  "ti",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zh",
  "zu"
], $y = tn(Zy), sM = (o) => $y.parse(o), uM = {
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bh: "Bihari languages",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  dv: "Dhivehi",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek",
  en: "English",
  eo: "Esperanto",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  ht: "Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ig: "Igbo",
  ii: "Sichuan Yi (Nuosu)",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  ki: "Kikuyu",
  kj: "Kuanyama",
  kk: "Kazakh",
  kl: "Kalaallisut",
  km: "Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  ky: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Māori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  nb: "Norwegian Bokmål",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  nr: "South Ndebele",
  nv: "Navajo",
  ny: "Chichewa",
  oc: "Occitan",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Odia",
  os: "Ossetian",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Southern Sotho",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tongan",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
}, Ky = [...Pl, "EU", "EXTRA_EU"];
function Hy(o) {
  return typeof o == "string" && Ky.includes(o);
}
function lM(o) {
  if (Hy(o) !== !0)
    throw new Error(`'${o}' is not a valid tax code origin`);
  return o;
}
const cM = [
  "Locate every piece of visible text in this photo of a bus.",
  "Include liveries, operator names, destination signs, phone numbers, web addresses, registration plates, and any small print.",
  "Return one entry per distinct piece of text."
].join(`
`), Ol = ["ai", "manual"], dM = Tt({
  left: to(),
  top: to(),
  width: to(),
  height: to(),
  origin: tn(Ol),
  text: Ae().optional()
}).readonly(), pM = Tt({
  page: to().int().min(0),
  left: to(),
  top: to(),
  width: to(),
  height: to(),
  origin: tn(Ol),
  field: Ae().optional()
}).readonly(), fM = { horizontal: 8, vertical: 1.5 }, mM = { r: 72, g: 72, b: 72 }, Hi = "https://145031484.fs1.hubspotusercontent-eu1.net/hubfs/145031484", hM = (o) => `${Hi}/sales/${o}.jpeg`, bM = `${Hi}/sales/fleequid-expert.webp`, _M = (o) => `${Hi}/flags/${o}.svg`, AM = "backoffice@fleequid.com", gM = "+39 0287176063", yM = {
  geocodeForward: {
    url: "https://api.mapbox.com/search/geocode/v6/forward",
    params: { types: "place,street,address" }
  }
}, Wy = {
  AD: "ca",
  AE: "ar",
  AF: "ps",
  AG: "en",
  AI: "en",
  AL: "sq",
  AM: "hy",
  AO: "pt",
  AQ: "en",
  AR: "es",
  AS: "sm",
  AT: "de",
  AU: "en",
  AW: "nl",
  AX: "sv",
  AZ: "az",
  BA: "bs",
  BB: "en",
  BD: "bn",
  BE: "fr",
  BF: "fr",
  BG: "bg",
  BH: "ar",
  BI: "rn",
  BJ: "fr",
  BL: "fr",
  BM: "en",
  BN: "ms",
  BO: "es",
  BQ: "nl",
  BR: "pt",
  BS: "en",
  BT: "dz",
  BV: "no",
  BW: "en",
  BY: "ru",
  BZ: "en",
  CA: "fr",
  CC: "en",
  CD: "fr",
  CF: "fr",
  CG: "fr",
  CH: "de",
  CI: "fr",
  CK: "en",
  CL: "es",
  CM: "fr",
  CN: "zh",
  CO: "es",
  CR: "es",
  CU: "es",
  CV: "pt",
  CW: "nl",
  CX: "en",
  CY: "el",
  CZ: "cs",
  DE: "de",
  DJ: "fr",
  DK: "da",
  DM: "en",
  DO: "es",
  DZ: "ar",
  EC: "es",
  EE: "et",
  EG: "ar",
  EH: "ar",
  ER: "ti",
  ES: "es",
  ET: "am",
  FI: "fi",
  FJ: "en",
  FK: "en",
  FM: "en",
  FO: "fo",
  FR: "fr",
  GA: "fr",
  GB: "en",
  GD: "en",
  GE: "ka",
  GF: "fr",
  GG: "en",
  GH: "en",
  GI: "en",
  GL: "kl",
  GM: "en",
  GN: "fr",
  GP: "fr",
  GQ: "es",
  GR: "el",
  GS: "en",
  GT: "es",
  GU: "en",
  GW: "pt",
  GY: "en",
  HK: "zh",
  HM: "en",
  HN: "es",
  HR: "hr",
  HT: "fr",
  HU: "hu",
  ID: "id",
  IE: "en",
  IL: "he",
  IM: "en",
  IN: "hi",
  IO: "en",
  IQ: "ar",
  IR: "fa",
  IS: "is",
  IT: "it",
  JE: "en",
  JM: "en",
  JO: "ar",
  JP: "ja",
  KE: "sw",
  KG: "ru",
  KH: "km",
  KI: "en",
  KM: "ar",
  KN: "en",
  KP: "ko",
  KR: "ko",
  KW: "ar",
  KY: "en",
  KZ: "ru",
  LA: "lo",
  LB: "ar",
  LC: "en",
  LI: "de",
  LK: "si",
  LR: "en",
  LS: "st",
  LT: "lt",
  LU: "de",
  LV: "lv",
  LY: "ar",
  MA: "ar",
  MC: "fr",
  MD: "ro",
  ME: "sr",
  MF: "fr",
  MG: "fr",
  MH: "en",
  MK: "mk",
  ML: "fr",
  MM: "my",
  MN: "mn",
  MO: "zh",
  MP: "en",
  MQ: "fr",
  MR: "ar",
  MS: "en",
  MT: "mt",
  MU: "en",
  MV: "dv",
  MW: "ny",
  MX: "es",
  MY: "ms",
  MZ: "pt",
  NA: "en",
  NC: "fr",
  NE: "fr",
  NF: "en",
  NG: "en",
  NI: "es",
  NL: "nl",
  NO: "no",
  NP: "ne",
  NR: "en",
  NU: "en",
  NZ: "en",
  OM: "ar",
  PA: "es",
  PE: "es",
  PF: "fr",
  PG: "en",
  PH: "tl",
  PK: "ur",
  PL: "pl",
  PM: "fr",
  PN: "en",
  PR: "es",
  PS: "ar",
  PT: "pt",
  PW: "en",
  PY: "es",
  QA: "ar",
  RE: "fr",
  RO: "ro",
  RS: "sr",
  RU: "ru",
  RW: "fr",
  SA: "ar",
  SB: "en",
  SC: "en",
  SD: "ar",
  SE: "sv",
  SG: "en",
  SH: "en",
  SI: "sl",
  SJ: "no",
  SK: "sk",
  SL: "en",
  SM: "it",
  SN: "fr",
  SO: "so",
  SR: "nl",
  SS: "en",
  ST: "pt",
  SV: "es",
  SX: "nl",
  SY: "ar",
  SZ: "ss",
  TC: "en",
  TD: "fr",
  TF: "fr",
  TG: "fr",
  TH: "th",
  TJ: "tg",
  TK: "en",
  TL: "pt",
  TM: "tk",
  TN: "ar",
  TO: "to",
  TR: "tr",
  TT: "en",
  TV: "en",
  TW: "zh",
  TZ: "sw",
  UA: "uk",
  UG: "en",
  UM: "en",
  US: "en",
  UY: "es",
  UZ: "uz",
  VA: "it",
  VC: "en",
  VE: "es",
  VG: "en",
  VI: "en",
  VN: "vi",
  VU: "bi",
  WF: "fr",
  WS: "sm",
  XK: "sq",
  YE: "ar",
  YT: "fr",
  ZA: "en",
  ZM: "en",
  ZW: "en"
};
function TM(o) {
  return Wy[o];
}
const MM = {
  cs: "CZ",
  de: "DE",
  en: "GB",
  es: "ES",
  fr: "FR",
  it: "IT",
  nl: "NL",
  pl: "PL",
  pt: "PT",
  ro: "RO",
  ru: "RU"
}, NM = 2, FM = 300, IM = /^ACT-\d+$/iu, SM = /^DS-\d+$/iu, xM = 0, vM = 25e5, wM = 5e3, EM = 0, CM = 25e5, kM = 5e4, DM = 1980, LM = (/* @__PURE__ */ new Date()).getFullYear(), BM = 1, RM = 3.5, PM = 23, zM = 0.5, OM = 1.5, GM = 5, qM = 0.1, UM = 1.5, ZM = 5, $M = 0.1, KM = 1, HM = 140, WM = 1, VM = [1, 2, 3, 4], jM = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], JM = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13], YM = 100, XM = 500, QM = 100, eN = 50, oN = 650, tN = 10, rN = 1, nN = 150, iN = 1, aN = 1, sN = 150, uN = 1, lN = 0, cN = 18, dN = 1, pN = 1500, fN = 18e3, mN = 500, hN = ["Auction", "DirectSale"], bN = ["cs", "de", "en", "es", "fr", "it", "nl", "pl", "pt", "ro", "ru"], Gl = {
  addressNumber: Ae().optional().nullable(),
  alternate: Ae().optional().nullable(),
  country: Ae(),
  countryCode: Ae(),
  fullAddress: Ae(),
  latitude: to(),
  longitude: to(),
  mapboxId: Ae(),
  place: Ae(),
  postcode: Ae().optional().nullable(),
  region: Ae(),
  streetName: Ae().optional().nullable()
}, _N = Tt(Gl), AN = (o) => Tt(Gl, { error: o }), Vy = "AdminUserPasswordResetToken", gN = Tt({
  type: fy(Vy),
  adminUserId: Ae(),
  /**
   * NB: this field is consumed by the client only, only has a presentational purposes
   */
  email: Ae()
}), jy = /^\+[1-9]\d{1,14}$/, yN = (o) => /^[+]?[\s0-9]{6,}$/.test(o), ql = (o) => typeof o != "string" || (o.match(/\s/g)?.length ?? 0) > 1 ? !1 : jy.test(o.replace(/\s/g, "")), Ul = "Phone must be in E.164 format (e.g. +393331234567)", TN = () => Ae().refine(ql, { message: Ul }), MN = () => Ae().refine((o) => !o || ql(o), { message: Ul }).optional(), Zl = Ae().min(5).brand("Tin");
function NN(o) {
  return Zl.safeParse(o).success;
}
function Jy(o) {
  const r = Zl.safeParse(o);
  if (r.success)
    return r.data;
  throw new Error(`Could not parse '${o}' as Tin: ${r.error.issues.map(({ message: n }) => n).join(", ")}`);
}
function FN(o) {
  return Jy(o.replace(/[^a-zA-Z0-9]/g, ""));
}
const IN = (o) => Math.ceil(o * 1.35962), SN = (o, ...r) => o ? r.map((n) => typeof n == "function" ? n() : n) : [];
function Yy(o) {
  return o.length > 0 && !!o[0] && typeof o[0] == "object";
}
const xN = (o) => {
  if (!o)
    return {};
  const n = Object.keys(o).map((a) => Array.isArray(o[a]) && o[a].length > 0 ? Yy(o[a]) ? o[a].map(
    (u, f) => Object.keys(u).map((d) => [`${a}[${f}][${d}]`, u[d]])
  ).flat() : [[`${a}[]`, o[a]]] : o[a] !== null && typeof o[a] == "object" && !Array.isArray(o[a]) ? Object.keys(o[a]).map((u) => [`${a}[${u}]`, o[a][u]]) : [[a, o[a]]]).flat();
  return Object.fromEntries(n);
};
var Hr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Wt = { exports: {} };
var Xy = Wt.exports, Xu;
function Qy() {
  return Xu || (Xu = 1, (function(o, r) {
    (function() {
      var n, a = "4.18.1", u = 200, f = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", d = "Expected a function", b = "Invalid `variable` option passed into `_.template`", T = "Invalid `imports` option passed into `_.template`", S = "__lodash_hash_undefined__", w = 500, O = "__lodash_placeholder__", k = 1, P = 2, ae = 4, ee = 1, po = 2, Ce = 1, No = 2, ke = 4, oe = 8, he = 16, ro = 32, Ro = 64, fo = 128, Mt = 256, nn = 512, ec = 30, oc = "...", tc = 800, rc = 16, Ji = 1, nc = 2, ic = 3, Po = 1 / 0, Fo = 9007199254740991, ac = 17976931348623157e292, Xt = NaN, no = 4294967295, sc = no - 1, uc = no >>> 1, lc = [
        ["ary", fo],
        ["bind", Ce],
        ["bindKey", No],
        ["curry", oe],
        ["curryRight", he],
        ["flip", nn],
        ["partial", ro],
        ["partialRight", Ro],
        ["rearg", Mt]
      ], Xo = "[object Arguments]", Qt = "[object Array]", cc = "[object AsyncFunction]", Nt = "[object Boolean]", Ft = "[object Date]", dc = "[object DOMException]", er = "[object Error]", or = "[object Function]", Yi = "[object GeneratorFunction]", Ve = "[object Map]", It = "[object Number]", pc = "[object Null]", mo = "[object Object]", Xi = "[object Promise]", fc = "[object Proxy]", St = "[object RegExp]", je = "[object Set]", xt = "[object String]", tr = "[object Symbol]", mc = "[object Undefined]", vt = "[object WeakMap]", hc = "[object WeakSet]", wt = "[object ArrayBuffer]", Qo = "[object DataView]", an = "[object Float32Array]", sn = "[object Float64Array]", un = "[object Int8Array]", ln = "[object Int16Array]", cn = "[object Int32Array]", dn = "[object Uint8Array]", pn = "[object Uint8ClampedArray]", fn = "[object Uint16Array]", mn = "[object Uint32Array]", bc = /\b__p \+= '';/g, _c = /\b(__p \+=) '' \+/g, Ac = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Qi = /&(?:amp|lt|gt|quot|#39);/g, ea = /[&<>"']/g, gc = RegExp(Qi.source), yc = RegExp(ea.source), Tc = /<%-([\s\S]+?)%>/g, Mc = /<%([\s\S]+?)%>/g, oa = /<%=([\s\S]+?)%>/g, Nc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Fc = /^\w*$/, Ic = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hn = /[\\^$.*+?()[\]{}|]/g, Sc = RegExp(hn.source), bn = /^\s+/, xc = /\s/, vc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, wc = /\{\n\/\* \[wrapped with (.+)\] \*/, Ec = /,? & /, Cc = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ta = /[()=,{}\[\]\/\s]/, kc = /\\(\\)?/g, Dc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ra = /\w*$/, Lc = /^[-+]0x[0-9a-f]+$/i, Bc = /^0b[01]+$/i, Rc = /^\[object .+?Constructor\]$/, Pc = /^0o[0-7]+$/i, zc = /^(?:0|[1-9]\d*)$/, Oc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, rr = /($^)/, Gc = /['\n\r\u2028\u2029\\]/g, nr = "\\ud800-\\udfff", qc = "\\u0300-\\u036f", Uc = "\\ufe20-\\ufe2f", Zc = "\\u20d0-\\u20ff", na = qc + Uc + Zc, ia = "\\u2700-\\u27bf", aa = "a-z\\xdf-\\xf6\\xf8-\\xff", $c = "\\xac\\xb1\\xd7\\xf7", Kc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Hc = "\\u2000-\\u206f", Wc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", sa = "A-Z\\xc0-\\xd6\\xd8-\\xde", ua = "\\ufe0e\\ufe0f", la = $c + Kc + Hc + Wc, _n = "['’]", Vc = "[" + nr + "]", ca = "[" + la + "]", ir = "[" + na + "]", da = "\\d+", jc = "[" + ia + "]", pa = "[" + aa + "]", fa = "[^" + nr + la + da + ia + aa + sa + "]", An = "\\ud83c[\\udffb-\\udfff]", Jc = "(?:" + ir + "|" + An + ")", ma = "[^" + nr + "]", gn = "(?:\\ud83c[\\udde6-\\uddff]){2}", yn = "[\\ud800-\\udbff][\\udc00-\\udfff]", et = "[" + sa + "]", ha = "\\u200d", ba = "(?:" + pa + "|" + fa + ")", Yc = "(?:" + et + "|" + fa + ")", _a = "(?:" + _n + "(?:d|ll|m|re|s|t|ve))?", Aa = "(?:" + _n + "(?:D|LL|M|RE|S|T|VE))?", ga = Jc + "?", ya = "[" + ua + "]?", Xc = "(?:" + ha + "(?:" + [ma, gn, yn].join("|") + ")" + ya + ga + ")*", Qc = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ed = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ta = ya + ga + Xc, od = "(?:" + [jc, gn, yn].join("|") + ")" + Ta, td = "(?:" + [ma + ir + "?", ir, gn, yn, Vc].join("|") + ")", rd = RegExp(_n, "g"), nd = RegExp(ir, "g"), Tn = RegExp(An + "(?=" + An + ")|" + td + Ta, "g"), id = RegExp([
        et + "?" + pa + "+" + _a + "(?=" + [ca, et, "$"].join("|") + ")",
        Yc + "+" + Aa + "(?=" + [ca, et + ba, "$"].join("|") + ")",
        et + "?" + ba + "+" + _a,
        et + "+" + Aa,
        ed,
        Qc,
        da,
        od
      ].join("|"), "g"), ad = RegExp("[" + ha + nr + na + ua + "]"), sd = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ud = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], ld = -1, Q = {};
      Q[an] = Q[sn] = Q[un] = Q[ln] = Q[cn] = Q[dn] = Q[pn] = Q[fn] = Q[mn] = !0, Q[Xo] = Q[Qt] = Q[wt] = Q[Nt] = Q[Qo] = Q[Ft] = Q[er] = Q[or] = Q[Ve] = Q[It] = Q[mo] = Q[St] = Q[je] = Q[xt] = Q[vt] = !1;
      var X = {};
      X[Xo] = X[Qt] = X[wt] = X[Qo] = X[Nt] = X[Ft] = X[an] = X[sn] = X[un] = X[ln] = X[cn] = X[Ve] = X[It] = X[mo] = X[St] = X[je] = X[xt] = X[tr] = X[dn] = X[pn] = X[fn] = X[mn] = !0, X[er] = X[or] = X[vt] = !1;
      var cd = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, dd = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, pd = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, fd = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, md = parseFloat, hd = parseInt, Ma = typeof Hr == "object" && Hr && Hr.Object === Object && Hr, bd = typeof self == "object" && self && self.Object === Object && self, be = Ma || bd || Function("return this")(), Mn = r && !r.nodeType && r, zo = Mn && !0 && o && !o.nodeType && o, Na = zo && zo.exports === Mn, Nn = Na && Ma.process, Ge = (function() {
        try {
          var _ = zo && zo.require && zo.require("util").types;
          return _ || Nn && Nn.binding && Nn.binding("util");
        } catch {
        }
      })(), Fa = Ge && Ge.isArrayBuffer, Ia = Ge && Ge.isDate, Sa = Ge && Ge.isMap, xa = Ge && Ge.isRegExp, va = Ge && Ge.isSet, wa = Ge && Ge.isTypedArray;
      function De(_, y, g) {
        switch (g.length) {
          case 0:
            return _.call(y);
          case 1:
            return _.call(y, g[0]);
          case 2:
            return _.call(y, g[0], g[1]);
          case 3:
            return _.call(y, g[0], g[1], g[2]);
        }
        return _.apply(y, g);
      }
      function _d(_, y, g, v) {
        for (var z = -1, W = _ == null ? 0 : _.length; ++z < W; ) {
          var pe = _[z];
          y(v, pe, g(pe), _);
        }
        return v;
      }
      function Le(_, y) {
        for (var g = -1, v = _ == null ? 0 : _.length; ++g < v && y(_[g], g, _) !== !1; )
          ;
        return _;
      }
      function Ad(_, y) {
        for (var g = _ == null ? 0 : _.length; g-- && y(_[g], g, _) !== !1; )
          ;
        return _;
      }
      function Ea(_, y) {
        for (var g = -1, v = _ == null ? 0 : _.length; ++g < v; )
          if (!y(_[g], g, _))
            return !1;
        return !0;
      }
      function Io(_, y) {
        for (var g = -1, v = _ == null ? 0 : _.length, z = 0, W = []; ++g < v; ) {
          var pe = _[g];
          y(pe, g, _) && (W[z++] = pe);
        }
        return W;
      }
      function ar(_, y) {
        var g = _ == null ? 0 : _.length;
        return !!g && ot(_, y, 0) > -1;
      }
      function Fn(_, y, g) {
        for (var v = -1, z = _ == null ? 0 : _.length; ++v < z; )
          if (g(y, _[v]))
            return !0;
        return !1;
      }
      function te(_, y) {
        for (var g = -1, v = _ == null ? 0 : _.length, z = Array(v); ++g < v; )
          z[g] = y(_[g], g, _);
        return z;
      }
      function So(_, y) {
        for (var g = -1, v = y.length, z = _.length; ++g < v; )
          _[z + g] = y[g];
        return _;
      }
      function In(_, y, g, v) {
        var z = -1, W = _ == null ? 0 : _.length;
        for (v && W && (g = _[++z]); ++z < W; )
          g = y(g, _[z], z, _);
        return g;
      }
      function gd(_, y, g, v) {
        var z = _ == null ? 0 : _.length;
        for (v && z && (g = _[--z]); z--; )
          g = y(g, _[z], z, _);
        return g;
      }
      function Sn(_, y) {
        for (var g = -1, v = _ == null ? 0 : _.length; ++g < v; )
          if (y(_[g], g, _))
            return !0;
        return !1;
      }
      var yd = xn("length");
      function Td(_) {
        return _.split("");
      }
      function Md(_) {
        return _.match(Cc) || [];
      }
      function Ca(_, y, g) {
        var v;
        return g(_, function(z, W, pe) {
          if (y(z, W, pe))
            return v = W, !1;
        }), v;
      }
      function sr(_, y, g, v) {
        for (var z = _.length, W = g + (v ? 1 : -1); v ? W-- : ++W < z; )
          if (y(_[W], W, _))
            return W;
        return -1;
      }
      function ot(_, y, g) {
        return y === y ? Ld(_, y, g) : sr(_, ka, g);
      }
      function Nd(_, y, g, v) {
        for (var z = g - 1, W = _.length; ++z < W; )
          if (v(_[z], y))
            return z;
        return -1;
      }
      function ka(_) {
        return _ !== _;
      }
      function Da(_, y) {
        var g = _ == null ? 0 : _.length;
        return g ? wn(_, y) / g : Xt;
      }
      function xn(_) {
        return function(y) {
          return y == null ? n : y[_];
        };
      }
      function vn(_) {
        return function(y) {
          return _ == null ? n : _[y];
        };
      }
      function La(_, y, g, v, z) {
        return z(_, function(W, pe, Y) {
          g = v ? (v = !1, W) : y(g, W, pe, Y);
        }), g;
      }
      function Fd(_, y) {
        var g = _.length;
        for (_.sort(y); g--; )
          _[g] = _[g].value;
        return _;
      }
      function wn(_, y) {
        for (var g, v = -1, z = _.length; ++v < z; ) {
          var W = y(_[v]);
          W !== n && (g = g === n ? W : g + W);
        }
        return g;
      }
      function En(_, y) {
        for (var g = -1, v = Array(_); ++g < _; )
          v[g] = y(g);
        return v;
      }
      function Id(_, y) {
        return te(y, function(g) {
          return [g, _[g]];
        });
      }
      function Ba(_) {
        return _ && _.slice(0, Oa(_) + 1).replace(bn, "");
      }
      function Be(_) {
        return function(y) {
          return _(y);
        };
      }
      function Cn(_, y) {
        return te(y, function(g) {
          return _[g];
        });
      }
      function Et(_, y) {
        return _.has(y);
      }
      function Ra(_, y) {
        for (var g = -1, v = _.length; ++g < v && ot(y, _[g], 0) > -1; )
          ;
        return g;
      }
      function Pa(_, y) {
        for (var g = _.length; g-- && ot(y, _[g], 0) > -1; )
          ;
        return g;
      }
      function Sd(_, y) {
        for (var g = _.length, v = 0; g--; )
          _[g] === y && ++v;
        return v;
      }
      var xd = vn(cd), vd = vn(dd);
      function wd(_) {
        return "\\" + fd[_];
      }
      function Ed(_, y) {
        return _ == null ? n : _[y];
      }
      function tt(_) {
        return ad.test(_);
      }
      function Cd(_) {
        return sd.test(_);
      }
      function kd(_) {
        for (var y, g = []; !(y = _.next()).done; )
          g.push(y.value);
        return g;
      }
      function kn(_) {
        var y = -1, g = Array(_.size);
        return _.forEach(function(v, z) {
          g[++y] = [z, v];
        }), g;
      }
      function za(_, y) {
        return function(g) {
          return _(y(g));
        };
      }
      function xo(_, y) {
        for (var g = -1, v = _.length, z = 0, W = []; ++g < v; ) {
          var pe = _[g];
          (pe === y || pe === O) && (_[g] = O, W[z++] = g);
        }
        return W;
      }
      function ur(_) {
        var y = -1, g = Array(_.size);
        return _.forEach(function(v) {
          g[++y] = v;
        }), g;
      }
      function Dd(_) {
        var y = -1, g = Array(_.size);
        return _.forEach(function(v) {
          g[++y] = [v, v];
        }), g;
      }
      function Ld(_, y, g) {
        for (var v = g - 1, z = _.length; ++v < z; )
          if (_[v] === y)
            return v;
        return -1;
      }
      function Bd(_, y, g) {
        for (var v = g + 1; v--; )
          if (_[v] === y)
            return v;
        return v;
      }
      function rt(_) {
        return tt(_) ? Pd(_) : yd(_);
      }
      function Je(_) {
        return tt(_) ? zd(_) : Td(_);
      }
      function Oa(_) {
        for (var y = _.length; y-- && xc.test(_.charAt(y)); )
          ;
        return y;
      }
      var Rd = vn(pd);
      function Pd(_) {
        for (var y = Tn.lastIndex = 0; Tn.test(_); )
          ++y;
        return y;
      }
      function zd(_) {
        return _.match(Tn) || [];
      }
      function Od(_) {
        return _.match(id) || [];
      }
      var Gd = (function _(y) {
        y = y == null ? be : nt.defaults(be.Object(), y, nt.pick(be, ud));
        var g = y.Array, v = y.Date, z = y.Error, W = y.Function, pe = y.Math, Y = y.Object, Dn = y.RegExp, qd = y.String, qe = y.TypeError, lr = g.prototype, Ud = W.prototype, it = Y.prototype, cr = y["__core-js_shared__"], dr = Ud.toString, V = it.hasOwnProperty, Zd = 0, Ga = (function() {
          var e = /[^.]+$/.exec(cr && cr.keys && cr.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        })(), pr = it.toString, $d = dr.call(Y), Kd = be._, Hd = Dn(
          "^" + dr.call(V).replace(hn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), fr = Na ? y.Buffer : n, vo = y.Symbol, mr = y.Uint8Array, qa = fr ? fr.allocUnsafe : n, hr = za(Y.getPrototypeOf, Y), Ua = Y.create, Za = it.propertyIsEnumerable, br = lr.splice, $a = vo ? vo.isConcatSpreadable : n, Ct = vo ? vo.iterator : n, Oo = vo ? vo.toStringTag : n, _r = (function() {
          try {
            var e = $o(Y, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        })(), Wd = y.clearTimeout !== be.clearTimeout && y.clearTimeout, Vd = v && v.now !== be.Date.now && v.now, jd = y.setTimeout !== be.setTimeout && y.setTimeout, Ar = pe.ceil, gr = pe.floor, Ln = Y.getOwnPropertySymbols, Jd = fr ? fr.isBuffer : n, Ka = y.isFinite, Yd = lr.join, Xd = za(Y.keys, Y), fe = pe.max, ye = pe.min, Qd = v.now, ep = y.parseInt, Ha = pe.random, op = lr.reverse, Bn = $o(y, "DataView"), kt = $o(y, "Map"), Rn = $o(y, "Promise"), at = $o(y, "Set"), Dt = $o(y, "WeakMap"), Lt = $o(Y, "create"), yr = Dt && new Dt(), st = {}, tp = Ko(Bn), rp = Ko(kt), np = Ko(Rn), ip = Ko(at), ap = Ko(Dt), Tr = vo ? vo.prototype : n, Bt = Tr ? Tr.valueOf : n, Wa = Tr ? Tr.toString : n;
        function c(e) {
          if (se(e) && !G(e) && !(e instanceof K)) {
            if (e instanceof Ue)
              return e;
            if (V.call(e, "__wrapped__"))
              return Vs(e);
          }
          return new Ue(e);
        }
        var ut = /* @__PURE__ */ (function() {
          function e() {
          }
          return function(t) {
            if (!ne(t))
              return {};
            if (Ua)
              return Ua(t);
            e.prototype = t;
            var i = new e();
            return e.prototype = n, i;
          };
        })();
        function Mr() {
        }
        function Ue(e, t) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = n;
        }
        c.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Tc,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Mc,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: oa,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: c
          }
        }, c.prototype = Mr.prototype, c.prototype.constructor = c, Ue.prototype = ut(Mr.prototype), Ue.prototype.constructor = Ue;
        function K(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = no, this.__views__ = [];
        }
        function sp() {
          var e = new K(this.__wrapped__);
          return e.__actions__ = Se(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Se(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Se(this.__views__), e;
        }
        function up() {
          if (this.__filtered__) {
            var e = new K(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function lp() {
          var e = this.__wrapped__.value(), t = this.__dir__, i = G(e), s = t < 0, l = i ? e.length : 0, p = Mf(0, l, this.__views__), m = p.start, h = p.end, A = h - m, M = s ? h : m - 1, F = this.__iteratees__, I = F.length, x = 0, E = ye(A, this.__takeCount__);
          if (!i || !s && l == A && E == A)
            return _s(e, this.__actions__);
          var R = [];
          e:
            for (; A-- && x < E; ) {
              M += t;
              for (var U = -1, L = e[M]; ++U < I; ) {
                var $ = F[U], H = $.iteratee, ze = $.type, Fe = H(L);
                if (ze == nc)
                  L = Fe;
                else if (!Fe) {
                  if (ze == Ji)
                    continue e;
                  break e;
                }
              }
              R[x++] = L;
            }
          return R;
        }
        K.prototype = ut(Mr.prototype), K.prototype.constructor = K;
        function Go(e) {
          var t = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++t < i; ) {
            var s = e[t];
            this.set(s[0], s[1]);
          }
        }
        function cp() {
          this.__data__ = Lt ? Lt(null) : {}, this.size = 0;
        }
        function dp(e) {
          var t = this.has(e) && delete this.__data__[e];
          return this.size -= t ? 1 : 0, t;
        }
        function pp(e) {
          var t = this.__data__;
          if (Lt) {
            var i = t[e];
            return i === S ? n : i;
          }
          return V.call(t, e) ? t[e] : n;
        }
        function fp(e) {
          var t = this.__data__;
          return Lt ? t[e] !== n : V.call(t, e);
        }
        function mp(e, t) {
          var i = this.__data__;
          return this.size += this.has(e) ? 0 : 1, i[e] = Lt && t === n ? S : t, this;
        }
        Go.prototype.clear = cp, Go.prototype.delete = dp, Go.prototype.get = pp, Go.prototype.has = fp, Go.prototype.set = mp;
        function ho(e) {
          var t = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++t < i; ) {
            var s = e[t];
            this.set(s[0], s[1]);
          }
        }
        function hp() {
          this.__data__ = [], this.size = 0;
        }
        function bp(e) {
          var t = this.__data__, i = Nr(t, e);
          if (i < 0)
            return !1;
          var s = t.length - 1;
          return i == s ? t.pop() : br.call(t, i, 1), --this.size, !0;
        }
        function _p(e) {
          var t = this.__data__, i = Nr(t, e);
          return i < 0 ? n : t[i][1];
        }
        function Ap(e) {
          return Nr(this.__data__, e) > -1;
        }
        function gp(e, t) {
          var i = this.__data__, s = Nr(i, e);
          return s < 0 ? (++this.size, i.push([e, t])) : i[s][1] = t, this;
        }
        ho.prototype.clear = hp, ho.prototype.delete = bp, ho.prototype.get = _p, ho.prototype.has = Ap, ho.prototype.set = gp;
        function bo(e) {
          var t = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++t < i; ) {
            var s = e[t];
            this.set(s[0], s[1]);
          }
        }
        function yp() {
          this.size = 0, this.__data__ = {
            hash: new Go(),
            map: new (kt || ho)(),
            string: new Go()
          };
        }
        function Tp(e) {
          var t = Br(this, e).delete(e);
          return this.size -= t ? 1 : 0, t;
        }
        function Mp(e) {
          return Br(this, e).get(e);
        }
        function Np(e) {
          return Br(this, e).has(e);
        }
        function Fp(e, t) {
          var i = Br(this, e), s = i.size;
          return i.set(e, t), this.size += i.size == s ? 0 : 1, this;
        }
        bo.prototype.clear = yp, bo.prototype.delete = Tp, bo.prototype.get = Mp, bo.prototype.has = Np, bo.prototype.set = Fp;
        function qo(e) {
          var t = -1, i = e == null ? 0 : e.length;
          for (this.__data__ = new bo(); ++t < i; )
            this.add(e[t]);
        }
        function Ip(e) {
          return this.__data__.set(e, S), this;
        }
        function Sp(e) {
          return this.__data__.has(e);
        }
        qo.prototype.add = qo.prototype.push = Ip, qo.prototype.has = Sp;
        function Ye(e) {
          var t = this.__data__ = new ho(e);
          this.size = t.size;
        }
        function xp() {
          this.__data__ = new ho(), this.size = 0;
        }
        function vp(e) {
          var t = this.__data__, i = t.delete(e);
          return this.size = t.size, i;
        }
        function wp(e) {
          return this.__data__.get(e);
        }
        function Ep(e) {
          return this.__data__.has(e);
        }
        function Cp(e, t) {
          var i = this.__data__;
          if (i instanceof ho) {
            var s = i.__data__;
            if (!kt || s.length < u - 1)
              return s.push([e, t]), this.size = ++i.size, this;
            i = this.__data__ = new bo(s);
          }
          return i.set(e, t), this.size = i.size, this;
        }
        Ye.prototype.clear = xp, Ye.prototype.delete = vp, Ye.prototype.get = wp, Ye.prototype.has = Ep, Ye.prototype.set = Cp;
        function Va(e, t) {
          var i = G(e), s = !i && Ho(e), l = !i && !s && Do(e), p = !i && !s && !l && pt(e), m = i || s || l || p, h = m ? En(e.length, qd) : [], A = h.length;
          for (var M in e)
            (t || V.call(e, M)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
            (M == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            l && (M == "offset" || M == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            p && (M == "buffer" || M == "byteLength" || M == "byteOffset") || // Skip index properties.
            go(M, A))) && h.push(M);
          return h;
        }
        function ja(e) {
          var t = e.length;
          return t ? e[Wn(0, t - 1)] : n;
        }
        function kp(e, t) {
          return Rr(Se(e), Uo(t, 0, e.length));
        }
        function Dp(e) {
          return Rr(Se(e));
        }
        function Pn(e, t, i) {
          (i !== n && !Qe(e[t], i) || i === n && !(t in e)) && io(e, t, i);
        }
        function Rt(e, t, i) {
          var s = e[t];
          (!(V.call(e, t) && Qe(s, i)) || i === n && !(t in e)) && io(e, t, i);
        }
        function Nr(e, t) {
          for (var i = e.length; i--; )
            if (Qe(e[i][0], t))
              return i;
          return -1;
        }
        function Lp(e, t, i, s) {
          return wo(e, function(l, p, m) {
            t(s, l, i(l), m);
          }), s;
        }
        function Ja(e, t) {
          return e && so(t, me(t), e);
        }
        function Bp(e, t) {
          return e && so(t, ve(t), e);
        }
        function io(e, t, i) {
          t == "__proto__" && _r ? _r(e, t, {
            configurable: !0,
            enumerable: !0,
            value: i,
            writable: !0
          }) : e[t] = i;
        }
        function zn(e, t) {
          for (var i = -1, s = t.length, l = g(s), p = e == null; ++i < s; )
            l[i] = p ? n : gi(e, t[i]);
          return l;
        }
        function Uo(e, t, i) {
          return e === e && (i !== n && (e = e <= i ? e : i), t !== n && (e = e >= t ? e : t)), e;
        }
        function Ze(e, t, i, s, l, p) {
          var m, h = t & k, A = t & P, M = t & ae;
          if (i && (m = l ? i(e, s, l, p) : i(e)), m !== n)
            return m;
          if (!ne(e))
            return e;
          var F = G(e);
          if (F) {
            if (m = Ff(e), !h)
              return Se(e, m);
          } else {
            var I = Te(e), x = I == or || I == Yi;
            if (Do(e))
              return ys(e, h);
            if (I == mo || I == Xo || x && !l) {
              if (m = A || x ? {} : Os(e), !h)
                return A ? ff(e, Bp(m, e)) : pf(e, Ja(m, e));
            } else {
              if (!X[I])
                return l ? e : {};
              m = If(e, I, h);
            }
          }
          p || (p = new Ye());
          var E = p.get(e);
          if (E)
            return E;
          p.set(e, m), mu(e) ? e.forEach(function(L) {
            m.add(Ze(L, t, i, L, e, p));
          }) : pu(e) && e.forEach(function(L, $) {
            m.set($, Ze(L, t, i, $, e, p));
          });
          var R = M ? A ? ni : ri : A ? ve : me, U = F ? n : R(e);
          return Le(U || e, function(L, $) {
            U && ($ = L, L = e[$]), Rt(m, $, Ze(L, t, i, $, e, p));
          }), m;
        }
        function Rp(e) {
          var t = me(e);
          return function(i) {
            return Ya(i, e, t);
          };
        }
        function Ya(e, t, i) {
          var s = i.length;
          if (e == null)
            return !s;
          for (e = Y(e); s--; ) {
            var l = i[s], p = t[l], m = e[l];
            if (m === n && !(l in e) || !p(m))
              return !1;
          }
          return !0;
        }
        function Xa(e, t, i) {
          if (typeof e != "function")
            throw new qe(d);
          return Zt(function() {
            e.apply(n, i);
          }, t);
        }
        function Pt(e, t, i, s) {
          var l = -1, p = ar, m = !0, h = e.length, A = [], M = t.length;
          if (!h)
            return A;
          i && (t = te(t, Be(i))), s ? (p = Fn, m = !1) : t.length >= u && (p = Et, m = !1, t = new qo(t));
          e:
            for (; ++l < h; ) {
              var F = e[l], I = i == null ? F : i(F);
              if (F = s || F !== 0 ? F : 0, m && I === I) {
                for (var x = M; x--; )
                  if (t[x] === I)
                    continue e;
                A.push(F);
              } else p(t, I, s) || A.push(F);
            }
          return A;
        }
        var wo = Is(ao), Qa = Is(Gn, !0);
        function Pp(e, t) {
          var i = !0;
          return wo(e, function(s, l, p) {
            return i = !!t(s, l, p), i;
          }), i;
        }
        function Fr(e, t, i) {
          for (var s = -1, l = e.length; ++s < l; ) {
            var p = e[s], m = t(p);
            if (m != null && (h === n ? m === m && !Pe(m) : i(m, h)))
              var h = m, A = p;
          }
          return A;
        }
        function zp(e, t, i, s) {
          var l = e.length;
          for (i = q(i), i < 0 && (i = -i > l ? 0 : l + i), s = s === n || s > l ? l : q(s), s < 0 && (s += l), s = i > s ? 0 : bu(s); i < s; )
            e[i++] = t;
          return e;
        }
        function es(e, t) {
          var i = [];
          return wo(e, function(s, l, p) {
            t(s, l, p) && i.push(s);
          }), i;
        }
        function _e(e, t, i, s, l) {
          var p = -1, m = e.length;
          for (i || (i = xf), l || (l = []); ++p < m; ) {
            var h = e[p];
            t > 0 && i(h) ? t > 1 ? _e(h, t - 1, i, s, l) : So(l, h) : s || (l[l.length] = h);
          }
          return l;
        }
        var On = Ss(), os = Ss(!0);
        function ao(e, t) {
          return e && On(e, t, me);
        }
        function Gn(e, t) {
          return e && os(e, t, me);
        }
        function Ir(e, t) {
          return Io(t, function(i) {
            return yo(e[i]);
          });
        }
        function Zo(e, t) {
          t = Co(t, e);
          for (var i = 0, s = t.length; e != null && i < s; )
            e = e[Xe(t[i++])];
          return i && i == s ? e : n;
        }
        function ts(e, t, i) {
          var s = t(e);
          return G(e) ? s : So(s, i(e));
        }
        function Me(e) {
          return e == null ? e === n ? mc : pc : Oo && Oo in Y(e) ? Tf(e) : Lf(e);
        }
        function qn(e, t) {
          return e > t;
        }
        function Op(e, t) {
          return e != null && V.call(e, t);
        }
        function Gp(e, t) {
          return e != null && t in Y(e);
        }
        function qp(e, t, i) {
          return e >= ye(t, i) && e < fe(t, i);
        }
        function Un(e, t, i) {
          for (var s = i ? Fn : ar, l = e[0].length, p = e.length, m = p, h = g(p), A = 1 / 0, M = []; m--; ) {
            var F = e[m];
            m && t && (F = te(F, Be(t))), A = ye(F.length, A), h[m] = !i && (t || l >= 120 && F.length >= 120) ? new qo(m && F) : n;
          }
          F = e[0];
          var I = -1, x = h[0];
          e:
            for (; ++I < l && M.length < A; ) {
              var E = F[I], R = t ? t(E) : E;
              if (E = i || E !== 0 ? E : 0, !(x ? Et(x, R) : s(M, R, i))) {
                for (m = p; --m; ) {
                  var U = h[m];
                  if (!(U ? Et(U, R) : s(e[m], R, i)))
                    continue e;
                }
                x && x.push(R), M.push(E);
              }
            }
          return M;
        }
        function Up(e, t, i, s) {
          return ao(e, function(l, p, m) {
            t(s, i(l), p, m);
          }), s;
        }
        function zt(e, t, i) {
          t = Co(t, e), e = Zs(e, t);
          var s = e == null ? e : e[Xe(Ke(t))];
          return s == null ? n : De(s, e, i);
        }
        function rs(e) {
          return se(e) && Me(e) == Xo;
        }
        function Zp(e) {
          return se(e) && Me(e) == wt;
        }
        function $p(e) {
          return se(e) && Me(e) == Ft;
        }
        function Ot(e, t, i, s, l) {
          return e === t ? !0 : e == null || t == null || !se(e) && !se(t) ? e !== e && t !== t : Kp(e, t, i, s, Ot, l);
        }
        function Kp(e, t, i, s, l, p) {
          var m = G(e), h = G(t), A = m ? Qt : Te(e), M = h ? Qt : Te(t);
          A = A == Xo ? mo : A, M = M == Xo ? mo : M;
          var F = A == mo, I = M == mo, x = A == M;
          if (x && Do(e)) {
            if (!Do(t))
              return !1;
            m = !0, F = !1;
          }
          if (x && !F)
            return p || (p = new Ye()), m || pt(e) ? Rs(e, t, i, s, l, p) : gf(e, t, A, i, s, l, p);
          if (!(i & ee)) {
            var E = F && V.call(e, "__wrapped__"), R = I && V.call(t, "__wrapped__");
            if (E || R) {
              var U = E ? e.value() : e, L = R ? t.value() : t;
              return p || (p = new Ye()), l(U, L, i, s, p);
            }
          }
          return x ? (p || (p = new Ye()), yf(e, t, i, s, l, p)) : !1;
        }
        function Hp(e) {
          return se(e) && Te(e) == Ve;
        }
        function Zn(e, t, i, s) {
          var l = i.length, p = l, m = !s;
          if (e == null)
            return !p;
          for (e = Y(e); l--; ) {
            var h = i[l];
            if (m && h[2] ? h[1] !== e[h[0]] : !(h[0] in e))
              return !1;
          }
          for (; ++l < p; ) {
            h = i[l];
            var A = h[0], M = e[A], F = h[1];
            if (m && h[2]) {
              if (M === n && !(A in e))
                return !1;
            } else {
              var I = new Ye();
              if (s)
                var x = s(M, F, A, e, t, I);
              if (!(x === n ? Ot(F, M, ee | po, s, I) : x))
                return !1;
            }
          }
          return !0;
        }
        function ns(e) {
          if (!ne(e) || wf(e))
            return !1;
          var t = yo(e) ? Hd : Rc;
          return t.test(Ko(e));
        }
        function Wp(e) {
          return se(e) && Me(e) == St;
        }
        function Vp(e) {
          return se(e) && Te(e) == je;
        }
        function jp(e) {
          return se(e) && Ur(e.length) && !!Q[Me(e)];
        }
        function is(e) {
          return typeof e == "function" ? e : e == null ? we : typeof e == "object" ? G(e) ? us(e[0], e[1]) : ss(e) : vu(e);
        }
        function $n(e) {
          if (!Ut(e))
            return Xd(e);
          var t = [];
          for (var i in Y(e))
            V.call(e, i) && i != "constructor" && t.push(i);
          return t;
        }
        function Jp(e) {
          if (!ne(e))
            return Df(e);
          var t = Ut(e), i = [];
          for (var s in e)
            s == "constructor" && (t || !V.call(e, s)) || i.push(s);
          return i;
        }
        function Kn(e, t) {
          return e < t;
        }
        function as(e, t) {
          var i = -1, s = xe(e) ? g(e.length) : [];
          return wo(e, function(l, p, m) {
            s[++i] = t(l, p, m);
          }), s;
        }
        function ss(e) {
          var t = ai(e);
          return t.length == 1 && t[0][2] ? qs(t[0][0], t[0][1]) : function(i) {
            return i === e || Zn(i, e, t);
          };
        }
        function us(e, t) {
          return ui(e) && Gs(t) ? qs(Xe(e), t) : function(i) {
            var s = gi(i, e);
            return s === n && s === t ? yi(i, e) : Ot(t, s, ee | po);
          };
        }
        function Sr(e, t, i, s, l) {
          e !== t && On(t, function(p, m) {
            if (l || (l = new Ye()), ne(p))
              Yp(e, t, m, i, Sr, s, l);
            else {
              var h = s ? s(ci(e, m), p, m + "", e, t, l) : n;
              h === n && (h = p), Pn(e, m, h);
            }
          }, ve);
        }
        function Yp(e, t, i, s, l, p, m) {
          var h = ci(e, i), A = ci(t, i), M = m.get(A);
          if (M) {
            Pn(e, i, M);
            return;
          }
          var F = p ? p(h, A, i + "", e, t, m) : n, I = F === n;
          if (I) {
            var x = G(A), E = !x && Do(A), R = !x && !E && pt(A);
            F = A, x || E || R ? G(h) ? F = h : ue(h) ? F = Se(h) : E ? (I = !1, F = ys(A, !0)) : R ? (I = !1, F = Ts(A, !0)) : F = [] : $t(A) || Ho(A) ? (F = h, Ho(h) ? F = _u(h) : (!ne(h) || yo(h)) && (F = Os(A))) : I = !1;
          }
          I && (m.set(A, F), l(F, A, s, p, m), m.delete(A)), Pn(e, i, F);
        }
        function ls(e, t) {
          var i = e.length;
          if (i)
            return t += t < 0 ? i : 0, go(t, i) ? e[t] : n;
        }
        function cs(e, t, i) {
          t.length ? t = te(t, function(p) {
            return G(p) ? function(m) {
              return Zo(m, p.length === 1 ? p[0] : p);
            } : p;
          }) : t = [we];
          var s = -1;
          t = te(t, Be(B()));
          var l = as(e, function(p, m, h) {
            var A = te(t, function(M) {
              return M(p);
            });
            return { criteria: A, index: ++s, value: p };
          });
          return Fd(l, function(p, m) {
            return df(p, m, i);
          });
        }
        function Xp(e, t) {
          return ds(e, t, function(i, s) {
            return yi(e, s);
          });
        }
        function ds(e, t, i) {
          for (var s = -1, l = t.length, p = {}; ++s < l; ) {
            var m = t[s], h = Zo(e, m);
            i(h, m) && Gt(p, Co(m, e), h);
          }
          return p;
        }
        function Qp(e) {
          return function(t) {
            return Zo(t, e);
          };
        }
        function Hn(e, t, i, s) {
          var l = s ? Nd : ot, p = -1, m = t.length, h = e;
          for (e === t && (t = Se(t)), i && (h = te(e, Be(i))); ++p < m; )
            for (var A = 0, M = t[p], F = i ? i(M) : M; (A = l(h, F, A, s)) > -1; )
              h !== e && br.call(h, A, 1), br.call(e, A, 1);
          return e;
        }
        function ps(e, t) {
          for (var i = e ? t.length : 0, s = i - 1; i--; ) {
            var l = t[i];
            if (i == s || l !== p) {
              var p = l;
              go(l) ? br.call(e, l, 1) : Jn(e, l);
            }
          }
          return e;
        }
        function Wn(e, t) {
          return e + gr(Ha() * (t - e + 1));
        }
        function ef(e, t, i, s) {
          for (var l = -1, p = fe(Ar((t - e) / (i || 1)), 0), m = g(p); p--; )
            m[s ? p : ++l] = e, e += i;
          return m;
        }
        function Vn(e, t) {
          var i = "";
          if (!e || t < 1 || t > Fo)
            return i;
          do
            t % 2 && (i += e), t = gr(t / 2), t && (e += e);
          while (t);
          return i;
        }
        function Z(e, t) {
          return di(Us(e, t, we), e + "");
        }
        function of(e) {
          return ja(ft(e));
        }
        function tf(e, t) {
          var i = ft(e);
          return Rr(i, Uo(t, 0, i.length));
        }
        function Gt(e, t, i, s) {
          if (!ne(e))
            return e;
          t = Co(t, e);
          for (var l = -1, p = t.length, m = p - 1, h = e; h != null && ++l < p; ) {
            var A = Xe(t[l]), M = i;
            if (A === "__proto__" || A === "constructor" || A === "prototype")
              return e;
            if (l != m) {
              var F = h[A];
              M = s ? s(F, A, h) : n, M === n && (M = ne(F) ? F : go(t[l + 1]) ? [] : {});
            }
            Rt(h, A, M), h = h[A];
          }
          return e;
        }
        var fs = yr ? function(e, t) {
          return yr.set(e, t), e;
        } : we, rf = _r ? function(e, t) {
          return _r(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Mi(t),
            writable: !0
          });
        } : we;
        function nf(e) {
          return Rr(ft(e));
        }
        function $e(e, t, i) {
          var s = -1, l = e.length;
          t < 0 && (t = -t > l ? 0 : l + t), i = i > l ? l : i, i < 0 && (i += l), l = t > i ? 0 : i - t >>> 0, t >>>= 0;
          for (var p = g(l); ++s < l; )
            p[s] = e[s + t];
          return p;
        }
        function af(e, t) {
          var i;
          return wo(e, function(s, l, p) {
            return i = t(s, l, p), !i;
          }), !!i;
        }
        function xr(e, t, i) {
          var s = 0, l = e == null ? s : e.length;
          if (typeof t == "number" && t === t && l <= uc) {
            for (; s < l; ) {
              var p = s + l >>> 1, m = e[p];
              m !== null && !Pe(m) && (i ? m <= t : m < t) ? s = p + 1 : l = p;
            }
            return l;
          }
          return jn(e, t, we, i);
        }
        function jn(e, t, i, s) {
          var l = 0, p = e == null ? 0 : e.length;
          if (p === 0)
            return 0;
          t = i(t);
          for (var m = t !== t, h = t === null, A = Pe(t), M = t === n; l < p; ) {
            var F = gr((l + p) / 2), I = i(e[F]), x = I !== n, E = I === null, R = I === I, U = Pe(I);
            if (m)
              var L = s || R;
            else M ? L = R && (s || x) : h ? L = R && x && (s || !E) : A ? L = R && x && !E && (s || !U) : E || U ? L = !1 : L = s ? I <= t : I < t;
            L ? l = F + 1 : p = F;
          }
          return ye(p, sc);
        }
        function ms(e, t) {
          for (var i = -1, s = e.length, l = 0, p = []; ++i < s; ) {
            var m = e[i], h = t ? t(m) : m;
            if (!i || !Qe(h, A)) {
              var A = h;
              p[l++] = m === 0 ? 0 : m;
            }
          }
          return p;
        }
        function hs(e) {
          return typeof e == "number" ? e : Pe(e) ? Xt : +e;
        }
        function Re(e) {
          if (typeof e == "string")
            return e;
          if (G(e))
            return te(e, Re) + "";
          if (Pe(e))
            return Wa ? Wa.call(e) : "";
          var t = e + "";
          return t == "0" && 1 / e == -Po ? "-0" : t;
        }
        function Eo(e, t, i) {
          var s = -1, l = ar, p = e.length, m = !0, h = [], A = h;
          if (i)
            m = !1, l = Fn;
          else if (p >= u) {
            var M = t ? null : _f(e);
            if (M)
              return ur(M);
            m = !1, l = Et, A = new qo();
          } else
            A = t ? [] : h;
          e:
            for (; ++s < p; ) {
              var F = e[s], I = t ? t(F) : F;
              if (F = i || F !== 0 ? F : 0, m && I === I) {
                for (var x = A.length; x--; )
                  if (A[x] === I)
                    continue e;
                t && A.push(I), h.push(F);
              } else l(A, I, i) || (A !== h && A.push(I), h.push(F));
            }
          return h;
        }
        function Jn(e, t) {
          t = Co(t, e);
          var i = -1, s = t.length;
          if (!s)
            return !0;
          for (; ++i < s; ) {
            var l = Xe(t[i]);
            if (l === "__proto__" && !V.call(e, "__proto__") || (l === "constructor" || l === "prototype") && i < s - 1)
              return !1;
          }
          var p = Zs(e, t);
          return p == null || delete p[Xe(Ke(t))];
        }
        function bs(e, t, i, s) {
          return Gt(e, t, i(Zo(e, t)), s);
        }
        function vr(e, t, i, s) {
          for (var l = e.length, p = s ? l : -1; (s ? p-- : ++p < l) && t(e[p], p, e); )
            ;
          return i ? $e(e, s ? 0 : p, s ? p + 1 : l) : $e(e, s ? p + 1 : 0, s ? l : p);
        }
        function _s(e, t) {
          var i = e;
          return i instanceof K && (i = i.value()), In(t, function(s, l) {
            return l.func.apply(l.thisArg, So([s], l.args));
          }, i);
        }
        function Yn(e, t, i) {
          var s = e.length;
          if (s < 2)
            return s ? Eo(e[0]) : [];
          for (var l = -1, p = g(s); ++l < s; )
            for (var m = e[l], h = -1; ++h < s; )
              h != l && (p[l] = Pt(p[l] || m, e[h], t, i));
          return Eo(_e(p, 1), t, i);
        }
        function As(e, t, i) {
          for (var s = -1, l = e.length, p = t.length, m = {}; ++s < l; ) {
            var h = s < p ? t[s] : n;
            i(m, e[s], h);
          }
          return m;
        }
        function Xn(e) {
          return ue(e) ? e : [];
        }
        function Qn(e) {
          return typeof e == "function" ? e : we;
        }
        function Co(e, t) {
          return G(e) ? e : ui(e, t) ? [e] : Ws(j(e));
        }
        var sf = Z;
        function ko(e, t, i) {
          var s = e.length;
          return i = i === n ? s : i, !t && i >= s ? e : $e(e, t, i);
        }
        var gs = Wd || function(e) {
          return be.clearTimeout(e);
        };
        function ys(e, t) {
          if (t)
            return e.slice();
          var i = e.length, s = qa ? qa(i) : new e.constructor(i);
          return e.copy(s), s;
        }
        function ei(e) {
          var t = new e.constructor(e.byteLength);
          return new mr(t).set(new mr(e)), t;
        }
        function uf(e, t) {
          var i = t ? ei(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.byteLength);
        }
        function lf(e) {
          var t = new e.constructor(e.source, ra.exec(e));
          return t.lastIndex = e.lastIndex, t;
        }
        function cf(e) {
          return Bt ? Y(Bt.call(e)) : {};
        }
        function Ts(e, t) {
          var i = t ? ei(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.length);
        }
        function Ms(e, t) {
          if (e !== t) {
            var i = e !== n, s = e === null, l = e === e, p = Pe(e), m = t !== n, h = t === null, A = t === t, M = Pe(t);
            if (!h && !M && !p && e > t || p && m && A && !h && !M || s && m && A || !i && A || !l)
              return 1;
            if (!s && !p && !M && e < t || M && i && l && !s && !p || h && i && l || !m && l || !A)
              return -1;
          }
          return 0;
        }
        function df(e, t, i) {
          for (var s = -1, l = e.criteria, p = t.criteria, m = l.length, h = i.length; ++s < m; ) {
            var A = Ms(l[s], p[s]);
            if (A) {
              if (s >= h)
                return A;
              var M = i[s];
              return A * (M == "desc" ? -1 : 1);
            }
          }
          return e.index - t.index;
        }
        function Ns(e, t, i, s) {
          for (var l = -1, p = e.length, m = i.length, h = -1, A = t.length, M = fe(p - m, 0), F = g(A + M), I = !s; ++h < A; )
            F[h] = t[h];
          for (; ++l < m; )
            (I || l < p) && (F[i[l]] = e[l]);
          for (; M--; )
            F[h++] = e[l++];
          return F;
        }
        function Fs(e, t, i, s) {
          for (var l = -1, p = e.length, m = -1, h = i.length, A = -1, M = t.length, F = fe(p - h, 0), I = g(F + M), x = !s; ++l < F; )
            I[l] = e[l];
          for (var E = l; ++A < M; )
            I[E + A] = t[A];
          for (; ++m < h; )
            (x || l < p) && (I[E + i[m]] = e[l++]);
          return I;
        }
        function Se(e, t) {
          var i = -1, s = e.length;
          for (t || (t = g(s)); ++i < s; )
            t[i] = e[i];
          return t;
        }
        function so(e, t, i, s) {
          var l = !i;
          i || (i = {});
          for (var p = -1, m = t.length; ++p < m; ) {
            var h = t[p], A = s ? s(i[h], e[h], h, i, e) : n;
            A === n && (A = e[h]), l ? io(i, h, A) : Rt(i, h, A);
          }
          return i;
        }
        function pf(e, t) {
          return so(e, si(e), t);
        }
        function ff(e, t) {
          return so(e, Ps(e), t);
        }
        function wr(e, t) {
          return function(i, s) {
            var l = G(i) ? _d : Lp, p = t ? t() : {};
            return l(i, e, B(s, 2), p);
          };
        }
        function lt(e) {
          return Z(function(t, i) {
            var s = -1, l = i.length, p = l > 1 ? i[l - 1] : n, m = l > 2 ? i[2] : n;
            for (p = e.length > 3 && typeof p == "function" ? (l--, p) : n, m && Ne(i[0], i[1], m) && (p = l < 3 ? n : p, l = 1), t = Y(t); ++s < l; ) {
              var h = i[s];
              h && e(t, h, s, p);
            }
            return t;
          });
        }
        function Is(e, t) {
          return function(i, s) {
            if (i == null)
              return i;
            if (!xe(i))
              return e(i, s);
            for (var l = i.length, p = t ? l : -1, m = Y(i); (t ? p-- : ++p < l) && s(m[p], p, m) !== !1; )
              ;
            return i;
          };
        }
        function Ss(e) {
          return function(t, i, s) {
            for (var l = -1, p = Y(t), m = s(t), h = m.length; h--; ) {
              var A = m[e ? h : ++l];
              if (i(p[A], A, p) === !1)
                break;
            }
            return t;
          };
        }
        function mf(e, t, i) {
          var s = t & Ce, l = qt(e);
          function p() {
            var m = this && this !== be && this instanceof p ? l : e;
            return m.apply(s ? i : this, arguments);
          }
          return p;
        }
        function xs(e) {
          return function(t) {
            t = j(t);
            var i = tt(t) ? Je(t) : n, s = i ? i[0] : t.charAt(0), l = i ? ko(i, 1).join("") : t.slice(1);
            return s[e]() + l;
          };
        }
        function ct(e) {
          return function(t) {
            return In(Su(Iu(t).replace(rd, "")), e, "");
          };
        }
        function qt(e) {
          return function() {
            var t = arguments;
            switch (t.length) {
              case 0:
                return new e();
              case 1:
                return new e(t[0]);
              case 2:
                return new e(t[0], t[1]);
              case 3:
                return new e(t[0], t[1], t[2]);
              case 4:
                return new e(t[0], t[1], t[2], t[3]);
              case 5:
                return new e(t[0], t[1], t[2], t[3], t[4]);
              case 6:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
              case 7:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
            }
            var i = ut(e.prototype), s = e.apply(i, t);
            return ne(s) ? s : i;
          };
        }
        function hf(e, t, i) {
          var s = qt(e);
          function l() {
            for (var p = arguments.length, m = g(p), h = p, A = dt(l); h--; )
              m[h] = arguments[h];
            var M = p < 3 && m[0] !== A && m[p - 1] !== A ? [] : xo(m, A);
            if (p -= M.length, p < i)
              return ks(
                e,
                t,
                Er,
                l.placeholder,
                n,
                m,
                M,
                n,
                n,
                i - p
              );
            var F = this && this !== be && this instanceof l ? s : e;
            return De(F, this, m);
          }
          return l;
        }
        function vs(e) {
          return function(t, i, s) {
            var l = Y(t);
            if (!xe(t)) {
              var p = B(i, 3);
              t = me(t), i = function(h) {
                return p(l[h], h, l);
              };
            }
            var m = e(t, i, s);
            return m > -1 ? l[p ? t[m] : m] : n;
          };
        }
        function ws(e) {
          return Ao(function(t) {
            var i = t.length, s = i, l = Ue.prototype.thru;
            for (e && t.reverse(); s--; ) {
              var p = t[s];
              if (typeof p != "function")
                throw new qe(d);
              if (l && !m && Lr(p) == "wrapper")
                var m = new Ue([], !0);
            }
            for (s = m ? s : i; ++s < i; ) {
              p = t[s];
              var h = Lr(p), A = h == "wrapper" ? ii(p) : n;
              A && li(A[0]) && A[1] == (fo | oe | ro | Mt) && !A[4].length && A[9] == 1 ? m = m[Lr(A[0])].apply(m, A[3]) : m = p.length == 1 && li(p) ? m[h]() : m.thru(p);
            }
            return function() {
              var M = arguments, F = M[0];
              if (m && M.length == 1 && G(F))
                return m.plant(F).value();
              for (var I = 0, x = i ? t[I].apply(this, M) : F; ++I < i; )
                x = t[I].call(this, x);
              return x;
            };
          });
        }
        function Er(e, t, i, s, l, p, m, h, A, M) {
          var F = t & fo, I = t & Ce, x = t & No, E = t & (oe | he), R = t & nn, U = x ? n : qt(e);
          function L() {
            for (var $ = arguments.length, H = g($), ze = $; ze--; )
              H[ze] = arguments[ze];
            if (E)
              var Fe = dt(L), Oe = Sd(H, Fe);
            if (s && (H = Ns(H, s, l, E)), p && (H = Fs(H, p, m, E)), $ -= Oe, E && $ < M) {
              var le = xo(H, Fe);
              return ks(
                e,
                t,
                Er,
                L.placeholder,
                i,
                H,
                le,
                h,
                A,
                M - $
              );
            }
            var eo = I ? i : this, Mo = x ? eo[e] : e;
            return $ = H.length, h ? H = Bf(H, h) : R && $ > 1 && H.reverse(), F && A < $ && (H.length = A), this && this !== be && this instanceof L && (Mo = U || qt(Mo)), Mo.apply(eo, H);
          }
          return L;
        }
        function Es(e, t) {
          return function(i, s) {
            return Up(i, e, t(s), {});
          };
        }
        function Cr(e, t) {
          return function(i, s) {
            var l;
            if (i === n && s === n)
              return t;
            if (i !== n && (l = i), s !== n) {
              if (l === n)
                return s;
              typeof i == "string" || typeof s == "string" ? (i = Re(i), s = Re(s)) : (i = hs(i), s = hs(s)), l = e(i, s);
            }
            return l;
          };
        }
        function oi(e) {
          return Ao(function(t) {
            return t = te(t, Be(B())), Z(function(i) {
              var s = this;
              return e(t, function(l) {
                return De(l, s, i);
              });
            });
          });
        }
        function kr(e, t) {
          t = t === n ? " " : Re(t);
          var i = t.length;
          if (i < 2)
            return i ? Vn(t, e) : t;
          var s = Vn(t, Ar(e / rt(t)));
          return tt(t) ? ko(Je(s), 0, e).join("") : s.slice(0, e);
        }
        function bf(e, t, i, s) {
          var l = t & Ce, p = qt(e);
          function m() {
            for (var h = -1, A = arguments.length, M = -1, F = s.length, I = g(F + A), x = this && this !== be && this instanceof m ? p : e; ++M < F; )
              I[M] = s[M];
            for (; A--; )
              I[M++] = arguments[++h];
            return De(x, l ? i : this, I);
          }
          return m;
        }
        function Cs(e) {
          return function(t, i, s) {
            return s && typeof s != "number" && Ne(t, i, s) && (i = s = n), t = To(t), i === n ? (i = t, t = 0) : i = To(i), s = s === n ? t < i ? 1 : -1 : To(s), ef(t, i, s, e);
          };
        }
        function Dr(e) {
          return function(t, i) {
            return typeof t == "string" && typeof i == "string" || (t = He(t), i = He(i)), e(t, i);
          };
        }
        function ks(e, t, i, s, l, p, m, h, A, M) {
          var F = t & oe, I = F ? m : n, x = F ? n : m, E = F ? p : n, R = F ? n : p;
          t |= F ? ro : Ro, t &= ~(F ? Ro : ro), t & ke || (t &= -4);
          var U = [
            e,
            t,
            l,
            E,
            I,
            R,
            x,
            h,
            A,
            M
          ], L = i.apply(n, U);
          return li(e) && $s(L, U), L.placeholder = s, Ks(L, e, t);
        }
        function ti(e) {
          var t = pe[e];
          return function(i, s) {
            if (i = He(i), s = s == null ? 0 : ye(q(s), 292), s && Ka(i)) {
              var l = (j(i) + "e").split("e"), p = t(l[0] + "e" + (+l[1] + s));
              return l = (j(p) + "e").split("e"), +(l[0] + "e" + (+l[1] - s));
            }
            return t(i);
          };
        }
        var _f = at && 1 / ur(new at([, -0]))[1] == Po ? function(e) {
          return new at(e);
        } : Ii;
        function Ds(e) {
          return function(t) {
            var i = Te(t);
            return i == Ve ? kn(t) : i == je ? Dd(t) : Id(t, e(t));
          };
        }
        function _o(e, t, i, s, l, p, m, h) {
          var A = t & No;
          if (!A && typeof e != "function")
            throw new qe(d);
          var M = s ? s.length : 0;
          if (M || (t &= -97, s = l = n), m = m === n ? m : fe(q(m), 0), h = h === n ? h : q(h), M -= l ? l.length : 0, t & Ro) {
            var F = s, I = l;
            s = l = n;
          }
          var x = A ? n : ii(e), E = [
            e,
            t,
            i,
            s,
            l,
            F,
            I,
            p,
            m,
            h
          ];
          if (x && kf(E, x), e = E[0], t = E[1], i = E[2], s = E[3], l = E[4], h = E[9] = E[9] === n ? A ? 0 : e.length : fe(E[9] - M, 0), !h && t & (oe | he) && (t &= -25), !t || t == Ce)
            var R = mf(e, t, i);
          else t == oe || t == he ? R = hf(e, t, h) : (t == ro || t == (Ce | ro)) && !l.length ? R = bf(e, t, i, s) : R = Er.apply(n, E);
          var U = x ? fs : $s;
          return Ks(U(R, E), e, t);
        }
        function Ls(e, t, i, s) {
          return e === n || Qe(e, it[i]) && !V.call(s, i) ? t : e;
        }
        function Bs(e, t, i, s, l, p) {
          return ne(e) && ne(t) && (p.set(t, e), Sr(e, t, n, Bs, p), p.delete(t)), e;
        }
        function Af(e) {
          return $t(e) ? n : e;
        }
        function Rs(e, t, i, s, l, p) {
          var m = i & ee, h = e.length, A = t.length;
          if (h != A && !(m && A > h))
            return !1;
          var M = p.get(e), F = p.get(t);
          if (M && F)
            return M == t && F == e;
          var I = -1, x = !0, E = i & po ? new qo() : n;
          for (p.set(e, t), p.set(t, e); ++I < h; ) {
            var R = e[I], U = t[I];
            if (s)
              var L = m ? s(U, R, I, t, e, p) : s(R, U, I, e, t, p);
            if (L !== n) {
              if (L)
                continue;
              x = !1;
              break;
            }
            if (E) {
              if (!Sn(t, function($, H) {
                if (!Et(E, H) && (R === $ || l(R, $, i, s, p)))
                  return E.push(H);
              })) {
                x = !1;
                break;
              }
            } else if (!(R === U || l(R, U, i, s, p))) {
              x = !1;
              break;
            }
          }
          return p.delete(e), p.delete(t), x;
        }
        function gf(e, t, i, s, l, p, m) {
          switch (i) {
            case Qo:
              if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
                return !1;
              e = e.buffer, t = t.buffer;
            case wt:
              return !(e.byteLength != t.byteLength || !p(new mr(e), new mr(t)));
            case Nt:
            case Ft:
            case It:
              return Qe(+e, +t);
            case er:
              return e.name == t.name && e.message == t.message;
            case St:
            case xt:
              return e == t + "";
            case Ve:
              var h = kn;
            case je:
              var A = s & ee;
              if (h || (h = ur), e.size != t.size && !A)
                return !1;
              var M = m.get(e);
              if (M)
                return M == t;
              s |= po, m.set(e, t);
              var F = Rs(h(e), h(t), s, l, p, m);
              return m.delete(e), F;
            case tr:
              if (Bt)
                return Bt.call(e) == Bt.call(t);
          }
          return !1;
        }
        function yf(e, t, i, s, l, p) {
          var m = i & ee, h = ri(e), A = h.length, M = ri(t), F = M.length;
          if (A != F && !m)
            return !1;
          for (var I = A; I--; ) {
            var x = h[I];
            if (!(m ? x in t : V.call(t, x)))
              return !1;
          }
          var E = p.get(e), R = p.get(t);
          if (E && R)
            return E == t && R == e;
          var U = !0;
          p.set(e, t), p.set(t, e);
          for (var L = m; ++I < A; ) {
            x = h[I];
            var $ = e[x], H = t[x];
            if (s)
              var ze = m ? s(H, $, x, t, e, p) : s($, H, x, e, t, p);
            if (!(ze === n ? $ === H || l($, H, i, s, p) : ze)) {
              U = !1;
              break;
            }
            L || (L = x == "constructor");
          }
          if (U && !L) {
            var Fe = e.constructor, Oe = t.constructor;
            Fe != Oe && "constructor" in e && "constructor" in t && !(typeof Fe == "function" && Fe instanceof Fe && typeof Oe == "function" && Oe instanceof Oe) && (U = !1);
          }
          return p.delete(e), p.delete(t), U;
        }
        function Ao(e) {
          return di(Us(e, n, Ys), e + "");
        }
        function ri(e) {
          return ts(e, me, si);
        }
        function ni(e) {
          return ts(e, ve, Ps);
        }
        var ii = yr ? function(e) {
          return yr.get(e);
        } : Ii;
        function Lr(e) {
          for (var t = e.name + "", i = st[t], s = V.call(st, t) ? i.length : 0; s--; ) {
            var l = i[s], p = l.func;
            if (p == null || p == e)
              return l.name;
          }
          return t;
        }
        function dt(e) {
          var t = V.call(c, "placeholder") ? c : e;
          return t.placeholder;
        }
        function B() {
          var e = c.iteratee || Ni;
          return e = e === Ni ? is : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function Br(e, t) {
          var i = e.__data__;
          return vf(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
        }
        function ai(e) {
          for (var t = me(e), i = t.length; i--; ) {
            var s = t[i], l = e[s];
            t[i] = [s, l, Gs(l)];
          }
          return t;
        }
        function $o(e, t) {
          var i = Ed(e, t);
          return ns(i) ? i : n;
        }
        function Tf(e) {
          var t = V.call(e, Oo), i = e[Oo];
          try {
            e[Oo] = n;
            var s = !0;
          } catch {
          }
          var l = pr.call(e);
          return s && (t ? e[Oo] = i : delete e[Oo]), l;
        }
        var si = Ln ? function(e) {
          return e == null ? [] : (e = Y(e), Io(Ln(e), function(t) {
            return Za.call(e, t);
          }));
        } : Si, Ps = Ln ? function(e) {
          for (var t = []; e; )
            So(t, si(e)), e = hr(e);
          return t;
        } : Si, Te = Me;
        (Bn && Te(new Bn(new ArrayBuffer(1))) != Qo || kt && Te(new kt()) != Ve || Rn && Te(Rn.resolve()) != Xi || at && Te(new at()) != je || Dt && Te(new Dt()) != vt) && (Te = function(e) {
          var t = Me(e), i = t == mo ? e.constructor : n, s = i ? Ko(i) : "";
          if (s)
            switch (s) {
              case tp:
                return Qo;
              case rp:
                return Ve;
              case np:
                return Xi;
              case ip:
                return je;
              case ap:
                return vt;
            }
          return t;
        });
        function Mf(e, t, i) {
          for (var s = -1, l = i.length; ++s < l; ) {
            var p = i[s], m = p.size;
            switch (p.type) {
              case "drop":
                e += m;
                break;
              case "dropRight":
                t -= m;
                break;
              case "take":
                t = ye(t, e + m);
                break;
              case "takeRight":
                e = fe(e, t - m);
                break;
            }
          }
          return { start: e, end: t };
        }
        function Nf(e) {
          var t = e.match(wc);
          return t ? t[1].split(Ec) : [];
        }
        function zs(e, t, i) {
          t = Co(t, e);
          for (var s = -1, l = t.length, p = !1; ++s < l; ) {
            var m = Xe(t[s]);
            if (!(p = e != null && i(e, m)))
              break;
            e = e[m];
          }
          return p || ++s != l ? p : (l = e == null ? 0 : e.length, !!l && Ur(l) && go(m, l) && (G(e) || Ho(e)));
        }
        function Ff(e) {
          var t = e.length, i = new e.constructor(t);
          return t && typeof e[0] == "string" && V.call(e, "index") && (i.index = e.index, i.input = e.input), i;
        }
        function Os(e) {
          return typeof e.constructor == "function" && !Ut(e) ? ut(hr(e)) : {};
        }
        function If(e, t, i) {
          var s = e.constructor;
          switch (t) {
            case wt:
              return ei(e);
            case Nt:
            case Ft:
              return new s(+e);
            case Qo:
              return uf(e, i);
            case an:
            case sn:
            case un:
            case ln:
            case cn:
            case dn:
            case pn:
            case fn:
            case mn:
              return Ts(e, i);
            case Ve:
              return new s();
            case It:
            case xt:
              return new s(e);
            case St:
              return lf(e);
            case je:
              return new s();
            case tr:
              return cf(e);
          }
        }
        function Sf(e, t) {
          var i = t.length;
          if (!i)
            return e;
          var s = i - 1;
          return t[s] = (i > 1 ? "& " : "") + t[s], t = t.join(i > 2 ? ", " : " "), e.replace(vc, `{
/* [wrapped with ` + t + `] */
`);
        }
        function xf(e) {
          return G(e) || Ho(e) || !!($a && e && e[$a]);
        }
        function go(e, t) {
          var i = typeof e;
          return t = t ?? Fo, !!t && (i == "number" || i != "symbol" && zc.test(e)) && e > -1 && e % 1 == 0 && e < t;
        }
        function Ne(e, t, i) {
          if (!ne(i))
            return !1;
          var s = typeof t;
          return (s == "number" ? xe(i) && go(t, i.length) : s == "string" && t in i) ? Qe(i[t], e) : !1;
        }
        function ui(e, t) {
          if (G(e))
            return !1;
          var i = typeof e;
          return i == "number" || i == "symbol" || i == "boolean" || e == null || Pe(e) ? !0 : Fc.test(e) || !Nc.test(e) || t != null && e in Y(t);
        }
        function vf(e) {
          var t = typeof e;
          return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
        }
        function li(e) {
          var t = Lr(e), i = c[t];
          if (typeof i != "function" || !(t in K.prototype))
            return !1;
          if (e === i)
            return !0;
          var s = ii(i);
          return !!s && e === s[0];
        }
        function wf(e) {
          return !!Ga && Ga in e;
        }
        var Ef = cr ? yo : xi;
        function Ut(e) {
          var t = e && e.constructor, i = typeof t == "function" && t.prototype || it;
          return e === i;
        }
        function Gs(e) {
          return e === e && !ne(e);
        }
        function qs(e, t) {
          return function(i) {
            return i == null ? !1 : i[e] === t && (t !== n || e in Y(i));
          };
        }
        function Cf(e) {
          var t = Gr(e, function(s) {
            return i.size === w && i.clear(), s;
          }), i = t.cache;
          return t;
        }
        function kf(e, t) {
          var i = e[1], s = t[1], l = i | s, p = l < (Ce | No | fo), m = s == fo && i == oe || s == fo && i == Mt && e[7].length <= t[8] || s == (fo | Mt) && t[7].length <= t[8] && i == oe;
          if (!(p || m))
            return e;
          s & Ce && (e[2] = t[2], l |= i & Ce ? 0 : ke);
          var h = t[3];
          if (h) {
            var A = e[3];
            e[3] = A ? Ns(A, h, t[4]) : h, e[4] = A ? xo(e[3], O) : t[4];
          }
          return h = t[5], h && (A = e[5], e[5] = A ? Fs(A, h, t[6]) : h, e[6] = A ? xo(e[5], O) : t[6]), h = t[7], h && (e[7] = h), s & fo && (e[8] = e[8] == null ? t[8] : ye(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = l, e;
        }
        function Df(e) {
          var t = [];
          if (e != null)
            for (var i in Y(e))
              t.push(i);
          return t;
        }
        function Lf(e) {
          return pr.call(e);
        }
        function Us(e, t, i) {
          return t = fe(t === n ? e.length - 1 : t, 0), function() {
            for (var s = arguments, l = -1, p = fe(s.length - t, 0), m = g(p); ++l < p; )
              m[l] = s[t + l];
            l = -1;
            for (var h = g(t + 1); ++l < t; )
              h[l] = s[l];
            return h[t] = i(m), De(e, this, h);
          };
        }
        function Zs(e, t) {
          return t.length < 2 ? e : Zo(e, $e(t, 0, -1));
        }
        function Bf(e, t) {
          for (var i = e.length, s = ye(t.length, i), l = Se(e); s--; ) {
            var p = t[s];
            e[s] = go(p, i) ? l[p] : n;
          }
          return e;
        }
        function ci(e, t) {
          if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
            return e[t];
        }
        var $s = Hs(fs), Zt = jd || function(e, t) {
          return be.setTimeout(e, t);
        }, di = Hs(rf);
        function Ks(e, t, i) {
          var s = t + "";
          return di(e, Sf(s, Rf(Nf(s), i)));
        }
        function Hs(e) {
          var t = 0, i = 0;
          return function() {
            var s = Qd(), l = rc - (s - i);
            if (i = s, l > 0) {
              if (++t >= tc)
                return arguments[0];
            } else
              t = 0;
            return e.apply(n, arguments);
          };
        }
        function Rr(e, t) {
          var i = -1, s = e.length, l = s - 1;
          for (t = t === n ? s : t; ++i < t; ) {
            var p = Wn(i, l), m = e[p];
            e[p] = e[i], e[i] = m;
          }
          return e.length = t, e;
        }
        var Ws = Cf(function(e) {
          var t = [];
          return e.charCodeAt(0) === 46 && t.push(""), e.replace(Ic, function(i, s, l, p) {
            t.push(l ? p.replace(kc, "$1") : s || i);
          }), t;
        });
        function Xe(e) {
          if (typeof e == "string" || Pe(e))
            return e;
          var t = e + "";
          return t == "0" && 1 / e == -Po ? "-0" : t;
        }
        function Ko(e) {
          if (e != null) {
            try {
              return dr.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function Rf(e, t) {
          return Le(lc, function(i) {
            var s = "_." + i[0];
            t & i[1] && !ar(e, s) && e.push(s);
          }), e.sort();
        }
        function Vs(e) {
          if (e instanceof K)
            return e.clone();
          var t = new Ue(e.__wrapped__, e.__chain__);
          return t.__actions__ = Se(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
        }
        function Pf(e, t, i) {
          (i ? Ne(e, t, i) : t === n) ? t = 1 : t = fe(q(t), 0);
          var s = e == null ? 0 : e.length;
          if (!s || t < 1)
            return [];
          for (var l = 0, p = 0, m = g(Ar(s / t)); l < s; )
            m[p++] = $e(e, l, l += t);
          return m;
        }
        function zf(e) {
          for (var t = -1, i = e == null ? 0 : e.length, s = 0, l = []; ++t < i; ) {
            var p = e[t];
            p && (l[s++] = p);
          }
          return l;
        }
        function Of() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var t = g(e - 1), i = arguments[0], s = e; s--; )
            t[s - 1] = arguments[s];
          return So(G(i) ? Se(i) : [i], _e(t, 1));
        }
        var Gf = Z(function(e, t) {
          return ue(e) ? Pt(e, _e(t, 1, ue, !0)) : [];
        }), qf = Z(function(e, t) {
          var i = Ke(t);
          return ue(i) && (i = n), ue(e) ? Pt(e, _e(t, 1, ue, !0), B(i, 2)) : [];
        }), Uf = Z(function(e, t) {
          var i = Ke(t);
          return ue(i) && (i = n), ue(e) ? Pt(e, _e(t, 1, ue, !0), n, i) : [];
        });
        function Zf(e, t, i) {
          var s = e == null ? 0 : e.length;
          return s ? (t = i || t === n ? 1 : q(t), $e(e, t < 0 ? 0 : t, s)) : [];
        }
        function $f(e, t, i) {
          var s = e == null ? 0 : e.length;
          return s ? (t = i || t === n ? 1 : q(t), t = s - t, $e(e, 0, t < 0 ? 0 : t)) : [];
        }
        function Kf(e, t) {
          return e && e.length ? vr(e, B(t, 3), !0, !0) : [];
        }
        function Hf(e, t) {
          return e && e.length ? vr(e, B(t, 3), !0) : [];
        }
        function Wf(e, t, i, s) {
          var l = e == null ? 0 : e.length;
          return l ? (i && typeof i != "number" && Ne(e, t, i) && (i = 0, s = l), zp(e, t, i, s)) : [];
        }
        function js(e, t, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = i == null ? 0 : q(i);
          return l < 0 && (l = fe(s + l, 0)), sr(e, B(t, 3), l);
        }
        function Js(e, t, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = s - 1;
          return i !== n && (l = q(i), l = i < 0 ? fe(s + l, 0) : ye(l, s - 1)), sr(e, B(t, 3), l, !0);
        }
        function Ys(e) {
          var t = e == null ? 0 : e.length;
          return t ? _e(e, 1) : [];
        }
        function Vf(e) {
          var t = e == null ? 0 : e.length;
          return t ? _e(e, Po) : [];
        }
        function jf(e, t) {
          var i = e == null ? 0 : e.length;
          return i ? (t = t === n ? 1 : q(t), _e(e, t)) : [];
        }
        function Jf(e) {
          for (var t = -1, i = e == null ? 0 : e.length, s = {}; ++t < i; ) {
            var l = e[t];
            io(s, l[0], l[1]);
          }
          return s;
        }
        function Xs(e) {
          return e && e.length ? e[0] : n;
        }
        function Yf(e, t, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = i == null ? 0 : q(i);
          return l < 0 && (l = fe(s + l, 0)), ot(e, t, l);
        }
        function Xf(e) {
          var t = e == null ? 0 : e.length;
          return t ? $e(e, 0, -1) : [];
        }
        var Qf = Z(function(e) {
          var t = te(e, Xn);
          return t.length && t[0] === e[0] ? Un(t) : [];
        }), em = Z(function(e) {
          var t = Ke(e), i = te(e, Xn);
          return t === Ke(i) ? t = n : i.pop(), i.length && i[0] === e[0] ? Un(i, B(t, 2)) : [];
        }), om = Z(function(e) {
          var t = Ke(e), i = te(e, Xn);
          return t = typeof t == "function" ? t : n, t && i.pop(), i.length && i[0] === e[0] ? Un(i, n, t) : [];
        });
        function tm(e, t) {
          return e == null ? "" : Yd.call(e, t);
        }
        function Ke(e) {
          var t = e == null ? 0 : e.length;
          return t ? e[t - 1] : n;
        }
        function rm(e, t, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = s;
          return i !== n && (l = q(i), l = l < 0 ? fe(s + l, 0) : ye(l, s - 1)), t === t ? Bd(e, t, l) : sr(e, ka, l, !0);
        }
        function nm(e, t) {
          return e && e.length ? ls(e, q(t)) : n;
        }
        var im = Z(Qs);
        function Qs(e, t) {
          return e && e.length && t && t.length ? Hn(e, t) : e;
        }
        function am(e, t, i) {
          return e && e.length && t && t.length ? Hn(e, t, B(i, 2)) : e;
        }
        function sm(e, t, i) {
          return e && e.length && t && t.length ? Hn(e, t, n, i) : e;
        }
        var um = Ao(function(e, t) {
          var i = e == null ? 0 : e.length, s = zn(e, t);
          return ps(e, te(t, function(l) {
            return go(l, i) ? +l : l;
          }).sort(Ms)), s;
        });
        function lm(e, t) {
          var i = [];
          if (!(e && e.length))
            return i;
          var s = -1, l = [], p = e.length;
          for (t = B(t, 3); ++s < p; ) {
            var m = e[s];
            t(m, s, e) && (i.push(m), l.push(s));
          }
          return ps(e, l), i;
        }
        function pi(e) {
          return e == null ? e : op.call(e);
        }
        function cm(e, t, i) {
          var s = e == null ? 0 : e.length;
          return s ? (i && typeof i != "number" && Ne(e, t, i) ? (t = 0, i = s) : (t = t == null ? 0 : q(t), i = i === n ? s : q(i)), $e(e, t, i)) : [];
        }
        function dm(e, t) {
          return xr(e, t);
        }
        function pm(e, t, i) {
          return jn(e, t, B(i, 2));
        }
        function fm(e, t) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = xr(e, t);
            if (s < i && Qe(e[s], t))
              return s;
          }
          return -1;
        }
        function mm(e, t) {
          return xr(e, t, !0);
        }
        function hm(e, t, i) {
          return jn(e, t, B(i, 2), !0);
        }
        function bm(e, t) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = xr(e, t, !0) - 1;
            if (Qe(e[s], t))
              return s;
          }
          return -1;
        }
        function _m(e) {
          return e && e.length ? ms(e) : [];
        }
        function Am(e, t) {
          return e && e.length ? ms(e, B(t, 2)) : [];
        }
        function gm(e) {
          var t = e == null ? 0 : e.length;
          return t ? $e(e, 1, t) : [];
        }
        function ym(e, t, i) {
          return e && e.length ? (t = i || t === n ? 1 : q(t), $e(e, 0, t < 0 ? 0 : t)) : [];
        }
        function Tm(e, t, i) {
          var s = e == null ? 0 : e.length;
          return s ? (t = i || t === n ? 1 : q(t), t = s - t, $e(e, t < 0 ? 0 : t, s)) : [];
        }
        function Mm(e, t) {
          return e && e.length ? vr(e, B(t, 3), !1, !0) : [];
        }
        function Nm(e, t) {
          return e && e.length ? vr(e, B(t, 3)) : [];
        }
        var Fm = Z(function(e) {
          return Eo(_e(e, 1, ue, !0));
        }), Im = Z(function(e) {
          var t = Ke(e);
          return ue(t) && (t = n), Eo(_e(e, 1, ue, !0), B(t, 2));
        }), Sm = Z(function(e) {
          var t = Ke(e);
          return t = typeof t == "function" ? t : n, Eo(_e(e, 1, ue, !0), n, t);
        });
        function xm(e) {
          return e && e.length ? Eo(e) : [];
        }
        function vm(e, t) {
          return e && e.length ? Eo(e, B(t, 2)) : [];
        }
        function wm(e, t) {
          return t = typeof t == "function" ? t : n, e && e.length ? Eo(e, n, t) : [];
        }
        function fi(e) {
          if (!(e && e.length))
            return [];
          var t = 0;
          return e = Io(e, function(i) {
            if (ue(i))
              return t = fe(i.length, t), !0;
          }), En(t, function(i) {
            return te(e, xn(i));
          });
        }
        function eu(e, t) {
          if (!(e && e.length))
            return [];
          var i = fi(e);
          return t == null ? i : te(i, function(s) {
            return De(t, n, s);
          });
        }
        var Em = Z(function(e, t) {
          return ue(e) ? Pt(e, t) : [];
        }), Cm = Z(function(e) {
          return Yn(Io(e, ue));
        }), km = Z(function(e) {
          var t = Ke(e);
          return ue(t) && (t = n), Yn(Io(e, ue), B(t, 2));
        }), Dm = Z(function(e) {
          var t = Ke(e);
          return t = typeof t == "function" ? t : n, Yn(Io(e, ue), n, t);
        }), Lm = Z(fi);
        function Bm(e, t) {
          return As(e || [], t || [], Rt);
        }
        function Rm(e, t) {
          return As(e || [], t || [], Gt);
        }
        var Pm = Z(function(e) {
          var t = e.length, i = t > 1 ? e[t - 1] : n;
          return i = typeof i == "function" ? (e.pop(), i) : n, eu(e, i);
        });
        function ou(e) {
          var t = c(e);
          return t.__chain__ = !0, t;
        }
        function zm(e, t) {
          return t(e), e;
        }
        function Pr(e, t) {
          return t(e);
        }
        var Om = Ao(function(e) {
          var t = e.length, i = t ? e[0] : 0, s = this.__wrapped__, l = function(p) {
            return zn(p, e);
          };
          return t > 1 || this.__actions__.length || !(s instanceof K) || !go(i) ? this.thru(l) : (s = s.slice(i, +i + (t ? 1 : 0)), s.__actions__.push({
            func: Pr,
            args: [l],
            thisArg: n
          }), new Ue(s, this.__chain__).thru(function(p) {
            return t && !p.length && p.push(n), p;
          }));
        });
        function Gm() {
          return ou(this);
        }
        function qm() {
          return new Ue(this.value(), this.__chain__);
        }
        function Um() {
          this.__values__ === n && (this.__values__ = hu(this.value()));
          var e = this.__index__ >= this.__values__.length, t = e ? n : this.__values__[this.__index__++];
          return { done: e, value: t };
        }
        function Zm() {
          return this;
        }
        function $m(e) {
          for (var t, i = this; i instanceof Mr; ) {
            var s = Vs(i);
            s.__index__ = 0, s.__values__ = n, t ? l.__wrapped__ = s : t = s;
            var l = s;
            i = i.__wrapped__;
          }
          return l.__wrapped__ = e, t;
        }
        function Km() {
          var e = this.__wrapped__;
          if (e instanceof K) {
            var t = e;
            return this.__actions__.length && (t = new K(this)), t = t.reverse(), t.__actions__.push({
              func: Pr,
              args: [pi],
              thisArg: n
            }), new Ue(t, this.__chain__);
          }
          return this.thru(pi);
        }
        function Hm() {
          return _s(this.__wrapped__, this.__actions__);
        }
        var Wm = wr(function(e, t, i) {
          V.call(e, i) ? ++e[i] : io(e, i, 1);
        });
        function Vm(e, t, i) {
          var s = G(e) ? Ea : Pp;
          return i && Ne(e, t, i) && (t = n), s(e, B(t, 3));
        }
        function jm(e, t) {
          var i = G(e) ? Io : es;
          return i(e, B(t, 3));
        }
        var Jm = vs(js), Ym = vs(Js);
        function Xm(e, t) {
          return _e(zr(e, t), 1);
        }
        function Qm(e, t) {
          return _e(zr(e, t), Po);
        }
        function eh(e, t, i) {
          return i = i === n ? 1 : q(i), _e(zr(e, t), i);
        }
        function tu(e, t) {
          var i = G(e) ? Le : wo;
          return i(e, B(t, 3));
        }
        function ru(e, t) {
          var i = G(e) ? Ad : Qa;
          return i(e, B(t, 3));
        }
        var oh = wr(function(e, t, i) {
          V.call(e, i) ? e[i].push(t) : io(e, i, [t]);
        });
        function th(e, t, i, s) {
          e = xe(e) ? e : ft(e), i = i && !s ? q(i) : 0;
          var l = e.length;
          return i < 0 && (i = fe(l + i, 0)), Zr(e) ? i <= l && e.indexOf(t, i) > -1 : !!l && ot(e, t, i) > -1;
        }
        var rh = Z(function(e, t, i) {
          var s = -1, l = typeof t == "function", p = xe(e) ? g(e.length) : [];
          return wo(e, function(m) {
            p[++s] = l ? De(t, m, i) : zt(m, t, i);
          }), p;
        }), nh = wr(function(e, t, i) {
          io(e, i, t);
        });
        function zr(e, t) {
          var i = G(e) ? te : as;
          return i(e, B(t, 3));
        }
        function ih(e, t, i, s) {
          return e == null ? [] : (G(t) || (t = t == null ? [] : [t]), i = s ? n : i, G(i) || (i = i == null ? [] : [i]), cs(e, t, i));
        }
        var ah = wr(function(e, t, i) {
          e[i ? 0 : 1].push(t);
        }, function() {
          return [[], []];
        });
        function sh(e, t, i) {
          var s = G(e) ? In : La, l = arguments.length < 3;
          return s(e, B(t, 4), i, l, wo);
        }
        function uh(e, t, i) {
          var s = G(e) ? gd : La, l = arguments.length < 3;
          return s(e, B(t, 4), i, l, Qa);
        }
        function lh(e, t) {
          var i = G(e) ? Io : es;
          return i(e, qr(B(t, 3)));
        }
        function ch(e) {
          var t = G(e) ? ja : of;
          return t(e);
        }
        function dh(e, t, i) {
          (i ? Ne(e, t, i) : t === n) ? t = 1 : t = q(t);
          var s = G(e) ? kp : tf;
          return s(e, t);
        }
        function ph(e) {
          var t = G(e) ? Dp : nf;
          return t(e);
        }
        function fh(e) {
          if (e == null)
            return 0;
          if (xe(e))
            return Zr(e) ? rt(e) : e.length;
          var t = Te(e);
          return t == Ve || t == je ? e.size : $n(e).length;
        }
        function mh(e, t, i) {
          var s = G(e) ? Sn : af;
          return i && Ne(e, t, i) && (t = n), s(e, B(t, 3));
        }
        var hh = Z(function(e, t) {
          if (e == null)
            return [];
          var i = t.length;
          return i > 1 && Ne(e, t[0], t[1]) ? t = [] : i > 2 && Ne(t[0], t[1], t[2]) && (t = [t[0]]), cs(e, _e(t, 1), []);
        }), Or = Vd || function() {
          return be.Date.now();
        };
        function bh(e, t) {
          if (typeof t != "function")
            throw new qe(d);
          return e = q(e), function() {
            if (--e < 1)
              return t.apply(this, arguments);
          };
        }
        function nu(e, t, i) {
          return t = i ? n : t, t = e && t == null ? e.length : t, _o(e, fo, n, n, n, n, t);
        }
        function iu(e, t) {
          var i;
          if (typeof t != "function")
            throw new qe(d);
          return e = q(e), function() {
            return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = n), i;
          };
        }
        var mi = Z(function(e, t, i) {
          var s = Ce;
          if (i.length) {
            var l = xo(i, dt(mi));
            s |= ro;
          }
          return _o(e, s, t, i, l);
        }), au = Z(function(e, t, i) {
          var s = Ce | No;
          if (i.length) {
            var l = xo(i, dt(au));
            s |= ro;
          }
          return _o(t, s, e, i, l);
        });
        function su(e, t, i) {
          t = i ? n : t;
          var s = _o(e, oe, n, n, n, n, n, t);
          return s.placeholder = su.placeholder, s;
        }
        function uu(e, t, i) {
          t = i ? n : t;
          var s = _o(e, he, n, n, n, n, n, t);
          return s.placeholder = uu.placeholder, s;
        }
        function lu(e, t, i) {
          var s, l, p, m, h, A, M = 0, F = !1, I = !1, x = !0;
          if (typeof e != "function")
            throw new qe(d);
          t = He(t) || 0, ne(i) && (F = !!i.leading, I = "maxWait" in i, p = I ? fe(He(i.maxWait) || 0, t) : p, x = "trailing" in i ? !!i.trailing : x);
          function E(le) {
            var eo = s, Mo = l;
            return s = l = n, M = le, m = e.apply(Mo, eo), m;
          }
          function R(le) {
            return M = le, h = Zt($, t), F ? E(le) : m;
          }
          function U(le) {
            var eo = le - A, Mo = le - M, wu = t - eo;
            return I ? ye(wu, p - Mo) : wu;
          }
          function L(le) {
            var eo = le - A, Mo = le - M;
            return A === n || eo >= t || eo < 0 || I && Mo >= p;
          }
          function $() {
            var le = Or();
            if (L(le))
              return H(le);
            h = Zt($, U(le));
          }
          function H(le) {
            return h = n, x && s ? E(le) : (s = l = n, m);
          }
          function ze() {
            h !== n && gs(h), M = 0, s = A = l = h = n;
          }
          function Fe() {
            return h === n ? m : H(Or());
          }
          function Oe() {
            var le = Or(), eo = L(le);
            if (s = arguments, l = this, A = le, eo) {
              if (h === n)
                return R(A);
              if (I)
                return gs(h), h = Zt($, t), E(A);
            }
            return h === n && (h = Zt($, t)), m;
          }
          return Oe.cancel = ze, Oe.flush = Fe, Oe;
        }
        var _h = Z(function(e, t) {
          return Xa(e, 1, t);
        }), Ah = Z(function(e, t, i) {
          return Xa(e, He(t) || 0, i);
        });
        function gh(e) {
          return _o(e, nn);
        }
        function Gr(e, t) {
          if (typeof e != "function" || t != null && typeof t != "function")
            throw new qe(d);
          var i = function() {
            var s = arguments, l = t ? t.apply(this, s) : s[0], p = i.cache;
            if (p.has(l))
              return p.get(l);
            var m = e.apply(this, s);
            return i.cache = p.set(l, m) || p, m;
          };
          return i.cache = new (Gr.Cache || bo)(), i;
        }
        Gr.Cache = bo;
        function qr(e) {
          if (typeof e != "function")
            throw new qe(d);
          return function() {
            var t = arguments;
            switch (t.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, t[0]);
              case 2:
                return !e.call(this, t[0], t[1]);
              case 3:
                return !e.call(this, t[0], t[1], t[2]);
            }
            return !e.apply(this, t);
          };
        }
        function yh(e) {
          return iu(2, e);
        }
        var Th = sf(function(e, t) {
          t = t.length == 1 && G(t[0]) ? te(t[0], Be(B())) : te(_e(t, 1), Be(B()));
          var i = t.length;
          return Z(function(s) {
            for (var l = -1, p = ye(s.length, i); ++l < p; )
              s[l] = t[l].call(this, s[l]);
            return De(e, this, s);
          });
        }), hi = Z(function(e, t) {
          var i = xo(t, dt(hi));
          return _o(e, ro, n, t, i);
        }), cu = Z(function(e, t) {
          var i = xo(t, dt(cu));
          return _o(e, Ro, n, t, i);
        }), Mh = Ao(function(e, t) {
          return _o(e, Mt, n, n, n, t);
        });
        function Nh(e, t) {
          if (typeof e != "function")
            throw new qe(d);
          return t = t === n ? t : q(t), Z(e, t);
        }
        function Fh(e, t) {
          if (typeof e != "function")
            throw new qe(d);
          return t = t == null ? 0 : fe(q(t), 0), Z(function(i) {
            var s = i[t], l = ko(i, 0, t);
            return s && So(l, s), De(e, this, l);
          });
        }
        function Ih(e, t, i) {
          var s = !0, l = !0;
          if (typeof e != "function")
            throw new qe(d);
          return ne(i) && (s = "leading" in i ? !!i.leading : s, l = "trailing" in i ? !!i.trailing : l), lu(e, t, {
            leading: s,
            maxWait: t,
            trailing: l
          });
        }
        function Sh(e) {
          return nu(e, 1);
        }
        function xh(e, t) {
          return hi(Qn(t), e);
        }
        function vh() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return G(e) ? e : [e];
        }
        function wh(e) {
          return Ze(e, ae);
        }
        function Eh(e, t) {
          return t = typeof t == "function" ? t : n, Ze(e, ae, t);
        }
        function Ch(e) {
          return Ze(e, k | ae);
        }
        function kh(e, t) {
          return t = typeof t == "function" ? t : n, Ze(e, k | ae, t);
        }
        function Dh(e, t) {
          return t == null || Ya(e, t, me(t));
        }
        function Qe(e, t) {
          return e === t || e !== e && t !== t;
        }
        var Lh = Dr(qn), Bh = Dr(function(e, t) {
          return e >= t;
        }), Ho = rs(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? rs : function(e) {
          return se(e) && V.call(e, "callee") && !Za.call(e, "callee");
        }, G = g.isArray, Rh = Fa ? Be(Fa) : Zp;
        function xe(e) {
          return e != null && Ur(e.length) && !yo(e);
        }
        function ue(e) {
          return se(e) && xe(e);
        }
        function Ph(e) {
          return e === !0 || e === !1 || se(e) && Me(e) == Nt;
        }
        var Do = Jd || xi, zh = Ia ? Be(Ia) : $p;
        function Oh(e) {
          return se(e) && e.nodeType === 1 && !$t(e);
        }
        function Gh(e) {
          if (e == null)
            return !0;
          if (xe(e) && (G(e) || typeof e == "string" || typeof e.splice == "function" || Do(e) || pt(e) || Ho(e)))
            return !e.length;
          var t = Te(e);
          if (t == Ve || t == je)
            return !e.size;
          if (Ut(e))
            return !$n(e).length;
          for (var i in e)
            if (V.call(e, i))
              return !1;
          return !0;
        }
        function qh(e, t) {
          return Ot(e, t);
        }
        function Uh(e, t, i) {
          i = typeof i == "function" ? i : n;
          var s = i ? i(e, t) : n;
          return s === n ? Ot(e, t, n, i) : !!s;
        }
        function bi(e) {
          if (!se(e))
            return !1;
          var t = Me(e);
          return t == er || t == dc || typeof e.message == "string" && typeof e.name == "string" && !$t(e);
        }
        function Zh(e) {
          return typeof e == "number" && Ka(e);
        }
        function yo(e) {
          if (!ne(e))
            return !1;
          var t = Me(e);
          return t == or || t == Yi || t == cc || t == fc;
        }
        function du(e) {
          return typeof e == "number" && e == q(e);
        }
        function Ur(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Fo;
        }
        function ne(e) {
          var t = typeof e;
          return e != null && (t == "object" || t == "function");
        }
        function se(e) {
          return e != null && typeof e == "object";
        }
        var pu = Sa ? Be(Sa) : Hp;
        function $h(e, t) {
          return e === t || Zn(e, t, ai(t));
        }
        function Kh(e, t, i) {
          return i = typeof i == "function" ? i : n, Zn(e, t, ai(t), i);
        }
        function Hh(e) {
          return fu(e) && e != +e;
        }
        function Wh(e) {
          if (Ef(e))
            throw new z(f);
          return ns(e);
        }
        function Vh(e) {
          return e === null;
        }
        function jh(e) {
          return e == null;
        }
        function fu(e) {
          return typeof e == "number" || se(e) && Me(e) == It;
        }
        function $t(e) {
          if (!se(e) || Me(e) != mo)
            return !1;
          var t = hr(e);
          if (t === null)
            return !0;
          var i = V.call(t, "constructor") && t.constructor;
          return typeof i == "function" && i instanceof i && dr.call(i) == $d;
        }
        var _i = xa ? Be(xa) : Wp;
        function Jh(e) {
          return du(e) && e >= -Fo && e <= Fo;
        }
        var mu = va ? Be(va) : Vp;
        function Zr(e) {
          return typeof e == "string" || !G(e) && se(e) && Me(e) == xt;
        }
        function Pe(e) {
          return typeof e == "symbol" || se(e) && Me(e) == tr;
        }
        var pt = wa ? Be(wa) : jp;
        function Yh(e) {
          return e === n;
        }
        function Xh(e) {
          return se(e) && Te(e) == vt;
        }
        function Qh(e) {
          return se(e) && Me(e) == hc;
        }
        var eb = Dr(Kn), ob = Dr(function(e, t) {
          return e <= t;
        });
        function hu(e) {
          if (!e)
            return [];
          if (xe(e))
            return Zr(e) ? Je(e) : Se(e);
          if (Ct && e[Ct])
            return kd(e[Ct]());
          var t = Te(e), i = t == Ve ? kn : t == je ? ur : ft;
          return i(e);
        }
        function To(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = He(e), e === Po || e === -Po) {
            var t = e < 0 ? -1 : 1;
            return t * ac;
          }
          return e === e ? e : 0;
        }
        function q(e) {
          var t = To(e), i = t % 1;
          return t === t ? i ? t - i : t : 0;
        }
        function bu(e) {
          return e ? Uo(q(e), 0, no) : 0;
        }
        function He(e) {
          if (typeof e == "number")
            return e;
          if (Pe(e))
            return Xt;
          if (ne(e)) {
            var t = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = ne(t) ? t + "" : t;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = Ba(e);
          var i = Bc.test(e);
          return i || Pc.test(e) ? hd(e.slice(2), i ? 2 : 8) : Lc.test(e) ? Xt : +e;
        }
        function _u(e) {
          return so(e, ve(e));
        }
        function tb(e) {
          return e ? Uo(q(e), -Fo, Fo) : e === 0 ? e : 0;
        }
        function j(e) {
          return e == null ? "" : Re(e);
        }
        var rb = lt(function(e, t) {
          if (Ut(t) || xe(t)) {
            so(t, me(t), e);
            return;
          }
          for (var i in t)
            V.call(t, i) && Rt(e, i, t[i]);
        }), Au = lt(function(e, t) {
          so(t, ve(t), e);
        }), gu = lt(function(e, t, i, s) {
          so(t, ve(t), e, s);
        }), Ai = lt(function(e, t, i, s) {
          so(t, me(t), e, s);
        }), nb = Ao(zn);
        function ib(e, t) {
          var i = ut(e);
          return t == null ? i : Ja(i, t);
        }
        var ab = Z(function(e, t) {
          e = Y(e);
          var i = -1, s = t.length, l = s > 2 ? t[2] : n;
          for (l && Ne(t[0], t[1], l) && (s = 1); ++i < s; )
            for (var p = t[i], m = ve(p), h = -1, A = m.length; ++h < A; ) {
              var M = m[h], F = e[M];
              (F === n || Qe(F, it[M]) && !V.call(e, M)) && (e[M] = p[M]);
            }
          return e;
        }), sb = Z(function(e) {
          return e.push(n, Bs), De(yu, n, e);
        });
        function ub(e, t) {
          return Ca(e, B(t, 3), ao);
        }
        function lb(e, t) {
          return Ca(e, B(t, 3), Gn);
        }
        function cb(e, t) {
          return e == null ? e : On(e, B(t, 3), ve);
        }
        function db(e, t) {
          return e == null ? e : os(e, B(t, 3), ve);
        }
        function pb(e, t) {
          return e && ao(e, B(t, 3));
        }
        function fb(e, t) {
          return e && Gn(e, B(t, 3));
        }
        function mb(e) {
          return e == null ? [] : Ir(e, me(e));
        }
        function hb(e) {
          return e == null ? [] : Ir(e, ve(e));
        }
        function gi(e, t, i) {
          var s = e == null ? n : Zo(e, t);
          return s === n ? i : s;
        }
        function bb(e, t) {
          return e != null && zs(e, t, Op);
        }
        function yi(e, t) {
          return e != null && zs(e, t, Gp);
        }
        var _b = Es(function(e, t, i) {
          t != null && typeof t.toString != "function" && (t = pr.call(t)), e[t] = i;
        }, Mi(we)), Ab = Es(function(e, t, i) {
          t != null && typeof t.toString != "function" && (t = pr.call(t)), V.call(e, t) ? e[t].push(i) : e[t] = [i];
        }, B), gb = Z(zt);
        function me(e) {
          return xe(e) ? Va(e) : $n(e);
        }
        function ve(e) {
          return xe(e) ? Va(e, !0) : Jp(e);
        }
        function yb(e, t) {
          var i = {};
          return t = B(t, 3), ao(e, function(s, l, p) {
            io(i, t(s, l, p), s);
          }), i;
        }
        function Tb(e, t) {
          var i = {};
          return t = B(t, 3), ao(e, function(s, l, p) {
            io(i, l, t(s, l, p));
          }), i;
        }
        var Mb = lt(function(e, t, i) {
          Sr(e, t, i);
        }), yu = lt(function(e, t, i, s) {
          Sr(e, t, i, s);
        }), Nb = Ao(function(e, t) {
          var i = {};
          if (e == null)
            return i;
          var s = !1;
          t = te(t, function(p) {
            return p = Co(p, e), s || (s = p.length > 1), p;
          }), so(e, ni(e), i), s && (i = Ze(i, k | P | ae, Af));
          for (var l = t.length; l--; )
            Jn(i, t[l]);
          return i;
        });
        function Fb(e, t) {
          return Tu(e, qr(B(t)));
        }
        var Ib = Ao(function(e, t) {
          return e == null ? {} : Xp(e, t);
        });
        function Tu(e, t) {
          if (e == null)
            return {};
          var i = te(ni(e), function(s) {
            return [s];
          });
          return t = B(t), ds(e, i, function(s, l) {
            return t(s, l[0]);
          });
        }
        function Sb(e, t, i) {
          t = Co(t, e);
          var s = -1, l = t.length;
          for (l || (l = 1, e = n); ++s < l; ) {
            var p = e == null ? n : e[Xe(t[s])];
            p === n && (s = l, p = i), e = yo(p) ? p.call(e) : p;
          }
          return e;
        }
        function xb(e, t, i) {
          return e == null ? e : Gt(e, t, i);
        }
        function vb(e, t, i, s) {
          return s = typeof s == "function" ? s : n, e == null ? e : Gt(e, t, i, s);
        }
        var Mu = Ds(me), Nu = Ds(ve);
        function wb(e, t, i) {
          var s = G(e), l = s || Do(e) || pt(e);
          if (t = B(t, 4), i == null) {
            var p = e && e.constructor;
            l ? i = s ? new p() : [] : ne(e) ? i = yo(p) ? ut(hr(e)) : {} : i = {};
          }
          return (l ? Le : ao)(e, function(m, h, A) {
            return t(i, m, h, A);
          }), i;
        }
        function Eb(e, t) {
          return e == null ? !0 : Jn(e, t);
        }
        function Cb(e, t, i) {
          return e == null ? e : bs(e, t, Qn(i));
        }
        function kb(e, t, i, s) {
          return s = typeof s == "function" ? s : n, e == null ? e : bs(e, t, Qn(i), s);
        }
        function ft(e) {
          return e == null ? [] : Cn(e, me(e));
        }
        function Db(e) {
          return e == null ? [] : Cn(e, ve(e));
        }
        function Lb(e, t, i) {
          return i === n && (i = t, t = n), i !== n && (i = He(i), i = i === i ? i : 0), t !== n && (t = He(t), t = t === t ? t : 0), Uo(He(e), t, i);
        }
        function Bb(e, t, i) {
          return t = To(t), i === n ? (i = t, t = 0) : i = To(i), e = He(e), qp(e, t, i);
        }
        function Rb(e, t, i) {
          if (i && typeof i != "boolean" && Ne(e, t, i) && (t = i = n), i === n && (typeof t == "boolean" ? (i = t, t = n) : typeof e == "boolean" && (i = e, e = n)), e === n && t === n ? (e = 0, t = 1) : (e = To(e), t === n ? (t = e, e = 0) : t = To(t)), e > t) {
            var s = e;
            e = t, t = s;
          }
          if (i || e % 1 || t % 1) {
            var l = Ha();
            return ye(e + l * (t - e + md("1e-" + ((l + "").length - 1))), t);
          }
          return Wn(e, t);
        }
        var Pb = ct(function(e, t, i) {
          return t = t.toLowerCase(), e + (i ? Fu(t) : t);
        });
        function Fu(e) {
          return Ti(j(e).toLowerCase());
        }
        function Iu(e) {
          return e = j(e), e && e.replace(Oc, xd).replace(nd, "");
        }
        function zb(e, t, i) {
          e = j(e), t = Re(t);
          var s = e.length;
          i = i === n ? s : Uo(q(i), 0, s);
          var l = i;
          return i -= t.length, i >= 0 && e.slice(i, l) == t;
        }
        function Ob(e) {
          return e = j(e), e && yc.test(e) ? e.replace(ea, vd) : e;
        }
        function Gb(e) {
          return e = j(e), e && Sc.test(e) ? e.replace(hn, "\\$&") : e;
        }
        var qb = ct(function(e, t, i) {
          return e + (i ? "-" : "") + t.toLowerCase();
        }), Ub = ct(function(e, t, i) {
          return e + (i ? " " : "") + t.toLowerCase();
        }), Zb = xs("toLowerCase");
        function $b(e, t, i) {
          e = j(e), t = q(t);
          var s = t ? rt(e) : 0;
          if (!t || s >= t)
            return e;
          var l = (t - s) / 2;
          return kr(gr(l), i) + e + kr(Ar(l), i);
        }
        function Kb(e, t, i) {
          e = j(e), t = q(t);
          var s = t ? rt(e) : 0;
          return t && s < t ? e + kr(t - s, i) : e;
        }
        function Hb(e, t, i) {
          e = j(e), t = q(t);
          var s = t ? rt(e) : 0;
          return t && s < t ? kr(t - s, i) + e : e;
        }
        function Wb(e, t, i) {
          return i || t == null ? t = 0 : t && (t = +t), ep(j(e).replace(bn, ""), t || 0);
        }
        function Vb(e, t, i) {
          return (i ? Ne(e, t, i) : t === n) ? t = 1 : t = q(t), Vn(j(e), t);
        }
        function jb() {
          var e = arguments, t = j(e[0]);
          return e.length < 3 ? t : t.replace(e[1], e[2]);
        }
        var Jb = ct(function(e, t, i) {
          return e + (i ? "_" : "") + t.toLowerCase();
        });
        function Yb(e, t, i) {
          return i && typeof i != "number" && Ne(e, t, i) && (t = i = n), i = i === n ? no : i >>> 0, i ? (e = j(e), e && (typeof t == "string" || t != null && !_i(t)) && (t = Re(t), !t && tt(e)) ? ko(Je(e), 0, i) : e.split(t, i)) : [];
        }
        var Xb = ct(function(e, t, i) {
          return e + (i ? " " : "") + Ti(t);
        });
        function Qb(e, t, i) {
          return e = j(e), i = i == null ? 0 : Uo(q(i), 0, e.length), t = Re(t), e.slice(i, i + t.length) == t;
        }
        function e_(e, t, i) {
          var s = c.templateSettings;
          i && Ne(e, t, i) && (t = n), e = j(e), t = Ai({}, t, s, Ls);
          var l = Ai({}, t.imports, s.imports, Ls), p = me(l), m = Cn(l, p);
          Le(p, function(L) {
            if (ta.test(L))
              throw new z(T);
          });
          var h, A, M = 0, F = t.interpolate || rr, I = "__p += '", x = Dn(
            (t.escape || rr).source + "|" + F.source + "|" + (F === oa ? Dc : rr).source + "|" + (t.evaluate || rr).source + "|$",
            "g"
          ), E = "//# sourceURL=" + (V.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ld + "]") + `
`;
          e.replace(x, function(L, $, H, ze, Fe, Oe) {
            return H || (H = ze), I += e.slice(M, Oe).replace(Gc, wd), $ && (h = !0, I += `' +
__e(` + $ + `) +
'`), Fe && (A = !0, I += `';
` + Fe + `;
__p += '`), H && (I += `' +
((__t = (` + H + `)) == null ? '' : __t) +
'`), M = Oe + L.length, L;
          }), I += `';
`;
          var R = V.call(t, "variable") && t.variable;
          if (!R)
            I = `with (obj) {
` + I + `
}
`;
          else if (ta.test(R))
            throw new z(b);
          I = (A ? I.replace(bc, "") : I).replace(_c, "$1").replace(Ac, "$1;"), I = "function(" + (R || "obj") + `) {
` + (R ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (h ? ", __e = _.escape" : "") + (A ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + I + `return __p
}`;
          var U = xu(function() {
            return W(p, E + "return " + I).apply(n, m);
          });
          if (U.source = I, bi(U))
            throw U;
          return U;
        }
        function o_(e) {
          return j(e).toLowerCase();
        }
        function t_(e) {
          return j(e).toUpperCase();
        }
        function r_(e, t, i) {
          if (e = j(e), e && (i || t === n))
            return Ba(e);
          if (!e || !(t = Re(t)))
            return e;
          var s = Je(e), l = Je(t), p = Ra(s, l), m = Pa(s, l) + 1;
          return ko(s, p, m).join("");
        }
        function n_(e, t, i) {
          if (e = j(e), e && (i || t === n))
            return e.slice(0, Oa(e) + 1);
          if (!e || !(t = Re(t)))
            return e;
          var s = Je(e), l = Pa(s, Je(t)) + 1;
          return ko(s, 0, l).join("");
        }
        function i_(e, t, i) {
          if (e = j(e), e && (i || t === n))
            return e.replace(bn, "");
          if (!e || !(t = Re(t)))
            return e;
          var s = Je(e), l = Ra(s, Je(t));
          return ko(s, l).join("");
        }
        function a_(e, t) {
          var i = ec, s = oc;
          if (ne(t)) {
            var l = "separator" in t ? t.separator : l;
            i = "length" in t ? q(t.length) : i, s = "omission" in t ? Re(t.omission) : s;
          }
          e = j(e);
          var p = e.length;
          if (tt(e)) {
            var m = Je(e);
            p = m.length;
          }
          if (i >= p)
            return e;
          var h = i - rt(s);
          if (h < 1)
            return s;
          var A = m ? ko(m, 0, h).join("") : e.slice(0, h);
          if (l === n)
            return A + s;
          if (m && (h += A.length - h), _i(l)) {
            if (e.slice(h).search(l)) {
              var M, F = A;
              for (l.global || (l = Dn(l.source, j(ra.exec(l)) + "g")), l.lastIndex = 0; M = l.exec(F); )
                var I = M.index;
              A = A.slice(0, I === n ? h : I);
            }
          } else if (e.indexOf(Re(l), h) != h) {
            var x = A.lastIndexOf(l);
            x > -1 && (A = A.slice(0, x));
          }
          return A + s;
        }
        function s_(e) {
          return e = j(e), e && gc.test(e) ? e.replace(Qi, Rd) : e;
        }
        var u_ = ct(function(e, t, i) {
          return e + (i ? " " : "") + t.toUpperCase();
        }), Ti = xs("toUpperCase");
        function Su(e, t, i) {
          return e = j(e), t = i ? n : t, t === n ? Cd(e) ? Od(e) : Md(e) : e.match(t) || [];
        }
        var xu = Z(function(e, t) {
          try {
            return De(e, n, t);
          } catch (i) {
            return bi(i) ? i : new z(i);
          }
        }), l_ = Ao(function(e, t) {
          return Le(t, function(i) {
            i = Xe(i), io(e, i, mi(e[i], e));
          }), e;
        });
        function c_(e) {
          var t = e == null ? 0 : e.length, i = B();
          return e = t ? te(e, function(s) {
            if (typeof s[1] != "function")
              throw new qe(d);
            return [i(s[0]), s[1]];
          }) : [], Z(function(s) {
            for (var l = -1; ++l < t; ) {
              var p = e[l];
              if (De(p[0], this, s))
                return De(p[1], this, s);
            }
          });
        }
        function d_(e) {
          return Rp(Ze(e, k));
        }
        function Mi(e) {
          return function() {
            return e;
          };
        }
        function p_(e, t) {
          return e == null || e !== e ? t : e;
        }
        var f_ = ws(), m_ = ws(!0);
        function we(e) {
          return e;
        }
        function Ni(e) {
          return is(typeof e == "function" ? e : Ze(e, k));
        }
        function h_(e) {
          return ss(Ze(e, k));
        }
        function b_(e, t) {
          return us(e, Ze(t, k));
        }
        var __ = Z(function(e, t) {
          return function(i) {
            return zt(i, e, t);
          };
        }), A_ = Z(function(e, t) {
          return function(i) {
            return zt(e, i, t);
          };
        });
        function Fi(e, t, i) {
          var s = me(t), l = Ir(t, s);
          i == null && !(ne(t) && (l.length || !s.length)) && (i = t, t = e, e = this, l = Ir(t, me(t)));
          var p = !(ne(i) && "chain" in i) || !!i.chain, m = yo(e);
          return Le(l, function(h) {
            var A = t[h];
            e[h] = A, m && (e.prototype[h] = function() {
              var M = this.__chain__;
              if (p || M) {
                var F = e(this.__wrapped__), I = F.__actions__ = Se(this.__actions__);
                return I.push({ func: A, args: arguments, thisArg: e }), F.__chain__ = M, F;
              }
              return A.apply(e, So([this.value()], arguments));
            });
          }), e;
        }
        function g_() {
          return be._ === this && (be._ = Kd), this;
        }
        function Ii() {
        }
        function y_(e) {
          return e = q(e), Z(function(t) {
            return ls(t, e);
          });
        }
        var T_ = oi(te), M_ = oi(Ea), N_ = oi(Sn);
        function vu(e) {
          return ui(e) ? xn(Xe(e)) : Qp(e);
        }
        function F_(e) {
          return function(t) {
            return e == null ? n : Zo(e, t);
          };
        }
        var I_ = Cs(), S_ = Cs(!0);
        function Si() {
          return [];
        }
        function xi() {
          return !1;
        }
        function x_() {
          return {};
        }
        function v_() {
          return "";
        }
        function w_() {
          return !0;
        }
        function E_(e, t) {
          if (e = q(e), e < 1 || e > Fo)
            return [];
          var i = no, s = ye(e, no);
          t = B(t), e -= no;
          for (var l = En(s, t); ++i < e; )
            t(i);
          return l;
        }
        function C_(e) {
          return G(e) ? te(e, Xe) : Pe(e) ? [e] : Se(Ws(j(e)));
        }
        function k_(e) {
          var t = ++Zd;
          return j(e) + t;
        }
        var D_ = Cr(function(e, t) {
          return e + t;
        }, 0), L_ = ti("ceil"), B_ = Cr(function(e, t) {
          return e / t;
        }, 1), R_ = ti("floor");
        function P_(e) {
          return e && e.length ? Fr(e, we, qn) : n;
        }
        function z_(e, t) {
          return e && e.length ? Fr(e, B(t, 2), qn) : n;
        }
        function O_(e) {
          return Da(e, we);
        }
        function G_(e, t) {
          return Da(e, B(t, 2));
        }
        function q_(e) {
          return e && e.length ? Fr(e, we, Kn) : n;
        }
        function U_(e, t) {
          return e && e.length ? Fr(e, B(t, 2), Kn) : n;
        }
        var Z_ = Cr(function(e, t) {
          return e * t;
        }, 1), $_ = ti("round"), K_ = Cr(function(e, t) {
          return e - t;
        }, 0);
        function H_(e) {
          return e && e.length ? wn(e, we) : 0;
        }
        function W_(e, t) {
          return e && e.length ? wn(e, B(t, 2)) : 0;
        }
        return c.after = bh, c.ary = nu, c.assign = rb, c.assignIn = Au, c.assignInWith = gu, c.assignWith = Ai, c.at = nb, c.before = iu, c.bind = mi, c.bindAll = l_, c.bindKey = au, c.castArray = vh, c.chain = ou, c.chunk = Pf, c.compact = zf, c.concat = Of, c.cond = c_, c.conforms = d_, c.constant = Mi, c.countBy = Wm, c.create = ib, c.curry = su, c.curryRight = uu, c.debounce = lu, c.defaults = ab, c.defaultsDeep = sb, c.defer = _h, c.delay = Ah, c.difference = Gf, c.differenceBy = qf, c.differenceWith = Uf, c.drop = Zf, c.dropRight = $f, c.dropRightWhile = Kf, c.dropWhile = Hf, c.fill = Wf, c.filter = jm, c.flatMap = Xm, c.flatMapDeep = Qm, c.flatMapDepth = eh, c.flatten = Ys, c.flattenDeep = Vf, c.flattenDepth = jf, c.flip = gh, c.flow = f_, c.flowRight = m_, c.fromPairs = Jf, c.functions = mb, c.functionsIn = hb, c.groupBy = oh, c.initial = Xf, c.intersection = Qf, c.intersectionBy = em, c.intersectionWith = om, c.invert = _b, c.invertBy = Ab, c.invokeMap = rh, c.iteratee = Ni, c.keyBy = nh, c.keys = me, c.keysIn = ve, c.map = zr, c.mapKeys = yb, c.mapValues = Tb, c.matches = h_, c.matchesProperty = b_, c.memoize = Gr, c.merge = Mb, c.mergeWith = yu, c.method = __, c.methodOf = A_, c.mixin = Fi, c.negate = qr, c.nthArg = y_, c.omit = Nb, c.omitBy = Fb, c.once = yh, c.orderBy = ih, c.over = T_, c.overArgs = Th, c.overEvery = M_, c.overSome = N_, c.partial = hi, c.partialRight = cu, c.partition = ah, c.pick = Ib, c.pickBy = Tu, c.property = vu, c.propertyOf = F_, c.pull = im, c.pullAll = Qs, c.pullAllBy = am, c.pullAllWith = sm, c.pullAt = um, c.range = I_, c.rangeRight = S_, c.rearg = Mh, c.reject = lh, c.remove = lm, c.rest = Nh, c.reverse = pi, c.sampleSize = dh, c.set = xb, c.setWith = vb, c.shuffle = ph, c.slice = cm, c.sortBy = hh, c.sortedUniq = _m, c.sortedUniqBy = Am, c.split = Yb, c.spread = Fh, c.tail = gm, c.take = ym, c.takeRight = Tm, c.takeRightWhile = Mm, c.takeWhile = Nm, c.tap = zm, c.throttle = Ih, c.thru = Pr, c.toArray = hu, c.toPairs = Mu, c.toPairsIn = Nu, c.toPath = C_, c.toPlainObject = _u, c.transform = wb, c.unary = Sh, c.union = Fm, c.unionBy = Im, c.unionWith = Sm, c.uniq = xm, c.uniqBy = vm, c.uniqWith = wm, c.unset = Eb, c.unzip = fi, c.unzipWith = eu, c.update = Cb, c.updateWith = kb, c.values = ft, c.valuesIn = Db, c.without = Em, c.words = Su, c.wrap = xh, c.xor = Cm, c.xorBy = km, c.xorWith = Dm, c.zip = Lm, c.zipObject = Bm, c.zipObjectDeep = Rm, c.zipWith = Pm, c.entries = Mu, c.entriesIn = Nu, c.extend = Au, c.extendWith = gu, Fi(c, c), c.add = D_, c.attempt = xu, c.camelCase = Pb, c.capitalize = Fu, c.ceil = L_, c.clamp = Lb, c.clone = wh, c.cloneDeep = Ch, c.cloneDeepWith = kh, c.cloneWith = Eh, c.conformsTo = Dh, c.deburr = Iu, c.defaultTo = p_, c.divide = B_, c.endsWith = zb, c.eq = Qe, c.escape = Ob, c.escapeRegExp = Gb, c.every = Vm, c.find = Jm, c.findIndex = js, c.findKey = ub, c.findLast = Ym, c.findLastIndex = Js, c.findLastKey = lb, c.floor = R_, c.forEach = tu, c.forEachRight = ru, c.forIn = cb, c.forInRight = db, c.forOwn = pb, c.forOwnRight = fb, c.get = gi, c.gt = Lh, c.gte = Bh, c.has = bb, c.hasIn = yi, c.head = Xs, c.identity = we, c.includes = th, c.indexOf = Yf, c.inRange = Bb, c.invoke = gb, c.isArguments = Ho, c.isArray = G, c.isArrayBuffer = Rh, c.isArrayLike = xe, c.isArrayLikeObject = ue, c.isBoolean = Ph, c.isBuffer = Do, c.isDate = zh, c.isElement = Oh, c.isEmpty = Gh, c.isEqual = qh, c.isEqualWith = Uh, c.isError = bi, c.isFinite = Zh, c.isFunction = yo, c.isInteger = du, c.isLength = Ur, c.isMap = pu, c.isMatch = $h, c.isMatchWith = Kh, c.isNaN = Hh, c.isNative = Wh, c.isNil = jh, c.isNull = Vh, c.isNumber = fu, c.isObject = ne, c.isObjectLike = se, c.isPlainObject = $t, c.isRegExp = _i, c.isSafeInteger = Jh, c.isSet = mu, c.isString = Zr, c.isSymbol = Pe, c.isTypedArray = pt, c.isUndefined = Yh, c.isWeakMap = Xh, c.isWeakSet = Qh, c.join = tm, c.kebabCase = qb, c.last = Ke, c.lastIndexOf = rm, c.lowerCase = Ub, c.lowerFirst = Zb, c.lt = eb, c.lte = ob, c.max = P_, c.maxBy = z_, c.mean = O_, c.meanBy = G_, c.min = q_, c.minBy = U_, c.stubArray = Si, c.stubFalse = xi, c.stubObject = x_, c.stubString = v_, c.stubTrue = w_, c.multiply = Z_, c.nth = nm, c.noConflict = g_, c.noop = Ii, c.now = Or, c.pad = $b, c.padEnd = Kb, c.padStart = Hb, c.parseInt = Wb, c.random = Rb, c.reduce = sh, c.reduceRight = uh, c.repeat = Vb, c.replace = jb, c.result = Sb, c.round = $_, c.runInContext = _, c.sample = ch, c.size = fh, c.snakeCase = Jb, c.some = mh, c.sortedIndex = dm, c.sortedIndexBy = pm, c.sortedIndexOf = fm, c.sortedLastIndex = mm, c.sortedLastIndexBy = hm, c.sortedLastIndexOf = bm, c.startCase = Xb, c.startsWith = Qb, c.subtract = K_, c.sum = H_, c.sumBy = W_, c.template = e_, c.times = E_, c.toFinite = To, c.toInteger = q, c.toLength = bu, c.toLower = o_, c.toNumber = He, c.toSafeInteger = tb, c.toString = j, c.toUpper = t_, c.trim = r_, c.trimEnd = n_, c.trimStart = i_, c.truncate = a_, c.unescape = s_, c.uniqueId = k_, c.upperCase = u_, c.upperFirst = Ti, c.each = tu, c.eachRight = ru, c.first = Xs, Fi(c, (function() {
          var e = {};
          return ao(c, function(t, i) {
            V.call(c.prototype, i) || (e[i] = t);
          }), e;
        })(), { chain: !1 }), c.VERSION = a, Le(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          c[e].placeholder = c;
        }), Le(["drop", "take"], function(e, t) {
          K.prototype[e] = function(i) {
            i = i === n ? 1 : fe(q(i), 0);
            var s = this.__filtered__ && !t ? new K(this) : this.clone();
            return s.__filtered__ ? s.__takeCount__ = ye(i, s.__takeCount__) : s.__views__.push({
              size: ye(i, no),
              type: e + (s.__dir__ < 0 ? "Right" : "")
            }), s;
          }, K.prototype[e + "Right"] = function(i) {
            return this.reverse()[e](i).reverse();
          };
        }), Le(["filter", "map", "takeWhile"], function(e, t) {
          var i = t + 1, s = i == Ji || i == ic;
          K.prototype[e] = function(l) {
            var p = this.clone();
            return p.__iteratees__.push({
              iteratee: B(l, 3),
              type: i
            }), p.__filtered__ = p.__filtered__ || s, p;
          };
        }), Le(["head", "last"], function(e, t) {
          var i = "take" + (t ? "Right" : "");
          K.prototype[e] = function() {
            return this[i](1).value()[0];
          };
        }), Le(["initial", "tail"], function(e, t) {
          var i = "drop" + (t ? "" : "Right");
          K.prototype[e] = function() {
            return this.__filtered__ ? new K(this) : this[i](1);
          };
        }), K.prototype.compact = function() {
          return this.filter(we);
        }, K.prototype.find = function(e) {
          return this.filter(e).head();
        }, K.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, K.prototype.invokeMap = Z(function(e, t) {
          return typeof e == "function" ? new K(this) : this.map(function(i) {
            return zt(i, e, t);
          });
        }), K.prototype.reject = function(e) {
          return this.filter(qr(B(e)));
        }, K.prototype.slice = function(e, t) {
          e = q(e);
          var i = this;
          return i.__filtered__ && (e > 0 || t < 0) ? new K(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), t !== n && (t = q(t), i = t < 0 ? i.dropRight(-t) : i.take(t - e)), i);
        }, K.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, K.prototype.toArray = function() {
          return this.take(no);
        }, ao(K.prototype, function(e, t) {
          var i = /^(?:filter|find|map|reject)|While$/.test(t), s = /^(?:head|last)$/.test(t), l = c[s ? "take" + (t == "last" ? "Right" : "") : t], p = s || /^find/.test(t);
          l && (c.prototype[t] = function() {
            var m = this.__wrapped__, h = s ? [1] : arguments, A = m instanceof K, M = h[0], F = A || G(m), I = function($) {
              var H = l.apply(c, So([$], h));
              return s && x ? H[0] : H;
            };
            F && i && typeof M == "function" && M.length != 1 && (A = F = !1);
            var x = this.__chain__, E = !!this.__actions__.length, R = p && !x, U = A && !E;
            if (!p && F) {
              m = U ? m : new K(this);
              var L = e.apply(m, h);
              return L.__actions__.push({ func: Pr, args: [I], thisArg: n }), new Ue(L, x);
            }
            return R && U ? e.apply(this, h) : (L = this.thru(I), R ? s ? L.value()[0] : L.value() : L);
          });
        }), Le(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var t = lr[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", s = /^(?:pop|shift)$/.test(e);
          c.prototype[e] = function() {
            var l = arguments;
            if (s && !this.__chain__) {
              var p = this.value();
              return t.apply(G(p) ? p : [], l);
            }
            return this[i](function(m) {
              return t.apply(G(m) ? m : [], l);
            });
          };
        }), ao(K.prototype, function(e, t) {
          var i = c[t];
          if (i) {
            var s = i.name + "";
            V.call(st, s) || (st[s] = []), st[s].push({ name: t, func: i });
          }
        }), st[Er(n, No).name] = [{
          name: "wrapper",
          func: n
        }], K.prototype.clone = sp, K.prototype.reverse = up, K.prototype.value = lp, c.prototype.at = Om, c.prototype.chain = Gm, c.prototype.commit = qm, c.prototype.next = Um, c.prototype.plant = $m, c.prototype.reverse = Km, c.prototype.toJSON = c.prototype.valueOf = c.prototype.value = Hm, c.prototype.first = c.prototype.head, Ct && (c.prototype[Ct] = Zm), c;
      }), nt = Gd();
      zo ? ((zo.exports = nt)._ = nt, Mn._ = nt) : be._ = nt;
    }).call(Xy);
  })(Wt, Wt.exports)), Wt.exports;
}
var Vt = Qy();
const vN = (o, r) => {
  const n = Vt.mapValues(o, (u) => u === "" || u === void 0 ? null : u);
  return Vt.omit(n, r);
}, wN = (o, r, n) => {
  const a = n ? Vt.omitBy(n, (u) => u === null) : {};
  Vt.assign(o, r, Vt.pick(a, Object.keys(o)));
}, EN = (o) => {
  const { properties: r } = o, { context: n } = r;
  return {
    addressNumber: n.address?.address_number,
    alternate: n.region?.alternate?.name,
    country: n.country?.name,
    countryCode: n.country?.country_code,
    fullAddress: r.full_address,
    latitude: r.coordinates.latitude,
    longitude: r.coordinates.longitude,
    mapboxId: r.mapbox_id,
    place: n.place?.name,
    postcode: n.postcode?.name,
    region: n.region?.name,
    regionCode: n.region?.region_code_full,
    streetName: n.street?.name
  };
}, CN = (o, r) => {
  if (r == null)
    return null;
  const n = r.trim();
  if (n.length === 0)
    return null;
  const a = Uy[o] ?? [];
  if (a.length === 0)
    return n.toUpperCase();
  const u = n.toLowerCase(), f = a.find((d) => d.code.toLowerCase() === u || d.name.toLowerCase() === u);
  return f ? f.code.toUpperCase() : null;
}, kN = (o, r, n, a = 0) => Array.from({ length: (r - o) / n + 1 }, (u, f) => Number((o + f * n).toFixed(a))), DN = (o) => {
  if (typeof o != "string") return !1;
  const r = o.replace(/-\d{1,2}$/, ""), n = /^\d+$/.test(r), a = /^[a-zA-Z0-9]+$/.test(r), u = r.length;
  return n && u >= 8 && u <= 10 || a && u === 17;
}, LN = (o, r) => {
  if (typeof o != "number" || !Number.isInteger(o)) return !1;
  const n = -(2 ** (r - 1)), a = 2 ** (r - 1) - 1;
  return o >= n && o <= a;
}, eT = [
  { threshold: 0, step: 1 },
  { threshold: 10, step: 5 },
  { threshold: 50, step: 10 },
  { threshold: 100, step: 50 },
  { threshold: 1e3, step: 100 },
  { threshold: 5e3, step: 200 },
  { threshold: 1e4, step: 500 },
  { threshold: 5e4, step: 1e3 }
];
class $l {
  constructor(r) {
    if (!r[0])
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.tiers = [...r].sort((a, u) => a.threshold - u.threshold);
    const n = this.tiers[0];
    if (!n)
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.firstTier = n;
  }
  /** Creates an instance with the default MVP1 tiers (see DEFAULT_SALE_STEP_TIERS). */
  static createDefault() {
    return new $l(eT);
  }
  /**
   * Checks whether an amount falls on the stepped price grid.
   *
   * @example validateAmount(1200) // true  (tier 1000-4999, step 100: (1200-1000) % 100 === 0)
   * @example validateAmount(1250) // false (tier 1000-4999, step 100: (1250-1000) % 100 !== 0)
   */
  validateAmount(r) {
    if (r < 0)
      return !1;
    const n = this.getTierForAmount(r, "up");
    return (r - n.threshold) % n.step === 0;
  }
  /**
   * Rounds an amount down (floor) to the nearest valid step value.
   *
   * @example getStepRoundedAmount(5300) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedAmount(r) {
    return this.getStepRoundedValue(r, Math.floor);
  }
  /**
   * Rounds a reserve price up (ceil) to the nearest valid step value.
   *
   * @example getStepRoundedReservePrice(5100) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedReservePrice(r) {
    return this.getStepRoundedValue(r, Math.ceil);
  }
  /**
   * Computes the Nth stepped amount past baseAmount. Positive deltaSteps moves up,
   * negative moves down. Correctly switches step size when crossing tier boundaries.
   * Throws if baseAmount is not itself a stepped amount, unless allowFreeBaseAmount
   * is set: a free base then counts as one move, landing on the first stepped amount
   * past it before the remaining steps are applied.
   *
   * @example getDeltaStepsAmount(4900, 2)  // 5200 (4900+100=5000, then 5000+200=5200)
   * @example getDeltaStepsAmount(5000, -1) // 4900 (at boundary, uses lower tier step 100)
   * @example getDeltaStepsAmount(9010, 1, { allowFreeBaseAmount: true }) // 9200, not 9400
   */
  getDeltaStepsAmount(r, n, { allowFreeBaseAmount: a = !1 } = {}) {
    if (this.validateAmount(r))
      return this.computeDeltaStepsAmount(r, n);
    if (!a)
      throw new Error(
        "Error in SaleSteppedPrice.getDeltaStepsAmount, base is not a valid amount (pass allowFreeBaseAmount to step from a free one)"
      );
    if (n === 0)
      return r;
    const u = this.getStepRoundedValue(r, n > 0 ? Math.ceil : Math.floor);
    return this.computeDeltaStepsAmount(u, n - Math.sign(n));
  }
  /**
   * Computes a default starting price for an auction given its reserve price.
   * Uses an exponential decay formula (BSD-3693) so the gap between starting
   * and reserve grows fast for cheap items and plateaus at ~25.000 for expensive ones.
   *
   * @example getAuctionStartingPriceDefaultValue(10000)  // 4600
   * @example getAuctionStartingPriceDefaultValue(100000) // 76500
   */
  getAuctionStartingPriceDefaultValue(r) {
    const a = r - 25e3 * (1 - Math.exp(-25e-6 * r));
    return this.getStepRoundedAmount(a);
  }
  /**
   * Returns the minimum negotiation offer for a direct sale: 30% of the price,
   * rounded down to the nearest valid step.
   *
   * @example getDirectSaleMinNegotiationOfferDefaultValue(10000) // 3000
   */
  getDirectSaleMinNegotiationOfferDefaultValue(r) {
    return this.getStepRoundedAmount(r * 0.3);
  }
  /**
   * Computes the suggested (discounted) price for a direct sale.
   * Uses a sigmoid that yields ~76% for low prices, trending toward
   * 100% for very high prices. Result is rounded down to the nearest valid step.
   *
   * @example getDirectSaleSuggestedPriceDefaultValue(5000)   // 4050  (~81%)
   * @example getDirectSaleSuggestedPriceDefaultValue(100000) // 88000 (~89%)
   */
  getDirectSaleSuggestedPriceDefaultValue(r) {
    const u = 0.98 - 0.16999999999999993 * Math.exp(-6e-6 * r);
    return this.getStepRoundedAmount(r * u);
  }
  /**
   * Finds the applicable tier for a given amount.
   * - direction 'up': returns the tier whose threshold is <= amount (used for validation/rounding)
   * - direction 'down': returns the tier whose threshold is < amount (at a boundary, picks the lower tier)
   */
  getTierForAmount(r, n) {
    const a = n === "up" ? (u) => u <= r : (u) => u < r;
    for (let u = this.tiers.length - 1; u >= 0; u--) {
      const f = this.tiers[u];
      if (f && a(f.threshold))
        return f;
    }
    return this.firstTier;
  }
  /** Rounds a value to the nearest valid step using the given rounding function (floor or ceil). */
  getStepRoundedValue(r, n) {
    const a = this.getTierForAmount(r, "up"), u = r - a.threshold;
    return n(u / a.step) * a.step + a.threshold;
  }
  /** Recursive implementation of getDeltaStepsAmount. Moves one step per call, recalculating the tier each time. */
  computeDeltaStepsAmount(r, n) {
    if (n === 0)
      return r;
    const a = n / Math.abs(n), u = n > 0 ? "up" : "down", f = this.getTierForAmount(r, u);
    return this.computeDeltaStepsAmount(r + f.step * a, n - a);
  }
}
const BN = ({
  reservePrice: o,
  isToBeScraped: r,
  isOneEuro: n
}) => {
  const a = r || o < 5e3 ? 50 : o < 1e4 ? 100 : o < 5e4 ? 500 : 1e3, u = r ? 50 : o < 5e3 ? 100 : o < 1e4 ? 500 : (o < 5e4, 1e3), f = r ? 1e3 : o < 5e3 ? 5e3 : o < 1e4 ? 1e4 : 5e4, d = r || n ? 250 : o <= 5e4 ? 500 : 1e3;
  return {
    minStepDefaultValue: a,
    maxStepDefaultValue: u,
    thresholdDefaultValue: f,
    bailDefaultValue: d
  };
};
function At(o) {
  const r = Object.prototype.toString.call(o);
  return o instanceof Date || typeof o == "object" && r === "[object Date]" ? new o.constructor(+o) : typeof o == "number" || r === "[object Number]" || typeof o == "string" || r === "[object String]" ? new Date(o) : /* @__PURE__ */ new Date(NaN);
}
function oT(o, r) {
  const n = At(o), a = At(r);
  return n.getTime() > a.getTime();
}
function tT(o, r) {
  const n = At(o), a = At(r);
  return +n < +a;
}
function Qu(o, r) {
  const n = At(o), a = At(r);
  return +n == +a;
}
function rn(o) {
  throw new Error("Should not have reached this line");
}
var lo = /* @__PURE__ */ ((o) => (o.Seller = "Seller", o.Buyer = "Buyer", o))(lo || {}), co = /* @__PURE__ */ ((o) => (o.FixedPercentage = "FixedPercentage", o.FixedAmount = "FixedAmount", o.Standard = "Standard", o))(co || {});
const rT = /* @__PURE__ */ new Date("2025-11-24"), nT = /* @__PURE__ */ new Date("2025-11-28"), ht = 250, Di = 0.0875, Kl = 0.0375, Hl = 5250, Li = 1e5, Wl = 2500, iT = (o, [r, n]) => (Qu(o, r) || oT(o, r)) && (tT(o, n) || Qu(o, n)), Vl = ({
  feeTarget: o,
  baseAmount: r,
  assetsCount: n,
  feeConfiguration: a
}) => {
  const u = {
    [lo.Seller]: 1,
    [lo.Buyer]: -1
  }[o], f = r / n;
  return (() => {
    if (!a || a.type === co.Standard) {
      const d = Wl - ht * u;
      return (() => {
        if (f <= d) return f + ht * u;
        const T = Li - ht * u - Di * Li * u;
        return f <= T ? (f + ht * u) / (1 - Di * u) : (f + Hl * u) / (1 - Kl * u);
      })() * n;
    }
    if (a.type === co.FixedPercentage)
      return r / (1 - a.feeOverrideValue * u);
    if (a.type === co.FixedAmount)
      return r + a.feeOverrideValue * u;
    rn(a.type);
  })();
}, RN = ({
  feeTarget: o,
  baseAmount: r,
  assetsCount: n,
  referenceDate: a,
  feeConfiguration: u
}) => {
  const f = r / n, d = (() => {
    if (!u || u.type === co.Standard)
      return f <= Wl ? ht * n : f <= Li ? (ht + Di * f) * n : (Hl + Kl * f) * n;
    if (u.type === co.FixedPercentage)
      return r * u.feeOverrideValue;
    if (u.type === co.FixedAmount)
      return u.feeOverrideValue;
    rn(u.type);
  })(), T = o === lo.Buyer && a && iT(a, [rT, nT]) ? d * 0.5 : d;
  return {
    grossTotal: Math.ceil(o === lo.Buyer ? r + d : r),
    grossNet: Math.ceil(o === lo.Buyer ? r : r - d),
    grossFees: Math.ceil(d),
    total: Math.ceil(o === lo.Buyer ? r + T : r),
    net: Math.ceil(o === lo.Buyer ? r : r - T),
    fees: Math.ceil(T)
  };
}, PN = ({
  sellerReservePrice: o,
  assetsCount: r,
  feeConfiguration: n
}) => {
  const a = Math.ceil(
    Vl({
      feeTarget: lo.Seller,
      baseAmount: o,
      assetsCount: r,
      feeConfiguration: n
    })
  );
  return {
    sellerReservePrice: o,
    fees: a - o,
    reservePrice: a
  };
}, zN = ({
  buyerBudget: o,
  assetsCount: r,
  feeConfiguration: n
}) => {
  const a = Math.ceil(
    Vl({
      feeTarget: lo.Buyer,
      baseAmount: o,
      assetsCount: r,
      feeConfiguration: n
    })
  );
  return {
    buyerBudget: o,
    fees: o - a,
    buyerMaxOffer: a
  };
}, ON = ({
  sellerReservePrice: o,
  feeConfiguration: r
}) => {
  const n = (() => {
    if (!r || r.type === co.Standard)
      return o <= 2250 ? 250 : o <= 91e3 ? (o + 250) / 0.9125 : (o + 5250) / 0.9625;
    if (r.type === co.FixedPercentage)
      return o / (1 - r.feeOverrideValue);
    if (r.type === co.FixedAmount)
      return o + r.feeOverrideValue;
    rn(r.type);
  })();
  return Math.ceil(n);
}, GN = ({
  isSeller: o,
  isCustomerService: r,
  isAssignedSalesRep: n
}) => o || r || n, qN = (o, r) => {
  let n = null;
  for (const a of o) {
    const u = r(a);
    (!n || u < n.fees) && (n = { candidate: a, fees: u });
  }
  return n ? n.candidate : null;
}, aT = [
  "MinibusCityIntercity",
  "MinibusTouristic",
  "AutobusNormalFloor2Axle",
  "AutobusNormalFloor3Axle",
  "AutobusLowFloorLowEntry8_12Mt",
  "Autobus18Mt",
  "DoubleDecker"
];
function UN(o) {
  return typeof o == "string" && aT.includes(o);
}
const sT = Ly, uT = By, Wi = 10, lT = Wi - 1, Vi = [
  ...Object.values(sT).map(
    (o) => ({
      name: o.name,
      kind: "image",
      isInternal: o.isInternal ?? !1,
      label: o.label,
      group: o.group,
      positionByType: o.positionByType,
      positionAdminByType: o.positionAdminByType,
      requiredFor: o.requiredFor
    })
  ),
  ...Object.values(uT).map(
    (o) => ({
      name: o.name,
      kind: "video",
      isInternal: o.isInternal,
      label: o.label,
      group: o.group,
      positionByType: o.positionByType,
      positionAdminByType: o.positionAdminByType,
      requiredFor: o.requiredFor
    })
  )
], Yt = new Map(Vi.map((o) => [o.name, o]));
function ZN(o) {
  return [o.name, o.anchor].some((r) => r !== void 0 && Yt.get(r)?.isInternal === !0);
}
function $N(o) {
  return o === "DoubleDecker";
}
function KN(o) {
  const r = Yt.get(o);
  return r ? r.kind === "image" ? "IMAGES_BASE" : o === "video_engine_working" ? "VIDEOS_ENGINE" : o === "video_warranty" ? "VIDEOS_WARRANTY" : "VIDEOS_OTHER" : null;
}
function Wr(o) {
  return Vi.filter((r) => r.positionAdminByType?.[o] !== void 0).sort((r, n) => (r.positionAdminByType?.[o] ?? 0) - (n.positionAdminByType?.[o] ?? 0)).map((r) => ({
    name: r.name,
    kind: r.kind,
    isInternal: r.isInternal,
    label: r.label,
    group: r.group,
    positionInspection: r.positionAdminByType?.[o] ?? 0,
    positionFleequid: r.positionByType?.[o] ?? null
  }));
}
function HN(o) {
  return Number.isInteger(o) && o > 0 && o % Wi !== 0;
}
function cT(o) {
  return o.anchor === void 0 ? null : { anchor: o.anchor, offset: o.position % Wi };
}
function WN({
  anchorPositionInspection: o,
  siblingOffsets: r,
  takenPositions: n
}) {
  const a = new Set(r), u = new Set(n);
  for (let f = 1; f <= lT; f++) {
    const d = o + f;
    if (!a.has(f) && !u.has(d))
      return d;
  }
  return null;
}
function VN(o, r) {
  const n = cT(r), a = n === null ? void 0 : Yt.get(n.anchor);
  if (n === null || !a || a.isInternal)
    return null;
  const u = a.positionByType?.[o];
  return u === void 0 ? null : u + n.offset;
}
function jN(o) {
  return Vi.filter((r) => !r.isInternal && r.positionByType?.[o] !== void 0).sort((r, n) => (r.positionByType?.[o] ?? 0) - (n.positionByType?.[o] ?? 0)).map((r) => r.name);
}
function JN(o, r) {
  const n = Yt.get(r);
  return !n || n.isInternal ? null : n.positionByType?.[o] ?? null;
}
const dT = [
  {
    applies: (o) => o.enginePresent === !1,
    media: [
      "video_engine_working",
      "photo_engine_below_without_protection",
      "photo_any_devices_onboard_3",
      "photo_dashboard_on_for_number_km_and_lights_on"
    ]
  },
  { applies: (o) => o.gearboxPresent === !1, media: ["photo_gearbox"] },
  { applies: (o) => o.spareWheel === !1, media: ["spare_wheel"] },
  { applies: (o) => o.tachograph === "Absent", media: ["photo_tachograph"] },
  { applies: (o) => o.wheelchairPlaces === 0, media: ["photo_disabled_area"] },
  { applies: (o) => o.hatBox === !1, media: ["photo_overhead_compartments"] },
  // The licence plate: a vehicle still to be registered has none.
  { applies: Bi, media: ["photo_plate_vehicle"] }
];
function pT(o) {
  const { trustReportType: r } = o;
  if (r === null || o.toBeScraped === !0)
    return [];
  const n = new Set(dT.filter((a) => a.applies(o)).flatMap((a) => a.media));
  return Wr(r).filter(
    (a) => Yt.get(a.name)?.requiredFor?.includes(r) === !0 && !n.has(a.name)
  );
}
function YN(o, r) {
  return pT(o).filter((n) => !r.has(n.name));
}
function XN({
  from: o,
  to: r,
  held: n
}) {
  const a = new Set(Wr(o).map((b) => b.name)), u = new Set(Wr(r).map((b) => b.name)), f = { kept: [], dropped: [], missing: [], keptExtras: [], droppedExtras: [], untouched: [] };
  for (const { name: b, anchor: T } of n)
    a.has(b) || u.has(b) ? (u.has(b) ? f.kept : f.dropped).push(b) : T === void 0 ? f.untouched.push(b) : (u.has(T) ? f.keptExtras : f.droppedExtras).push(b);
  const d = new Set(n.map(({ name: b }) => b));
  for (const b of Wr(r))
    d.has(b.name) || f.missing.push(b.name);
  return f;
}
var fT = /* @__PURE__ */ ((o) => (o.VEHICLE_TOO_OLD = "VEHICLE_TOO_OLD", o.ELECTRIC_OR_HYBRID = "ELECTRIC_OR_HYBRID", o.MILEAGE_OR_MAINTENANCE_EXCEEDED = "MILEAGE_OR_MAINTENANCE_EXCEEDED", o.NOT_SUPPORTED_VEHICLE_CLASS = "NOT_SUPPORTED_VEHICLE_CLASS", o.MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA", o))(fT || {});
const QN = {
  FleequidCare: {
    coverageCap: 1e4,
    warrantyDurationMonths: 3,
    creditPercentageGuidelines: [
      { maxAmount: 3e3, minCreditPercentage: 50 },
      { maxAmount: 5e3, minCreditPercentage: 45 },
      { maxAmount: 7e3, minCreditPercentage: 40 },
      { maxAmount: 9e3, minCreditPercentage: 35 },
      { maxAmount: 1e4, minCreditPercentage: 30 }
    ]
  },
  PowertrainWarranty: {
    coverageCap: 25e3,
    mileageLimits: [
      { durationMonths: 3, maxKm: 15e3 },
      { durationMonths: 6, maxKm: 3e4 },
      { durationMonths: 9, maxKm: 45e3 },
      { durationMonths: 12, maxKm: 6e4 }
    ],
    creditPercentageGuidelines: [
      { maxAmount: 1e4, minCreditPercentage: 30 },
      { maxAmount: 15e3, minCreditPercentage: 25 },
      { maxAmount: 2e4, minCreditPercentage: 20 },
      { maxAmount: 25e3, minCreditPercentage: 10 }
    ]
  }
}, eF = ["ListingBase", "ListingClass", "ListingBrand", "ListingBrandModel", "SaleDetail"], oF = ["title", "description"], tF = ["className", "brandName", "modelName", "type", "brand", "model", "year", "km"], jl = {
  ListingBase: { allowed: [], required: { title: [], description: [] } },
  // Without the placeholder of its level, every page of that level has the same title.
  ListingClass: { allowed: ["className"], required: { title: ["className"], description: [] } },
  ListingBrand: { allowed: ["brandName"], required: { title: ["brandName"], description: [] } },
  ListingBrandModel: { allowed: ["brandName", "modelName"], required: { title: ["brandName", "modelName"], description: [] } },
  // Whole fleets share type, brand, model and year: the mileage is what tells two vehicle pages apart, in both fields.
  SaleDetail: { allowed: ["type", "brand", "model", "year", "km"], required: { title: ["brand", "model", "km"], description: ["km"] } }
}, mT = 120, hT = 320, rF = 60, nF = 160, Jl = "Fleequid", bT = {
  slp: {
    Auction: {
      base: {
        title: "Autobusy na prodej v aukci online",
        description: "Autobusy v aukci na Fleequid: každé vozidlo s inspekcí TrustReport, bezpečné platby a doprava po Evropě. Podejte svou nabídku online."
      },
      class: {
        title: "{className} v aukci",
        description: "{className} v aukci na Fleequid: inspekce TrustReport, bezpečné platby a doprava. Podejte svou nabídku."
      },
      brand: {
        title: "Autobusy {brandName} v aukci",
        description: "Autobusy {brandName} v aukci na Fleequid: inspekce TrustReport, bezpečné platby a doprava. Podejte svou nabídku."
      },
      brandModel: {
        title: "{brandName} {modelName} v aukci",
        description: "Autobusy {brandName} {modelName} v aukci na Fleequid: inspekce TrustReport, bezpečné platby a doprava. Podejte nabídku."
      }
    },
    DirectSale: {
      base: {
        title: "Autobusy na prodej, Koupit ihned",
        description: "Autobusy na prodej na Fleequid: kupte ihned nebo nabídněte cenu. Pouze prověřená vozidla, bezpečné platby a plná podpora."
      },
      class: {
        title: "{className} na prodej",
        description: "{className} na prodej na Fleequid: kupte ihned nebo nabídněte cenu. Pouze prověřená vozidla, bezpečné platby."
      },
      brand: {
        title: "Autobusy {brandName} na prodej",
        description: "Autobusy {brandName} na prodej na Fleequid: kupte ihned nebo nabídněte cenu. Pouze prověřená vozidla, bezpečné platby."
      },
      brandModel: {
        title: "{brandName} {modelName} na prodej",
        description: "Autobusy {brandName} {modelName} na prodej na Fleequid: kupte ihned nebo nabídněte cenu. Pouze prověřená vozidla."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} {year} {km} v aukci",
      description: "{brand} {model} {year} {km}, v aukci na Fleequid s inspekcí TrustReport, bezpečnými platbami a dopravou. Podejte svou nabídku."
    },
    DirectSale: {
      title: "{type}{brand} {model} {year} {km} na prodej",
      description: "Ojetý {brand} {model} {year} {km}, kupte ihned nebo nabídněte cenu. Na Fleequid pouze zaručená a prověřená vozidla."
    }
  }
}, _T = {
  slp: {
    Auction: {
      base: {
        title: "Gebrauchte Busse in der Auktion",
        description: "Gebrauchte Busse in der Auktion bei Fleequid: jedes Fahrzeug mit TrustReport, sichere Zahlung und europaweite Lieferung. Jetzt bieten."
      },
      class: {
        title: "{className} in der Auktion",
        description: "Gebrauchte {className} in der Auktion bei Fleequid: TrustReport, sichere Zahlung und Lieferung europaweit. Jetzt bieten."
      },
      brand: {
        title: "{brandName} Busse in der Auktion",
        description: "Gebrauchte {brandName} Busse in der Auktion bei Fleequid: TrustReport, sichere Zahlung und Lieferung europaweit. Jetzt bieten."
      },
      brandModel: {
        title: "{brandName} {modelName} gebraucht in der Auktion",
        description: "Gebrauchte {brandName} {modelName} in der Auktion bei Fleequid: TrustReport, sichere Zahlung und Lieferung. Jetzt bieten."
      }
    },
    DirectSale: {
      base: {
        title: "Gebrauchte Busse kaufen, Sofortkauf",
        description: "Gebrauchte Busse bei Fleequid: sofort kaufen oder Preis vorschlagen. Nur geprüfte Fahrzeuge, sichere Zahlung und volle Unterstützung."
      },
      class: {
        title: "Gebrauchte {className} kaufen",
        description: "Gebrauchte {className} bei Fleequid: sofort kaufen oder Preis vorschlagen. Nur geprüfte Fahrzeuge, sichere Zahlung."
      },
      brand: {
        title: "Gebrauchte {brandName} Busse kaufen",
        description: "Gebrauchte {brandName} Busse bei Fleequid: sofort kaufen oder Preis vorschlagen. Nur geprüfte Fahrzeuge, sichere Zahlung."
      },
      brandModel: {
        title: "{brandName} {modelName} gebraucht kaufen",
        description: "Gebrauchte {brandName} {modelName} bei Fleequid: sofort kaufen oder Preis vorschlagen. Nur geprüfte Fahrzeuge, sichere Zahlung."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} gebraucht {year} {km} in der Auktion",
      description: "{brand} {model} {year} {km} gebraucht, in der Auktion bei Fleequid mit TrustReport, sicherer Zahlung und Lieferung. Jetzt bieten."
    },
    DirectSale: {
      title: "{type}{brand} {model} gebraucht {year} {km} kaufen",
      description: "{brand} {model} {year} {km} gebraucht, sofort kaufen oder Preis vorschlagen. Bei Fleequid nur geprüfte und garantierte Fahrzeuge."
    }
  }
}, AT = {
  slp: {
    Auction: {
      base: {
        title: "Used Buses & Coaches at Auction",
        description: "Used buses and coaches at auction on Fleequid: each vehicle has a TrustReport inspection, secure payments and delivery. Place your bid."
      },
      class: {
        title: "Used {className} at auction",
        description: "Used {className} at auction on Fleequid: TrustReport inspection, secure payments and delivery. Place your bid."
      },
      brand: {
        title: "Used {brandName} buses at auction",
        description: "Used {brandName} buses at auction on Fleequid: TrustReport inspection, secure payments and delivery. Place your bid."
      },
      brandModel: {
        title: "Used {brandName} {modelName} at auction",
        description: "Used {brandName} {modelName} buses at auction on Fleequid: TrustReport inspection, secure payments and delivery. Place your bid."
      }
    },
    DirectSale: {
      base: {
        title: "Used Buses & Coaches for Sale, Buy Now",
        description: "Used buses and coaches for sale on Fleequid: buy now or make your price offer. Only inspected vehicles, secure payments and full support."
      },
      class: {
        title: "Used {className} for sale",
        description: "Used {className} for sale on Fleequid: buy now or make your price offer. Only inspected vehicles, secure payments."
      },
      brand: {
        title: "Used {brandName} buses for sale",
        description: "Used {brandName} buses for sale on Fleequid: buy now or make your price offer. Only inspected vehicles, secure payments."
      },
      brandModel: {
        title: "Used {brandName} {modelName} for sale",
        description: "Used {brandName} {modelName} buses for sale on Fleequid: buy now or make your price offer. Only inspected vehicles, secure payments."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} used {year} {km} at auction",
      description: "Used {brand} {model} {year} {km}, at auction on Fleequid with TrustReport inspection, secure payments and delivery. Place your bid."
    },
    DirectSale: {
      title: "{type}{brand} {model} used {year} {km} for sale",
      description: "Used {brand} {model} {year} {km}, buy now or make your price offer. On Fleequid only guaranteed and inspected vehicles."
    }
  }
}, gT = {
  slp: {
    Auction: {
      base: {
        title: "Autobuses de segunda mano en subasta",
        description: "Autobuses de segunda mano y autocares en subasta en Fleequid: TrustReport, pagos garantizados y entrega en Europa. Haz tu puja online."
      },
      class: {
        title: "{className} de segunda mano en subasta",
        description: "{className} de segunda mano en subasta en Fleequid: inspección TrustReport, pagos garantizados y entrega. Haz tu puja."
      },
      brand: {
        title: "Autobuses {brandName} de segunda mano en subasta",
        description: "Autobuses {brandName} de segunda mano en subasta en Fleequid: inspección TrustReport, pagos garantizados y entrega. Haz tu puja."
      },
      brandModel: {
        title: "{brandName} {modelName} de segunda mano en subasta",
        description: "Autobuses {brandName} {modelName} de segunda mano en subasta en Fleequid: TrustReport, pagos garantizados y entrega. Haz tu puja."
      }
    },
    DirectSale: {
      base: {
        title: "Autobuses de segunda mano, Compra Ya",
        description: "Autobuses de segunda mano en Fleequid: compra ya o haz tu oferta de precio. Solo vehículos inspeccionados, pagos seguros y soporte completo."
      },
      class: {
        title: "{className} de segunda mano",
        description: "{className} de segunda mano en Fleequid: compra ya o haz tu oferta. Solo vehículos inspeccionados, pagos seguros."
      },
      brand: {
        title: "Autobuses {brandName} de segunda mano",
        description: "Autobuses {brandName} de segunda mano en Fleequid: compra ya o haz tu oferta. Solo vehículos inspeccionados, pagos seguros."
      },
      brandModel: {
        title: "{brandName} {modelName} de segunda mano",
        description: "Autobuses {brandName} {modelName} de segunda mano en Fleequid: compra ya o haz tu oferta. Solo vehículos inspeccionados, pagos seguros."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} de segunda mano {year} {km} en subasta",
      description: "{brand} {model} {year} {km} de segunda mano, en subasta en Fleequid con inspección TrustReport, pagos garantizados y entrega. Haz tu puja."
    },
    DirectSale: {
      title: "{type}{brand} {model} de segunda mano {year} {km}",
      description: "{brand} {model} {year} {km} de segunda mano, compra ya o haz tu oferta de precio. En Fleequid solo vehículos garantizados e inspeccionados."
    }
  }
}, yT = {
  slp: {
    Auction: {
      base: {
        title: "Autocars et bus d'occasion aux enchères",
        description: "Autocars et bus d'occasion aux enchères sur Fleequid : chaque véhicule avec TrustReport, paiement sécurisé et livraison. Enchérissez."
      },
      class: {
        title: "{className} d'occasion aux enchères",
        description: "{className} d'occasion aux enchères sur Fleequid : inspection TrustReport, paiement sécurisé et livraison. Enchérissez."
      },
      brand: {
        title: "{brandName} d'occasion aux enchères",
        description: "Autocars et bus {brandName} d'occasion aux enchères sur Fleequid : TrustReport, paiement sécurisé et livraison. Enchérissez."
      },
      brandModel: {
        title: "{brandName} {modelName} d'occasion aux enchères",
        description: "{brandName} {modelName} d'occasion aux enchères sur Fleequid : inspection TrustReport, paiement sécurisé et livraison. Enchérissez."
      }
    },
    DirectSale: {
      base: {
        title: "Autocars et bus d'occasion, Achat direct",
        description: "Autocars et bus d'occasion sur Fleequid : achat immédiat ou faites votre offre de prix. Véhicules inspectés, paiement sûr et accompagnement complet."
      },
      class: {
        title: "{className} d'occasion à vendre",
        description: "{className} d'occasion sur Fleequid : achat immédiat ou faites votre offre. Véhicules inspectés, paiement sûr."
      },
      brand: {
        title: "{brandName} d'occasion à vendre",
        description: "Autocars et bus {brandName} d'occasion sur Fleequid : achat immédiat ou faites votre offre. Véhicules inspectés, paiement sûr."
      },
      brandModel: {
        title: "{brandName} {modelName} d'occasion à vendre",
        description: "{brandName} {modelName} d'occasion sur Fleequid : achat immédiat ou faites votre offre. Véhicules inspectés, paiement sûr."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} d'occasion {year} {km} aux enchères",
      description: "{brand} {model} {year} {km} d'occasion, aux enchères sur Fleequid avec inspection TrustReport, paiement sécurisé et livraison. Enchérissez."
    },
    DirectSale: {
      title: "{type}{brand} {model} d'occasion {year} {km} à vendre",
      description: "{brand} {model} {year} {km} d'occasion, achat immédiat ou faites votre offre de prix. Sur Fleequid, uniquement des véhicules garantis et inspectés."
    }
  }
}, TT = {
  slp: {
    Auction: {
      base: {
        title: "Autobus usati all'asta",
        description: "Autobus usati all'asta su Fleequid: ogni veicolo con ispezione TrustReport, pagamenti garantiti e consegna in tutta Europa. Fai la tua offerta."
      },
      class: {
        title: "{className} usati all'asta",
        description: "{className} usati all'asta su Fleequid: ispezione TrustReport, pagamenti garantiti e consegna in Europa. Fai la tua offerta."
      },
      brand: {
        title: "Autobus {brandName} usati all'asta",
        description: "Autobus {brandName} usati all'asta su Fleequid: ispezione TrustReport, pagamenti garantiti e consegna in Europa. Fai la tua offerta."
      },
      brandModel: {
        title: "{brandName} {modelName} usati all'asta",
        description: "Autobus {brandName} {modelName} usati all'asta su Fleequid: ispezione TrustReport, pagamenti garantiti e consegna. Fai la tua offerta."
      }
    },
    DirectSale: {
      base: {
        title: "Autobus usati in vendita, Compra Subito",
        description: "Autobus usati in vendita su Fleequid: compra subito o fai la tua offerta di prezzo. Solo veicoli ispezionati, pagamenti sicuri e supporto completo."
      },
      class: {
        title: "{className} usati in vendita",
        description: "{className} usati in vendita su Fleequid: compra subito o fai la tua offerta. Solo veicoli ispezionati, pagamenti sicuri."
      },
      brand: {
        title: "Autobus {brandName} usati in vendita",
        description: "Autobus {brandName} usati in vendita su Fleequid: compra subito o fai la tua offerta. Solo veicoli ispezionati, pagamenti sicuri."
      },
      brandModel: {
        title: "{brandName} {modelName} usati in vendita",
        description: "Autobus {brandName} {modelName} usati in vendita su Fleequid: compra subito o fai la tua offerta. Solo veicoli ispezionati, pagamenti sicuri."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} usato {year} {km} in asta",
      description: "{brand} {model} {year} {km} usato, all'asta su Fleequid con ispezione TrustReport, pagamenti garantiti e consegna in Europa. Fai la tua offerta."
    },
    DirectSale: {
      title: "{type}{brand} {model} usato {year} {km} in vendita",
      description: "{brand} {model} {year} {km} usato, acquista subito o fai la tua offerta di prezzo. Su Fleequid solo veicoli garantiti e ispezionati."
    }
  }
}, MT = {
  slp: {
    Auction: {
      base: {
        title: "Bussen en touringcars in veiling",
        description: "Bussen en touringcars in veiling op Fleequid: elk voertuig met TrustReport-inspectie, veilige betalingen en levering in Europa. Plaats uw bod online."
      },
      class: {
        title: "Tweedehands {className} in veiling",
        description: "Tweedehands {className} in veiling op Fleequid: TrustReport-inspectie, veilig betalen en levering. Plaats uw bod."
      },
      brand: {
        title: "Tweedehands {brandName} bussen in veiling",
        description: "Tweedehands {brandName} bussen in veiling op Fleequid: TrustReport-inspectie, veilig betalen en levering. Plaats uw bod."
      },
      brandModel: {
        title: "{brandName} {modelName} in veiling",
        description: "Tweedehands {brandName} {modelName} in veiling op Fleequid: TrustReport-inspectie, veilig betalen en levering. Plaats uw bod."
      }
    },
    DirectSale: {
      base: {
        title: "Bussen en touringcars te koop, Nu Kopen",
        description: "Bussen en touringcars op Fleequid: nu kopen of doe een prijsvoorstel. Alleen gekeurde voertuigen, veilig betalen en volledige ondersteuning."
      },
      class: {
        title: "Tweedehands {className} te koop",
        description: "Tweedehands {className} op Fleequid: nu kopen of doe een prijsvoorstel. Alleen gekeurde voertuigen, veilig betalen."
      },
      brand: {
        title: "Tweedehands {brandName} bussen te koop",
        description: "Tweedehands {brandName} bussen op Fleequid: nu kopen of doe een prijsvoorstel. Alleen gekeurde voertuigen, veilig betalen."
      },
      brandModel: {
        title: "{brandName} {modelName} te koop",
        description: "Tweedehands {brandName} {modelName} op Fleequid: nu kopen of doe een prijsvoorstel. Alleen gekeurde voertuigen, veilig betalen."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} {year} {km} in veiling",
      description: "{brand} {model} {year} {km}, in veiling op Fleequid met TrustReport-inspectie, veilig betalen en levering in Europa. Plaats uw bod."
    },
    DirectSale: {
      title: "{type}{brand} {model} {year} {km} te koop",
      description: "Tweedehands {brand} {model} {year} {km}, nu kopen of doe een prijsvoorstel. Op Fleequid alleen gegarandeerde en gekeurde voertuigen."
    }
  }
}, NT = {
  slp: {
    Auction: {
      base: {
        title: "Autobusy używane na aukcji online",
        description: "Autobusy używane na aukcji na Fleequid: każdy pojazd z inspekcją TrustReport, bezpieczne płatności i dostawa w Europie. Złóż ofertę online."
      },
      class: {
        title: "{className} używane na aukcji",
        description: "{className} używane na aukcji na Fleequid: inspekcja TrustReport, bezpieczne płatności i dostawa. Złóż ofertę."
      },
      brand: {
        title: "Autobusy {brandName} używane na aukcji",
        description: "Autobusy {brandName} używane na aukcji na Fleequid: inspekcja TrustReport, bezpieczne płatności i dostawa. Złóż ofertę."
      },
      brandModel: {
        title: "{brandName} {modelName} używane na aukcji",
        description: "Autobusy {brandName} {modelName} używane na aukcji na Fleequid: inspekcja TrustReport, bezpieczne płatności i dostawa. Złóż ofertę."
      }
    },
    DirectSale: {
      base: {
        title: "Autobusy na sprzedaż, Kup Teraz",
        description: "Autobusy używane na sprzedaż na Fleequid: kup teraz lub złóż ofertę cenową. Tylko sprawdzone pojazdy, bezpieczne płatności i pełne wsparcie."
      },
      class: {
        title: "{className} na sprzedaż",
        description: "{className} używane na sprzedaż na Fleequid: kup teraz lub złóż ofertę. Tylko sprawdzone pojazdy, bezpieczne płatności."
      },
      brand: {
        title: "Autobusy {brandName} na sprzedaż",
        description: "Autobusy {brandName} używane na sprzedaż na Fleequid: kup teraz lub złóż ofertę. Tylko sprawdzone pojazdy, bezpieczne płatności."
      },
      brandModel: {
        title: "{brandName} {modelName} na sprzedaż",
        description: "Autobusy {brandName} {modelName} używane na sprzedaż na Fleequid: kup teraz lub złóż ofertę. Tylko sprawdzone pojazdy."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} używany {year} {km} na aukcji",
      description: "{brand} {model} {year} {km} używany, na aukcji na Fleequid z inspekcją TrustReport, bezpiecznymi płatnościami i dostawą. Złóż ofertę."
    },
    DirectSale: {
      title: "{type}{brand} {model} używany {year} {km} na sprzedaż",
      description: "{brand} {model} {year} {km} używany, kup teraz lub złóż ofertę cenową. Na Fleequid tylko gwarantowane i sprawdzone pojazdy."
    }
  }
}, FT = {
  slp: {
    Auction: {
      base: {
        title: "Autocarros usados em leilão online",
        description: "Autocarros usados em leilão na Fleequid: cada veículo com inspeção TrustReport, pagamentos seguros e entrega na Europa. Faça a sua oferta."
      },
      class: {
        title: "{className} usados em leilão",
        description: "{className} usados em leilão na Fleequid: inspeção TrustReport, pagamentos seguros e entrega. Faça a sua oferta."
      },
      brand: {
        title: "Autocarros {brandName} usados em leilão",
        description: "Autocarros {brandName} usados em leilão na Fleequid: inspeção TrustReport, pagamentos seguros e entrega. Faça a sua oferta."
      },
      brandModel: {
        title: "{brandName} {modelName} usados em leilão",
        description: "Autocarros {brandName} {modelName} usados em leilão na Fleequid: inspeção TrustReport, pagamentos seguros e entrega. Faça a sua oferta."
      }
    },
    DirectSale: {
      base: {
        title: "Autocarros usados à venda, Compra Já",
        description: "Autocarros usados na Fleequid: compre já ou faça a sua proposta de preço. Só veículos inspecionados, pagamentos seguros e apoio completo."
      },
      class: {
        title: "{className} usados à venda",
        description: "{className} usados na Fleequid: compre já ou faça a sua proposta. Só veículos inspecionados, pagamentos seguros."
      },
      brand: {
        title: "Autocarros {brandName} usados à venda",
        description: "Autocarros {brandName} usados na Fleequid: compre já ou faça a sua proposta. Só veículos inspecionados, pagamentos seguros."
      },
      brandModel: {
        title: "{brandName} {modelName} usados à venda",
        description: "Autocarros {brandName} {modelName} usados na Fleequid: compre já ou faça a sua proposta. Só veículos inspecionados, pagamentos seguros."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} usado {year} {km} em leilão",
      description: "{brand} {model} {year} {km} usado, em leilão na Fleequid com inspeção TrustReport, pagamentos seguros e entrega. Faça a sua oferta."
    },
    DirectSale: {
      title: "{type}{brand} {model} usado {year} {km} à venda",
      description: "{brand} {model} {year} {km} usado, compre já ou faça a sua proposta de preço. Na Fleequid só veículos garantidos e inspecionados."
    }
  }
}, IT = {
  slp: {
    Auction: {
      base: {
        title: "Autobuze și autocare la licitație",
        description: "Autobuze și autocare la licitație pe Fleequid: fiecare vehicul are TrustReport, plăți sigure și livrare în Europa. Licitează acum."
      },
      class: {
        title: "{className} la licitație",
        description: "{className} la licitație pe Fleequid: inspecție TrustReport, plăți sigure și livrare. Licitează acum."
      },
      brand: {
        title: "Autobuze {brandName} la licitație",
        description: "Autobuze și autocare {brandName} la licitație pe Fleequid: inspecție TrustReport, plăți sigure și livrare. Licitează acum."
      },
      brandModel: {
        title: "{brandName} {modelName} la licitație",
        description: "Autobuze {brandName} {modelName} la licitație pe Fleequid: inspecție TrustReport, plăți sigure și livrare. Licitează acum."
      }
    },
    DirectSale: {
      base: {
        title: "Autocare și autobuze de vânzare, Cumpără acum",
        description: "Autocare și autobuze pe Fleequid: cumpără acum sau fă o ofertă de preț. Doar vehicule inspectate, plăți sigure și suport complet."
      },
      class: {
        title: "{className} de vânzare",
        description: "{className} pe Fleequid: cumpără acum sau fă o ofertă. Doar vehicule inspectate, plăți sigure."
      },
      brand: {
        title: "Autobuze {brandName} de vânzare",
        description: "Autobuze și autocare {brandName} pe Fleequid: cumpără acum sau fă o ofertă. Doar vehicule inspectate, plăți sigure."
      },
      brandModel: {
        title: "{brandName} {modelName} de vânzare",
        description: "Autobuze {brandName} {modelName} pe Fleequid: cumpără acum sau fă o ofertă. Doar vehicule inspectate, plăți sigure."
      }
    }
  },
  sdp: {
    Auction: {
      title: "{type}{brand} {model} {year} {km} la licitație",
      description: "{brand} {model} {year} {km}, la licitație pe Fleequid cu inspecție TrustReport, plăți sigure și livrare în Europa. Licitează acum."
    },
    DirectSale: {
      title: "{type}{brand} {model} {year} {km} de vânzare",
      description: "{brand} {model} {year} {km}, cumpără acum sau fă o ofertă de preț. Pe Fleequid doar vehicule garantate și inspectate."
    }
  }
}, ST = {
  slp: {
    Auction: {
      base: {
        title: "Автобусы бу на аукционе онлайн",
        description: "Автобусы бу на аукционе Fleequid: каждое транспортное средство с инспекцией TrustReport, безопасная оплата и доставка по Европе. Сделайте ставку онлайн."
      },
      class: {
        title: "{className} бу на аукционе",
        description: "{className} бу на аукционе Fleequid: инспекция TrustReport, безопасная оплата и доставка. Сделайте ставку."
      },
      brand: {
        title: "Автобусы {brandName} бу на аукционе",
        description: "Автобусы {brandName} бу на аукционе Fleequid: инспекция TrustReport, безопасная оплата и доставка. Сделайте ставку."
      },
      brandModel: {
        title: "{brandName} {modelName} бу на аукционе",
        description: "Автобусы {brandName} {modelName} бу на аукционе Fleequid: инспекция TrustReport, безопасная оплата и доставка. Сделайте ставку."
      }
    },
    DirectSale: {
      base: {
        title: "Купить автобус бу, фиксированная цена",
        description: "Автобусы бу на Fleequid: купите сейчас или предложите свою цену. Только проверенные машины, безопасная оплата и полная поддержка."
      },
      class: {
        title: "{className} бу, фиксированная цена",
        description: "{className} бу на Fleequid: купите сейчас или предложите свою цену. Только проверенные машины, безопасная оплата."
      },
      brand: {
        title: "Купить автобусы {brandName} бу",
        description: "Автобусы {brandName} бу на Fleequid: купите сейчас или предложите свою цену. Только проверенные машины, безопасная оплата."
      },
      brandModel: {
        title: "Купить {brandName} {modelName} бу",
        description: "Автобусы {brandName} {modelName} бу на Fleequid: купите сейчас или предложите цену. Только проверенные машины."
      }
    }
  },
  sdp: {
    Auction: {
      title: "Купить {type}{brand} {model} бу {year} {km}",
      description: "{brand} {model} {year} {km} бу, на аукционе Fleequid с инспекцией TrustReport, безопасной оплатой и доставкой. Сделайте ставку."
    },
    DirectSale: {
      title: "Купить {type}{brand} {model} бу {year} {km}",
      description: "{brand} {model} {year} {km} бу, купите сейчас или предложите свою цену. На Fleequid только проверенные машины с гарантией."
    }
  }
}, xT = {
  cs: bT,
  de: _T,
  en: AT,
  es: gT,
  fr: yT,
  it: TT,
  nl: MT,
  pl: NT,
  pt: FT,
  ro: IT,
  ru: ST
}, vT = {
  ListingBase: "base",
  ListingClass: "class",
  ListingBrand: "brand",
  ListingBrandModel: "brandModel"
}, iF = ({
  language: o,
  template: r,
  sellingMethod: n
}) => {
  const a = xT[o];
  return r === "SaleDetail" ? a.sdp[n] : a.slp[n][vT[r]];
}, wT = /[\t\n\v\f\r\u0085\u2028\u2029]/gu, ET = /[\u00ad\u061c\u200b\u200e\u200f\u202a-\u202e\u2060\u2066-\u2069\ufeff]/gu, CT = / {2,}/gu, ji = /\{([A-Za-z]+)\}/gu, kT = /[{}]/u, DT = /[<>]/u, LT = /&(?:[A-Za-z][A-Za-z0-9]*|#[0-9]+|#[xX][0-9A-Fa-f]+);/u, el = {
  title: mT,
  description: hT
}, ol = (o) => o === 32 || o === 160 || o === 5760 || o >= 8192 && o <= 8202 || o === 8204 || o === 8205 || o === 8239 || o === 8287 || o === 12288, BT = (o) => {
  let r = 0, n = o.length;
  for (; r < n && ol(o.charCodeAt(r)); )
    r += 1;
  for (; n > r && ol(o.charCodeAt(n - 1)); )
    n -= 1;
  return o.slice(r, n);
}, tl = (o) => BT(o.replace(wT, " ").replace(ET, "").normalize("NFC").replace(CT, " ")), RT = (o) => {
  for (let r = 0; r < o.length; r += 1) {
    const n = o.charCodeAt(r);
    if (n <= 31 || n >= 127 && n <= 159)
      return !0;
  }
  return !1;
}, PT = (o) => {
  for (let r = 0; r < o.length; r += 1) {
    const n = o.charCodeAt(r);
    if (n >= 55296 && n <= 56319) {
      const a = o.charCodeAt(r + 1);
      if (!(a >= 56320 && a <= 57343))
        return !0;
      r += 1;
    } else if (n >= 56320 && n <= 57343)
      return !0;
  }
  return !1;
}, Yl = (o) => {
  const r = /* @__PURE__ */ new Set();
  for (const n of o.matchAll(ji)) {
    const a = n[1];
    a !== void 0 && r.add(a);
  }
  return [...r];
}, Xl = (o) => kT.test(o.replace(ji, "")), Ql = (o, r) => {
  const n = jl[o].allowed;
  return r.filter((a) => !n.includes(a));
}, aF = ({
  template: o,
  field: r,
  text: n
}) => {
  const { allowed: a, required: u } = jl[o], f = Yl(n), d = [];
  n.length > el[r] && d.push({ code: "tooLong", maxLength: el[r] }), RT(n) && d.push({ code: "controlCharacter" }), PT(n) && d.push({ code: "unpairedSurrogate" }), (DT.test(n) || LT.test(n)) && d.push({ code: "markup" }), Xl(n) && d.push({ code: "malformedPlaceholder" });
  for (const b of Ql(o, f))
    d.push({ code: "unknownPlaceholder", placeholder: b, allowed: a });
  for (const b of u[r])
    f.includes(b) || d.push({ code: "missingRequiredPlaceholder", placeholder: b });
  return r === "title" && n.toLowerCase().includes(Jl.toLowerCase()) && d.push({ code: "containsSiteName" }), d;
}, sF = (o) => {
  switch (o.code) {
    case "tooLong":
      return `must be at most ${o.maxLength} characters`;
    case "controlCharacter":
      return "must not contain control characters";
    case "unpairedSurrogate":
      return "must not contain unpaired surrogates";
    case "markup":
      return "must not contain HTML: remove <, > and entities such as &amp;";
    case "malformedPlaceholder":
      return "has a malformed placeholder: write it as {name}, without spaces";
    case "unknownPlaceholder":
      return o.allowed.length > 0 ? `uses the unknown placeholder {${o.placeholder}}. Allowed here: ${o.allowed.map((r) => `{${r}}`).join(", ")}` : `uses the unknown placeholder {${o.placeholder}}. No placeholder is allowed here`;
    case "missingRequiredPlaceholder":
      return `must contain {${o.placeholder}}`;
    case "containsSiteName":
      return `must not contain "${Jl}": the platform appends it`;
    default:
      return rn();
  }
}, uF = ({
  template: o,
  text: r,
  values: n
}) => {
  if (r == null)
    return null;
  const a = tl(r);
  if (a === "" || Xl(a) || Ql(o, Yl(a)).length > 0)
    return null;
  const u = tl(a.replace(ji, (f, d) => n[d] ?? ""));
  return u === "" ? null : u;
};
export {
  Vy as ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  IM as AUCTION_INCREMENT_ID_REGEX,
  gN as AdminUserPasswordResetTokenPayloadSchema,
  XT as BANK_TRANSFER_BAIL_AUTHORIZATION_ID_PREFIX,
  Ly as BUS_ASSET_BASE_IMAGES,
  QT as BUS_ASSET_COVER_IMAGES,
  By as BUS_ASSET_VIDEOS,
  jT as CalcomBookingMetadataSchema,
  eT as DEFAULT_SALE_STEP_TIERS,
  SM as DIRECT_SALE_INCREMENT_ID_REGEX,
  mM as DOCUMENT_INPAINT_FILL,
  fM as DOCUMENT_INPAINT_PADDING_PT,
  aM as FILE_UPLOAD_EXTENSIONS,
  iM as FILE_UPLOAD_PDF_MAX_SIZE,
  jM as FILTER_COMPANION_SEATS_VALUES,
  fN as FILTER_DISPLACEMENT_END,
  pN as FILTER_DISPLACEMENT_START,
  mN as FILTER_DISPLACEMENT_STEP,
  VM as FILTER_FOLDING_SEATS_VALUES,
  XM as FILTER_FUEL_TANK_CAPACITY_END,
  YM as FILTER_FUEL_TANK_CAPACITY_START,
  QM as FILTER_FUEL_TANK_CAPACITY_STEP,
  ZM as FILTER_HEIGHT_END,
  UM as FILTER_HEIGHT_START,
  $M as FILTER_HEIGHT_STEP,
  CM as FILTER_KM_END,
  EM as FILTER_KM_START,
  kM as FILTER_KM_STEP,
  PM as FILTER_LENGTH_END,
  RM as FILTER_LENGTH_START,
  zM as FILTER_LENGTH_STEP,
  cN as FILTER_OPENABLE_WINDOWS_END,
  lN as FILTER_OPENABLE_WINDOWS_START,
  dN as FILTER_OPENABLE_WINDOWS_STEP,
  oN as FILTER_POWER_END,
  eN as FILTER_POWER_START,
  tN as FILTER_POWER_STEP,
  vM as FILTER_PRICE_END,
  xM as FILTER_PRICE_START,
  wM as FILTER_PRICE_STEP,
  LM as FILTER_REGISTRATION_YEAR_END,
  DM as FILTER_REGISTRATION_YEAR_START,
  BM as FILTER_REGISTRATION_YEAR_STEP,
  HM as FILTER_SEATS_END,
  KM as FILTER_SEATS_START,
  WM as FILTER_SEATS_STEP,
  sN as FILTER_STANDING_PLACES_END,
  aN as FILTER_STANDING_PLACES_START,
  uN as FILTER_STANDING_PLACES_STEP,
  nN as FILTER_TOTAL_CAPACITY_END,
  rN as FILTER_TOTAL_CAPACITY_START,
  iN as FILTER_TOTAL_CAPACITY_STEP,
  JM as FILTER_WHEELCHAIR_PLACES_VALUES,
  GM as FILTER_WIDTH_END,
  OM as FILTER_WIDTH_START,
  qM as FILTER_WIDTH_STEP,
  lo as FeeTarget,
  co as FeeType,
  Ol as INPAINT_BOX_ORIGINS,
  Py as ITALIAN_REGIONS,
  $y as LanguageISO6391Schema,
  yM as MAPBOX_API_CONFIG,
  lT as MAX_DISCRETIONARY_PHOTOS_PER_GAP,
  YT as ONE_EURO_STARTING_PRICE,
  fT as PowertrainWarrantyIneligibilityReason,
  FM as SEARCH_INTERPRET_MAX_QUERY_LENGTH,
  NM as SEARCH_MIN_QUERY_LENGTH,
  xT as SEO_META_DEFAULTS,
  hT as SEO_META_DESCRIPTION_MAX_LENGTH,
  nF as SEO_META_DESCRIPTION_RECOMMENDED_LENGTH,
  jl as SEO_META_PLACEHOLDERS,
  Jl as SEO_META_SITE_NAME,
  mT as SEO_META_TITLE_MAX_LENGTH,
  rF as SEO_META_TITLE_RECOMMENDED_LENGTH,
  JT as STEP_LOWEST_COMMON_DENOMINATOR,
  $l as SaleSteppedPrice,
  cM as TEXT_INPAINT_DEFAULT_PROMPT,
  QN as VAS_CLAIM_CONFIGURATION,
  vN as adaptFormDataToDto,
  EN as adaptMapboxFeatureToAddressBody,
  _N as addressFormFieldSchema,
  WT as busClasses,
  OT as busDossierDocumentKeys,
  j_ as busRegistrationDependentFieldKeys,
  HT as busTypes,
  zN as computeBuyerMaxOfferAndFees,
  RN as computeFees,
  GN as computeIsSellerPov,
  ON as computeReservePrice,
  BN as computeSaleDefaultValues,
  PN as computeSellerReservePriceAndFees,
  IN as convertKwToHp,
  Ki as countriesConfig,
  Pl as countryIso2List,
  AM as customerServiceEmail,
  gM as customerServicePhone,
  zT as derivedSeatFields,
  rl as derivedStandingPlaces,
  V_ as derivedTotalCapacity,
  sF as describeSeoMetaTextIssue,
  pM as documentInpaintBoxSchema,
  xN as fetchFormatQuery,
  AN as getAddressFormFieldSchema,
  tM as getAsCountryISO2,
  rM as getAsCountryISO3,
  sM as getAsLanguageISO6391,
  lM as getAsTaxCodeOrigin,
  Jy as getAsTin,
  KT as getBusDossierDocumentResponsibility,
  qT as getBusDossierFieldResponsibility,
  UT as getBusDossierRequiredVaryingFields,
  oM as getCountryCodesByContinent,
  nM as getCountryISO3FromISO2,
  eM as getCountryNameInEnglish,
  jN as getFleequidOrder,
  _M as getHubspotFlagUrl,
  hM as getHubspotSalesRepImageUrl,
  Wr as getInspectionSequence,
  TM as getLanguage6391FromCountryIso2,
  KN as getMediaTypeForName,
  YN as getMissingRequiredMedia,
  pT as getRequiredMedia,
  iF as getSeoMetaDefaultTexts,
  bM as hubspotDefaultSalesRepImageUrl,
  Hi as hubspotPublicFilesBaseUrl,
  wN as initFormData,
  dM as inpaintBoxSchema,
  SN as insertIf,
  HN as isAnchoredPosition,
  ZT as isBusDossierDocumentHidden,
  $T as isBusDossierDocumentRequired,
  GT as isBusDossierFieldHidden,
  eA as isBusDossierFieldRequired,
  Bi as isBusToBeRegistered,
  Gy as isCountryISO2,
  qy as isCountryISO3,
  LN as isDbIntegerValidator,
  $N as isDoubleDecker,
  ZN as isInternalMedia,
  Hy as isTaxCodeOrigin,
  NN as isTin,
  UN as isTrustReportType,
  J_ as isWaivedByBusRegistration,
  uM as languageNames,
  MM as languageToRepresentativeCountryMap,
  hN as listingSellingMethods,
  tl as normalizeSeoMetaText,
  FN as parseAsTin,
  yN as phoneValidator,
  ql as phoneValidatorE164,
  qN as pickLowestFee,
  bN as platformLanguages,
  Uy as provinces,
  kN as range,
  XN as reconcileForTrustReportTypeChange,
  cT as resolveDiscretionaryAnchor,
  JN as resolveFleequidPosition,
  VN as resolveInterlacedFleequidPosition,
  WN as resolveNextAnchoredPosition,
  CN as resolveProvinceCode,
  uF as resolveSeoMetaText,
  bT as seoMetaDefaultsCs,
  _T as seoMetaDefaultsDe,
  AT as seoMetaDefaultsEn,
  gT as seoMetaDefaultsEs,
  yT as seoMetaDefaultsFr,
  TT as seoMetaDefaultsIt,
  MT as seoMetaDefaultsNl,
  NT as seoMetaDefaultsPl,
  FT as seoMetaDefaultsPt,
  IT as seoMetaDefaultsRo,
  ST as seoMetaDefaultsRu,
  oF as seoMetaFields,
  tF as seoMetaPlaceholders,
  eF as seoMetaTemplates,
  VT as suggestedLuggageCapacity,
  Ky as taxCodeOriginList,
  aT as trustReportTypes,
  aF as validateSeoMetaText,
  DN as vinValidator,
  TN as zodPhoneE164,
  MN as zodPhoneE164Optional
};
//# sourceMappingURL=shared.mjs.map
